{
  "searchBox": {
    "placeholder": "Entrer un numéro (pièce, type), un titre, ou définir le document"
  },
  "customLoginPage": {
    "badRequest": {
      "bad_credentials": "L’adresse courriel ou le mot de passe saisis ne sont pas corrects.",
      "account_disabled": "User is disabled. Please contact administration.",
      "unknown_error": "An unknown error occurred. Please try again later."
    }
  },
  "common": {
    "b2b_login_disabled": "Pour des raisons de sécurité, votre compte utilisateur a été bloqué en raison d'une période prolongée d'inactivité. Veuillez contacter votre administrateur afin de réactiver votre compte.",
    "text_orderTemplate_csv_missing_header": "La commande n'a pas pu être téléchargée. Veuillez utiliser le modèle de commande pour télécharger une commande.",
    "customer_registration": "INSCRIPTION CLIENT",
    "search_mobile_page_searchText": "Votre recherche portait sur",
    "header_quick_order": "COMMANDE\n RAPIDE",
    "text_account_saveCart_edit_success": "Mise à jour réussie du panier",
    "additional_soldto_location_description": "Saisissez les numéros de client Knorr-Bremse supplémentaires auxquels vous devriez avoir accès (numéro de client et/ou adresse)",
    "header_welcome": "Bienvenue",
    "closest_equivalent_product_text": "Produit équivalent le plus proche",
    "closest_equivalent_product_desc": "Il s'agit du produit équivalent le plus proche et il se peut qu'il ne corresponde pas exactement à la référence recherchée. Veuillez consulter toute la documentation technique avant de passer commande afin de vous assurer que le produit est bien adapté, qu'il a la forme voulue et qu'il fonctionne correctement.",
    "search_page_totalResults": "article(s) trouvé(s)",
    "error_account_myPart_part_notcorrect": "ligne {0}Â : {1} numéro de pièces {2} nâest pas reconnu, donc non téléversé. Corrigez votre entrée ou communiquez avec votre service client {3} local.",
    "mycompany_user_delete_note": "Remarque: vous ne pouvez pas annuler cette suppression.",
    "mycompany_user_delete_account": "Supprimer un compte utilisateur",
    "mycompany_user_delete_confMessage": "Voulez-vous vraiment supprimer le compte d'utilisateur suivant?",
    "text_warranty_submit_part_type_number": "Type no",
    "text_account_dropship_address": "Adresse d’expédition directe",
    "ppd_freight_greater_than_subtotal_info": "Le total (exclut les charges de base) partiel de votre panier est {0} {1}. Le transport sera gratuit si vous ajoutez des pièces valant {2} {1} à votre panier.",
    "text_account_warranty_table_header_dsiplay_status": "Motif de l’état de la réclamation",
    "search_page_searchText": "Votre recherche portait sur",
    "vizseek_search_Invalid_text3": "ou",
    "text_Show_warranty_of_coworkers": "Show warranty requests from coworkers",
    "register_data-protection": "Déclaration de confidentialité",
    "loginTitle": "Client régulier",
    "loginsubTitle": "Veuillez vous connecter",
    "loginremembermecheck": "Se souvenir de ma connexion",
    "forgotPassword": "Vous avez oublié votre mot de passe?",
    "userlogin": "Connexion à votre compte",
    "loginpara": "Inscrivez-vous à Bendix pour obtenir la disponibilité des produits, la tarification, les informations de commande et bien plus encore!",
    "loginNewUser": "Nouvel utilisateur?",
    "loginregisterBtn": " S’inscrire",
    "text_aftermarket_part_number": "Référence AM",
    "text_quick_order_form": "Formulaire de commande rapide",
    "text_import_order": "Importer la commande",
    "text_company_managePermissions_page_firstPage": "&laquo; ",
    "text_company_managePermissions_page_lastPage": "&raquo; ",
    "text_company_manageUser_pageAll_firstPage": "&laquo; ",
    "text_company_administrators_page_firstPage": "&laquo; ",
    "text_company_manageusers_restpassword_breadcrumb": "Mettre à jour le mot de passe ",
    "text_company_manageUser_registration_lastPage": "&raquo; ",
    "text_company_manageB2BUserGroup_page_firstPage": "&laquo; ",
    "updatePwd_pwd_invalid": "Le mot de passe ne répond pas aux conditions minimales. ",
    "text_company_children_page_lastPage": "&raquo; ",
    "text_company_members_page_lastPage": "&raquo; ",
    "text_company_manageUser": "Utilisateurs    ",
    "text_company_manageUser_pageAll_lastPage": "&raquo; ",
    "text_company_budget_page_firstPage": "&laquo; ",
    "text_company_managers_page_firstPage": "&laquo; ",
    "text_company_customers_page_lastPage": "&raquo; ",
    "text_company_costCenter_page_lastPage": "&raquo; ",
    "text_company_members_page_firstPage": "&laquo; ",
    "text_company_usergroups_page_firstPage": "&laquo; ",
    "text_company_costCenter_page_firstPage": "&laquo; ",
    "text_company_approvers_page_firstPage": "&laquo; ",
    "text_company_children_page_firstPage": "&laquo; ",
    "text_company_manageUsers": "Utilisateurs    ",
    "text_company_manageusers_label": "Utilisateurs    ",
    "text_company_approvers_page_lastPage": "&raquo; ",
    "text_company_usergroups_page_lastPage": "&raquo; ",
    "text_company_managers_page_lastPage": "&raquo; ",
    "text_company_permissions_page_firstPage": "&laquo; ",
    "text_company_manageUser_registration_firstPage": "&laquo; ",
    "text_company_manageB2BUserGroup_page_lastPage": "&raquo; ",
    "text_company_usergroup_members": "Utilisateurs    ",
    "text_company_customers_page_firstPage": "&laquo; ",
    "text_company_manageUser_button_create": "Créer un nouvel utilisateur    ",
    "text_company_approvers_page_showPageResults": "Afficher paginé ",
    "text_company_administrators_page_lastPage": "&raquo; ",
    "text_company_budget_page_lastPage": "&raquo; ",
    "text_company_permissions_page_lastPage": "&raquo; ",
    "checkout_product_not_purchasable": "Désolé, le numéro de pièce {0} n’est plus achetable; supprimez ce produit avant de passer à la caisse.",
    "text_core_search_heading": "Si vous n’êtes pas certain du numéro d’article ou du groupe de cores, entrez les renseignements connus ci-dessous dans le champ pertinent. Les renseignements fournis vous aident à remplir correctement la demande de retour de cores et, donc, à bien gérer les reprises.",
    "checkout_summary_paymentMethod_savedCards_paymentCard": "Carte de paiement",
    "basket_add_to_cart": "Ajouter",
    "basket_save_cart_action_save": "Enregistrer",
    "quote_save": "Enregistrer le devis",
    "checkout_orderConfirmation_order_note": "Commentaires:",
    "guest_register_submit": "S’inscrire",
    "basket_save_cart_validation_description_size": "La description du panier ne doit pas dépasser 255 caractères",
    "guest_checkout_existingaccount_register_error": "Un compte avec ID courriel {0} existe déjà.",
    "storelocator_dealer": "Dealers",
    "basket_information_quantity_adjusted": "Vos articles ont été modifiés pour correspondre aux stocks disponibles",
    "text_warranty_search_to_date_invalid": "Claim Date To can't be less than the Claim Date From.",
    "pickup_in_stock": "{0} EN STOCK",
    "text_account_quote_status_display_SELLER_SUBMITTED": "Envoyé",
    "checkout_page_DeliveryMethodForOrder_NA_orderNote": "Entrez les notes de commande: <br /> (Veuillez entrer le code postal ci-dessous lié au numéro de compte du transporteur fourni)",
    "aria_pickupinstore_storesloaded": "Magasins chargés",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_firstName": "Cette valeur n’est pas valide pour ce champ",
    "text_button_save": "Enregistrer",
    "text_core_search_CR": "CR#",
    "text_core_search_CRStatus": "CR Statut",
    "text_core_search_CreationDate": "Date de création",
    "text_core_search_CoreReturnMonth": "Core Mois de retour",
    "text_core_search_BOLStatus": "Numéro d'expédition",
    "text_core_search_BOLPDF": "BOL PDF",
    "text_core_search_savedReturn": "Saved (Not Submitted)",
    "text_core_search_noSavedReturn": "SUBMITTED",
    "address_companyName_invalid": "Veuillez saisir le nom de l'entreprise",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationYear": "Entrez une année d’expiration",
    "text_select_you_path_upload": "Chemin du fichier à téléverser:",
    "text_reports_detailEmea": "Each line item transaction",
    "checkout_summary_deliveryMode_useThisDeliveryMethod": "Utiliser cette méthode de livraison",
    "user_request_approval": "Demander l'approbation",
    "mycompany_click_locked_user": "Utilisateur bloqué - Cliquez pour activer l'utilisateur",
    "payment_issueNumber_toolong": "Le numéro d’émission est trop long.",
    "text_generalInfo_packaging": "Conditionnement",
    "text_currency": "Sélectionner la deviset",
    "text_quote_yes_button_label": "Oui",
    "text_account_coreReports": "Core Reports",
    "storeDetails_table_telephone": "Téléphone",
    "text_swithToMobileStore": "Revenir à mobile",
    "text_account_consent_template_notFound": "Modèle de consentement introuvable",
    "text_headertext": "Confirmer",
    "text_account_myPart_updatePersonalDetails": "Modèle d’importation du numéro de pièce client",
    "checkout_summary_paymentMethod_addPaymentDetails_enterYourCardDetails": "Entrez les détails de votre carte pour le paiement",
    "pdp_page_add_to_cart": "Ajouter au panier",
    "search_nav_facetShowMore_price": "plus de prix...",
    "text_account_orderDetails_backToOrderHistory": "Retour à l’historique des commandes",
    "basket_page_totals_total_items_one": "{0} ARTICLE",
    "mobile_storelocator_title": "Localisateur de magasins",
    "text_paymentcard_remove_confirm": "Voulez-vous vraiment supprimer cette carte de paiement?",
    "text_account_warranty_table_header_core_value": "Valeur de reprise",
    "checkout_summary_placeOrder_wrongDateFormatMessage": "Le format de date doit être {0}.",
    "guest_description": "Vous préférez magasiner sans créer un compte? <br />C’est simple et rapide!",
    "text_quote_discount_by_percentage": "Remise par pourcentage",
    "mobile_search_nav_facetValueCount": "{0}",
    "coupon_already_exists_cart": "Un coupon de la même campagne a déjà été affecté à votre panier.",
    "order_history_order_number": "Commande no :",
    "text_reports_download": "Télécharger un rapport",
    "checkout_multi_deliveryAddress_remove": "Supprimer",
    "basket_save_cart_on_success": "Enregistrement réussi du panier {0}",
    "text_actions": "Actionstt",
    "text_warranty_submit_date": "Date",
    "checkout_summary_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Utiliser ces détails de paiement",
    "basket_page_totals_netTax": "Taxe :",
    "import_csv_savedCart_requestedDateEmea": "Facultatif : Date de livraison demandée (format JJ/MM/AAAA)",
    "text_orderimport_error_dateformat_message": "jj/mm/aaaa",
    "checkout_page_DeliveryMethodForOrder_EMEA_orderNote": "Commentaires",
    "address_prefecture_invalid": "Sélectionnez une préfecture",
    "address_line2_shipping_page_form": "Adresse ligne 2",
    "text_account_order_yourOrder": "Votre commande",
    "text_account_savedCarts_page_showPageResults": "Afficher paginé",
    "text_storefinder_desktop_page_totalResults": "{0} magasins trouvés",
    "text_account_consent_already_withdrawn": "Consentement déjà refusé",
    "netPrice_check": "Prix net",
    "storeFinder_line_text": "ou",
    "text_reports_detailNa": "Transactions par éléments",
    "text_core_search_finder": "Outil de recherche des groupes de cores",
    "text_account_order_back_btn": "Retour",
    "product_share_share": "Téléchargements",
    "login_password": "Mot de passe*",
    "form_select_empty": "Sélectionnez",
    "checkout_page_back_to_cart": "Retour au panier",
    "text_warranty_terms_highway_applications": "Ces utilisations impliquent une fréquence normale des cycles de freinage, principalement sur un revÃªtement dur.",
    "search_nav_applied_facets_emea": "Filtres appliqués",
    "basket_export_user_orders": "Commandes",
    "text_Shipping_Packaging_content1": "Envoyez un courriel à",
    "text_Shipping_Packaging_content2": "si vous avez des questions. Veuillez donner votre numéro de compte et celui de retour de cores.",
    "basket_export_user_preferredEmailLanguage": "Langue e-mail préférée",
    "password_strength_verystrong": "Très fort",
    "text_storefinder_mobile_page_linkNextPage": "Suivant &raquo;",
    "text_account_consent_notFound": "Consentement introuvable",
    "text_core_search_partnum": "No de pièce Bendix",
    "text_account_orderHistory_page_sort_byCodeDesc": "Order No-Desc",
    "text_account_coworker_orders": "Afficher les commandes des collègues",
    "basket_page_itemNumber": "Article no",
    "account_confirmation_address_added": "Adresse créée avec succès",
    "basket_export_user_country": "Pays",
    "text_core_submission_pleaseNote": "Veuillez noter",
    "text_page_message_underconstruction": "<strong>Information:</strong>  Page en construction – pas entièrement fonctionnelle",
    "text_account_quote_action_display_ORDER": "Commande, Devis",
    "text_quickOrder_page_total": "Total",
    "text_account_order_total_includesTax": "Le total comprend {0} en taxes",
    "cart_product_deleteall": "Voulez-vous supprimer tous les articles sélectionnés?",
    "checkout_multi_address_added": "Votre adresse a été créée.",
    "address_selectPrefecture": "Préfecture",
    "checkout_summary_deliveryAddress_saveAndUseThisAddress": "Enregistrer et utiliser cette adresse",
    "text_warranty_submit_primary_complaint": "Réclamation principale**",
    "text_headline_search": "Vous pouvez ici rechercher des produits",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_phoneNumber": "Entrez une valeur pour ce champ",
    "text_account_order_order": "Commande",
    "register_company_address_two_invalid": "Entrez la seconde adresse de l’entrepriset",
    "inverse_check": "Xref",
    "text_account_myPart_success_uploded": "Téléversement réussi de tous les numéros de pièce.",
    "address_lastName_invalid": "Entrez un nom",
    "general_zoom": "Vue agrandie de l’image",
    "open_qty": "Qté à définir**",
    "system_error_link_expired_title": "Désolé, ce lien a expiré",
    "basket_restoration": "Heureux de vous revoir, {0}. Des articles de votre panier antérieur ont été restaurés dans votre panier d’achat actuel.",
    "checkout_summary_deliveryAddress_saveAddressInMyAddressBook": "Enregistrer l’adresse d’expédition",
    "text_core_submit_emailAddress_invalid": "Please Enter Valid Email",
    "basket_page_totals_error_wrongzipcode": "Entrez un code postal valide",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_postalCode": "Cette valeur n’est pas valide pour ce champ",
    "text_deliveryMethod": "Méthode de livraisont",
    "cart_product_deletealltext": "Voulez-vous supprimer les éléments sélectionnés ?",
    "product_product_salesStatus": "État du produit",
    "text_storefinder_desktop_page_linkNextPage": "Suivant",
    "text_warranty_submit_recall_type": "Recall Type*",
    "profile_checkNewPassword_invalid": "Confirmez votre nouveau mot de passe",
    "core_report_coreparent": "Please Select Core Parent",
    "quote_requote_error": "Erreur durant la recréation du devis.",
    "core_error_reports_emea": "You do not have permission, please <a href",
    "storeFinder_table_view_map": "Afficher carte",
    "order_history_billing_address": "Adresse de facturation :",
    "text_account_orderHistory_page_linkNextPage": "Page suivante",
    "cart_page_deliverydate": "Date de livraison",
    "basket_page_totals_total": "Total",
    "login_link_forgottenPwd": "Vous avez oublié votre mot de passe?",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_city": "Entrez une valeur pour ce champ",
    "cart_total_poa_EMEA": "Prix sur demande = nous ne pouvons afficher un prix actuellement. Cependant vous pouvez continuer votre commande.<p>Si vous avez besoin d’aide, veuillez contacter votre  <a target='_blank' href='https://truckservices.knorr-bremse.com/about-us/contacts'>service client Knorr-Bremse local.</a></p> ",
    "text_headline_bottombanner": "Bannière inférieure",
    "import_csv_savedCart_fileCSVRequired": "Téléversez les données dans le bon format – prenez le modèle Excel de téléversement",
    "checkout_orderConfirmation_orderStatus": "État de la commande : {0}",
    "checkout_multi_hostedOrderPostPage_header_wait": "Nous vous transférons; veuillez patienter",
    "mobile_checkout_continue_button": "Continuer",
    "checkout_checkout_single": "Caisse Unique (une page)",
    "core_report_NA_description": "Les rapports des cores, publiés sur Internet au début de chaque mois, rendent compte de l’activité du mois précédent.",
    "product_grid_expand": "Développer",
    "text_product": "Produitt",
    "search_nav_done_button": "Terminé",
    "text_quote_not_cancelable": "Le devis {0} ne peut être annulé",
    "text_account_addressBook_addAddress_label": "Ajouter une adresse pour les commandes d'urgence",
    "text_consent_disclaimer": "l’exclusion de responsabilité du téléchargement",
    "quote_create_success": "Création réussie du devis.",
    "import_csv_savedCart_uploadFile": "Conservez le format du modèle de commande si vous créez votre propre fichier à téléverser dans votre PRE",
    "text_account_close": "Fermer le compte",
    "warranty_eligibility_check_date_removed_from_service": "Date de retrait de service",
    "text_warranty_document_claim_refund": "Si vous demandez un remboursement, vous devez téléverser une preuve de vos dépenses; les demandes non accompagnées d’une preuve seront refusées.",
    "payment_nameOnCard_invalid": "Entrez le nom qui est sur la carte",
    "price_here_download_files": "Vous pouvez télécharger vos fichiers de prix ici.",
    "basket_page_change_configuration": "Changer la configuration",
    "text_account_orderHistory_emptyOrderHistory": "Historique vide des commandes",
    "basket_export_user_title": "Titre",
    "popup_cart_title": "Votre panier d’achat",
    "text_account_quote_status_display_SELLER_REQUEST": "Demandé",
    "address_line1_invalid": "Entrez adresse Ligne 1",
    "checkout_multi_deliveryAddress_editAddress": "Modifier adresse",
    "import_csv_savedCart_import": "Importer",
    "text_quote_comments_label": "Commentaires",
    "checkout_error_authorization_failed": "Désolé, votre transaction ne peut être terminée en ce moment; veuillez réessayer plus tard ou joindre notre service à la clientèle au 555 555-5555",
    "text_storefinder_responsive_page_showAllResults": "Afficher tout",
    "text_account_saved_cart_detail_list_price": "Prix courant",
    "product_view_details_name": "Désignation de la piècet",
    "checkout_summary_reviewYourOrder": "Examen final",
    "checkout_express_error_deliveryAddress": "La caisse rapide n’est pas offerte, car vous n’avez pas une adresse de livraison par défaut. Définissez une adresse de livraison par défaut dans votre compte pour utiliser Caisse rapide la prochaine fois.",
    "text_account_order_orderDetails_orderNumber": "Commande no {0}",
    "text_storefinder_desktop_page_firstPage": "&laquo;",
    "productsalesstatus_label_apac_code20": "Identifiant du titre",
    "text_warranty_submit_part_information": "Numéro d'information sur la pièce",
    "register_checkPwd_invalid": "Confirmez votre mot de passe",
    "checkout_multi_deliveryMethod_stepHeader": "2 – Sélectionner une méthode de livraison",
    "text_warranty_submit_types_operation": "Type d’opération*",
    "checkout_orderConfirmation_Order_ID": "Commande no :",
    "checkout_error_paymentethod_formentry_sop_invalid_card_accountNumber": "Le numéro de carte n’est pas valide",
    "checkout_pickup_estimated_total": "Total estimatif :",
    "review_based_on": "({0})",
    "text_account_quote_action_display_EXPIRED": "Expiré",
    "register_company_accessRequesting_invalid": "Choisissez au moins un accès",
    "text_account_core_search_showAllResults": "Afficher tout",
    "storelocator_error_no_results_title": "Vos critères de recherche n’ont donné aucun résultat de magasin.",
    "register_email_mandatory": "Votre adresse e-mail d'entreprise",
    "text_account_warranty_table_header_model": "Modèle",
    "text_account_core_table_header_model": "Modèle",
    "payment_month": "Mois",
    "search_back_to_product_list": "Retour à la liste de produits",
    "text_core_submit_address_addressCompany": "Company*",
    "text_account_order_status_display_open": "à définir",
    "checkout_multi_deliveryAddress_noExistingAddresses": "Votre carnet n’a aucune adresse.",
    "checkout_summary_paymentMethod_securityCode_whatIsThis": "(Qu’est-ce que c’est?)",
    "text_account_closeAccount_popup_title": "Confirmer la fermeture du compte",
    "order_history_shipping_address": "Adresse d’expédition :",
    "mobile_checkout_confirmOrder": "Examen final",
    "text_core_submission_pkgQty": "Paquet, qté",
    "text_core_submission_BoxQty": "Boîte Qté",
    "text_core_submission_palletQty": "Qté de palettes",
    "order_form_subtotal": "Sous-total",
    "text_core_submission_headerNA_text2": "Pour plus d'informations sur la manière de remplir ce formulaire, rendez-vous sur la page",
    "text_core_submission_headerNA_text1": "Veuillez remplir toutes les informations requises afin de garantir un processus de retour des carottes efficace.",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationMonth": "Le mois d’expiration n’est pas valide",
    "text_account_online_ordering": "Commande en ligne",
    "address_townCity_invalid": "Entrez une ville",
    "text_account_trackOrders": "Suivre vos commandes",
    "productsalesstatus_label_apac_code10": "Numéro tarifaire",
    "text_stores": "Magasins",
    "warranty_check": "Garantie",
    "text_quickOrder_requested": "Demandée",
    "productsalesstatus_label_apac_code40": "Unité",
    "address_error_sim_invalid": "Le numéro de pièce {0} ne peut être expédié à l’adresse de livraison saisie. Changez l’adresse de livraison ou supprimez ce numéro.",
    "validation_donotcontainName_invalid": "please do not use first name,last name or full name in password.",
    "open_estimated_delivery_date": "Estimated Delivery Date",
    "login_optional": "(optionnelle)",
    "storeDetails_table_from": "de",
    "storeFinder_link": "Points de vente",
    "text_account_savedCarts_page_sortTitle": "Ordre de tri",
    "text_account_myPart_select_customer": "Sélectionnez au moins un client",
    "register_phone": "Numéro de téléphone (portable de préférence)",
    "basket_export_user_city": "Ville",
    "storelocator_distributor": "Distributors",
    "guest_register_description": "Profitez d’une validation plus rapide lors de votre prochain achat et de l’accès à l’historique de vos commandes",
    "checkout_checkout_multi_pci": "Caisse Multi avec PCI",
    "import_csv_savedCart_uploadStarted": "Téléversement du fichier...",
    "text_account_core_search_noRequestFound": "No Results found.",
    "checkout_multi_confirmOrder": "Révision finale",
    "general_month_december": "Décembre",
    "password_strength_medium": "Moyenne",
    "text_core_submission_headerEMEA_text3": "Please check the",
    "text_core_submission_headerEMEA_text2": "Rejected core e.g. calipers without adjuster in place, will be scrapped without credit or further notice.",
    "address_building": "Nom ou numéro de l’immeuble",
    "text_core_submission_headerEMEA_text4": "for further details.t",
    "text_core_submission_headerEMEA_text1": "Fill in carefully all required information to ensure an efficient return process - only complete forms can be processed!",
    "checkout_summary_deliveryAddress_enterDeliveryAddressButton": "Modifier l’adresse de livraison",
    "productsalesstatus_label_apac_code30": "Numéro du type",
    "basket_page_quote_discounts_link_percent_off": "Remise de {0} %",
    "text_account_paymentDetails": "Détails du paiement",
    "order_totals_savings": "Économies :",
    "text_updates": "Mises à jour",
    "text_account_savedcart_cart_name": "Nom du panier",
    "vor_textnextline_warning": "Knorr-Bremse is not liable for late or missed deliveries due to incorrectly entered addresses.",
    "text_quote_done_button_label": "Terminé",
    "text_warranty_submit_business_type": "Type d’entreprise*",
    "registration_error_account_exists_title": "Un compte existe déjà pour cette adresse électronique.",
    "text_account_profile_updatePersonalDetails_mobile": "Modifier",
    "text_account_warranty_table_header_claim_status": "État de la réclamation",
    "cart_product_configuration_toolong": "La valeur est trop longue",
    "search_page_xref_number": "Réf croisé",
    "basket_page_viewFuture": "Vérifier la disponibilité en cas d’urgence",
    "checkout_multi_hostedOrderPageError_header": "Détails de l’erreur",
    "review_comment": "Exprimer son avis",
    "text_account_orderHistory_seebelow": "See Below",
    "text_checkout_pickup_in_store_address": "Prendre en magasin – {0}, {1}t",
    "text_iam_partNo": "No de pièce IAM",
    "updatePwd_description": "Entrez un nouveau mot de passe",
    "text_account_order_status": "État : {0}",
    "text_select_file_type_upload": "Remarque: Les fichiers Word, xls, xlsx, csv, txt, tif, gif, jpg, pdf, HTML sont permis!",
    "file_size_gigabytes": "{0} Go",
    "product_product_partname": "Nom de pièce :t",
    "register_accept_read": "Lire",
    "search_page_linkPreviousPage": "Page précédente",
    "login_new_user": "Nouvel utilisateur?",
    "import_csv_savedCart_noFile": "Aucun fichier choisi.",
    "register_name_invalid": "Téléchargements",
    "text_select_all_file_loaded": "All files has been attached successfully",
    "checkout_pickup_simplifyPickup": "Simplifier le lieu de prélèvement",
    "basket_page_totalUSD": "Total",
    "review_show_all": "Afficher tout",
    "checkout_multi_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Enregistrer ces détails de paiement dans mon compte.",
    "text_select_country": "Sélectionner votre pays ou langue",
    "text_expresscheckout_line3": "utilisez une méthode d’expédition par défaut",
    "text_expresscheckout_line1": "définissez une adresse de livraison par défaut dans votre compte ou lorsque vous passez à la caisse",
    "text_expresscheckout_line2": "définissez un « détails de paiement par défaut » lorsque vous passez à la caisse",
    "address_regionIso_invalid": "Entrez une région",
    "text_generalInfo_netWeight": "Poids net",
    "text_free": "GRATUIT",
    "product_grid_itemsText": "articles",
    "profile_lastName_invalid": "Entrez un nom",
    "basket_page_listpriceApac": "List Price(Total)",
    "payment_startDate": "Date de début (Maestro / Solo / Switch seulement)",
    "address_country_invalid": "Sélectionnez un pays/une région",
    "checkout_multi_paymentMethod_createSubscription_billingAddress_noneSelectedMsg": "Entrez une adresse de facturation ou entrez d’abord une adresse de livraison, qui servira alors d’adresse de facturation.",
    "address_prefecture": "Nom de la préfecture",
    "minicart_cart_alt": "Votre panier d’achat",
    "text_account_update_email_address": "Adresse électronique",
    "text_account_savedCarts_page_currentPage": "Page {0} sur {1}",
    "text_account_order_min_NA": "Supplément Commande min./urgente:",
    "text_account_orderHistory_page_totalResultsSingleOrder": "1 commande",
    "text_core_submit_fax": "Fax",
    "checkout_orderConfirmation_yourItems": "Vos articles",
    "basket_select_product": "Sélectionner",
    "kb_search_result_breadcrumb": "résultats pour",
    "basket_page_totals_minordercharge": "Frais de commande min.",
    "text_account_quote_status": "État",
    "storelocator_postcode_city_search": "Recherche code postal/ville",
    "text_account_savedCarts_page_lastPage": "&raquo;",
    "quote_cart_empty_error": "Panier manquant ou vide",
    "quick_order_page_ordertype": "Type de commande",
    "text_warranty_terms_pick_delivery": "Ramassage et livraison (carrosserie cargo)",
    "text_account_orderHistory_mobile_page_currentPage": "{0} sur {1}",
    "profile_currentPassword_invalid": "Entrez votre mot de passe actuel",
    "text_storefinder_desktop_page_currentPage": "{0} sur {1}",
    "register_terms_not_accepted": "Acceptez nos conditions d’inscription.",
    "mini_cart_text_cart": "Panier",
    "checkout_multi_deliveryMethod_breadcrumb": "OPTIONS LIVRAISON",
    "text_generalInfo_customsInfo": "information sur le client",
    "text_warranty_terms_inter_city": "Camion interurbain",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street1": "Cette valeur n’est pas valide pour ce champ",
    "cart_items": "{0} article(s)tt",
    "login_error_incorrect_password_title": "L’adresse courriel ou le mot de passe saisis ne sont pas corrects.",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_street2": "Cette valeur n’est pas valide pour ce champ",
    "text_account_closeAccount_popup_confirm": "Voulez-vous vraiment fermer votre compte?",
    "text_generalInfo_subjecttochange": "Sous réserve de changement, selon les entrepôts de livraison; joindre son service à la clientèle local pour plus de détails.",
    "basket_validation_voucherNotValid": "Le coupon affecté au panier n’étant plus valide, il a été retiré du panier.",
    "address_city": "Ville*",
    "text_warranty_submit_vehicle_manufacturer": "Vehicle Manufacturer",
    "search_nav_applied_facets": "Facettes affectées",
    "text_warranty_terms_highway_information": "Utilisations sur routeÂ :",
    "text_account_myPart": "Ma pièce",
    "onLine_check": "Commander en ligne",
    "mobile_checkout_items_hide": "Masquer les articles",
    "text_account_savedCart_delete": "Supprimer le panier",
    "pickup_in_store": "Prendre en magasin",
    "basket_page_coresurcharge": "Frais de base",
    "basket_page_coredeposit": "Provision Contrepartie",
    "checkout_orderConfirmation_coupon_valid_range": "Valide {0} à {1}",
    "register_company_industryRole": "Rôle d’industrie de l’entreprise",
    "text_account_order_discount": "Remises sur les commandes :",
    "text_account_addressBook_page_firstPage": "&laquo;",
    "basket_error_occurred": "Une erreur s’est produite lors de l’ajout au panier",
    "pickup_force_in_stock": "EN STOCK",
    "text_core_submit_address_requestedDate": "Available collection dates:*",
    "text_account_myPart_download_button": "Télécharger mes numéros de pièce",
    "checkout_summary_paymentMethod_billingAddress_header": "Adresse de facturation :",
    "product_bookmark_and_share": "Ajouter aux favoris et partager",
    "basket_page_title_yourPickUpItems": "Vos articles à prendre",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street1": "Entrez une valeur pour ce champ",
    "remember_me": "Se souvenir de ma connexion",
    "text_core_submission_return": "Demande de retour du noyau",
    "text_account_quote_page_sortTitle": "Ordre de tri",
    "checkout_paymentMethod_notSelected": "Donnez les détails de votre paiement pour votre commande.",
    "checkout_orderConfirmation_thankYou": "Merci de votre commande. Votre numéro de commande est {0}",
    "text_generalInfo_weight_dimensions": "Poids et dimensions",
    "text_submit_warranty": "Demande de réclamation de garantie",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_street2": "Entrez une valeur pour ce champ",
    "coupon_invalid_code_provided": "Le code coupon saisi n’est pas valide.",
    "sold_to_popup_text_three": "pour obtenir de l’aide",
    "text_warranty_submit_vehicle_engine_manufacturers": "Hauteur du piston plongeur / bouton",
    "text_showFacet": "Montrer la mise au pointt",
    "register_company_address_city_invalid": "Entrez la ville de l’entrepriset",
    "basket_page_coreCharges": "Frais de base",
    "basket_page_message_update_reducedNumberOfItemsAdded_noStock": "<a href",
    "text_page_ifnotfound": "si vous ne trouvez pas ce que vous cherchez.",
    "globle_search_message": "Veuillez entrer au moins 3 caractères",
    "storeDetails_table_openingSpecialDays": "Heures d’ouverture spéciales",
    "text_reports_creditReconNa": "Détails – débit/crédit cores en fin de mois",
    "text_account_table_header_poNumber": "Numéro de commande client",
    "text_warranty_submit_product_not_found": "Produit non trouvé",
    "register_company_accessRequesting": "Demande d’accès pour",
    "checkout_express_error_paymentInfo": "La caisse rapide n’est pas offerte, car vous n’avez pas une info de paiement par défaut. Définissez une info de paiement par défaut dans votre compte pour utiliser Caisse rapide la prochaine fois.",
    "text_account_order_title_deliveryItems": "Articles de livraison",
    "text_warranty_submit_customer_information": "Référence et informations client",
    "checkout_multi_order_summary": "RÉCAPITULATIF DE COMMANDE",
    "core_submit_warranty_crn_number_label": "Si cette case est cochée, le système créera le numéro CR",
    "basket_information_obselete_status_true": "Ce produit est remplacé par {0} car il est maintenant obsolète.",
    "checkout_multi_sop_useMyDeliveryAddress": "Utiliser mon adresse de livraison",
    "address_postcode": "Code postal",
    "text_warranty_select_file_wish": "Sélectionnez le fichier que vous souhaitez téléverser, puis cliquez sur le bouton Upload (Téléverser). Chaque fichier téléversé sera ajouté à la demande.",
    "register_company_industryRole_invalid": "Sélectionnez au moins un rôle d’industrie",
    "text_sales_status_description_emea_code_40_anonymous": "Numéro du type",
    "storeDetails_table_opening_opened": "Ouvert",
    "mycompany_search_term": "Terme de rercherche",
    "header_quick_order": "COMMANDE RAPIDE",
    "text_account_orderHistory_mobile_page_sort_byOrderNumber": "Numéro de commande",
    "basket_page_availability": "Disponibilité",
    "checkout_error_paymentethod_formentry_sop_invalid_card_issueNumber": "Le numéro d’émission n’est pas valide",
    "product_view_details_code": "No de piècet",
    "basket_error_invalid_configuration": "Configuration du produit non valide. {0} erreur(s) doivent être corrigée(s) avant de passer à la caisse.",
    "text_header_connect": "Connecter",
    "text_quote_edit_confirmation_modal_title": "Avertissement (modification du devis)",
    "order_quantity": "Quantité",
    "download_click_on_text": "To do so, click on \"START DOWNLOAD\"",
    "text_storefinder_responsive_page_lastPage": "&raquo;",
    "text_reports_detail": "Tous les détails",
    "address_state": "État/Province",
    "storeFinder_pagination_previous": "Précédent",
    "pdp_page_contact_us": "Nous joindre",
    "text_sales_status_description_apac_code_40": "Unité",
    "text_sales_status": "Statut de vente",
    "login_error_incorrect_password_subtitle": "Si vous avez oublié votre mot de passe, utilisez le lien Mot de passe oublié.",
    "file_size_megabytes": "{0} Mo",
    "text_headline_navigationbar": "Parcourir la barre de navigation",
    "text_account_orderHistory_page_sortTitle": "Ordre de tri",
    "basket_page_remove": "Supprimer",
    "text_account_account": "Compte",
    "address_line2_shipping_page_form_emea": "Numéro municipal*",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_city": "Entrez une valeur pour ce champ",
    "checkout_multi_pickup_items": "Prélèvement no {0} – {1} article(s)",
    "text_quickOrder_order_type": "Type de commande",
    "register_dataprotection_acceptNA": "J’accepte les",
    "text_quote_submit_not_modifiable_message": "Après qu’une demande de devis est envoyée, il ne peut être modifié.",
    "checkout_multi_paymentMethod_edit": "Modifier",
    "updatePwd_checkPwd": "Confirmer le mot de passe",
    "order_productDetails": "Détails produit",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startYear": "L’année de début n’est pas valide",
    "text_account_myPart_upload_button": "Téléverser mes numéros de pièce.",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_city": "Cette valeur n’est pas valide pour ce champ",
    "pickup_location_required": "Donnez votre emplacement pour voir les produits offerts dans votre région",
    "text_account_addressBook_yourDefaultAddress": "Cette adresse est votre adresse par défaut",
    "text_account_profile_confirmationUpdated": "Votre profil a été mis à jour",
    "coWorker_check": "Co-Worker Order",
    "text_pagenotfound_homepage": "page d’accueil",
    "pickup_here_button": "Passer prendre ici",
    "mobile_checkout_deliveryAddress_use": "Utiliser",
    "checkout_page_summary_final_review_shipping_address": "Adresse d’expédition :",
    "checkout_orderConfirmation_get_coupon": "Vous avez mérité le coupon suivant!",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_postalCode": "Entrez une valeur pour ce champ",
    "text_account_savedcart_numberofproducts": "Nombre de produits",
    "text_reports_creditEmea": "Explanation of the month end core debit/credit",
    "checkout_error_paymentethod_formentry_sop_missing_card_cvNumber": "Entrez une valeur pour ce champ",
    "checkout_multi_deliveryAddress_selectAddressMessage": "Sélectionnez une adresse existante pour votre livraison.",
    "checkout_orderConfirmation_copySentToShort": "Une copie de vos détails de commande a été envoyée à",
    "checkout_multi_address_updated": "Votre adresse a été mise à jour",
    "register_pwd_invalid": "Le mot de passe ne répond pas aux conditions minimales.",
    "text_country_selector_APAC": "Asia Pacific",
    "promotional_box_main_heading": "News & Updates of Products and Services",
    "address_postalcode": "Code postal*",
    "text_checkout_noDeliveryModes": "Vérifiez l’adresse de livraison. Si ce n’est déjà fait, sélectionnez l’adresse de livraison, puis réessayez.t",
    "checkout_summary_deliveryAddress_header": "Adresse de livraison",
    "storeFinder_see_more": "Afficher la suite",
    "text_account_savedcart_save_activecart": "Je ne souhaite pas enregistrer des articles pour plus tard.",
    "general_find_a_store": "Trouver un magasin",
    "search_mobile_page_sortTitle": "Ordre de tri :",
    "register_email_duplicate": "L’adresse électronique saisie est déjà enregistrée avec un compte existant.",
    "text_voucher_apply_invalid_error": "Ce coupon n’est pas valide",
    "text_quickOrder_product_not_unique": "Produit non unique",
    "text_account_quote_myquotes": "Mes devis",
    "basket_information_quantity_reducedNumberOfItemsAdded_maxOrderQuantityExceeded": "Malheureusement, la quantité choisie excède la quantité de commande maximale de ce produit.",
    "text_account_confirmation_password_updated": "Votre mot de passe a été changé",
    "general_required_po_checkout_mandatory": "Le no de bon de commande client est obligatoire pour terminer le processus de validation d’achat.",
    "search_nav_facetShowLess_brand": "moins de marques...",
    "checkout_page_summary_order_type": "Type de commande",
    "basket_save_cart_name": "Nom",
    "text_headline_login": "Cliquer ici pour ouvrir une session",
    "checkout_multi_pickupInStore_confirm_and_continue": "Confirmez simplement les renseignements ci-dessous, puis passez à l’étape suivante de validation.",
    "text_cookie_notification_accept": "x",
    "checkout_multi_deliveryMethod_message": "Les articles seront expédiés dès qu’ils seront disponibles. <br> Voir Récapitulatif de commande pour un complément d’information.",
    "text_account_quote_remove": "Supprimer",
    "text_quote_comment_label": "Negotiation Comment",
    "text_account_profile_updateEmail_mobile": "Changer l’adresse de courriel",
    "basket_page_total": "Total",
    "checkout_checkout_multi_pci-sop": "PCI-SOP",
    "text_account_savedCarts_noSavedCarts": "Aucun panier enregistré trouvé",
    "account_confirmation_forgotten_password_link_sent": "Des instructions de réinitialisation du mot de passe ont été envoyées à votre adresse électronique. Veuillez joindre le service à la clientèle si vous avez besoin d’une aide supplémentaire.",
    "basket_page_shipping_find_store": "Trouver un magasin",
    "basket_page_totals_grossTax": "Votre commande comprend {0} taxe.",
    "storeDetails_table_opening": "Heures",
    "checkout_summary_deliveryMode_selectDeliveryMethodForOrder": "Méthode d’expédition",
    "account_confirmation_email_sent": "Instructions de réinitialisation du mot de passe envoyées!",
    "text_account_savedCarts_page_totalResultsSingleOrder": "{1} panier enregistré",
    "text_company_manage_units_notapproved": "Votre demande d’inscription est en attente d’approbation; vous recevrez alors un complément d’information par courriel.",
    "text_account_addressBook_page_sort_byName": "Nom",
    "DeliveryType_Complete_name": "Trousse d'action sur le terrain",
    "text_account_orderHistory_page_totalResults": "sur {0} commandes",
    "checkout_orderConfirmation_copySentTo": "Une copie de vos détails de commande a été envoyée à {0}",
    "import_csv_savedCart_filesNote": "Vous pouvez ici téléverser un fichier contenant une liste de tous les numéros de pièce que vous voulez commander. La liste servira à une mise à jour automatique de votre panier d’achat. Mode d’emploi : Cliquez sur <b>Télécharger un modèle de commande</b>, entrez les informations versées à votre dossier, sélectionnez votre type de commande, puis cliquez sur <b>Téléverser un modèle de commande</b>",
    "text_quote_discount_apply_calculation_error": "Une erreur interne empêche d’appliquer la remise. Veuillez réessayer.",
    "text_core_submission_wghtApx": "Poids approximatif.",
    "breadcrumb_techteam_text": "Équipe technique",
    "search_nav_categoryNav": "Magasiner par catégorie",
    "storeFinder_noResults": "No Stores Found",
    "text_pleaseSelect": "titre",
    "register_company_address_two": "Adresse 2",
    "basket_error_entrygroup_remove": "Suppression impossible du groupe d’entrée panier #{0} en raison d’une erreur.",
    "consent_form_global_error": "Un problème est survenu lors de l’enregistrement de votre consentement. Gérez votre consentement dans la page Gestion du consentement.",
    "text_volumePrices": "Prix de volume offerts",
    "text_account_warranty_search_page_totalResultsSinglePag": "{0} réclamations",
    "product_bundles": "Acheter cet article en lot",
    "order_free": "GRATUIT",
    "product_grid_confirmQtys_message": "Quitter cette page entraînera la perte des données que vous avez saisies!",
    "text_headline_myaccount": "Cliquer ici pour ouvrir une session ou accéder à votre compte",
    "text_paymentDetails": "Détails du paiementt",
    "pickup_search_button": "Trouver des magasins",
    "text_warranty_submit_part_scale": "Échelle*",
    "text_warranty_submit_part_scale_emea": "Échelle",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "Utilisez ce formulaire pour entrer votre adresse de facturation si elle diffère de votre adresse de livraison",
    "popup_cart_empty": "Vider le panier",
    "register_title": "Titre",
    "text_warranty_submit_part_requestedPartAmount": "Montant demandé, pièce*",
    "text_account_orderHistory_page_sort_byOrderType": "Order Type-Asc",
    "profile_newPassword": "Nouveau mot de passe*",
    "basket_restoration_errorMsg": "Restauration impossible de votre panier.",
    "basket_page_totals_quote_total_original": "Sous-total original :",
    "register_company_phoneNumber": "Numéro de téléphone",
    "quote_approve": "Approuver le devis",
    "checkout_error_paymentethod_formentry_sop_missing_card_expirationMonth": "Entrez un mois d’expiration",
    "checkout_orderDetails_hide": "[-] Masquer les détails de la commande",
    "search_meta_title": "Recherche",
    "text_account_order_status_display_processing": "En traitement",
    "text_addToCart_outOfStock": "Rupture de stock en lignet",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_firstName": "Entrez une valeur pour ce champ",
    "quickorder_page_ordertypes": "Type de commande",
    "storeFinder_pagination_next": "Suivant",
    "text_account_order_summary": "Récapitulatif de votre commande ci-dessous :",
    "text_warranty_terms_firetruck_home": "Voiture de pompiers",
    "checkout_multi_next": "Suivant &raquo;",
    "text_warranty_submit_labourrequested_no": "Non",
    "text_account_paymentDetails_billingAddress": "Adresse de facturation",
    "mini_cart_popup_quantity": "Quantité :",
    "text_storefinder_mobile_page_totalResults": "{0} magasins trouvés",
    "text_warranty_submit_email2": "Adresse électronique 2",
    "text_warranty_submit_email1": "Adresse électronique 1",
    "text_account_savedCart_dateSaved": "Date d’enregistrement",
    "checkout_summary_deliveryMode_noneSelected": "Aucun élément sélectionné",
    "checkout_multi_shipment_pickup_location": "Lieu d’expédition/de prélèvement",
    "checkout_page_summary_final_review_carrierSelection": "Choix de l’entreprise de transport :",
    "quote_create_error": "Erreur durant la création du devis.",
    "payment_cardType_invalid": "Sélectionnez un type de carte",
    "register_remember": "Mémoriser mes informations sur cet ordinateur",
    "search_nav_changeLocation": "Changer l’emplacement",
    "text_account_orderHistory_page_sort_byCategory": "Order Category-Asc",
    "product_share_viewMoreServices": "Afficher plus de services",
    "basket_validation_couponNotValid": "Le coupon affecté au panier n’étant plus valide, il a été retiré du panier.",
    "address_countryIso": "Pays*",
    "open_total_usd": "Total USD à définir",
    "warranty_eligibility_check_vehicle_identification_number": "Numéro d’identification de véhicule",
    "text_account_addressBook_page_sort_byDateModified": "Date de modification",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_STOR": "Choix de l’entreprise de transport (pour les envois en port dû uniquement)",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA": "Choix de l’entreprise de transport",
    "register_dataprotection_id": "protection des données-contrôle",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_email": "Cette valeur n’est pas valide pour ce champ",
    "product_average_review_rating": "Note moyenne des produits {0} / 5",
    "search_nav_facetShowLess_category": "moins de catégories...",
    "text_label_loadingmoreresults": "Chargement d’autres résultats...",
    "text_warranty_submit_final_review": "Vérification finale",
    "cart_page_customer_reference_apac": "Item Ref No.",
    "warranty_eligibility_check_bendix_part_number": "No de pièce Bendix*",
    "pdp_page_sign_in": "Se connecter",
    "text_coreClass": "Classe pièce usée",
    "pickup_pagination_next": "Suivant",
    "text_account_savedCart_id": "Jeu de pièces de rechange",
    "text_logout": "Déconnexion",
    "register_email": "Adresse électronique",
    "text_select_customerid_account": "Sélectionnez l'ID client qui sera lié à ce nouveau compte utilisateur",
    "text_warranty_submit_claim_ref_number": "No de référence client de la réclamation",
    "forgottenPwd_email_invalid": "Entrez une adresse de courriel valide",
    "text_select_cutomer_id_user_account": "Sélectionner l’ID client qui sera lié à ce nouveau compte utilisateur",
    "basket_export_cart_item_quantity": "Quantité",
    "address_postcodeJP": "Code postal précédé d’un symbole postal",
    "text_header_languageandcurrency": "Langue et devise",
    "productsalesstatus_label_apac_code40_anonymous": "Numéro du type",
    "search_mobile_no_results": "Aucun résultat trouvé",
    "product_grid_futurestock_updatefuture_availability": "Afficher disponibilité future",
    "text_account_savedCarts_ShoopingCart": "Panier d’achat enregistré",
    "text_account_profile_myProfile": "Mon profil",
    "text_quote_cancel_success": "Devis {0} annulé",
    "review_back": "Retour à Avis",
    "text_account_orderHistory_page_sort_byDate": "Date",
    "text_warranty_eligibility_part_number_error": "Please enter a valid Bendix Part Number",
    "aria_pickupinstore_loading": "Chargement... Veuillez patienter...",
    "text_account_order_placedBy": "Passée par : {0}",
    "basket_restoration_restorationError": "Restauration impossible de votre panier.",
    "product_start_bundle": "Commencer le lot",
    "text_account_orderHistory_orderNumber": "Numéro de commande",
    "register_title_invalid": "Sélectionnez un titre",
    "text_cust_part_no": "No de pièce client",
    "register_company_name_invalid": "Entrez le nom de l’entreprise",
    "text_account_closeAccount_button": "Fermer le compte",
    "text_warranty_search_reset": "Réinitialiser",
    "checkout_pickup_pickup_in_store": "Prendre en magasin – {0}, {1}",
    "profile_newPassword_invalid": "Entrez votre nouveau mot de passe",
    "profile_pwd": "Mot de passe",
    "register_company_faxNumber_invalid": "Entrez le numéro de télécopieur de l’entrepriset",
    "text_add_row_button": "Add Row",
    "profile_email_invalid": "Entrez une adresse de courriel valide",
    "import_csv_savedCart_requestedDate": "Date de livraison demandée (format MM/JJ/AAAA)",
    "profile_title": "Titre",
    "checkout_multi_cancel": "Annuler",
    "header_link_logout": "Se déconnecter",
    "checkout_multi_inStore": "En magasin",
    "basket_page_title": "Article",
    "address_line1": "Adresse*",
    "checkout_multi_deliveryMethod_notprovided": "Vous devez fournir une adresse de livraison avant de passer à l’étape suivante.",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_shippingMethod": "Entrez une valeur pour ce champ",
    "text_button_menu": "Menu",
    "text_quote_expiration_time_warning": "Remarque : Si la date d’expiration est définie sur aujourd’hui ou plus tôt, elle sera fixée à {0} jours à partir d’aujourd’hui",
    "address_line2": "Adresse Ligne 2",
    "only_bendix_personel": "Droits – personnel Bendix seulement",
    "text_htcCode": "Code HTSt",
    "warranty_eligibility_check_date_in_service": "Date en service",
    "text_account_addressBook_addressDetails": "Détails de l’adresse",
    "checkout_summary_deliveryAddress_noneSelected": "Aucun élément sélectionné",
    "text_button_showall": "Afficher tout",
    "text_account_addressBook_confirmationUpdated": "Votre adresse a été mise à jour",
    "review_alias": "Votre nom",
    "test_account_core_reportsinfoEMEA": "If you cannot get a particular core report, please contact your",
    "popup_cart_showing": "Affichage {0} sur {1} articles",
    "text_warranty_claim_information": "Réclamations Information",
    "text_account_savedCart_name": "Nom",
    "register_termsOfUsage_message": "Conditions d’utilisation de la boutique en ligne",
    "text_account_quote_status_display_BUYER_ORDERED": "Commandé",
    "basket_page_cartId": "ID panier :",
    "search_nav_facetShowLess_typenumber": "moins ..",
    "register_customer_regisration": "INSCRIPTION CLIENT",
    "text_checkout": "Caisset",
    "mycompany_set_right": "Définir les droits de l’utilisateu",
    "product_overview": "Détails",
    "mobile_checkout_multi_button_submit": "Envoyer",
    "product_volumePrices_column_price": "Prix unitaire",
    "text_warranty_search_from_date_to_date_invalid": "Claim Date From can't be greater than Claim Date To.",
    "text_account_profile_resetPassword": "Réinitialiser le mot de passe",
    "review_show_less": "Afficher moins",
    "checkout_pickup_no_delivery_required": "Aucune livraison requise pour cette commande",
    "pagination_items": "article(s)",
    "breadcrumb_quickOrder": "Commande rapide",
    "checkout_summary_deliveryAddress_editDeliveryAddressButton": "Modifier l’adresse de livraison",
    "register_company_phoneNumber_invalid": "Entrez le numéro de téléphone de l’entrepriset",
    "header_changecustomer_id": "Changer numéro de client",
    "search_spellingSuggestion_prompt": "Vouliez-vous dire :",
    "text_account_savedCart_message": "Les promotions et les totaux sont ceux qui existaient au moment de l’enregistrement du panier. Les promotions et les totaux peuvent changer ou ne plus s’appliquer une fois le panier restauré.",
    "text_account_profile_cancel": "Annuler",
    "text_warranty_submit_requested_cost": "Demandé Coûts Remboursement",
    "click_export_download": "Cliquez sur « Exporter » pour télécharger les données dans un fichier Excel.",
    "basket_confirmation_items_added": "Vos articles enregistrés ont été ajoutés à votre panier.",
    "text_warranty_search_search": "Recherche",
    "checkout_multi_hostedOrderPageError_ERROR_150": "Défaillance générale du système. Mesure possible : Patientez quelques minutes, puis renvoyez la commande.",
    "pickup_product_availability": "Disponibilité des produits par emplacement de magasin",
    "text_account_yourAccount": "Mon compte",
    "basket_page_cartIdShort": "ID :",
    "review_rating_invalid": "Donnez une note",
    "text_account_order_orderNumberShort": "Commande no : {0}",
    "text_warranty_search_claim_from_date": "Réclamation, date de début",
    "text_quickOrder_product_quantity_max": "Quantité réduite en raison de l’insuffisance du stock",
    "checkout_multi_hostedOrderPageError_ERROR_151": "La demande a été reçue, mais un arrêt serveur s’est produit. Mesure possible : Pour éviter une duplication, joignez notre équipe des ventes avant de renvoyer la demande.",
    "text_account_warranty_search_page_linkNextPage": "Page suivante",
    "checkout_multi_hostedOrderPageError_ERROR_152": "La demande a été reçue, mais l’exécution d’un service n’a pas pris fin à temps. Mesure possible : Pour éviter une duplication, joignez notre équipe des ventes avant de renvoyer la demande.",
    "search_meta_description_results": "Résultats de la recherche pour",
    "profile_title_invalid": "Sélectionnez un titre",
    "text_generalInfo_coreInformation": "Information pièce usée",
    "order_history_status_date": "Date d’état :",
    "address_townJP": "Ville, village, quartier urbain",
    "checkout_summary_paymentMethod_securityCode_whatIsThis_description": "Les 3 derniers chiffres sur la bande signature au dos de la carte. American Express : les 4 chiffres juste au-dessus de l’hologramme au recto de la carte.",
    "text_account_order_status_display_created": "Créée",
    "product_product_spec": "Téléchargements",
    "text_account_quotes_noQuotes": "Aucun devis",
    "checkout_page_replaced": "Remplacée",
    "paymentMethod_paymentDetails_expires": "Expire {0} / {1}",
    "text_core_submit_coreGroup": "Groupe pièce uséet",
    "product_grid_outOfStock": "Rupture de stock",
    "text_materialType": "Type de matériautt",
    "storeDetails_table_email": "Email",
    "basket_export_cart_item_sku": "UGS",
    "text_pagenotfound_or": "ou",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_phoneNumber": "Cette valeur n’est pas valide pour ce champ",
    "text_warranty_submit_enter_product_code": "Please enter product code",
    "cart_product_deletetext": "Do you want to delete the selected item?",
    "text_weight_approx": "Weight approx. [kg]",
    "basket_page_totals_quote_total_after_discount": "Nouveau sous-total :",
    "pickup_out_of_stock": "RUPTURE DE STOCK",
    "general_unknown_identifier": "Un identificateur inconnu a été passé",
    "text_account_addressBook_page_showAllResults": "Afficher tout",
    "text_core_submit_address_address": "Adresse*",
    "text_quantity": "Quantitét",
    "general_continue_button": "Continuer",
    "quote_approve_error": "Erreur durant l’approbation du devis.",
    "text_account_warranty_search_page_showPageResults": "Afficher paginé",
    "product_grid_future_tooltip_qty": "QTÉ",
    "text_account_savedcart_restore_btn": "Restaurer",
    "text_account_savedcart_cart_id": "Jeu de pièces de rechange",
    "search_nav_facetShowMore": "Afficher plus",
    "basket_validation_configurationError": "{0} a une configuration erronée qui doit être corrigée avant de passer à la caisse.",
    "storelocator_search_results_go": "Aller",
    "text_headline_homebanner": "Bannière supérieure",
    "account_confirmation_address_updated": "Adresse mise à jour avec succès",
    "text_cutoff_orderconfirmation_timezone_EMEA": "Cut-off time: {0} must be placed by {1} {2}",
    "text_quote_discount_modal_title": "Remise {0}",
    "text_warranty_terms_transit_bus": "Autobus urbain",
    "text_account_savedCart_position": "Positions",
    "checkout_multi_items_to_pickup": "Passer prendre :",
    "pickup_pagination_from": "from&nbsp;",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard": "Utiliser une carte enregistrée",
    "text_account_savedcart_retain_savedcart": "Conserver une copie de ce panier dans une liste enregistrée",
    "cart_page_ordertypes": "Type de commande",
    "text_warranty_terms_highway_off": "Utilisations hors routeÂ :",
    "text_account_quote_page_sort_byName": "Nom",
    "text_account_warranty_search_page_totalResults": "sur {0} réclamations",
    "text_warranty_submit_part_labour_requested": "Main-d’œuvre requise**",
    "login_title": "Client régulier",
    "coupon_general_error": "Échec de l’utilisation du coupon.",
    "checkout_login_loginAndCheckout": "Connexion à votre compte",
    "text_account_orderHistory_mobile_page_currentResults": "{0} – {1} sur {2} commandes",
    "basket_your_shopping_basket": "Votre panier d’achat",
    "review_submitted_by": "Envoyé par",
    "register_company_address_zip": "Code postal*",
    "guest_confirm_email": "Téléchargements",
    "checkout_orderDetails_show": "[+] Afficher les détails de la commande",
    "text_account_warranty_table_header_ref_number": "Customer Warranty Claim Reference No.",
    "text_headertext_conf": "Confirmer",
    "cart_groups_remove": "supprimer",
    "checkout_multi_deliveryMethod": "OPTIONS LIVRAISON",
    "popup_cart_customer_price": "Tarif client",
    "search_nav_facetShowMore_brand": "plus de marques...",
    "review_write_review": "Écrire avis",
    "product_grid_futurestock_refresh": "Futur, mettre à jour",
    "checkout_orderConfirmation_summary": "Récapitulatif de votre commande ci-dessous :",
    "text_account_saveCart_edit_success": "Mise à jour réussie du panier {0}",
    "checkout_page_show_all_position_text": "Show / Hide sub items",
    "cart_page_total": "Total",
    "header_link_account": "Mon compte",
    "text_account_savedCart_total": "Total",
    "text_account_addressBook_addAddress": "Ajouter adresse",
    "text_skipToNavigation": "Passer au menu de navigationt",
    "checkout_summary_deliveryMode_items_for_pickup": "{0} articles à prendre en magasin",
    "guest_pwd": "Mot de passe",
    "core_report_date": "Mois, année",
    "basket_add_free_gift": "Ajouter votre cadeau gratuit au panier",
    "checkout_pages_availabilty_final_review": "SUIVANT",
    "price_select_all": "Sélectionner tout",
    "text_warranty_submit_part_hourlyLabourRate": "Taux horaire de main-d’œuvre",
    "mobile_payment_issueNumber": "Numéro d’émission (Maestro / Solo / Switch seulement)",
    "address_shipping_page_form": "Adresse municipale*",
    "text_account_warranty_search_empty": "Réclamation sous garantie introuvable Modifier vos critères de recherche, puis réessayer.",
    "paymentMethod_header": "Détails du paiement",
    "address_townCity": "Ville",
    "search_nav_refine_button": "Affiner",
    "text_account_profile_updatePersonalDetails": "Détails personnels",
    "checkout_summary_paymentMethod_addPaymentDetails_billingAddress": "Adresse de facturation",
    "text_core_search_kbpart": "No de pièce Knorr-Bremse",
    "search_nav_facetShowMore_stores": "Afficher plus de magasins",
    "download_must_agree_text": "You must agree to our",
    "product_view_details": "Afficher les détails",
    "text_account_order_total": "Total",
    "payment_cardNumber_invalid": "Entrez un numéro de carte valide",
    "general_month_july": "Juillet",
    "product_grid_selectSize": "Sélectionner",
    "text_headline_description": "Désignationt",
    "quote_reject": "Refuser le devis",
    "import_csv_savedCart_chooseFile": "Choisir un fichier",
    "text_core_submission_NA_text1": "Merci d'avoir soumis votre demande de retour de base. Veuillez vérifier votre boîte de réception pour obtenir une copie du formulaire de retour de base soumis.",
    "text_core_submission_NA_text2": "Rappel:",
    "text_core_submission_NA_text2a": "Si votre envoi dépasse 500 lb ou 100 mâchoires de frein, un connaissement sera disponible",
    "text_account_saved_cart_detail_net_price": "Prix net",
    "text_core_submission_NA_text3": "Si votre colis excède 230 kg, cliquez sur le lien suivant pour demander une prise en charge <br> Si le poids de votre colis est inférieur à 230 kg ou à 100 segments de frein, envoyez-le PRÉPAYÉ. Cliquez sur le lien suivant pour de plus amples renseignements",
    "search_nav_appliedFilters": "Supprimer",
    "checkout_multi_payment": "Paiement :",
    "text_account_gereral_rights": "Droits généraux",
    "checkout_multi_deliveryAddress_selectSuggestedAddress": "Vérifiez votre adresse.<br>Nous vous suggérons d’accepter l’un des changements suivants de votre adresse :",
    "checkout_multi_secure_checkout": "VALIDATION SÉCURISÉE",
    "checkout_checkout": "Aller au panier",
    "checkout_multi_hostedOrderPostPage_button_submit": "Envoyer",
    "general_month_june": "Juin",
    "text_account_addressBook_manageYourAddresses": "Gérer votre carnet d’adresses",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_postalCode": "Cette valeur n’est pas valide pour ce champ",
    "product_detail_quantity": "Qté",
    "text_status": "Étattt",
    "checkout_multi_deliveryMethod_edit": "Modifier",
    "text_generalInfo_packagingInformation": "Information conditionnement",
    "text_headline_profile": "Cliquer ici pour afficher votre profil, le carnet d’adresses, les détails de paiement et l’historique des commandes.",
    "storeFinder_search": "Recherche",
    "text_quickOrder_delete_checkboxes": "Tout supprimer",
    "text_account_orderHistory_page_sort_byCategoryDesc": "Order Category-Desc",
    "open_order_category": "Order Category",
    "basket_added_to_mobile_basket": "Article ajouté",
    "product_share_sendToFacebook": "Envoyer à Facebook",
    "order_form": "Formulaire de commande",
    "text_account_savedCart_edit_title": "Modifier le panier enregistré",
    "basket_page_totals_estimatedtotal": "Total estimatif :",
    "text_warranty_terms_motor_home": "Autocaravane",
    "basket_page_deliveryQty": "Delivery Qty",
    "general_month_april": "Avril",
    "text_iam_for": "Numéro(s) de pièce IAM pour",
    "text_quote_edit_warning_message": "Voulez-vous vraiment modifier ce devis approuvé?",
    "checkout_multi_hostedOrderPostPage_header_debug": "Cette page montre tous les champs API de la page de paiement hébergé (HOP) qui seront envoyés à l’URL HOP.  Elle permet de déboguer la HOP par modification des valeurs pour simuler le comportement souhaité.",
    "text_quote_conteroffer_confirmation_message": "Voulez-vous vraiment offrir ce devis fournisseur?",
    "quote_state_BUYER_DRAFT": "BROUILLON",
    "text_account_addressBook_page_totalResults": "{0} Address(s) Found",
    "address_province_invalid": "Entrez une province",
    "text_warranty_submit_part_datecode": "Date Code.",
    "text_headline_orderitems": "Tous les renseignements concernant vos articles de commande",
    "form_global_already_registered": "L’adresse électronique saisie est déjà enregistrée avec un compte existant.",
    "homepage_proeuct_categories": "Catégories de produits",
    "search_page_nearbyStores": "Votre recherche portait sur des magasins proches",
    "text_account_addressBook_page_linkPreviousPage": "Page précédente",
    "text_shippingMethod": "Méthode d’expéditiont",
    "basket_page_totals_estimatedZip": "Code postal :",
    "text_account_saved_cart_detail_core_charges": "Frais de base",
    "order_form_currency": "$",
    "basket_page_price": "Prix",
    "basket_export_user_fax": "Fax",
    "storelocator_search_totalResults": "Affichage {0} magasins les plus proches",
    "checkout_multi_deliveryMethod_header": "Options livraison",
    "text_unitOfMeasure": "Unitét",
    "text_marketType": "Typet",
    "text_market": "Marché",
    "text_account_open_position": "Positions en cours",
    "checkout_estimateDeliveryDate_empty": "à définir",
    "text_generalInfo_countryOrigin": "Pays d’origine",
    "text_user_table_delete_user_account": "Supprimer le compte",
    "text_account_orderHistory_total": "Total",
    "text_add_button": "AJOUTER",
    "product_variants_size": "Taille",
    "text_account_quote_duplicate": "Dupliquer",
    "text_account_addressBook": "Carnet d’adresses",
    "text_account_quote_page_linkPreviousPage": "Page précédente",
    "text_warranty_search_from_date_invalid_future": "Claim Date From can't be in future date.",
    "cart_groups_edit": "modifier",
    "label_emea_nextday": "Demain avant midi",
    "checkout_multi_hostedOrderPageError_globalError": "Échec de création de l’abonnement.  Voir les détails de l’erreur ci-dessous.",
    "text_headline_coreAttributes": "Pièce uséet",
    "size_of_freight": "Size of Freight",
    "text_account_quote_page_totalResultsSingleOrder": "1 devis trouvé",
    "text_warranty_eligibility_mileage_km_error": "Mileage can't be more than 9999999 kilometers",
    "product_variants_colour": "Couleur",
    "text_account_paymentDetails_setDefaultPaymentDetails": "Définir les détails de paiement par défaut",
    "checkout_summary_paymentMethod_editPaymentMethod": "Modifier le mode de paiement",
    "checkout_multi_deliveryMethod_continue": "Suivant",
    "register_webshop_accept_invalid": "Vous devez accepter les conditions d’utilisation de la boutique en ligne",
    "text_warranty_terms_refuse_hauler": "Remorque Ã  ordures",
    "checkout_multi_deliveryMethod_stepHeader_done": "2 – Méthode de livraison",
    "checkout_summary_deliveryMode_selectDeliveryMethod": "Sélectionner une méthode de livraison",
    "checkout_multi_paymentDetails_notprovided": "Vous devez remplir un « détails de paiement » avant de passer à l’étape suivante.",
    "storeFinder_table_distance": "Distance",
    "product_price_from": "De {0}",
    "basket_page_delivery": "Livraison",
    "checkout_page_summary_final_review_billing_address": "Adresse de facturation",
    "storeFinder_postcode_town": "Code postal / Ville",
    "search_page_showPageResults": "Afficher paginé",
    "text_warranty_submit_part_repairTime": "Durée de la réparation (en h)",
    "text_core_submit_date": "Date",
    "text_search_icon_coreGroup": "Recherche Contreparties",
    "text_add_to_core_form": "Ajouter au formulaire contreparties",
    "general_delete_all_button": "Supprimer",
    "button_label_viewcart": "Voir le panier",
    "checkout_page_summary_final_review_delivery_type": "Type de livraison :",
    "text_warranty_terms_other_vehicle": "Autres Véhicules Ã  utilisation non classique",
    "basket_page_item": "d’article (numéro de modèle)",
    "text_account_closeAccount_popup_action": "Fermer mon compte",
    "review_no_reviews": "Soyez le premier à écrire un avis.",
    "label_emea_forwarder": "Stock",
    "text_core_rights_label": "Droits – cores",
    "open_total_usd_APAC": "Total USD en cours",
    "text_account_savedCarts_page_sort_byCode": "Jeu de pièces de rechange",
    "search_nav_facetShowMore_collection": "plus de collections...",
    "checkout_pickup_items_to_pickup": "{0} article(s) à prendre",
    "product_grid_formDescription": "Sélectionner les articles ci-dessous et ajouter au panier",
    "basket_page_message_update_pickupinstoreitem": "L’article à prendre en magasin a été mis à jour.",
    "basket_information_merge_successful": "Le panier enregistré sous votre compte utilisateur et votre panier actuel ont été fusionnés. Cliquez ici pour visiter votre panier.",
    "register_dataprotection_accept": "J’accepte lest",
    "basket_page_totals_subtotal": "Sous-total:",
    "order_totals_delivery": "Livraison :",
    "text_generalInfo_coreGroup": "Groupe pièce usée",
    "address_room_invalid": "Entrez un numéro de bureau",
    "text_warranty_terms_yard_truck": "Tracteur de manÅuvre",
    "text_account_consent_consentManagement_general_text": "En vue de personnaliser votre expérience, nous avons besoin de votre consentement pour recevoir vos données de profil :",
    "checkout_multi_addressDetails": "Détails de l’adresse",
    "cart_count": "{0}t",
    "partsAvailable": "La commande ne sera expédiée que si toutes les pièces sont disponibles",
    "storeFinder_table_address": "Adresse",
    "address_default": "Choisir cette adresse par défaut",
    "address_regionIso": "État/Province*",
    "search_mobile_page_totalResults": "{0} article(s)",
    "save_page_continue": "Panier enregistré",
    "text_account_orderHistory_page_sort_byTypeNo": "Type No-Asc",
    "text_account_order_status_display_cancelled": "Annulée",
    "checkout_login_registerAndCheckout": "S’inscrire et commander",
    "pickup_results_button": "Passer prendre",
    "basket_export_user_customerID": "Numéro de client",
    "core_report_format": "Format de fichier",
    "checkout_orderConfirmation_orderNumber": "Votre numéro de commande est {0}",
    "storeFinder_pagination_stores": "magasins trouvés",
    "checkout_multi_pickupInStore": "Prendre en magasin",
    "text_account_savedCarts_page_linkPreviousPage": "Page précédente",
    "text_account_quote_date_placed": "Date comm. passée",
    "text_account_profile": "Profil",
    "text_account_addressBook_addEditAddress": "Ajouter/Modifier adresse",
    "pagination_or": "ou",
    "text_account_core_search_showPageResults": "Afficher paginé",
    "text_warranty_name": "Nom",
    "text_header_language": "Cliquer ici pour changer la langue",
    "text_quickOrder_page_part_no": "No de pièce",
    "text_consent_agree": "et j’accepte la collecte et le traitement des données personnelles que je fournis pour télécharger un document",
    "review_based_on_one": "Selon {0} avis",
    "import_csv_savedCart_fileConstraint": "Taille max. du fichier :",
    "text_quote_not_submitable": "Envoi du devis impossible (le total est négatif)",
    "text_address": "Adresse",
    "text_additional_info": "Addtional information:",
    "text_quickorder_limit_character": "Max. 35 characters, no more input!",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_phoneNumber": "Cette valeur n’est pas valide pour ce champ",
    "product_variants_type": "Téléchargements",
    "collection_address_provided": "If different from above, please add personal contact details applicable for the collection address:",
    "register_dataprotection_accept_invalid": "Vous devez accepter la Protection des données",
    "review_submitted_anonymous": "Anonyme",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_phoneNumber": "Entrez une valeur pour ce champ",
    "register_company_soldto": "Compte principal siège social",
    "text_quick_order_reset_form": "Réinitialiser le formulaire",
    "product_close": "Fermer",
    "text_account_warranty_table_header_date": "Date de demande",
    "text_account_warranty_search_page_sort_byDate": "Date",
    "search_page_product_document": "Documents",
    "text_warranty_terms_line_haul": "Tracteur et remorque de ligne",
    "basket_page_min_order_NA": "Supplément Commande min./urgente:",
    "header_link_selectSalesarea": "Sélectionnez le secteur de ventes",
    "text_warranty_search_to_date_invalid_future": "Claim Date To can't be in future date.",
    "register_webshop": "boutique en ligne",
    "order_history_min_order": "Supplément Commande min./urgente:",
    "search_nav_facetShowLess_nameForFacet": "moins ..",
    "account_error_account_exists_with_email_address_subtitle": "Veuillez choisir une autre adresse électronique.",
    "text_quote_description_not_applicable": "S.O.",
    "register_webshop_accept": "J’accepte les",
    "product_product_document": "Documents",
    "text_submit_review_carefully": "Veuillez examiner attentivement toutes vos entrées avant de soumettre votre formulaire en ligne. Vous ne pouvez pas modifier votre formulaire une fois qu'il a été soumis.",
    "quote_save_error": "Erreur durant l’enregistrement du devis.",
    "core_error_submission_emea": "You do not have permission, please <a href",
    "text_account_savedCarts_page_sort_byTotal": "Total",
    "general_required": "Obligatoire",
    "category_navTitle": "Magasiner par catégorie",
    "search_mobile_page_linkPreviousPage": "&laquo; Précédent",
    "basket_error_checkout_empty_cart": "Vous ne pouvez pas passer à la caisse avec un panier vide.",
    "text_account_paymentDetails_delete_following": "Le mode de paiement suivant sera supprimé",
    "checkout_summary_paymentMethod_paymentDetails_noneSelected": "Aucun élément sélectionné",
    "text_core_submit_month": "Mois de retour",
    "import_csv_savedCart_importCondition": "*Le type de commande doit être sélectionné avant de pouvoir téléverser le fichier. Le format de fichier doit être CSV, sa taille max (10 ko).",
    "text_storefinder_responsive_page_sortTitle": "Ordre de tri :",
    "text_quote_discount_by_amount": "Remise par montant",
    "cart_checkout_error": "Erreur de passage en caisse.",
    "download_the_document_text": "before you can download the document.",
    "basket_page_productdetails": "Détails produit",
    "payment_cardNumber": "Numéro de carte",
    "popup_cart_showall": "Afficher tout",
    "text_account_addressBook_back_btn": "Retour",
    "test_account_core_reportsinfoNA": "Veuillez nous joindre à Cores@Bendix.com si vous avez des questions sur les rapports de cores",
    "profile_checkPwd_invalid": "Confirmez votre mot de passe",
    "basket_export_user_zipCode": "Code postal / Zip",
    "text_core_submission_package": "Type de paquet",
    "quote_reject_initiate_request": "Minimum {0} sous-total pour envoyer un devis.",
    "payment_cardType_pleaseSelect": "Sélectionnez un type de carte",
    "search_nav_facetShowMore_availableInStores": "plus de magasins...",
    "login_login": "Connexion à votre compte",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddressDiffersFromDeliveryAddress": "Utilisez ce formulaire pour entrer votre adresse de facturation si elle diffère de votre adresse de livraison",
    "basket_export_user_phone": "Téléphone",
    "text_account_order_netTax": "Taxe :",
    "text_header_storefinder": "Points de vente",
    "checkout_pages_change_billing_address": "Changer l’adresse de facturation",
    "text_warranty_please_upload_all": "Veuillez télécharger tous les documents nécessaires au traitement de votre formulaire de demande de retour.",
    "import_csv_savedCart_enterContentNote": ", entrez les informations versées à votre dossier, puis cliquez sur",
    "mobile_search_add_refinements": "Affiner",
    "text_account_order_shipping": "Coûts d’expédition :",
    "text_account_quote_status_display_SELLER_DRAFT": "Brouillon",
    "text_paymentMethod": "Mode de paiementt",
    "text_account_quote_page_totalResults": "sur {0} devis",
    "j_password": "Mot de passe",
    "register_company_website_invalid": "Entrez l’adresse du site Web de l’entrepriset",
    "mobile_checkout_paymentMethod": "Détails du paiement",
    "basket_error_quantity_invalid_binding": "Quantité non valide : donnez un chiffre valide pour ajouter ce produit à votre panier.",
    "text_account_core_search_lastPage": "&raquo;",
    "text_warranty_submit_duplicate_parts_error": "Please remove duplicate Part Number and submit again.",
    "basket_save_cart_action_cancel": "Annuler",
    "cart_page_reqdeliveryApac": "Req Departure Date",
    "text_account_quote_page_firstPage": "&laquo;",
    "breadcrumb_login": "Ouverture de session",
    "order_product_seeDetails": "Afficher les détails",
    "text_account_order_placedByText": "Passée par : Membre de l’équipe du service à la clientèle",
    "general_month_october": "Octobre",
    "basket_view_basket": "Voir le panier",
    "text_storefinder_desktop_page_sort_byName": "Par nom",
    "text_setDefault": "Définir par défautt",
    "checkout_summary_shippingAddress": "Adresse d’expédition",
    "text_warranty_submit_replacement_type": "Type de remplacement",
    "register_company_address_street": "Adresse avec numéro municipal*",
    "text_warranty_terms_shuttle_bus": "Navette ou autocar affrété",
    "order_history_reorder_button": "Re-Commander",
    "basket_export_user_warranty": "Garantie",
    "text_account_kbOrderNumber": "Numéro de commande Knorr Bremse",
    "cart_view": "VOIR LE PANIERtt",
    "popup_cart_quantity": "Quantité",
    "review_general_error": "Remplissez tous les champs d’avis obligatoires.",
    "text_storefinder_responsive_page_showPageResults": "Afficher paginé",
    "text_pagenotfound_error": "Désolé, la page que vous recherchiez est introuvable.",
    "text_button_accept": "Accepter",
    "text_account_addressBook_page_linkNextPage": "Page suivante",
    "text_account_order_savings": "Économies de commande :",
    "text_core_address": "Collection Address",
    "text_quote_discount_apply_argument_invalid_error": "L’entrée de remise n’est pas valide. Veuillez réessayer.",
    "basket_page_per_pc": "(par pc)",
    "text_address_delete": "Supprimer",
    "core_report_parent": "Parent des Cores",
    "text_quickOrder_product_not_found": "Produit introuvable",
    "text_voucher_release_error": "Erreur lors de la suppression de la pièce justificative {0}",
    "basket_save_cart_info_msg": "Votre panier passera à la liste Panier enregistré.",
    "text_nocategory_found_message": "Aucune catégorie trouvée",
    "text_account_orderHistory_page_sort_byTypeDesc": "Type No-Desc",
    "basket_page_error_remove": "Product was already removed from your cart.",
    "basket_page_viewFuture_unavailable": "Le système de stock futur est occupé, veuillez réessayer plus tard.",
    "basket_page_totals_delivery": "Livraison :",
    "login_register": "S’inscrire",
    "text_account_orderHistory_page_sort_byOpenQty": "Open Qty-Asc",
    "text_quickOrder_page_emea_apac_part_no": "Knorr-Bremse de la pièce retournée* / Client de la pièce retournée",
    "address_province": "Province",
    "guest_required_message": "Les champs marqués * sont obligatoires",
    "address_phone_invalid": "Numéro de téléphone inexact",
    "basket_page_shipping_change_store": "Changer de magasin",
    "pdp_page_quantity": "Qté",
    "text_storefinder_responsive_page_sort_byName": "Par nom",
    "text_core_taillift": "Taillift Required?*",
    "checkout_page_summary_change_shipping_address": "Changer l’adresse d’expédition",
    "static_category_sidenavigation_empty": "Aucune sous-catégorie trouvée pour \"{0}\"",
    "text_account_paymentDetails_noPaymentInformation": "Aucun détail de paiement enregistré",
    "text_warranty_vehicle_manufacter": "Vehicle Manufacturer",
    "checkout_orderConfirmation_title": "Confirmation de commande",
    "review_number_of": "de",
    "compare_product_note_footer_compare_block": "Comparer",
    "compare_product_note_footer": "Vous pouvez comparer jusqu'à 4 références",
    "compare_product_note_footer_clear_all": "Tout effacer",
    "compare_product_note_footer_compare": "Comparer",
    "compare_product_note_checkbox": "Comparer",
    "text_compare_products": "Comparer les produits",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_country": "Cette valeur n’est pas valide pour ce champ",
    "basket_page_totals_savings": "Économies",
    "checkout_multi_breadcrumb": "Caisse",
    "address_subarea": "Sous-secteur",
    "text_back_to_result_button": "Retour au résultat",
    "basket_page_deliveryDateApac": "Requested Departure Date",
    "document_download_kb_text": "Download a Knorr-Bremse document",
    "text_warranty_same_email_invalid": "Email 1 & 2 cannot be same",
    "sold_to_popup_text_two": "Nous joindre",
    "order_product": "Produit",
    "text_warranty_submit_part_serialno": "Serial No.",
    "quick_order_customer_reference": "Customer Item Ref. No.",
    "product_product_typenumber": "Numéro du type",
    "user_locked_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "user_error_account_invalid_doubleOpt_msg": "Veuillez confirmer votre inscription dans l'e-mail avec le lien de confirmation. Ce n'est qu'alors que votre inscription pourra être traitée et vous recevrez un e-mail contenant des informations complémentaires.",
    "order_totals_total": "Total :",
    "text_warranty_rights_label": "Droits de garantie",
    "checkout_multi_deliveryAddress_address": "Adresse",
    "product_image_zoom_out": "Zoom arrière",
    "register_company_faxNumber": "Numéro de télécopieur",
    "register_checkbox_ordering_label": "Commande en ligne",
    "text_account_order_receivedPromotions": "Promotions reçues",
    "quote_edit_done": "Nouveau panier",
    "text_deliveryAddress": "Adresse de livraisontt",
    "basket_page_min_order_qty": "QTÉ, commande min.",
    "address_companyAddress_shipping_page_form_emea": "Adresse 2",
    "text_core_submission_upgradegrp": "Rattrapage, groupe pièces usées",
    "address_country": "Pays/Région",
    "quote_submit": "Envoyer le devis",
    "text_generalInfo_coreClass": "Classe pièce usée",
    "text_quickOrder_page_na_part_no": "Bendix de la pièce retournée* / Client de la pièce retournée",
    "text_quickOrder_page_qty": "Qté",
    "text_account_quote_page_showAllResults": "Afficher tout",
    "register_company_countryState_invalid": "Sélectionnez l’État/la province*",
    "basket_potential_promotions": "Promotions possibles",
    "text_consent_button_decline": "Refuser",
    "product_share_email": "Courriel",
    "text_account_consent_withdrawn": "Consentement refusé",
    "text_account_quote_action_display_SAVE": "Enregistrer le devis",
    "basket_export_user_email": "Email",
    "popup_cart_core_charges": "Frais de base",
    "basket_validation_unavailable": "Désolé, {0} a été retiré de votre panier car il n’est plus offert.",
    "checkout_multi_paymentMethod_savedCards_paymentCard": "Carte de paiement",
    "text_core_submit_coreClass": "Classe pièce usée",
    "text_account_configuration_display": "Afficher la configuration",
    "address_companyName": "Nom de l’entreprise*",
    "quote_accept_error": "Erreur durant l’acceptation du devis",
    "order_date_to": "Date de commande à*",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_state": "Cette valeur n’est pas valide pour ce champ",
    "basket_text_shippingcost": "Coûts d’expédition",
    "text_submit_warranty_error": "Erreur dans la demande de garantie Soumettre. Veuillez réessayer ou contacter le service client.",
    "text_account_orderHistory_page_sort_byPartNo": "Part No-Asc",
    "text_account_warranty_search_page_showAllResults": "Afficher tout",
    "text_account_warranty_search_page_sort_byOrderNumber": "Warranty Claim Number",
    "text_account_addressBook_page_sort_byDateSaved": "Date d’enregistrement",
    "breadcrumb_home": "Accueil",
    "storeFinder_use_this_form": "Utiliser ce formulaire pour rechercher un magasin",
    "text_core_search_or": "OR",
    "register_accept_message": "Accepter",
    "text_account_orderHistory_page_sort_byTotalDesc": "Total-Desc",
    "search_nav_refinements": "Mises au point",
    "payment_expiryMonth_invalid": "Sélectionnez le mois d’expiration de la carte",
    "text_account_addressBook_updateAddress": "Mettre à jour l’adresse",
    "file_size_kilobytes": "{0} ko",
    "checkout_multi_deliveryAddress_continue": "Obtenir la disponibilité et Révision finale",
    "product_grid_subtotalText": "Sous-total",
    "basket_added_to_basket_pdp": "Ajouter au panier",
    "account_confirmation_default_address_changed": "Votre adresse par défaut a été mise à jour.",
    "checkout_security_code": "Code de sécurité",
    "text_core_submit_crm_invalid": "Obligatoire",
    "guest_email": "Adresse électronique",
    "storefinder_location_disabled": "Please enable location services from browser",
    "order_history_customer_po_number": "Numéro de commande :",
    "product_grid_editSize": "Modifier",
    "basket_pickup_product_variant": "{0} : {1}",
    "checkout_multi_saveAddress": "Enregistrer l’adresse",
    "text_warranty_submit_product_not_unique": "Product Not Unique",
    "basket_page_number": "No",
    "product_product_details_future_nostock": "Aucune information sur la disponibilité future de ce produit.",
    "text_header_loginandaccount": "Connexion et compte",
    "text_warranty_email_one_invalid": "Please correct email id",
    "checkout_error_paymentethod_formentry_sop_missing_card_cardType": "Sélectionnez un type de carte",
    "checkout_summary_deliveryAddress": "Adresse de livraison",
    "text_viewfullsite": "Afficher le site complet",
    "mycompany_legend": "Légende",
    "address_title": "Titre",
    "mobile_search_nav_clearSelections": "Effacer toutes les sélections",
    "register_title_emea": "Titre*",
    "category_na_meta_description": "Bendix ABS, ATC, Actuators, Air Disc Brakes, Air Treatment, Compressors, Drum Brakes, Steering Gears, Valves, and Formula Blue Hydraulic Brakes",
    "register_checkbox_inversexref_label": "Inverse search KB to Xref",
    "checkout_multi_deliveryAddress_selectSuggestedAddress_sumbitAsIs": "Envoyer tel quel",
    "review_reviews": "Avis",
    "text_account_orderHistory_page_firstPage": "&laquo;",
    "text_account_savedCarts_page_sort_byDateSaved": "Date d’enregistrement",
    "text_account_profile_updateForm": "Utilisez ce formulaire pour actualiser vos détails personnels",
    "checkout_error_tax_missing": "Désolé, votre transaction ne peut être terminée en ce moment; veuillez réessayer plus tard ou joindre notre service à la clientèle au 555 555-5555",
    "password_strength_tooshortpwd": "Trop court",
    "cart_expresscheckout_checkbox": "Je souhaite une Caisse rapidet",
    "text_account_orderHistory_page_showPageResults": "Afficher paginé",
    "product_grid_yourPrice": "Votre tarif",
    "checkout_orderConfirmation_Shipping_Address": "Adresse d’expédition :",
    "text_core_submission_crmno": "CRM Number",
    "basket_page_quote_discounts_link": "Remise",
    "basket_page_min_order": "Frais de commande minimale :",
    "quick_order_page_qty_validation": "Veuillez saisir les quantités requises",
    "checkout_summary_paymentMethod_paymentDetails_expires": "Expire {0} / {1}",
    "storeFinder_table_opening": "Heures d’ouverture",
    "quote_approve_success": "Approbation du devis réussie.",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_titleCode": "Entrez une valeur pour ce champ",
    "storelocator_error_no_results_subtitle": "Vérifiez que vous avez saisi un code postal ou un nom de lieu valides.",
    "checkout_pickup_continue_button": "Continuer",
    "basket_validation_noStock": "Désolé, <a href",
    "product_variants_size_guide": "Guide de tailles",
    "text_account_quote_page_sort_byState": "État",
    "text_account_addressBook_page_lastPage": "&raquo;",
    "login_required": "Obligatoire",
    "basket_export_cart_item_price": "Prix",
    "quote_cart_comments": "Commentaires panier",
    "text_account_warranty_search_page_totalResultsSingleOrder": "1 Claim",
    "text_headline_orders": "Afficher vos commandes",
    "text_account_addressBook_page_totalResultsSinglePag": "{0} Adresses",
    "popup_cart_quantity_added": "Quantité ajoutée",
    "text_itemPrice": "Prix unitaire",
    "text_address_delete_popup_title": "Supprimer l’adresse",
    "checkout_orderConfirmation_order_Type": "Type de commande :",
    "text_document_download": "Commencer le téléchargement du document",
    "basket_restoration_success": "{0}",
    "text_core_submission_review_text": "Revisez votre formulaire avant de l’envoyer;  vous ne pourrez le corriger après son envoi.",
    "text_account_openPositions_back": "Back to Open Positions",
    "text_core_submission_pdfEMEA": "Core Manual (Y059594)",
    "popup_cart_pickup": "Passer prendre",
    "payment_issueNumber_invalid": "Ce champ n’accepte que les numéros",
    "text_label_showmoreresults": "Afficher d’autres résultats",
    "basket_page_title_yourDeliveryItems_pickup": "Les articles de commande à prendre apparaîtront plus tard à la caisse.",
    "search_nav_facetShowMore_colour": "plus de couleurs...",
    "text_quote_cancel_confirmation_modal_title": "Annuler le devis {0}",
    "search_nav_facetShowLess_availableInStores": "moins de magasins...",
    "register_company_address_street_invalid": "Entrez l’adresse de l’entreprise",
    "text_account_warranty_search_page_currentPage": "Page {0} sur {1}",
    "text_core_search_partNumber_EMEA": "Entrez le no de pièce Knorr-Bremse",
    "text_account_core_search_totalResultsSinglePag": "{0} Result(s) found",
    "basket_page_title_yourItems": "Votre panier",
    "search_openPositions_export_line1": "\"Open Positions Export File status quo: {0}\"",
    "payment_nameOnCard": "Nom sur la carte",
    "checkout_orderConfirmation_PO_Date": "No de bon de commande :",
    "checkout_multi_deliveryAddress_stepHeader": "1 – Sélectionner une adresse de livraison",
    "storeFinder_pagination_from": "de",
    "text_cutoff_timezone_EMEA": "Veuillez noter : {0} doit être passée par {1} {2}.",
    "search_openPositions_export_line2": "\"Selection : {0},{1},Orders sent from {2} to {3}\"",
    "text_account_profile_updateEmail": "Mettre à jour votre adresse de courriel",
    "text_warranty_search_claim_to_date": "Réclamation, date de fin",
    "basket_error_product_removed": "Désolé, un ou plusieurs produits ont été retirés de votre panier, car ils ne sont pas en stock ou ne sont plus offerts.",
    "text_weight_complete": "Weight complete. [kg]",
    "basket_page_quote_discounts_link_target_as": "Cible à {0}",
    "text_account_savedcart_delete_popuptitle": "Supprimer le panier enregistré",
    "DeliveryType_Partial_name": "Largeur",
    "file_size_bytes": "{0} octets",
    "registration_error_generic": "Une erreur s’est produite. Veuillez réessayer plus tard.",
    "text_account_addressBook_page_sortTitle": "Ordre de tri",
    "storeDetails_table_distance": "Distance",
    "basket_page_qty": "Qté",
    "basket_restoration_delivery_changed": "{0} est restauré dans votre panier, mais la méthode de livraison est différente en raison du faible stock local.",
    "text_expires": "Expiret",
    "updatePwd_title": "Mettre à jour le mot de passe",
    "checkout_orderConfirmation_coupon_valid_from": "Début de validité : {0}",
    "payment_expiryYear_invalid": "Sélectionnez l’année d’expiration de la carte",
    "basket_page_title_yourDeliveryItems": "Vos articles de livraison",
    "saved_cart_total_number_one": "{0} panier enregistré",
    "checkout_orderConfirmation_pickupItems": "{0} articles à prendre en magasin",
    "text_account_profile_emailNotChanged": "Votre adresse de courriel n’a pas été mise à jour",
    "text_account_quote_cancel": "Annuler",
    "form_register_empty": "Sélectionnez votre pays",
    "order_confirmation_guest_register_description": "Validation rapide et accès facile à vos commandes précédentes",
    "product_variants_select_variant": "Sélectionnez une version",
    "text_remove": "Supprimert",
    "address_furtherSubarea": "Numéro de sous-secteur, numéro de domicile supplémentaires",
    "text_account_orderHistory_mobile_page_linkPreviousPage": "&laquo; Précédent",
    "text_account_savedCart_qty": "QTÉ",
    "text_help": "Aide",
    "register_company_countryCode_invalid": "Sélectionner le pays de l’entreprise",
    "text_storefinder_desktop_page_showAllResults": "Afficher tout",
    "text_account_order_orderDetails_billingInformtion": "Informations de facturation",
    "text_account_orderHistory_page_showAllResults": "Afficher tout",
    "text_account_orderHistory_page_sort_byPO": "PO No-Asc",
    "order_history_customer_reference_number": "No de référence client :",
    "warranty_eligibility_check_mileage_in_service": "Kilométrage en service*",
    "checkout_multi_deliveryMethod_selectDeliveryMethodMessage": "Méthode d’expédition",
    "text_none": "Aucun",
    "warranty_claim_yes": "Oui",
    "text_warranty_search_customerID": "Client ID",
    "coupon_order_recalculation_error": "Une erreur s’est produite lors du recalcul de la commande.",
    "mobile_checkout_paymentMethod_addOrSelect_card": "Sélectionner une carte de paiement enregistrée dans votre portefeuille ou ajouter une carte.",
    "updatePwd_pwd": "Nouveau mot de passe",
    "menu_button_home": "Accueil",
    "storeFinder_orSearchBy": "Or search by:",
    "text_account_order_delivery": "Livraison :",
    "testuser_message_display": "Test User is not allowed to place an order",
    "basket_export_user_lastLogin": "Dernière connexion",
    "basket_export_user_currency": "Devise",
    "text_headline_refinements": "Choisir la pertinence ou ajouter des mises au point",
    "text_account_profile_updateProfile_mobile": "Mettre à jour le profil",
    "updatePwd_token_invalid": "Le lien utilisé pour l’accès à la page de mise à jour n’est pas valide.",
    "address_district_and_street": "Secteur et rue",
    "order_totals_subtotal": "Sous-total:",
    "address_subarea_invalid": "Entrez un sous-secteur",
    "text_cookie_notification": "Nous utilisons des témoins pour garantir une expérience optimale sur notre site Web. Si vous continuez, vous acceptez notre déclaration de principes.",
    "checkout_pickup_items_appear_later": "Les articles de commande à prendre apparaîtront plus tard à la caisse",
    "checkout_order_type_maxQuantityExceeded": "Vous êtes autorisé à commander un maximum de {0} pièces par position selon le type de commande choisi comme {1}. Veuillez actualiser votre panier avant de poursuivre.",
    "text_warranty_submit_claim_type": "Type de réclamation",
    "text_quote_discount_type_null_error": "Le taux de remise est nul.",
    "basket_add_to_basket": "Ajouter au panier",
    "pdp_technicalattribute_guide": "Attributs techniques",
    "storeFinder_stores_nearto": "Magasins proches :  {0}",
    "text_account_quote_status_display_SELLERAPPROVER_PENDING": "En attente d’approbation",
    "text_cutoff_timezone_NA": "Veuillez noter : Les commandes urgentes doivent être passées avant 16 h HNE.",
    "checkout_pickup_items_to_be_delivered": "Articles à livrer",
    "text_weight_code": "[kg]",
    "b2b_unit_order_block_error_checkout": "Vous ne pouvez passer une commande en ce moment; veuillez nous joindre",
    "text_account_savedCarts_page_firstPage": "&laquo;",
    "text_account_quote_page_sort_byCode": "ID devis",
    "register_dataprotection_messageNA": "Déclaration de confidentialité",
    "text_account_orderHistory_page_sort_byPartNoDesc": "Part No-Desc",
    "product_grid_items_selected": "Quantité sélectionnée :",
    "basket_save_cart_description": "Désignation",
    "text_button_new": "Nouveau",
    "user_invalid_msg": "Your account has been locked, please contact your company administrator accordingly",
    "text_account_savedCarts": "Paniers enregistrés",
    "text_generalInfo_customTarrifNo": "Code du système harmonisé",
    "checkout_checkout_multi_deliveryAddress_viewAddressBook": "Carnet d’adresses",
    "profile_currentPassword": "Mot de passe actuel*",
    "text_total": "Totalt",
    "core_report_pdf": "PDF",
    "text_account_consent_already_given": "Consentement déjà donné",
    "text_headline_addtocart": "Cliquer pour ajouter le produit au panier",
    "text_account_order_orderStatus": "La commande est {0}",
    "cart_total_poa_NA": "Un prix sur demande apparaît dans votre panier, nous n'avons pas été en mesure de vous fournir un prix pour le moment, mais vous pouvez poursuivre votre commande. <p>Si vous avez besoin d'aide supplémentaire, veuillez nous envoyer un courriel via <a target='_blank' href='https://b2bendix.com/contact-us-form'> Contactez-nous</a> ou appelez le 1-800-AIR-BRAKE, option1.</p>",
    "text_account_savedCart_numberOfProducts": "Nombre de produits",
    "text_vmrsCodeRear": "Code VMRS (arrière)t",
    "register_company_companyStateCode_invalid": "Entrez l’État/la province de l’entreprise",
    "basket_export_csv_file": "Exporter CSV",
    "text_warranty_submit_part_otherCost": "Autres frais",
    "text_core_submission_EMEA_text2": "If you have got further questions about your submitted core return request, please contact your local Knorr-Bremse core team.",
    "mobile_checkout_cart_viewFullCart": "Voir le panier rempli",
    "text_core_submission_EMEA_text1": "Merci pour votre envoi d’une demande de reprise de cores. Vérifiez l’arrivée dans votre boîte de réception d’une copie du retour de cores présenté.",
    "register_site_companyrole_invalid": "Sélectionnez le rôle d’industrie",
    "text_account_savedCart_edit": "Modifier",
    "text_media_languages": "Languestt",
    "checkout_error_paymentethod_formentry_sop_missing_card_issueNumber": "Entrez un numéro d’émission",
    "forgottenPwd_email": "Adresse électronique",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street2": "Cette valeur n’est pas valide pour ce champ",
    "checkout_summary_paymentMethod_addPaymentDetails_savePaymentDetailsInAccount": "Enregistrer ces détails de paiement dans mon compte",
    "product_variants_available": "disponible en ligne",
    "checkout_summary_paymentMethod_savedCards_noExistingSavedCards": "Vous n’avez aucune carte enregistrée",
    "storeFinder_navigateTo": "Naviguer vers",
    "text_account_online_order_rights": "Droits – commande en ligne",
    "text_user_onlineOrdering_label": "Commande en ligne",
    "text_user_viewpricesandatp_label": "Voir le prix et la disponibilité",
    "text_storefront_true_value": "Vrai",
    "text_storefront_false_value": "Faux",
    "na_text_emergencyOrder_withoutstock_message1": "La quantité demandée pour",
    "na_text_emergencyOrder_withoutstock_message2": "la référence",
    "na_text_emergencyOrder_withoutstock_message3": "n’est pas entièrement disponible. Par conséquent le type de commande",
    "na_text_emergencyOrder_withoutstock_message4": "ne sera pas expédié aujourd’hui.",
    "na_text_emergencyOrder_withoutstock_message5": "Vous pouvez continuer votre commande ou revenir au panier et modifier votre type de commande.",
    "na_text_emergencyOrder_withoutstock_message6": "Les frais de port express s’appliqueront toujours si vous continuez votre commande.",
    "text_emergencyOrder_left_quotes": "\"",
    "text_emergencyOrder_right_quotes": "\"",
    "go_back_to_cart_button_text": "Revenir au panier",
    "continue_to_checkout_button_text": "Continuer la commande",
    "text_popup_title_Vor": "Express Priority J+1",
    "text_popup_title_emergency": "Express Priority J+2",
    "text_Show_orders_of_coworkers": "Afficher les commandes des collègues",
    "text_account_quote_action_display_CANCEL": "Annuler le devis",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_street1": "Cette valeur n’est pas valide pour ce champ",
    "import_csv_savedCart_genericError": "Erreur de téléversement du modèle de commande. Essayez à nouveau ou joignez le service à la clientèle.",
    "text_headline_marketType": "Type de marchét",
    "text_account_quote_date_updated": "Date de mise à jour",
    "text_account_quote_date_created": "Date de création",
    "checkout_multi_deliveryAddress_useThisAddress": "Utiliser cette adresse",
    "text_headline_terms": "Consentir aux conditions",
    "checkout_summary_paymentMethod_savedCards_UseThisSavedCard": "Utiliser ces détails de paiement",
    "basket_export_user_lastName": "Nom",
    "checkout_pickup_pickup_in_store_title": "PRENDRE EN MAGASIN",
    "review_required": "Les champs marqués * sont obligatoires",
    "basket_validation_movedFromPOSToStore": "Vos articles ont été modifiés pour correspondre aux stocks disponibles Un ou plusieurs articles à prendre en magasin seront maintenant expédiés.",
    "checkout_deliverydate_past": "La date de livraison demandée ne peut être inférieure à {0}.",
    "popup_cart_total": "Total",
    "text_account_orderHistory_page_sort_byOrderTypeDesc": "Order Type-Desc",
    "text_account_orderHistory": "Historique des commandes",
    "basket_page_quantity": "Quantité",
    "text_account_savedCarts_page_sort_byName": "Nom",
    "text_warranty_submit_parts_disposition": "Parts Disposition if denied*",
    "checkout_page_summary_final_review_order_type": "Type de commande :",
    "account_confirmation_signout_title": "Vous vous êtes déconnecté de votre compte.",
    "basket_page_validation_message": "Mise à jour/Suppression de produit(s) exécutées dans votre panier.",
    "profile_checkEmail": "Confirmer la nouvelle adresse électronique",
    "text_dimension": "Dimensions (L x l x H)t",
    "basket_page_emea_orderQty": "Qté cdée",
    "basket_page_1_pc_only": "(1 PC seulement)",
    "order_history_subtotal": "Sous-total:",
    "search_page_xref_name": "Nom de réf croisé",
    "text_account_order_status_display_completed": "Exécutée",
    "text_sales_status_description_emea_code_40": "Unité",
    "basket_page_product": "Produit",
    "product_grid_in_stock": "En stock",
    "checkout_error_cart_notcalculated": "Désolé, votre transaction ne peut être terminée en ce moment; veuillez réessayer plus tard ou joindre notre service à la clientèle au 555 555-5555",
    "mobile_checkout_deliveryAddress": "Adresse de livraison",
    "text_quote_state_label": "État",
    "storeFinder_currentPosition": "Current Position",
    "import_csv_savedCart_uploadTemplate": "Téléverser un modèle de commande",
    "text_generalInfo_vrms": "Codes VRMS / Explication",
    "cart_page_checkout_no": "Non",
    "address_selectState": "État/Province",
    "review_write_title_product": "Écrire un avis sur {0}",
    "basket_page_title_pickupFrom": "Passer prendre ici :",
    "text_account_orderHistory_noOrders": "Aucune commande trouvée",
    "text_quote_name_label": "Nom",
    "text_enter_partnumber_placeholder": "Entrez le numéro de pièce",
    "storeFinder_table_store": "Magasin",
    "text_consent_and": "et",
    "login_error_account_not_found_title": "L’adresse courriel ou le mot de passe saisis ne sont pas corrects.",
    "register_company_companyStateCode_japan": "Prefecture*",
    "account_error_login_please": "Vous devez vous connecter pour avoir accès à cette page. Connectez-vous ci-dessous avec vos informations d’identification.",
    "checkout_multi_paymentMethod_addPaymentDetails_useThesePaymentDetails": "Utiliser ces détails de paiement",
    "checkout_multi_sop_globalError": "Une erreur s’est produite lors du traitement de votre demande. Mesure possible : Patientez quelques minutes, puis renvoyez la commande.",
    "basket_page_na_orderQty": "Qté",
    "checkout_multi_paymentMethod_savedCards_actions": "Actions",
    "account_confirmation_profile_updated": "Votre profil a été mis à jour.",
    "register_company_companyStateCode": "État/Province*",
    "product_grid_viewFuture": "Futur",
    "text_account_quote_page_totalResultsCurrPage": "{0} sur {1} devis",
    "text_account_savedCarts_page_showAllResults": "Afficher tout",
    "checkout_edit": "Modifier",
    "text_quote_code": "ID devis :",
    "text_account_quote_action_display_CREATE": "Créer un devis",
    "label_emea_snd": "Vue Web",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cardType": "Le type de carte n’est pas pris en charge",
    "core_error_reports_na": "You do not have permission, please <a href",
    "text_myaccount": "&laquo; Mon compte",
    "import_csv_savedCart_enterContentNoteEmea": ", entrez les informations versées à votre dossier, sélectionnez votre type de commande, puis cliquez sur",
    "script": "Adresses de facturation enregistrés",
    "checkout_login_guestCheckout": "Commande en mode invité",
    "text_account_quote_status_display_EXPIRED": "Expiré",
    "text_core_submission_address_emea": "If the collection address is not provided in the selection above, then please fill in the collection address in the entry fields below:",
    "text_backToMobileStore": "Mobile",
    "text_account_order_appliedCoupons": "Coupons affectés :",
    "text_warranty_eligibility_error": "Error in Warranty Eligibility Check. Please try again or contact customer service.",
    "label_emea_collection": "Collecte",
    "mobile_basket_page_update": "Mettre à jour la quantité",
    "checkout_paymentMethod_noSecurityCode": "Fournissez un code de sécurité.",
    "address_line1_shipping_page_form_emea": "Adresse*",
    "text_edit": "Modifier",
    "checkout_summary_deliveryAddress_useForNewAddress": "Utilisez ce formulaire pour entrer une nouvelle adresse.",
    "text_warranty_terms_school_bus": "Autobus scolaire",
    "search_nav_facetShowMore_size": "plus de tailles...",
    "payment_cardType": "Type de carte",
    "product_product_partnumber": "No de pièce :",
    "text_account_addressBook_page_currentPage": "Page {0} sur {1}",
    "checkout_error_terms_not_accepted": "Veuillez accepter nos conditions avant d’envoyer votre commande.",
    "register_email_invalid": "Entrez une adresse de courriel valide",
    "import_csv_savedCart_fileContentNote": "Mode d’emploi : Sélectionnez votre type de commande, cliquez sur",
    "search_nav_resultsForStore": "Résultats pour : {0}",
    "text_select_you_can_upload": "You can only upload max 9 mb",
    "checkout_summary_paymentMethod_securityCode": "Code de sécurité",
    "core_report_csv": "CSV",
    "text_storefinder_desktop_page_showPageResults": "Afficher paginé",
    "text_quote_expiration_time_label": "Date d’expiration",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard": "Utiliser une carte enregistrée",
    "text_select_specific_file": "Sélectionnez le fichier que vous souhaitez téléverser, puis cliquez sur le bouton Upload (Téléverser). Chaque fichier téléversé sera ajouté à la demande.",
    "address_city_shipping_page_form": "Ville*",
    "text_account_order_consignment_status_processing": "En traitement",
    "text_account_closeAccount_retention_info": "Lorsque vous fermez votre compte, vos renseignements de profil sont conservés pendant la période de rétention imposée par les lois et les réglementations de votre pays/région. Le service à la clientèle vous aidera si vous avez besoin d’un historique des commandes ou d’une preuve d’achat durant cette période.<br/><br/>Au terme de la période de rétention, les renseignements de profil suivants seront supprimés, et vous ou toute autre personne ne pourrez plus y avoir accès :<br/><br/><ul><li>adresses de courriels</li><li>coordonnées</li><li>détails d’expédition</li><li>préférences de livraison</li><li>paramètres de gestion du consentement</li><li>historique du compte</li><li>détails de paiement</li><li>historique des commandes</li></ul>",
    "core_report_EMEA_description": "Cette page vous permet de télécharger vos rapports de cores Knorr-Bremse des 18 mois précédents. Des mises à jour des rapports de cores seront publiées en ligne au début du mois suivant.",
    "basket_page_free": "GRATUIT",
    "text_account_quote_status_display_BUYER_DRAFT": "Brouillon",
    "checkout_summary_placeOrder_readTermsAndConditions": "Lorsque je passe cette commande, je confirme avoir lu et accepté les",
    "text_warranty_submit_part_labourAmount": "Montant main-d’œuvre (remplissage auto)",
    "checkout_multi_paymentMethod_paymentDetails_noneSelected": "Aucune sélectionnée",
    "basket_export_user_website": "Adresse du site Web",
    "text_account_order_totalSavings": "Vous avez économisé {0} sur votre commande",
    "address_building_and_room": "Nom de l’immeuble et numéro du bureau",
    "storelocator_query": "Code postal / Ville",
    "system_error_page_not_found": "404 page introuvable",
    "text_account_savedcart_activecart_msg": "Les articles actuels dans le panier seront enregistrés comme :",
    "text_warranty_print": "Imprimer",
    "product_variants_select_size": "Sélectionner une taille",
    "login_required_message": "Les champs marqués * sont obligatoires",
    "password_strength_weak": "Faible",
    "text_country_selector_EMEA": "Europe",
    "text_voucher_apply_input_placeholder": "entrer le code du coupon",
    "text_quote_illegal_state_error_reason": "Notez que votre tentative d’exécution de {0} action n’est pas autorisée pour le devis {1} avec {2} état. Raison : {3}",
    "register_termsConditions_id": "conditions-contrôlet",
    "register_lastName_invalid": "Entrez un nom",
    "text_quote_dateformat": "MM/jj/aaaa",
    "pickup_pagination_previous": "Précédent",
    "register_checkPwd": "Confirmer le mot de passe*",
    "text_account_paymentDetails_paymentCard_default": "Ma carte de paiement par défaut",
    "text_quote_no_button_label": "Non",
    "text_warranty_document_once_claim": "Une fois la demande envoyée, il n’est plus possible d’y joindre un document.",
    "text_quote_checkout_confirmation_modal_title": "Confirmer devis Accepter et Caisse {0}?",
    "import_csv_savedCart_fileContentEmea": "Doit être un numéro de pièce Knorr-Bremse vendable",
    "text_account_savedcart_delete_msg": "Le panier suivant sera supprimé",
    "text_account_order_consignment_status_pickedup": "A été pris",
    "storeFinder_store_locator": "Localisateur de magasins",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_country": "Entrez une valeur pour ce champ",
    "text_warranty_eligibility_endDateLesser_error_title": "Date Removed from Service should be greater than Date in Service",
    "storeFinder_meta_title": "Stores near",
    "text_account_quote_code": "ID devis",
    "order_history_customer_ID": "Numéro de client",
    "product_grid_availability": "Disponibilité",
    "search_mobile_page_showAllResults": "Afficher tout",
    "checkout_multi_summary_breadcrumb": "Examen final",
    "checkout_paymentMethod_createSubscription_billingAddress_noneSelected": "Entrez une adresse de facturation ou entrez d’abord une adresse de livraison, qui servira alors d’adresse de facturation.",
    "text_warranty_submit_button": "Envoyer",
    "checkout_multi_deliveryAddress_addressBook": "Carnet d’adresses",
    "text_core_submit_coreLineItems_invalid": "Obligatoire",
    "quote_cart_title": "Devis en cours pour ce panier",
    "product_grid_averagePriceUnitText": "Prix moyen / Unité",
    "system_error_link_expired_subtitle": "Remplir à nouveau le formulaire de mot de passe oublié.",
    "price_to_use_feature": "Méthode – Sélectionnez les fichiers de prix que vous souhaitez télécharger. Cliquez ensuite sur Télécharger les fichiers de prix.",
    "register_company_address_street_emea1": "Adresse*",
    "basket_page_quote_discounts_link_absolute_off": "Remise de {0}",
    "text_plp_page_impp": "No de pièce IAM",
    "address_surname": "Nom",
    "review_rating": "Votre note",
    "register_companystreet_name_invalid_kbRegisterForm_companyStreetNumber": "Entrez le numéro municipal",
    "text_warranty_terms_some_parts": "**Certaines pièces auront une garantie prolongée; cliquez sur lâonglet Documents de garantie pour un complément dâinformation.",
    "general_month_august": "Août",
    "text_account_core_search_linkPreviousPage": "Page précédente",
    "checkout_multi_paymentMethod_savedCards_billingAddress": "Adresse de facturation :",
    "label_emea_bnd": "Données Web",
    "text_rememberMe_cookie": "Veuillez consentir à l'utilisation de cookies fonctionnels pour \"Se souvenir de ma connexion\". Vous pouvez modifier vos paramètres de cookies",
    "here": "ici",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street1": "Entrez une valeur pour ce champ",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_street2": "Entrez une valeur pour ce champ",
    "product_variants_only_left": "seulement {0} restant en ligne",
    "registration_confirmation_message_title": "Merci d'avoir soumis votre inscription, vous recevrez un e-mail pour confirmer votre inscription.",
    "demo_registration_confirmation_message_title": "Merci d'avoir soumis votre enregistrement de démo, veuillez sélectionner les démos disponibles ci-dessous.",
    "basket_page_netpriceApac": "Net Price (Total)",
    "general_continue_shopping": "Continuer vos achats",
    "text_quote_conteroffer_possible_checkout_message": "Ce devis fournisseur est contractuel. L’acheteur peut passer à la caisse immédiatement.",
    "mobile_checkout_edit_link": "Modifier",
    "checkout_orderConfirmation_Total": "Total",
    "checkout_checkout_multi_pci_select": "Sélectionner une option PCI",
    "text_homepage_banner_label": "INNOVATION MODÈLE : LE RECYCLAGE DES PATINS DE FREIN ÉVITE LE GASPILLAGE",
    "pdp_page_listprice": "Prix courant",
    "text_percentage": "%",
    "text_headertext_info": "Info",
    "text_storefinder_desktop_page_sortTitle": "Ordre de tri :",
    "text_account_orderHistory_page_sort_byDateDesc": "Date-Desc",
    "register_checkbox_list_label": "Prix courant",
    "text_account_order_consignment_store_title": "Magasin",
    "quote_state_expired": "Le devis a expiré Créer un nouveau devis ou modifier le devis expiré",
    "basket_page_message_update_pickupinstoreitem_toship": "L’article à prendre en magasin sera maintenant expédié.",
    "search_nav_facetShowLess_price": "moins de prix...",
    "search_nav_facetValueCount": "({0})",
    "review_rating_alt": "étoiles",
    "core_report_NA_description_example": "Exemple : Le 1er janvier, vous pouvez télécharger votre rapport de cores de décembre, qui vous montrera toute l’activité durant ce mois.",
    "text_headline_breadcrumbs": "Fil d’Ariane",
    "text_account_savedcart_restore_popuptitle": "Restaurer le panier enregistré",
    "header_mobile_link_login": "Ouverture de session",
    "orderHistory_page_totalResultsDetails": "{0} sur {1} commandes",
    "mycompany_enter_name_placeholder": "Entrer un nom ou une adresse courriel",
    "form_select_none": "Aucune",
    "text_quote_submit_confirmation_message": "Voulez-vous vraiment envoyer ce devis?",
    "text_generalInfo_grossWeight": "Poids brut",
    "text_account_addressBook_setDefaultDeliveryAddress": "Définir l’adresse de livraison par défaut",
    "basket_restoration_unavailable": "Désolé, {0} n’est plus offert. Vous aviez auparavant {2} dans votre panier.",
    "updatePwd_token_invalidated": "Votre mot de passe a déjà été mis à jour.",
    "pagination_view": "Afficher",
    "text_voucher_apply_input_label": "Code du coupon",
    "profile_pwd_invalid": "Entrez votre mot de passe",
    "register_site_companyrole": "Rôle de l’industrie*",
    "storeDetails_table_features": "Caractéristiques",
    "text_core_submit_address_addressPhone": "Téléphone",
    "basket_page_customerPrice": "Prix pour les clients",
    "register_lastName": "Nom*",
    "text_account_orderHistory_actions": "Actions",
    "text_pagenotexist_error": "Cette page n’existe pas!",
    "payment_expiryDate": "Date d’expiration*",
    "address_zipcode": "Code postal",
    "quote_less_comments": "Afficher moins de commentaires",
    "checkout_multi_deliveryMethod_noExistingDeliveryMethod": "Il n’y a pour l’instant aucune méthode de livraison.",
    "quote_cart_checkout_error": "Le devis fournisseur a été modifié; veuillez refaire Accepter et Caisse.",
    "text_consent_dpr_pdp": "Déclaration de confidentialité",
    "customeradmin_check": "Customer Admin",
    "registration_error_account_exists_subtitle": "Si vous avez oublié votre mot de passe, utilisez le lien Mot de passe oublié.",
    "text_core_submit_address_countryISO": "Pays*",
    "text_account_order_includesTax": "Votre commande comprend {0} taxe.",
    "import_csv_savedCart_title": "Importation de commande",
    "text_warranty_terms_logging_vehicle": "Véhicules forestiers ou miniers",
    "checkout_multi_purchaseOrderNumber_label_NA": "No de bon de commande client",
    "register_back_login": "Retour à connexion",
    "checkout_multi_paymentMethod_createSubscription_failedMsg": "Échec de création de l’abonnement. Vérifiez les valeurs saisies",
    "checkout_pages_availabilty_final_review_NA": "SUIVANT",
    "text_warranty_submit_part_description": "Désignation",
    "address_shipping_page_form_na": "Adresse de rue*",
    "text_account_savedCart_description": "Désignation",
    "register_termsConditions": "Je confirme avoir lu et accepté les <a class",
    "text_account_orderHistory_page_totalResultsSinglePag": "{0} commandes",
    "text_address_remove_following": "L’adresse suivante sera supprimée de votre carnet d’adresses",
    "quote_cancel": "Annuler le devis",
    "quote_save_cart_error": "Une erreur interne s’est produite. Veuillez réessayer.",
    "checkout_checkout_multi_pci-hop": "PCI-HOP",
    "text_account_quote_manage_items": "Gérer les articles",
    "basket_received_promotions": "Promotions reçues",
    "text_quote_validity_message": "Ce devis est valide jusqu’au {0}",
    "text_account_order_status_display_Error": "En attente",
    "text_account_orderHistory_page_sort_byDescription": "Description-Asc",
    "core_submit_warranty_material_included": "Matériel sous garantie joint?",
    "core_submit_warranty_material_includedyes_warrantyClaimNo": "Warranty Claim Number",
    "text_account_savedCarts_page_totalResultsCurrPage": "{0} sur {1} paniers enregistrés",
    "text_skipToContent": "Passer au contenut",
    "text_account_customerPONumber": "Numéro de commande client",
    "pickup_search_message": "Entrer une ville ou un code postal :",
    "text_quote_submit_confirmation_modal_title": "Confirmer le devis demandé {0}?",
    "pickup_pagination_last": "Dernier",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder": "Type de livraison",
    "checkout_multi_hostedOrderPageError_breadcrumb": "Erreur",
    "register_webshop_id": "boutique en ligne-contrôlet",
    "text_account_order_consignment_status_cancelled": "Annulé",
    "text_warranty_size": "Taille",
    "address_phone": "Numéro de téléphone",
    "text_headline_footer_navigationbar": "Parcourir la barre de navigation du pied de page",
    "text_warranty_submit_part_otherCostDescription": "Définition des autres frais",
    "review_show_more": "Afficher plus",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_state": "Cette valeur n’est pas valide pour ce champ",
    "text_account_orderHistory_mobile_page_totalResults": "{0} commandes trouvées",
    "text_warranty_terms_ineterstate_truck": "Camion inter-états / interprovincial",
    "product_related_products": "Produits connexes",
    "text_account_core_breadcrumbEMEA": "Outil de recherche des groupes de cores",
    "basket_page_orderQty": "Qté cdée",
    "text_reports_creditRecon": "Rapprochement",
    "text_quickOrder_product_quantity_invalid": "Quantité non valide",
    "search_nav_removeAttribute": "Supprimer un attribut",
    "checkout_summary_deliveryMode_editDeliveryMethod": "Modifier la méthode de livraison",
    "saved_quote_total_number": "Devis {0}",
    "text_account_paymentType": "Type de paiement",
    "basket_information_quantity_reducedNumberOfItemsAdded_lowStock": "Une quantité réduite de ce produit a été ajoutée à votre panier en raison d’une insuffisance de stock.",
    "checkout_orderConfirmation_thankYouForOrder": "Merci de votre commande!",
    "order_itemPrice": "Prix unitaire",
    "text_company_manage_units_notActivated": "Votre compte n’a pas encore été activé; veuillez joindre votre administration client pour de plus amples renseignements.",
    "text_warranty_upload_file": "Télécharger des fichiers",
    "text_headline_weightAndDimension": "Poids et dimensionst",
    "To": "use this feature - Click on <b>Download Order Template</b>, enter your information on the file, select your order type and click on <b>Upload Order Template</b>",
    "mobile_checkout_cart_viewLess": "Voir moins",
    "text_company_users_label": "Utilisateurs entreprise",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_lastName": "Cette valeur n’est pas valide pour ce champ",
    "text_reports_summaryNa": "Toutes les activités de haut niveau des groupes de cores",
    "text_warranty_submit_labourrequested_yes": "Oui",
    "checkout_multi_paymentMethod_addPaymentDetails_generalError": "Erreur de communication avec le fournisseur de traitement de paiement.  Patientez quelques minutes, puis réessayez.  Si le problème persiste, communiquez avec notre équipe des ventes.",
    "text_account_order_status_display_cancelling": "Annulation en attente",
    "checkout_orderConfirmation_continueShopping": "Continuer vos achats",
    "text_core_submission_thank_text": "Merci de la part de votre équipe des cores Bendix",
    "core_check": "Pièce uséet",
    "popup_close": "Fermer",
    "text_warranty_search_claim_ref_no": "No de référence client de la demande",
    "text_select_you_record_sets": "Record Sets:",
    "login_email": "Adresse électronique*",
    "text_quickOrder_form_product_exists": "UGS déjà existante dans le formulaire",
    "text_account_savedCart_link": "Enregistrer le panier",
    "register_terms_condition": "Conditions d’utilisation",
    "register_termsOfUsage": "Conditions d’utilisationt",
    "corePrice_check": "Core Price",
    "text_quote_name_description_invalid": "Entrez un nom et une description valides",
    "address_selectProvince": "Province",
    "cart_page_estdelivery": "Date de livr. prévue",
    "text_weight": "Poidst",
    "text_core_submit_lastName": "Nom",
    "basket_validation_invalidGroup": "Ce groupe est mal configuré. Veuillez le modifier.",
    "import_csv_savedCart_fileContentNoteEmea": "Mode d’emploi : Cliquez sur",
    "address_townJP_invalid": "Entrez une ville, un village, un quartier urbain",
    "basket_error_date_invalid": "Sélectionnez une date non antérieure à {0}.",
    "search_mobile_page_linkNextPage": "Suivant &raquo;",
    "checkout_orderConfirmation_thankYouForOrder_bendix": "Merci de votre commande à Bendix (récapitulatif ci-dessous).",
    "general_mobile_store": "Boutique mobile",
    "text_filter_by": "Filtrer par",
    "text_account_quotes_page_totalResultsCurrPage": "{0} sur {1} devis",
    "basket_export_user_status": "État",
    "search_nav_facetTitle": "Magasiner par {0}",
    "basket_page_entry_unknownAction": "Mesure de saisie du panier inconnue",
    "text_account_paymentDetails_managePaymentDetails": "Gérer vos détails de paiement",
    "basket_page_message_update": "La quantité du produit a été actualisée.",
    "sold_to_popup_text_one": "Vous ne pouvez passer une commande en ce moment, veuillez",
    "checkout_summary_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Sélectionner les détails de paiement existants ou en entrer de nouveaux",
    "text_account_core_search_totalResultsSingleOrder": "1 Result found.",
    "text_account_quote_page_totalResultsSinglePag": "{0} devis trouvés",
    "checkout_summary_paymentMethod_savedCards_billingAddress": "Adresse de facturation",
    "mobile_checkout_deliveryMethod": "Options livraison",
    "cart_page_customer_reference": "Customer Item Ref. No.",
    "account_error_account_not_found": "Aucun compte n’a été trouvé pour l’adresse électronique fournie.",
    "address_phoneNumber": "Numéro de téléphone",
    "basket_save_cart_max_chars": "Caractères restants",
    "checkout_error_paymentethod_formentry_sop_invalid_card_cvNumber": "Le code de sécurité n’est pas valide",
    "checkout_multi_paymentMethod_breadcrumb": "Paiement et Adresse de facturation",
    "text_headline_register": "Cliquer ici pour inscrire un nouveau client",
    "basket_save_cart_on_error": "Une exception s’est produite durant l’enregistrement du panier {0}",
    "text_account_warranty_table_header_status": "État",
    "basket_export_user_userCreated": "Date de création / d'activation par l'utilisateur",
    "mycompany_click_delete_user": "Cliquer pour supprimer l’utilisateur",
    "doubleopt_confirmation_message_title": "Merci de confirmer votre inscription, vous recevrez un e-mail avec les détails de connexion une fois approuvés.",
    "product_view_details_typenumber": "No de modèle",
    "j_username": "Ouverture de session",
    "checkout_orderConfirmation_success": "Commande passée avec succès!",
    "cart_page_checkout": "Caisse",
    "text_quickOrder_page_price": "Prix",
    "checkout_order_type_lineEntriesExceeded_emergencyEMEA": "Vous avez sélectionné {0} commande : Vous pouvez commander 2 positions avec un maximum de 2 pièces par position. Veuillez actualiser votre panier avant de poursuivre.",
    "quote_not_editable": "Quote ID : {0} is not editable",
    "text_warranty_vehicle_identification_number": "Numéro d’identification de véhicule*",
    "text_checkout_pickup_in_store": "Prendre en magasint",
    "text_reports_credit": "Debit/Credit Reconciliation",
    "mobile_checkout_deliveryAddress_selectAddressMessage": "Choisir une adresse de livraison dans le carnet d’adresses, ou ajouter une nouvelle.",
    "text_warranty_submit_part_totalCost": "Coût total (remplissage auto)",
    "product_share_tweet": "Gazouiller ceci",
    "checkout_multi_paymentMethod_continue": "Suivant",
    "resetPwd_title": "Réinitialiser le mot de passe",
    "checkout_summary_paymentMethod_savedCards_enterNewPaymentDetails": "Entrer les nouveaux détails du paiement",
    "basket_restoration_view_cart": "<a href",
    "checkout_orderConfirmation_thankYouForOrder_emea": "Merci de votre commande à Knorr-Bremse Commercial Vehicle Systems (récapitulatif ci-dessous)",
    "text_account_order_orderNumberLabel": "Votre numéro de commande est",
    "basket_cartpage_kb_partNo": "Knorr-Bremse",
    "text_storefinder_responsive_page_firstPage": "&laquo;",
    "text_account_addressBook_saveAddress": "Enregistrer l’adresse",
    "search_page_showAllResults": "Afficher tout",
    "text_address_remove_confirm": "Voulez-vous vraiment supprimer cette adresse?",
    "text_account_order_consignment_trackingID_notavailable": "Non disponible.",
    "profile_email_unique": "L’adresse courriel que vous avez saisie n’est plus présente",
    "checkout_summary_edit": "Modifier",
    "checkout_page_summary_final_review_order_note": "Commentaires:",
    "text_account_orderHistory_page_linkPreviousPage": "Page précédente",
    "text_core_submit_address_addressFax": "Fax",
    "breadcrumb_not_found": "Page introuvable",
    "label_emea_uk_pksh": "Demain avant midi",
    "text_warranty_select_all_files": "All files has been attached successfully",
    "text_core_submit_crm": "Numéro CR*",
    "text_core_na_submit_crm": "Numéro de retour du noyau Bendix",
    "text_core_submit_customercrm": "Numéro de référence du client",
    "text_core_search_crm": "Numéro CR",
    "basket_page_cartHelpMessageMobile": "Besoin d’aide? <br />Appelez notre équipe pour obtenir une aide directe <a href",
    "choose_delivery_carrier_account_number": "Votre numéro de compte transporteur",
    "address_title_pleaseSelect": "titre",
    "text_account_quote_status_display_SELLERAPPROVER_DRAFT": "Brouillon",
    "text_warranty_submit_claim_information": "Réclamations Information",
    "basket_page_totals_noNetTax": "*Aucune taxe comprise dans le total",
    "checkout_order_type_lineEntriesExceeded_emergencyNA": "Vous avez sélectionné {0} commande : Vous pouvez commander des articles à 2 lignes avec un maximum de 2 pièces par ligne. Veuillez actualiser votre panier avant de poursuivre.",
    "text_core_submission_clarify": "Veuillez étiqueter clairement les pièces \"matériel sous garantie\".",
    "product_emea_meta_description": "Get detailed information about the selected Knorr-Bremse product including technical attributes, associated documents, service solutions and tools.",
    "text_storefinder_mobile_page_description": "Indiquez votre emplacement pour voir les magasins dans votre région ou laissez votre appareil trouver pour vous les magasins proches",
    "text_expresscheckout_header": "Caisse rapide",
    "text_storefinder_desktop_page_linkPreviousPage": "Précédent",
    "register_dataprotection_message": "Déclaration de protection des données",
    "text_quote_illegal_state_error": "Notez que votre tentative d’exécution de {0} action n’est pas autorisée pour le devis {1} avec {2} état",
    "text_account_quote_page_showPageResults": "Afficher paginé",
    "checkout_orderConfirmation_Order_Date": "Date de commande :",
    "text_account_quote_page_lastPage": "&raquo;",
    "register_pwd": "Mot de passe*",
    "review_confirmation_thank_you_subtitle": "Nous nous efforçons de publier sur le site tous les avis dans les 24 heures.",
    "basket_page_totals_total_items": "{0} ARTICLES",
    "updatePwd_pwd_invalidMatch": "« Le mot de passe doit répondre aux conditions stipulées. »",
    "quote_view": "Afficher le devis",
    "basket_error_no_pickup_location": "Sélectionnez les magasins pour les entrées surlignées en rouge",
    "basket_cartpage_typeNo": "Type no",
    "cart_basket_typeNo": "Type no",
    "search_meta_description_on": "le",
    "text_account_order_consignment_pickUpBy": "À être pris par",
    "download_agree_disclaimer_text": "I agree to the disclaimer",
    "review_write_description": "Entrez votre avis",
    "basket_information_quantity_noItemsAdded_noStock": "Désolé, le stock est insuffisant pour votre panier.",
    "text_account_orderHistory_mobile_page_sort_byDate": "Date",
    "text_account_profile_paymentCart_removed": "Suppression réussie de la carte de paiement",
    "password_strength_strong": "Fort",
    "text_sales_status_description_apac_code_40_anonymous": "Numéro du type",
    "validation_checkEmail_equals": "« Adresse courriel » ne correspond pas à « Entrer à nouveau l’adresse courriel »",
    "mobile_checkout_continue_shopping": "Continuer vos achats",
    "text_account_savedCarts_page_totalResultsSinglePag": "{0} paniers enregistrés",
    "register_company_website": "Adresse du site Web",
    "text_account_orderHistory_page_sort_byDescriptionDesc": "Description-Desc",
    "basket_items": "Articles",
    "text_quickOrder_page_product": "Produit",
    "basket_page_cartHelpContent": "Besoin d’aide? Communiquez avec nous ou appelez le service à la clientèle au 1-###-###-####. Si le sujet de votre appel est le panier d’achat, donnez l’ID panier ci-dessus.",
    "vor_text_warning": "Please ensure you have entered the complete address including post code as per the correct mail standard format.",
    "guest_checkout": "Nouveau à {0}?",
    "quote_newcart_error": "Une erreur s’est produite lors du traitement de votre demande. Essayez à nouveau d’envoyer votre demande.",
    "breadcrumb_quote_edit": "Modifier le devis",
    "checkout_summary_paymentMethod_addPaymentDetails_useSavedCard_description": "Les clients inscrits peuvent sélectionner une carte enregistrée auparavant",
    "basket_restoration_lowStock": "Désolé, une quantité réduite de {0} a été restaurée dans votre panier en raison du faible stock. {3} ont été ajoutés à votre panier, vous avez maintenant {2}.",
    "text_account_orderHistory_page_sort_byTotal": "Total-Asc",
    "text_account_quote_action_display_EDIT": "Modifier le devis",
    "basket_page_poa": "Prix sur demande",
    "storeDetails_title": "Détails du magasin",
    "order_history_realtime_heading": "Les renseignements de cette page sont en temps réel. Les données livraison actualisées sont indiquées en rouge.",
    "text_account_consent_consentManagement": "Gestion du consentement",
    "address_room": "Numéro de bureau",
    "text_guest_customer": "Invité",
    "checkout_multi_paymentMethod_addPaymentDetails_enterYourCardDetails": "Entrez les détails de votre carte pour le paiement",
    "profile_checkPwd": "Confirmer le mot de passe*",
    "profile_checkEmail_invalid": "Confirmez votre adresse électronique",
    "checkout_checkout_flow_select": "Sélectionner un autre flux de paiement",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_shippingMethod": "Cette valeur n’est pas valide pour ce champ",
    "basket_page_itemDescription": "Désignation",
    "checkout_multi_hostedOrderPageError_continue": "Continuer",
    "review_see_reviews": "Afficher les avis",
    "checkout_information_delivery_method_changed": "Votre méthode de livraison a été mise à jour selon votre lieu de livraison.",
    "text_account_order_qty": "Qté",
    "address_regionIso_shipping_form": "État/Province*",
    "text_iconCartRemove": "Supprimer",
    "text_account_search": "Chercher",
    "pdp_page_corecharges": "Frais de base",
    "basket_page_totals_discounts": "Remises commandes :",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_lastName": "Cette valeur n’est pas valide pour ce champ",
    "basket_page_entry_action_REMOVE": "Supprimer",
    "register_company_address_city": "Ville*",
    "quote_comment_invalid": "Le commentaire ne doit pas dépasser 255 caractères",
    "general_month_february": "Février",
    "text_account_profile_changePassword_mobile": "Changer le mot de passe",
    "text_account_viewOrderHistory": "Afficher l’historique des commandes",
    "saved_cart_total_number": "Paniers enregistrés {0}",
    "checkout_error_paymentethod_formentry_invalid": "Vérifiez l’exactitude de vos détails de paiement ou fournissez un mode de paiement différent.",
    "checkout_multi_sop_remove": "Supprimer",
    "pickup_pagination_page_details": "{0} à {1} sur {2}",
    "checkout_error_paymentethod_formentry_sop_invalid_card_startMonth": "Le mois de début n’est pas valide",
    "checkout_pickup_store_destinations": "À prendre en magasin : {0} Destination(s)",
    "product_product_details_future_title": "Disponibilité future",
    "saved_cart_total_description": "Vous avez",
    "text_account_table_head_order_category": "Order Category",
    "NotBlank_orderHistoryForm_startDate": "Please enter Start Date",
    "review_confirmation_thank_you_title": "Merci de votre avis.",
    "text_core_submit_emailAddress": "Adresse électronique pour la confirmation",
    "text_max_vehicle_size": "e.g. max. vehicle size",
    "checkout_order_type_lineEntriesExceeded": "Vous êtes autorisé à commander un maximum de {0} lignes selon le type de commande choisi comme {1}. Veuillez actualiser votre panier avant de poursuivre.",
    "core_error_submission_na": "You do not have permission, please <a href",
    "checkout_summary_paymentMethod_savedCards_actions": "Actions",
    "popup_quick_view_select": "Sélectionner les options",
    "basket_export_user_core": "Rapports des Cores",
    "text_delete_savedcart_error": "Erreur lors de la suppression du panier enregistré",
    "checkout_summary_placeOrder_readTermsAndConditions_EMEA": "Lorsque je passe cette commande, je confirme avoir lu et accepté les <a class",
    "text_storefinder_responsive_page_currentPage": "{0} sur {1}",
    "registration_consent_link": "Pour afficher d’autres options ou changer vos paramètres, allez à la page Gestion du consentement dans Mon compte.",
    "checkout_orderConfirmation_Carrier_Selection": "Choix de l’entreprise de transport :",
    "basket_error_invalid_configuration_edit": "Corriger les erreurs",
    "checkout_orderConfirmation_coupon_valid_until": "Fin de validité : {0}",
    "text_consent_button_more": "En savoir plus",
    "text_warranty_submit_part_add": "Ajouter un numéro de pièce",
    "order_orderItems": "Articles commande",
    "register_company_address_street_emea": "Numéro municipal*",
    "register_company_address_street_emea_lite_user": "Numéro municipal",
    "text_reports_summary": "Résumé",
    "text_account_savedCart_backToSavedCarts": "Retour aux paniers enregistrés",
    "text_quickOrder_delivery_date": "Date de livraison",
    "text_productDetails": "Détails produitt",
    "text_account_order_orderBreadcrumb": "Commande {0}",
    "text_account_quote_page_linkNextPage": "Page suivante",
    "cart_total_note": "* les frais de transport peuvent être ajoutés",
    "storeFinder_find_a_store": "Trouver un point de vente autorisé Bendix proche",
    "text_button_cancel": "Annuler",
    "please_select_state_text": "Sélectionnez",
    "text_warranty_terms_charter_bus": "Autobus nolisé/inter-états/inter-provinces",
    "basket_page_shipping": "Expédition",
    "text_core_submit_soldto": "Numéro de client",
    "text_account_order_status_display_error": "En attente",
    "quote_reject_error": "Erreur durant le refus du devis.",
    "b2b_unit_order_blocked_login": "Communiquez avec le service à la clientèle.",
    "order_history_order_type_others": "Others",
    "address_district_invalid": "Entrez un secteur",
    "text_core_submit_address_address2": "Adresse 2",
    "checkout_multi_paymentMethod_viewSavedPayments": "Afficher les paiements enregistrés",
    "open_total_usd_EMEA": "Open Value - in EUR*",
    "text_warranty_attachement_available": "Pièces jointes disponibles",
    "text_warranty_eligibility_success": "Oui, la pièce est sous garantie",
    "general_month_september": "Septembre",
    "text_guest_ordererror": "Page erreur commande d’invité",
    "storeFinder_nearby_stores": "Magasins proches",
    "text_button_use": "Utiliser",
    "text_quote_description_label": "Désignationt",
    "text_account_core_search_currentPage": "Page {0} sur {1}",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_country": "Entrez une valeur pour ce champ",
    "checkout_multi_paymentMethod_savedCards_stepHeader": "3 – Sélectionner les détails du paiement",
    "text_account_quote_name": "Nom",
    "text_quote_discount_adjust_total": "Rectifier le total",
    "address_title_invalid": "Sélectionnez un titre",
    "basket_added_to_basket": "Ajouté au panier",
    "deliveryMode_select_delivery_type": "Livraison",
    "text_cart": "Panier",
    "text_account_warranty_search_page_totalResultsCurrPage": "{0} sur {1} réclamations",
    "text_restore_savedcart_error": "Erreur lors de la restauration du panier enregistré",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_email": "Entrez une valeur pour ce champ",
    "text_default": "Par défautt",
    "paymentMethod_billingAddress_header": "Adresse de facturation :",
    "checkout_deliveryAddress_notSelected": "Donnez une adresse de livraison pour votre commande",
    "basket_page_customerprice": "Prix pour les clients",
    "quick_order_req": "Date de livraison",
    "text_expresscheckout_info1": "Après avoir défini ainsi vos paramètres avec succès, les utilisateurs connectés passeront directement à l’étape Examen Final lors du passage à la caisse.",
    "text_expresscheckout_info2": "Les utilisateurs qui ne se sont pas déjà connectés peuvent choisir Caisse rapide dans le panier d’achat.",
    "general_month_march": "Mars",
    "text_warranty_terms_app_frequency": "Ces utilisations impliquent une fréquence élevée des cycles de freinage, dans des conditions plus rudes, sur un revÃªtement dur ou hors route.",
    "text_confirmation_warranty": "Warranty Confirmation",
    "text_account_warranty_search_page_linkPreviousPage": "Page précédente",
    "text_expresscheckout_info3": "La fonction Caisse rapide n’est pas offerte aux utilisateurs invités.",
    "enter_part_number_quick_order": "Entrez le numéro de pièce",
    "search_nav_facetShowLess_size": "moins de tailles...",
    "general_month_january": "Janvier",
    "order_history_order_date": "Date de commande :",
    "text_countryOfOrigin": "Pays d’origine",
    "text_account_addressBook_page_sort_byCode": "Jeu de pièces de rechange",
    "checkout_orderConfirmation_orderNumberShort": "Commande no {0}",
    "text_user_registraion_request_label": "Demandes d’inscription",
    "basket_page_totals_estimatetaxesbutton": "Estimer la taxe",
    "login_description": "Veuillez vous connecter",
    "text_account_orderHistory_page_totalResultsCurrPage": "{0} sur {1} commandes",
    "warranty_claim_no": "Oui",
    "register_state_placeholder": "Sélectionner votre État/Province",
    "text_storefinder_responsive_page_linkNextPage": "Suivant",
    "checkout_error_paymentethod_formentry_sop_invalid_billTo_country": "Cette valeur n’est pas valide pour ce champ",
    "register_checkbox_priceDownloadAccess_label": "Télécharger le fichier de prix",
    "storeFinder_table_view_store": "Afficher magasin",
    "quote_submit_success": "Envoi du devis réussi.",
    "text_storefinder_mobile_page_currentResults": "{0} – {1} sur {2} magasins",
    "checkout_multi_deliveryAddress_noSuggestedAddresses": "Aucune suggestion d’adresses.",
    "basket_page_itemPrice": "Prix unitaire",
    "search_page_sortTitle": "Ordre de tri :",
    "account_confirmation_address_removed": "Adresse supprimée avec succès",
    "checkout_summary_deliveryMode_number_of_pickup_destinations": "À prendre en magasin : {0} Destination(s)",
    "register_termsOfUsage_accept_invalid": "Vous devez accepter les conditions d’utilisation de la boutique en ligne",
    "import_csv_savedCart_downloadTemplate": "Télécharger un modèle de commande",
    "import_csv_core_downloadTemplate": "Download Core Template",
    "price_download_files": "Téléchargez vos fichiers de prix",
    "text_account_order_consignment_status_shipped": "Expédié",
    "text_account_change_email_address": "Changer l’adresse électronique",
    "search_nav_selectRefinements_title": "Sélectionner les mises au point",
    "text_core_submit_phone": "Téléphone*",
    "text_core_submit_personalDetails_phone": "Téléphone",
    "text_core_submit_personalDetails_emailAddress": "Adresse électronique pour la confirmation",
    "text_core_submit_address": "Adresse*",
    "text_core_submit_address_city": "Ville*",
    "text_core_submit_address_country": "De campagne*",
    "text_core_submit_address_selectState": "État/Province*",
    "text_core_submission_wghttotal": "Poids total",
    "checkout_multi_paymentMethod_addPaymentDetails_header": "Détails du paiement",
    "checkout_summary_deliveryAddress_noExistingAddresses": "Votre carnet n’a aucune adresse.",
    "text_account_savedCarts_page_linkNextPage": "Page suivante",
    "checkout_multi_addEditform": "Utilisez ce formulaire pour ajouter/modifier une adresse.",
    "storeDetails_map_link": "Map",
    "basket_page_netprice": "Prix net",
    "pdp_information_replacedby": "Remplacé par :",
    "payment_year": "Année",
    "checkout_page_summary_final_review_customer_refrence": "No de référence client :",
    "checkout_orderConfirmation_Summary_title": "Récapitulatif de commande",
    "text_warranty_submit_enter_amount": "(enter amount on a per piece basis)",
    "text_account_savedCarts_page_totalResults": "{0} panier(s) trouvé(s)",
    "text_account_quote_action_display_CHECKOUT": "Devis, Accepter et Caisse",
    "text_account_orderHistory_mobile_page_sortTitle": "Ordre de tri :",
    "text_quote_dateformat_datepicker_selection": "mm/jj/aaaa",
    "register_company_b2bUnits_invalid": "Please Select at least one sold to",
    "review_number_reviews": "Avis",
    "pickup_pagination_stores": "&nbsp;magasins trouvés",
    "basket_error_quantity_notNull": "Le champ de quantité ne peut être vide.",
    "text_account_addressBook_noSavedAddresses": "Aucune adresse enregistrée trouvée",
    "quote_submit_error": "Erreur durant l’envoi du devis.",
    "basket_page_deliveryDate": "Date de livraison demandée",
    "product_share_print": "Imprimer",
    "download_disclaimer_text": "Download Disclaimer",
    "review_submit": "Envoyer un avis",
    "pickup_in_store_back_to_results": "Retour",
    "text_account_warranty_search_page_sortTitle": "Ordre de tri",
    "import_csv_savedCart_fileContent": "Doit être un numéro de pièce Bendix vendable",
    "text_myCompanyManage_content": "Dans cette section vous pouvez créer, modifier et supprimer tous les utilisateurs de votre entreprise.",
    "import_csv_savedCart_selectFile": "Sélectionner un fichier à téléverser. Le fichier doit être un fichier texte avec extension CSV.",
    "basket_error_date_success": "Date de livraison demandée mise à jour.",
    "checkout_orderConfirmation_cut-off-time": "Temps limite :",
    "product_grid_future_tooltip_delivery": "Livraison",
    "storeDetails_table_distanceFromCurrentLocation": "{0} from Current Location",
    "search_mobile_page_currentPage": "{0} – {1} sur {2} produits",
    "quote_acceptandcheckout": "Accepter et Caisse",
    "pickup_mobile_back_to_cart_page": "Retour au sac à emplettes",
    "basket_restoration_items_msg": "Les articles suivants sont :",
    "checkout_pickup_items_to_be_shipped": "Expédier à :",
    "checkout_error_paymentethod_formentry_sop_missing_card_accountNumber": "Entrez un numéro de carte",
    "text_minOrderQuantity": "Commande, quantité minimalet",
    "checkout_checkout_multi": "Caisse Multi (plusieurs pages)",
    "checkout_multi_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Entrer une adresse de facturation différente",
    "text_account_consent_cookiesusage": "Utilisation de témoins",
    "address_postcode_invalid": "Entrez le code postal",
    "text_headline_addaddress": "Cliquer pour ajouter une adresse",
    "storeDetails_table_opening_closed": "Fermé",
    "basket_page_message_remove": "Le produit a été retiré de votre panier.",
    "address_line2_invalid": "Entrez adresse Ligne 2",
    "search_Results_NextPage_link": "Suivant",
    "register_checkbox_admin_label": "Customer Admin",
    "register_site_company": "Entrez les renseignements sur votre société*",
    "text_account_orderHistory_page_sort_byPODesc": "PO No-Desc",
    "warranty_eligibility_check_type_of_operation": "Type d’opération*",
    "text_core_submit_address_zipCode": "Code postal*",
    "popup_done": "Terminé",
    "register_termOfUsage_accept_dataProtection": "Vous devez accepter la Déclaration de protection des données",
    "cart_page_quantity_label": "Qté",
    "basket_export_user_username": "Nom d'utilisateur",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA": "Type de livraison",
    "text_core_submission_pdfNA": "Bendix Core Center",
    "checkout_summary_paymentMethod_savedCards_header": "Sélectionner les détails du paiement",
    "text_warranty_document_attachement_all": "Les documents peuvent être joints s'ils sont au format jpg, word ou pdf et s'ils ne dépassent pas 9 Mo au total.",
    "product_product_details_future_date": "Date de livraison prévue",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_state": "Entrez une valeur pour ce champ",
    "order_form_total": "Total, Formulaire de commande",
    "order_history_order_type": "Type de commande :",
    "text_account_warranty_search_page_lastPage": "&raquo;",
    "core_error_generic": "No Results found.",
    "NotBlank_orderHistoryForm_endDate": "Please enter End Date",
    "checkout_summary_paymentMethod_addPaymentDetails_header": "Détails du paiement",
    "address_required": "Les champs marqués * sont obligatoires",
    "checkout_orderConfirmation_pickupPoints": "À prendre en magasin : {0} Destination(s)",
    "text_warranty_eligibility_mileageInService_invalid": "Please enter a valid Mileage in Service",
    "payment_issueNumber": "Numéro d’émission",
    "quote_newcart_success": "Enregistrement réussi du devis {0}",
    "text_coreGroup": "Groupe pièce uséet",
    "text_warranty_email_two_invalid": "Please correct email id",
    "review_headline": "Titre de l’avis",
    "checkout_multi_deliveryAddress_addressSuggestions_addressNotFound": "Ou garder l’adresse originale :",
    "address_district": "Secteur",
    "checkout_multi_paymentMethod_seeOrderSummaryForMoreInformation": "Voir la zone Récapitulatif de commande pour un complément d’information.",
    "text_account_addressBook_page_sort_byTotal": "Totalt",
    "basket_save_cart_validation_name_notBlank": "Le nom du panier est obligatoire",
    "text_popupCartTitle": "Votre panier d’achatt",
    "basket_page_surcharge": "Supplément pièce usée",
    "text_account_core_search_firstPage": "&laquo;",
    "text_warranty_eligibility_mileage_mi_error": "Mileage can't be more than 6213711 miles",
    "forgottenPwd_description": "Entrez votre adresse électronique du compte.  Les instructions de réinitialisation de votre mot de passe seront envoyées à cette adresse.",
    "error_account_myPart_template_format": "Téléversez les données dans le bon format – prenez le modèle Excel de téléversement",
    "basket_page_needHelp": "Besoin d’aide?",
    "checkout_multi_paymentMethod_addPaymentDetails_billingAddress": "Adresse de facturation :",
    "text_account_paymentDetails_paymentCard": "Carte de paiement",
    "general_delete_button": "Supprimer",
    "text_account_savedCart_savedCartBreadcrumb": "Panier enregistré {0}",
    "text_account_quote_action_display_REJECT": "Refuser le devis",
    "basket_cartpage_pos": "Bons d’achat",
    "cart_page_reqdelivery": "Date de livr. demandée",
    "text_account_paymentDetails_delete_popup_title": "Supprimer le paiement",
    "text_headline_productinfo": "Cliquer pour un complément d’information sur : vue d’ensemble du produit, avis sur le produit ou méthode de livraison",
    "text_account_orderHistory_page_sort_byOrderNumber": "Numéro de commande",
    "text_reports_summaryEmea": "All activity for the month by group at a high level",
    "text_account_quote_page_currentPage": "Page {0} sur {1}",
    "storeFinder_viewMap": "Afficher Carte",
    "text_headline_orderinfo": "Tous les renseignements concernant l’adresse de livraison, la méthode de livraison et le mode de paiement",
    "checkout_order_purchaseOrderNumber_label_EMEA": "No de référence client :",
    "search_page_firstPage": "&laquo;",
    "storefinder_searchterm_invalid": "Entrez un terme de recherche ou un code postal",
    "checkout_pickup_confirm_and_continue": "Confirmez simplement les renseignements ci-dessous, puis passez à l’étape suivante de validation.",
    "text_account_warranty_table_header_reason": "Motif du refus",
    "checkout_multi_paymentMethod_savedCards_selectSavedCardOrEnterNew": "Sélectionner les détails de paiement existants ou en entrer de nouveaux",
    "basket_save_cart": "Panier enregistré",
    "checkout_multi_deliveryAddress_stepHeader_done": "1 – Adresse de livraison",
    "basket_quick_order_error": "{0} produit(s) non ajoutés au panier; Cf. erreurs à la page Commandes rapides",
    "text_component_message_underconstruction": "<strong>Information:</strong>  Composant en construction – pas entièrement fonctionnel",
    "text_account_paymentDetails_delete": "Supprimer",
    "text_account_core_search_total": "Totalt",
    "text_copyright": "&copy; logiciel hybris 2016",
    "search_page_software": "Logiciel",
    "text_account_quote_action_display_SUBMIT": "Envoyer le devis",
    "review_comment_invalid": "Exprimez votre avis",
    "pickup_back_to_product_page": "&lt; Retour à la page des produits",
    "error_account_myPart_part_notcorrect": "ligne {0} : {1} numéro de pièce {2} n’est pas reconnu, donc non téléversé. Corrigez votre entrée ou communiquez avec votre service client {3} local.",
    "text_warranty_submit_quantity_invalid": "Please enter a valid Quantity",
    "text_voucher_apply_button_label": "Affecter",
    "product_volumePrices_column_qa": "Quantité",
    "search_page_showing_text": "",
    "search_page_of_text": "sur",
    "search_page_result_text": "demande(s) trouvée(s)",
    "checkout_error_paymentethod_formentry_sop_invalid_card_expirationYear": "L’année d’expiration n’est pas valide",
    "text_account_manageQuotes_breadcrumb": "Devis",
    "text_productHierarchy": "Hiérarchie de produitt",
    "account_confirmation_close_title": "Votre compte a été fermé.",
    "text_account_order_pickup_location": "Lieu de prélèvement :",
    "basket_export_user_company": "Entreprise",
    "text_account_quote_email": "E-Mail",
    "text_account_order_consignment_status_readyforpickup": "Pour prendre en magasin",
    "download_start_download_button_text": "start download",
    "text_headline_productcategories": "Catégories de produits",
    "import_csv_savedCart_quantity": "Quantité",
    "address_selectCountry": "Pays",
    "text_attn": "À l’attention de :",
    "checkout_summary_placeOrder_readTermsAndConditions_close": "Fermer",
    "profile_lastName": "Nom",
    "product_na_meta_description": "Bendix Commercial Vehicle Systems offers a complete line of air compressors, valves, ABS, stability systems, driver assistance systems, air dryers, plus air disc and drum brakes",
    "checkout_pickup_items_at_one_location": "Tous les articles dans votre commande sélectionnés pour être pris en magasin sont disponibles à ces emplacements :",
    "open_total_usd_NA": "Total USD en cours",
    "mycompany_click_edit_user": "Cliquer pour modifier les détails utilisateur",
    "text_account_quote_status_display_BUYER_SUBMITTED": "Envoyé",
    "text_quote_previous_estimated_total_display": "Total estimatif précédent",
    "text_warranty_submit_part_nature_defect": "Nature du défaut",
    "text_warranty_submit_part_nature_defect_na": "Nature du défaut",
    "text_quickOrder_product_not_purchaseable": "Achat impossible du produit. Entrez une autre UGS",
    "register_checkbox_coworker_label": "Afficher les commandes des collègues",
    "text_headline_findstore": "Trouver votre magasin",
    "quote_name_invalid": "Entrez un nom valide",
    "text_compare_part_number": "Vous pouvez comparer jusqu'à 4 références",
    "text_account_quote_status_display_CANCELLED": "Annulé",
    "text_part_number": "No de pièce",
    "text_account_orderHistory_page_currentPage": "Page {0} sur {1}",
    "text_core_submission_review_emea": "Vérifiez toutes vos entrées dans ce formulaire.  Une fois la demande de retour présentée, aucun changement ne sera possible.",
    "text_account_orderHistory_page_lastPage": "&raquo;",
    "listPrice_check": "Prix courant",
    "order_history_total": "Totalt",
    "header_hello": "Bonjour",
    "text_product_image": "Image produit",
    "quote_requote": "Nouveau devis",
    "text_javascript_disabled": "JavaScript est nécessaire à l’accès de cette page Veuillez activer JavaScript.",
    "basket_page_listprice": "Prix courant",
    "text_account_savedCart_back_to_saved_cart": "Retour aux paniers enregistrés",
    "search_nav_facetShowMore_style": "plus de modèles...",
    "register_company_countryState": "État/Province*",
    "checkout_orderConfirmation_Billing_Address": "Adresse de facturation",
    "text_account_quote_total": "Total",
    "checkout_error_paymentethod_formentry_sop_missing_card_startYear": "Entrez une année de début",
    "text_account_core_search_linkNextPage": "Page suivante",
    "text_consent_dpr": "déclaration de protection",
    "product_grid_quantityText": "Quantité",
    "checkout_summary_deliveryAddress_useThisAddress": "Utiliser cette adresse",
    "address_regionIso_prefecture": "Préfecture",
    "mobile_checkout_paymentMethod_add_card": "Ajouter une carte",
    "checkout_multi_paymentMethod_addPaymentDetails_useSavedCard_description": "Les clients inscrits peuvent sélectionner une carte enregistrée auparavant",
    "basket_information_quantity_reducedNumberOfItemsAdded_nextDeliveryUnit": "La quantité saisie pour le numéro de pièce {1} a été changée en raison des restrictions de taille du conditionnement.",
    "coupon_not_active_expired": "Le code coupon saisi n’est plus valide.",
    "text_notproduct_found_message": "Aucun produit trouvé",
    "checkout_multi_paymentMethod_savedCards_noExistingSavedCards": "Vous n’avez aucune carte enregistrée",
    "import_csv_savedCart_fileMaxSizeExceeded": "Le fichier est trop volumineux.",
    "text_account_orderHistory_page_sort_byCode": "Order No-Asc",
    "pickup_buy_online_message": "Achetez vos produits maintenant; passez les prendre plus tard au magasin.",
    "text_account_order_orderPlaced": "Passée le {0}",
    "text_warranty_view_add_information": "Afficher/Ajouter",
    "text_view": "Affichert",
    "text_deviceCode": "Code de dispositiftt",
    "form_global_error": "Corrigez les erreurs ci-dessous.",
    "text_warranty_view_max_mb": "(9 Mo max.)",
    "text_account_order_unconsignedEntry_status_pending": "En attente",
    "text_account_savedcart_to_activecart": "Le panier suivant enregistré sera restauré comme panier actif.",
    "text_account_kbpartNumber": "Numéro de pièce Bendix/Numéro de pièce client",
    "text_account_order_warning_storePickUpItems": "Rappel – Passez prendre votre ou vos articles bientôt.",
    "cart_page_checkout_yes": "Oui",
    "text_account_quote_status_display_BUYER_APPROVED": "Approuvé",
    "text_account_core_search_sortTitle": "Sort By:",
    "text_warranty_tag_serial_number": "T.A.G. (Garantie totale air) Numéro de série",
    "checkout_pickup_items_available_at_one_location": "VOS ARTICLES À PRENDRE SONT DISPONIBLES À UN EMPLACEMENT (cela n’a aucun effet sur les commandes de livraison)",
    "basket_restoration_noStock": "Désolé, <a href",
    "quote_create": "Demander un devis (quotation)",
    "search_page_product_cross_reference_emea": "Réf Croisé",
    "pickup_mobile_back_to_product_page": "Retour à la page des produits",
    "basket_page_id": "ID article",
    "search_page_product": "Produit",
    "search_Results_previousPage_link": "Préc.",
    "search_page_lastPage": "&raquo;",
    "text_expresscheckout_title": "Profitez d’une validation d’achat plus rapide ainsi :",
    "basket_error_quantity_invalid": "Fournissez un nombre positif pour actualiser la quantité d’un article.",
    "text_account_order_orderNumber": "Votre numéro de commande est {0}",
    "text_hideFacet": "Masquer la mise au point",
    "search_page_linkNextPage": "Page suivante",
    "text_account_order_orderTotals": "Total de la commande",
    "order_order_totals": "Totaux commande",
    "product_variants_in_stock": "En stock",
    "register_checkbox_updateMyPart_label": "Télécharger / Téléverser ses propres numéros de pièce",
    "basket_page_shipping_pickup": "Prendre",
    "mobile_checkout_items_show": "Afficher plus d’articles",
    "storeDetails_table_distanceFromSource": "{0} sur {1}",
    "text_headline_sortandrefine": "Trier et affiner",
    "text_account_order_subtotal": "Sous-total:",
    "register_company_name": "Nom de l’entreprise*",
    "cart_page_shop": "Magasinage",
    "checkout_multi_deliveryMethod_deliveryOptions": "Options livraison",
    "label_emea_sand": "SAND",
    "text_page_return": "Ou vous pouvez retourner à notre.",
    "checkout_summary_deliveryMode_header": "Options livraison",
    "text_headline_categories": "Cliquer ici sur le bouton de menu pour accéder aux catégories",
    "search_page_pageSize_title": "Produits par page :",
    "text_core_submission_wghtCode": "(lbs)",
    "basket_export_user_address2": "Adresse 2",
    "basket_export_user_address1": "Address 1",
    "checkout_multi_purchaseOrderNumber_label_EMEA": "Réf. client",
    "search_no_results": "0 articles trouvés pour mot-clé <strong>{0}</strong>",
    "product_variants_select_style": "Sélectionnez d’abord un modèle",
    "text_quote_edit_confirmation_message": "Ce devis a été approuvé; si vous le modifiez, vous ne pourrez passer à la caisse avant l’approbation des nouvelles modifications.",
    "checkout_multi_paymentMethod": "Paiement et Adresse de facturation",
    "text_country_selector_NA": "North America",
    "product_grid_readonly_qty": "Qté",
    "text_warranty_vehicle_unit_number": "Numéro véhicule/unité",
    "basket_page_shipping_ship": "Expédier",
    "text_account_OrderDateTo": "Date de commande à*",
    "core_error_b2bunit": "Please Select at least one Core Parent",
    "profile_email": "Nouvelle adresse électronique",
    "open_type_number": "Numéro du type",
    "text_save_cart_title": "Panier enregistré",
    "register_new_customer": "Créer un compte",
    "text_header_menu": "Menu",
    "cart_page_requested": "Demandé",
    "register_company_countryCode": "De campagne*",
    "text_companyRegistrationRequest_heading": "Demandes dâinscription",
    "basket_save_cart_validation_name_charset": "Le nom du panier doit être uniquement alphanumérique",
    "checkout_summary_paymentMethod_addPaymentDetails_paymentCard": "Carte de paiement",
    "quick_order_delivery_date": "DEM.",
    "text_account_addressBook_page_showPageResults": "Afficher paginé",
    "cart_page_replaced": "Remplacé",
    "product_grid_future_tooltip_error": "Désolé, impossible d’obtenir les données de disponibilité future en ce moment. Veuillez réessayer plus tard.",
    "payment_startDate_invalid": "La date de début doit précéder la date d’expiration",
    "basket_page_comment_menu": "Commentaire",
    "text_core_submission_memo": "(Core Return Memo Number)",
    "product_product_details": "Détails produit",
    "quote_reject_success": "Refus du devis réussi.",
    "text_account_profile_updatePassword": "Utilisez ce formulaire pour actualiser le mot de passe de votre compte",
    "checkout_multi_paymentMethod_savedCards_enterNewPaymentDetails": "Entrer les nouveaux détails du paiement",
    "core_submit_warranty_certify_check": "Je certifie que les noyaux de ce CR ont été retirés de camions et/ou de véhicules lourds sur le territoire du Canada.",
    "text_core_submit_address_addressLName": "Nom",
    "text_account_quote_page_sort_byDate": "Date mise à jour",
    "text_account_quote_status_display_SELLERAPPROVER_REJECTED": "Refusé",
    "text_account_quote_status_display_BUYER_REJECTED": "Refusé",
    "checkout_summary_deliveryAddress_selectExistingAddress": "Sélectionner une adresse existante",
    "cart_page_estdeliveryApac": "Est Departure Date",
    "text_subcategories_label": "Catégorie",
    "checkout_checkout_multi_pci-ws": "PCI-par défaut",
    "mycompany_active_user": "Utilisateur actif – Cliquer pour bloquer l’utilisateur",
    "text_storefinder_mobile_page_currentPage": "{0} sur {1}",
    "basket_page_quote_discounts": "Remise devis :",
    "basket_export_cart_item_name": "Nom",
    "text_account_savedcart_numberofpositions": "Number of Positions",
    "warranty_eligibility_check_submit": "Envoyer",
    "text_quickOrder_product_code_invalid": "Code de produit non valide",
    "checkout_multi_sop_savePaymentInfo": "Enregistrer l’info de paiement",
    "search_nav_facetShowLess_style": "moins de modèles...",
    "cart_checkout": "CAISSEt",
    "text_storefinder_responsive_page_linkPreviousPage": "Précédent",
    "search_nav_facetShowLess": "Afficher moins",
    "text_account_core_search_totalResultsCurrPage": "Affichage {0} sur {1} résultats",
    "product_image_zoom_in": "Cliquer pour faire un zoom",
    "text_quote_cancel_button_label": "Annuler",
    "checkout_multi_deliveryAddress_addAddress": "Ajouter une nouvelle adresse",
    "payment_cvn": "Numéro de vérification de carte",
    "product_variants_out_of_stock": "Rupture de stock",
    "checkout_multi_deliveryAddress": "Lieu d’expédition/de prélèvement",
    "text_account_core_search_totalResults": "{0} New Result(s) found",
    "storeFinder_findStoresNearMe": "Trouver des magasins",
    "text_connect": "Connecter",
    "text_account_savedCart_restore": "Restaurer",
    "text_account_warranty_table_header_decision": "Decision",
    "account_confirmation_payment_details_removed": "Vos détails de paiement ont été supprimés.",
    "product_product_details_more": "Plus de détails produit",
    "text_account_profile_createnewuser": "Créer un nouveau compte utilisateur",
    "checkout_summary_reviewYourOrderMessage": "Vérifiez avec attention votre commande!",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_lastName": "Entrez une valeur pour ce champ",
    "pdp_page_generaltab_soldinmultipleof": "Vendu en multiples de",
    "label_emea_b9nd": "B9ND",
    "order_history_status": "Order Status:",
    "checkout_error_payment_not_accepted": "Votre paiement a été refusé. Vérifiez l’exactitude de vos détails de paiement.",
    "checkout_pickup_items_simplify_pickup_location": "Je souhaite changer ma commande pour prendre tous mes articles au même magasin.",
    "text_account_myCore": "Mes pièces usées",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_postalCode": "Entrez une valeur pour ce champ",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_firstName": "Cette valeur n’est pas valide pour ce champ",
    "text_account_orderHistory_page_sort_byOpenQtyDesc": "Open Qty-Desc",
    "account_confirmation_password_updated": "Réussite! Vous pouvez maintenant ouvrir une session avec votre nouveau mot de passe.",
    "login_error_invalidSalesArea": "Vous ne disposez pas des autorisations suffisantes pour vous connectertt",
    "search_page_product_cross_reference": "Réf Croisé",
    "general_month_november": "Novembre",
    "register_state_invalid": "Sélectionnez l’État/la province",
    "text_warranty_dealer_code": "Résultat, code concessionnaire",
    "text_quickOrder_header": "Commande rapide",
    "text_account_quote_status_display_SELLERAPPROVER_APPROVED": "Approuvé",
    "form_empty_select": "Sélectionnez",
    "quote_description_invalid": "La description ne doit pas dépasser 255 caractères",
    "order_history_delivery_type": "Type de livraison :",
    "checkout_summary_paymentMethod_addPaymentDetails_enterDifferentBillingAddress": "Entrer une adresse de facturation différente",
    "text_account_closeAccount_header": "Fermeture du compte",
    "order_total": "Total",
    "Please": "carefully check each request and either edit and approve it, or decline it.",
    "registration_confirmation_message_subtitle": "Ouvrez votre courriel pour vérifier votre adresse électronique.",
    "mobile_multi_checkout_selectExistingCard": "Choisir parmi les détails de paiement existants",
    "text_account_order_title_storePickUpItems": "Articles à prendre en magasin",
    "text_quote_discount_rate_null_error": "Le taux de remise est nul.",
    "address_street": "Nom de la rue avec numéro de la rue",
    "checkout_error_paymentethod_formentry_sop_invalid_shipTo_city": "Cette valeur n’est pas valide pour ce champ",
    "login_error_account_not_found_subtitle": "Si vous avez oublié votre mot de passe, utilisez le lien Mot de passe oublié.",
    "text_storefinder_mobile_page_linkPreviousPage": "&laquo; Précédent",
    "text_headline_vmrs": "Rapports d’entretien normalisés (VMRS)t",
    "text_account_order_min_EMEA": "Frais de commande minimale :",
    "text_account_addressBook_page_totalResultsCurrPage": "{0} sur {1} adresses enregistrées",
    "text_warranty_submit_requestedPartAmount_invalid": "Please enter a valid Requested Handling Amount",
    "checkout_placeOrder_failed": "La commande n’a pu être passée",
    "address_error_formentry_invalid": "Des erreurs ont été trouvées dans l’adresse fournie. Vérifiez les erreurs ci-dessous, puis renvoyez votre adresse.",
    "checkout_summary_paymentMethod_header": "Détails du paiement",
    "cart_page_continue": "Continuer vos achats",
    "text_account_addressBook_page_totalResultsSingleOrder": "1 Adresses",
    "text_consent_email": "Entrez votre adresse de courriel",
    "text_account_consent_given": "Consentement donné",
    "text_warranty_submit_part_quantity": "Quantité*",
    "basket_page_message_update_reducedNumberOfItemsAdded_lowStock": "La quantité saisie au numéro de position {4}, numéro de pièce {5}, a été changée en raison des restrictions de taille du conditionnement.",
    "text_warranty_submit_vehicle_information": "Véhicule Information",
    "text_dates_difference_error": "Veuillez limiter la période à un maximum de 365 jours.",
    "basket_cartpage_partNo": "No de pièce",
    "text_storefinder_responsive_page_totalResults": "1-10 sur {0} magasins trouvés",
    "basket_page_totals_deliverycountry": "Destination de livraison :",
    "text_account_OrderDate": "Date de commande de*",
    "basket_export_user_state": "État",
    "address_postcodeJP_invalid": "Entrez le code postal précédé d’un symbole postal",
    "text_account_orderHistory_orderStatus": "État de la commande",
    "text_account_quote_action_display_VIEW": "Afficher le devis",
    "checkout_orderConfirmation_checkoutSuccessful": "Validation d’achat réussie",
    "checkout_multi_deliveryAddress_notprovided": "Vous devez fournir une adresse d’expédition avant de passer à l’étape suivante.",
    "product_product_details_future_qty": "Qté",
    "text_CloseMyAccount_label": "Fermer mon compte",
    "text_account_order_shipto": "Destinataire :",
    "text_vmrsCode": "Code VMRSt",
    "checkout_page_delivery_address_emergency": "Ajouter une adresse (commandes urgentes seulement)",
    "text_cust_ref_no": "Item Ref No.",
    "account_error_account_exists_with_email_address_title": "Un compte existe déjà pour cette adresse électronique {0}",
    "text_quote_cancel_confirmation_message": "Voulez-vous vraiment annuler ce devis?",
    "form_field_required": "Obligatoire",
    "label_emea_emgy": "Express Priority J+1",
    "checkout_multi_shipment_items": "Expédition – {0} article(s)",
    "text_account_order_title_details": "Détails de la commande",
    "password_strength_veryweak": "Très faible",
    "text_account_table_header_date": "Order Date",
    "breadcrumb_cart": "Panier",
    "text_link_home_label": "Accueil",
    "checkout_multi_deliveryAddress_select": "Sélectionner",
    "basket_restoration_view_cart_btn": "Voir le panier",
    "profile_checkNewPassword": "Confirmer le nouveau mot de passe*",
    "text_generalInfo_description": "Désignation",
    "checkout_summary_paymentMethod_addPaymentDetails_saveAndUseThesePaymentDetails": "Enregistrer et utiliser ces détails de paiement",
    "general_month_may": "Mai",
    "basket_save_cart_validation_name_size": "Le nom du panier ne doit pas dépasser 255 caractères",
    "basket_configure_product": "Configurer",
    "orderHistory_page_totalResults": "sur {0} commandes",
    "text_account_addressBook_manageDeliveryAddresses": "Gérer votre adresse de livraison",
    "checkout_summary_deliveryAddress_edit": "Modifier",
    "checkout_error_paymentethod_formentry_sop_missing_card_startMonth": "Entrez un mois de début",
    "quote_enter_comment": "Ajouter un commentaire, puis appuyer sur Entrée",
    "text_addToCart": "Ajouter au panier",
    "text_account_order_title_inProgressItems": "Articles de commande en cours",
    "text_core_submit_address_addressEmail": "Email",
    "import_csv_savedCart_fileRequired": "Le fichier ne peut être vide.",
    "cart_page_merge_message": "You have multiple positions in the cart with same part number and requested delivery date which will be merged on checkout, do you wish to proceed?",
    "text_headline_additional": "Renseignements supplémentaires",
    "quote_cart_insufficient_access_rights_error": "Droits d’accès insuffisants pour panier {0}.",
    "pdp_page_netprice": "Prix net",
    "quote_edit_locked": "ID devis : {0} est en train d’être modifié par {1}",
    "storeDetails_table_address": "Adresse",
    "text_account_orderHistory_mobile_page_linkNextPage": "Suivant &raquo;",
    "text_account_quote_status_display_BUYER_OFFER": "Devis fournisseur",
    "text_storefinder_mobile_page_noResults": "Aucun résultat dans votre région.",
    "text_core_submission_upgrade": "Mise à niveau",
    "text_account_profile_changePassword": "Changer votre mot de passe",
    "text_voucher_apply_applied_success": "Le {0} a été affecté avec succès",
    "search_page_currentPage": "Page {0} sur {1}",
    "search_nav_facetShowLess_collection": "moins de collections...",
    "import_csv_savedCart_requestedDateApac": "Optional : Requested delivery date (format YYYY/MM/DD)",
    "checkout_summary_placeOrder": "Achat",
    "basket_information_quantity_noItemsAdded_maxOrderQuantityExceeded": "Malheureusement, la quantité choisie excède la quantité de commande maximale de ce produit.",
    "text_account_saveCart_edit_error": "Une exception s’est produite durant la mise à jour du panier {0}",
    "breadcrumb_quote_view": "Devis {0}",
    "basket_export_user_industryRole": "Rôle de l'industrie",
    "search_nav_facetShowLess_colour": "moins de couleurs...",
    "checkout_paymentMethod_createSubscription_failed": "Échec de création de l’abonnement. Vérifiez les valeurs saisies.",
    "text_quote_checkout_warning_message": "Modifier le panier peut entraîner l’annulation du devis fournisseur.",
    "checkout_express_error_notAvailable": "Caisse rapide non disponible, car désactivée.",
    "basket_page_update": "Mise à jour",
    "text_account_quote_status_display_BUYER_ACCEPTED": "Accepté",
    "pickup_pagination_first": "Premier",
    "text_loadingMessage": "Chargement...",
    "register_checkbox_net_label": "Prix net",
    "text_account_core_search": "Afficher tout",
    "product_view_more": "Plus >",
    "product_variants_update": "Mise à jour",
    "text_account_profile_updateEmailAddress": "Entrez votre nouvelle adresse courriel, puis confirmez avec mot de passe",
    "pickup_product_by_store_location": "Produit par emplacement de magasin",
    "text_quote_conteroffer_confirmation_modal_title": "Confirmer le devis fournisseur {0}?",
    "basket_export_cart_error": "Une exception s’est produite durant l’exportation du panier",
    "account_confirmation_signout_subtitle": "Votre panier attendra votre retour (votre reconnexion).",
    "checkout_multi_sop_useThisPaymentInfo": "Utiliser cette info de paiement",
    "checkout_multi_paymentMethod_addPaymentDetails_paymentCard": "Détails de la carte",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_lastName": "Entrez une valeur pour ce champ",
    "review_headline_invalid": "Entrez un titre",
    "text_core_submit_address_requestedTime": "Available collection times:*",
    "basket_page_viewFuture_not_multisku": "Le code sélectionné {0} n’est pas un produit multidimensionnel",
    "text_core_submit_itemQty_invalid": "Obligatoire",
    "checkout_error_paymentethod_formentry_sop_missing_shipTo_state": "Entrez une valeur pour ce champ",
    "checkout_express_error_deliveryMode": "Caisse rapide non disponible. Une erreur s’est produite lors de la définition du mode de livraison.",
    "review_write_title": "Écrire un avis",
    "text_quickorder_template": "Modèle importation de commande",
    "text_productreviews": "Avis",
    "quote_more_comments": "Afficher plus de commentaires",
    "forgottenPwd_submit": "Envoyer un courriel",
    "import_csv_savedCart_success": "Chaque ligne peut être téléversée avec succès sans aucune erreur.",
    "address_furtherSubarea_invalid": "Entrez un numéro de sous-secteur supplémentaire",
    "text_consent_button_accept": "OK",
    "checkout_multi_deliveryMethod_useThisDeliveryMethod": "Utiliser la méthode de livraison sélectionnée",
    "checkout_error_paymentethod_formentry_sop_missing_billTo_firstName": "Entrez une valeur pour ce champ",
    "guest_checkPwd": "Confirmer le mot de passe*",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_error": "Veuillez sélectionner une entreprise de transport pour compléter le processus de validation d’achat.",
    "text_companyRegistrationRequest_content": "Le survol ci-dessous vous montre chaque demande d’inscription des employés de votre société qui ont déjà envoyé ce formulaire. Veuillez vérifier attentivement chaque demande, puis révisez-la et approuvez-la, ou refusez-la.",
    "text_storefinder_desktop_page_lastPage": "&raquo;",
    "checkout_orderConfirmation_coupon_code": "Utiliser le code coupon : {0}",
    "register_company_address_zip_invalid": "Entrez le code postal de l’entrepriset",
    "quote_edit": "Modifier le devis",
    "text_account_selectSalesarea": "À quel secteur de ventes souhaitez-vous avoir accès?t",
    "basket_validation_entryGroupError": "L’un des groupes d’entrée est erroné; il doit être corrigé avant de passer à la caisse.",
    "basket_page_totals_error_wrongcountry": "Sélectionnez un pays/une région",
    "forgottenPwd_title": "Réinitialiser le mot de passe",
    "text_account_orderHistory_viewOrders": "Afficher votre historique des commandes",
    "register_termsOfUsage_accept": "J’accepte lest",
    "order_history_status_details": "Détails, état de la commande",
    "checkout_multi_deliveryAddress_edit": "Modifier",
    "guest_register": "Créer un compte",
    "checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_EMEA_error": "Veuillez sélectionner un type de livraison pour compléter la validation d’achat.",
    "text_search": "Recherchet",
    "checkout_multi_deliveryAddress_breadcrumb": "Lieu d’expédition/de prélèvement",
    "text_account_savedCart_title_details": "Détails du panier enregistré",
    "text_myaccount_orderHistory": "&laquo; Historique des commandes",
    "text_warranty_submit_part_requestedHandlingAmount": "Montant demandé, manutention",
    "checkout_multi_paymentMethod_savedCards_select": "Sélectionner",
    "text_warranty_terms_cement_mixer": "Camion-malaxeur",
    "checkout_multi_paymentMethod_paymentDetails_expires": "Expire {0} / {1}",
    "cart_page_title": "Votre panier d’achatt",
    "product_grid_futurestock_hidefuture_availability": "Masquer disponibilité future",
    "text_country_selector_MENA": "Middle East & Africa",
    "updatePwd_checkPwd_invalid": "Confirmez votre mot de passe",
    "storeFinder_stores_nearby": "Magasins avoisinants",
    "register_checkbox_core_label": "Frais de base",
    "basket_page_packing_qty": "Vendu en multiples de",
    "coupon_already_redeemed": "Le code coupon saisi a déjà été utilisé.",
    "text_account_warranty_page_totalResults": "{0} réclamation(s) trouvée(s)",
    "storeFinder_meta_description_results": "emplacements magasins proches de",
    "basket_validation_lowStock": "Désolé, une quantité réduite de <a href",
    "text_quote_dateformat_datepicker_selection_hint": "mm/jj/aaaa",
    "text_account_orderHistory_back": "Retour",
    "text_account_openPosition_emptyPositions": "Non Positions en cours trouvés",
    "text_account_savedCarts_page_sort_byDateModified": "Date de modification",
    "product_product_details_future_quantity": "Quantité",
    "text_account_orderHistory_datePlaced": "Date comm. passée",
    "quick_order_page_alert_order_type_change": "Les dates ont été révisées en fonction du type de commande",
    "order_date_from": "Date de commande de*",
    "text_warranty_cahssis_number": "Numéro de châssis",
    "text_account_core_breadcrumbNA": "Centre d’informations des cores Bendix",
    "text_core_submission_coregrade": "Core Grade",
    "checkout_summary_select_payment_method": "Sélectionner le mode de paiement",
    "text_company_users": "Utilisateurs entreprise",
    "text_quote_expiration_time_invalid": "Entrez une date d’expiration valide",
    "text_language": "Sélectionner la languet",
    "basket_page_totals_estimatedtotaltax": "Taxe estimative :",
    "search_nav_facetShowMore_category": "plus de catégories...",
    "text_warranty_terms_dump_truck": "Camion-benne",
    "text_generalInfo_dimension": "Dimensions (L x l x H)",
    "text_headertext_error": "Erreur(s)",
    "mycompany_user_delete_note": "Note: You can not undo this deletion.",
    "mycompany_user_delete_account": "Delete a user account",
    "mycompany_user_delete_confMessage": "Are you sure you want to delete the following user account?",
    "checkout_page_deliveryType_complete_message": "Full delivery chosen: The last date in your cart positions is the expected delivery date for the entire order",
    "pdp_availableText": "DISPONIBLE",
    "pdp_unavailableText": "NON DISPONIBLE",
    "pdp_validEmailText": "Entrez une adresse de courriel valide",
    "globle_invalidDateFormat": "Format de date non valide!",
    "globle_notLessThanToday": "The Date must not less than today's date",
    "globle_notLessThanDefault": "The Date must not less than default date",
    "globle_weekendDate": "Fin de semaine! Sélectionnez une autre date",
    "warranty_vinError": "Le VIN doit être composé de 17 chiffres",
    "warranty_duplicatePartNo": "Numéro de pièce déjà utilisé.",
    "fselect_defaultPlaceholder": "Select some options",
    "fselect_pageCoreReportPlaceholder": "Veuillez sélectionner le parent principal",
    "fselect_noResultFound": "Aucun résultat trouvé",
    "fselect_selected": "sélectionnée",
    "text_software_download_heading2": "Type de pack logiciel",
    "text_software_download_heading": "Logiciel",
    "fselect_pageUploadPartPlaceholder": "Rechercher un identifiant client, un nom d'entreprise",
    "fselect_pageAddUserPlaceholder": "Rechercher un identifiant client, un nom d'entreprise ou une adresse",
    "text_Saved_Shipping_Addresses": "Adresses d’expédition enregistrées",
    "text_Saved_Billing_Addresses": "Adresses de facturation enregistrées",
    "user_rights_approval": "Définir les droits de l’utilisateur",
    "core_submit_warranty_material_includedyes": "Warranty Material Included",
    "text_core_PackageType": "PackageType",
    "select_collection_address_pdf": "Collection Address",
    "text_core_Ship-to_pdf": "Ship-to",
    "text_core_packaging_pdf": "Type Of packaging",
    "text_core_Stackable_pdf": "Stackable",
    "text_core_CollectionDate": "Collection Date",
    "text_core_CollectionTime": "Collection Time",
    "text_core_ForkLift": "Fork Lift Required",
    "text_core_TailLift": "Tail Lift Required",
    "text_core_addinfo": "Addition Info",
    "automatically_generated_by_kb": "Automatically generated by Knorr-Bremse",
    "text_core_submission_upgradeonly": "Upgrade Core",
    "text_core_submission_grouponly": "Group",
    "text_core_submission_classonly": "Class",
    "tooltip_text": "e.g. max. vehicle size",
    "text_account_quote_msg1": "Supprimer un compte utilisateur",
    "text_account_quote_msg2": "Voulez-vous vraiment supprimer le compte utilisateur suivant?",
    "text_account_quote_msg3": "Remarque : Vous ne pourrez annuler cette suppression.",
    "quickorder_checkbox_not_selected_text": "Aucune case n’est cochée",
    "order_history_cumulative_price": "*Prix cumulé pour une pièce incluant le cas échéant la consigne, les frais de port et surcharges applicables",
    "text_core_submit_firstName": "Prénom",
    "profile_firstName_invalid": "Entrez un prénom",
    "search_placeholder": "Entrer un numéro (pièce, type), un titre, ou définir le document",
    "basket_export_user_firstName": "Prénom",
    "checkout_orderConfirmation_Customer_ID": "Numéro de client :",
    "header_customer_id": "Numéro de client :",
    "register_firstName_invalid": "Entrez un prénom",
    "profile_firstName": "Prénom",
    "address_firstName_invalid": "Entrez un prénom",
    "text_ExportMyData_label": "Exporter mes données",
    "password_strength_minchartext": "Le mot de passe doit comporter au moins %d caractères, des lettres majuscules et minuscules et un caractère spécial",
    "text_register_caps": "S’INSCRIRE",
    "checkout_page_summary_final_review_customerId": "Numéro de client :",
    "profile_submit": "Mise à jour",
    "text_account_profile_saveUpdates": "Mise à jour",
    "register_firstName": "Prénom*",
    "address_firstName": "Prénom",
    "updatePwd_submit": "Mise à jour",
    "text_core_submit_address_addressFName": "Prénom",
    "text_Type_here_to_search_address": "Tapez ici pour rechercher une adresse",
    "error_account_myPart_template_format_confirm_msg": "Le fichier sélectionné n'est pas au bon format - voulez-vous continuer?",
    "user_diaabled_invalid_msg": "Ce compte utilisateur a été fermé, veuillez contacter votre administrateur",
    "basket_error_admin_missing": "Cannot access the requested url ,as login customer does not belongs to admin group",
    "type_of_packaging_select": "Veuillez sélectionner",
    "text_warranty_submit_part_type_number": "Modèle (remplissage auto)",
    "text_order_status_partially_delivered": "Partiellement livré",
    "text_user_table_lock_user_account": "Bloquer le compte",
    "text_account_dropship_address": "Drop ship Address",
    "text_warranty_vehicle_identification_notnumber": "Numéro d’identification de véhicule",
    "breadcrumbs_core": "Présentation de pièces usées",
    "text_warranty_shipping_packaging_tab_part_return": "Retour de pièces – Directives d’expédition:",
    "text_warranty_shipping_packaging_tab_product_claim": "Le produit dit défectueux doit être retourné prépayé (sans frais de transport pour le destinataire) par le concessionnaire de l’équipement d’origine (EO) ou par le distributeur agréé Bendix dans les trente (30) jours après la découverte du défaut.",
    "text_warranty_shipping_packaging_tab__address": "Expédiez au centre de réclamations sous garantie Bendix (cf. ci-dessous). Veillez à écrire lisiblement « Bendix Warranty Center » sur le colis.",
    "text_warranty_shipping_packaging_tab_us_address": "Aux É.-U., expédiez le colis PRÉPAYÉ à:",
    "text_warranty_shipping_packaging_tab_us_address_bendix": "Bendix Warranty Center",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line1": "1155 East Franklin Street",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line2": "Huntington, Indiana 46750",
    "text_warranty_shipping_packaging_tab_us_address_bendix_line3": "",
    "text_warranty_shipping_packaging_tab_canada_address": "Au Canada, expédiez le colis PRÉPAYÉ à:",
    "text_warranty_shipping_packaging_tab_canada_address_bendix": "Bendix Commercial Vehicle Systems Warranty Center",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line1": "8851 Crescent 4",
    "text_warranty_shipping_packaging_tab_canada_address_bendix_line2": "Anjou, Quebec H1J 1A9",
    "register_company_additionalSoldToLocations": "Sites donneurs d'ordre additionnels",
    "heading_dtc_description": "Description DTC",
    "heading_service_data_sheet": "Fiche Technique",
    "heading_dtc_search": "Recherche DTC",
    "dtc_go_btn": "Go",
    "text_core_search_contact": "Contactez <u><a href=\"mailto:cores@bendix.com\"> cores@bendix.com </a></u> si vous avez des problÃ¨mes ou des questions.",
    "dtc_component_title": "Piece (ECU)",
    "dtc_type_title": "Type de Code",
    "breadcrumb_DTC_text": "Recherche Code DTC",
    "DTC_Trouble_Code_Search": "Centre de recherche DTC",
    "DTC_Please_Select": "Choisir",
    "dtc_PlaceHolder_description": "Entrez un DTC, SPN/FMI, SID/FMI ou code clignotement",
    "delete_all_no_text_label": "No",
    "text_coreimport_error_allotherlines_message": "Toutes les autres lignes ont été téléchargées avec succès sur le formulaire de retour de base.",
    "text_coreimport_error_errorinline_message": "Erreur à la ligne",
    "text_coreimport_error_notvalidornotfound_message": ";Veuillez réessayer ou effectuer une recherche <a href",
    "text_core_csv_infoTip_text": "Pour éviter les erreurs de téléchargement, utilisez les valeurs de note de base suivantes:<br>Bon noyau, dommages en 1 partie, dommages en 2 parties, mise au rebut et ne sait pas<br>Si vous avez une mise à niveau, cochez la case après le téléchargement<br>*Tous les champs sont obligatoires, si des informations invalides sont saisies, vous verrez un message d'erreur.",
    "text_orderimport_error_allotherlines_message": "Toutes les autres lignes ont été téléchargées avec succès dans le panier d'achat.",
    "text_orderimport_error_errorinline_message": "Erreur dans la ligne",
    "text_orderimport_error_invaliddateformat_message": "&nbspLe format de la date de livraison demandée n'est pas correct, veuillez le modifier comme suit&nbsp",
    "text_orderimport_error_invalidcsvformat_message": "&nbspSéparateur csv incorrect, veuillez le remplacer par un&nbsp",
    "text_orderimport_error_notvalidornotfound_message": "&nbspnon valide/non trouvé.",
    "text_orderimport_error_partno_message": "&nbspRéférence&nbsp",
    "text_orderimport_error_tryagainorcontact_message": "&nbspVeuillez réessayer ou contacter le<a target",
    "text_orderimport_error_customerservice_message": "'> Service client</a>",
    "text_orderimport_error_notpurchasable_message": "&nbspn'est pas vendable et n'a pas été téléchargé",
    "text_orderimport_error_pleasecheck_message": "&nbspveuillez vérifier la <a href ",
    "text_orderimport_error_notpurchasable1_message": "&nbspLa référence ou la quantité ne peuvent pas être vides.",
    "text_orderimport_error_deliverydate_message": "&nbspLa date de livraison demandée pour la référence&nbsp",
    "text_orderimport_error_deliverydate1_message": "&nbspne peut être dans le passé.",
    "text_orderimport_error_obsolete_message": "&nbspest obsolète et n'a pas été téléchargé, veuillez vérifier la <a href ",
    "text_orderimport_error_obsolete1_message": "'> page détail produit</a> pour plus d'informations.",
    "text_orderimport_error_semicolon_message": "point-virgule",
    "text_orderimport_error_comma_message": "virgule",
    "text_dimension_length": "Longueur",
    "text_dimension_width": "Largeur",
    "text_dimension_height": "Hauteur",
    "checkout_error_payment_address_empty": "Votre demande ne peut être traitée, veuillez contacter le service client.",
    "text_saved_cart_qty_label": "Qté:",
    "document_text_language": "Language : ",
    "document_video_launch_btn": "Lancer la vidéo",
    "document_text_revision": "Revision : ",
    "document_text_releaseDate": "Date de publication : ",
    "text_account_warranty_table_header_inspection_report": "Inspection Report",
    "ppd_freight_greater_than_subtotal_info": "Your cart total (exclude core charges) is {0} {1}. You can qualify for prepaid freight if you add {2} {1} worth of parts to your cart.",
    "text_account_document_favorite_totalResults": " document(s) trouvé(s)",
    "DEALER_ADB": "Formulaire de demande de freins",
    "text_account_document_favorite_table_doc_description": "Définition doc.",
    "text_account_document_favorite_table_doc_number": "Numéro doc.",
    "text_account_document_favorite_table_doc_rev": "Rév. doc.",
    "text_account_document_favorite_table_doc_type": "Type doc.",
    "document_library_text_document": "Webliothèque",
    "document_download_btn": "Documents à télécharger",
    "document_library_placeholder_text": "Entrer le nom ou une définition du document",
    "text_breadcrumb_favorite_documents": "mes documents favoris",
    "text_account_document_favorite_heading": "Mes Favoris",
    "text_account_document_favorite_heading_NA": "Mes Favoris",
    "text_account_warranty_table_header_display_creditmemo_popup_content": "S’adresser à votre siège social au sujet des modalités de paiement. Verser les paiements de garantie à",
    "document_library_text_document_category": "Catégorie de produits",
    "text_account_document_favorite_table_doc_language": "Translation",
    "action_send_ticket_invite_confirm": "Voulez-vous vraiment attribuer le CRM au billet sélectionné?",
    "action_send_ticket_invite_sent_title": "Billet attribué au CRM.",
    "action_send_ticket_invite_error_title": "Échec de l’attribution CRM, veuillez réessayer plus tard.",
    "text_account_supporttickets_requestSupport": "Créer un nouveau billet",
    "text_account_supporttickets_newticket": "Nouveau billet",
    "text_account_supporttickets_search_ticketCategory_PSA": "Installation produit/système",
    "text_account_supporttickets_search_ticketCategory_PSG": "Produit/système (renseignements généraux)",
    "text_account_supporttickets_search_ticketCategory_TST": "Dépannage",
    "text_account_supporttickets_search_ticketCategory_SOther": "Assistance Autre",
    "text_account_supporttickets_ticketType": "Type de billet",
    "text_account_supporttickets_status_All": "Tous",
    "text_account_supportTickets_page_totalResults_AllTickets": "{0} billets trouvés",
    "supportticket_startDate_invalid": "Sélectionner une date de début valide.",
    "supportticket_endDate_invalid": "Sélectionner une date de fin valide.",
    "text_account_supportticket_startDate": "Sélectionner une date de début.",
    "text_account_search_to_date_invalid_future": "\"Date de début\" ne peut être dans \"date future\".",
    "text_account_search_from_date_invalid_future": "\"À compter de\" ne peut être dans \"date future\".",
    "text_account_search_from_date_to_date_invalid": "\"À compter de\" ne peut être postérieur à \"date actuelle de la demande\".",
    "text_account_search_to_date_invalid": "La \"date actuelle\" ne peut être antérieure à \"date de début de la demande\".",
    "text_account_supportticket_endDate": "Sélectionner une date de fin.",
    "text_account_supportticket_defaultSoldTo": "Sélectionnez l’ID client",
    "text_account_supporttickets_createTicket_ticketCategory_ORDER": "Aide commande",
    "text_account_supporttickets_createTicket_ticketCategory_WARRANTY": "Aide garantie",
    "text_account_supporttickets_createTicket_ticketCategory_CORE": "Aide pièces usées",
    "text_account_supporttickets_createTicket_ticketCategory_SOTHER": "Assistance Autre",
    "supportticket_category_invalid": "Entrer une catégorie valide",
    "supportticket_associatedTo_invalid": "Entrer un \"Associé à\" valide",
    "text_ADB_applicationNum": "Numéro de l’installation des freins*",
    "text_ADB_controlNumber": "Numéro de contrôle clients",
    "text_ADB_axleManufacturer": "Fabricant d’essieux*",
    "text_ADB_oem": "Équipementier*",
    "vehicleModel_code_value": "Modèle véhicule*",
    "text_ADB_vehicleType": "Type véhicule*",
    "text_ADB_chassisNumber": "Numéro de châssis*",
    "text_ADB_axleConfig": "Configuration d’essieux*",
    "text_ADB_vocation": "Emploi*",
    "text_ADB_GAWR_Front": "Poids technique maximal sous essieu avant",
    "text_ADB_GAWR_Forward": "Poids technique maximal sous essieu arrière en avant",
    "text_ADB_GAWR_Pusher": "Poids technique maximal sous essieu poussé",
    "text_ADB_GAWR_Rear": "Poids technique maximal sous essieu arrière",
    "text_ADB_GAWR_Tag": "Poids technique maximal sous essieu traîné/auxiliaire",
    "text_ADB_Auxiliary_Axle": "Essieu auxiliaire",
    "text_ADB_GAWR_Mid_Rear": "Poids technique maximal sous essieu mi-arrière",
    "text_ADB_ADDITIONAL_AXLE": "Poids technique maximal sous essieu additionnel",
    "text_ADB_Additional_Axle_Cust": "Autre limitation client du poids sous essieu",
    "text_ADB_tire_Type": "Type de pneus",
    "text_ADB_tire_TypeSLR": "Rayon sous charge",
    "text_ADB_gvwr": "PNBV*",
    "text_ADB_wheelBaseRange": "Plage d’empattement*",
    "text_ADB_frontTires": "Pneus avant*",
    "text_ADB_frontTiresSLR": "Rayon sous charge, pneus AV*",
    "text_ADB_rearTire": "Pneus arrière*",
    "text_ADB_wheelBase": "Empattement*",
    "text_ADB_cgHeightLaden": "Hauteur centre de gravité (en charge)*",
    "text_ADB_cgHeightUnladen": "Hauteur centre de gravité (à vide)*",
    "text_ADB_proposed_FR": "Arrière en avant proposé",
    "text_ADB_proposed_FM": "Mi-avant proposé",
    "text_ADB_proposed_SAB": "Arrière et arrière en avant proposés",
    "text_ADB_proposed_DAB": "Frein d’essieu directeur proposé",
    "text_ADB_please_note": "Noter:",
    "text_ADB_customer_information": "Informations sur le client",
    "text_ADB_vehicle_information": "Informations sur le véhicule :",
    "text_ADB_axle_gawr": "Poids Essieu:",
    "text_ADB_add_an_aditional_axl_gawr": "Ajouter un poids technique maximal sous essieu :",
    "text_ADB_customer_axle_weight_limitation": "Limitation client du poids sous essieu :",
    "text_ADB_add_aditional_customer_axle_weight_limitation": "Ajouter une autre limitation client du poids sous essieu :",
    "text_ADB_tire_statically_loaded_radius": "Rayon sous charge statique des pneus",
    "text_ADB_vehicle_specification": "Spécification véhicule",
    "text_ADB_proposed_tag_axle": "Frein proposé essieu traîné/essieu auxiliaire",
    "Bendix_break_application": "Formulaire de demande de freins",
    "text_warranty_note": "Noter:",
    "text_ADB_add_axel": "Ajouter essieu",
    "text_ADB_add_axel_cutomer": "Ajouter client essieu",
    "text_ADB_tire_type": "Ajouter type de pneus",
    "text_ADB_add_tire_slr": "Ajouter rayon sous charge statique",
    "text_break_submission_NA_text1": "Merci de votre envoi du formulaire de freins à disque pneumatiques;",
    "Bendix_break_application_msg1": "Veuillez remplir tous les champs et revoir votre formulaire de demande de frein avant de le soumettre.",
    "Bendix_break_application_msg2": "Pour plus d'informations, veuillez consulter le  <a href='https://n0c357rmy1njbuit2friqwu.blob.core.windows.net/documents/OSMALy4oI0EBhB_Y497108_EN_000.pdf' target='_blank'> <b>Processus de Demande de demande de frein </b></a>",
    "text_bendix_search_text1": "Les clients de Bendix peuvent s’informer en ligne de leur formulaire de demande de freins. Les critères de recherche suivants vous permettront de trouver votre formulaire de demande de freins.",
    "text_bendix_search_text2": "Notez que les champs ID client et plage de date sont obligatoires.",
    "text_bendix_search_text3": "Recherche d’un formulaire de demande de freins",
    "text_ADB_rearTires": "Pneus arrière*",
    "text_adb_submission_review_text": "Réviser votre formulaire avant de l’envoyer.",
    "text_account_warranty_claim_search": "Recherche de réclamations sous garantie",
    "text_account_warranty_table_header_dsiplay_status": "Réclamer Statut Raison",
    "text_account_warranty_claim_tracking_info": "Pièces retournées par",
    "text_account_warranty_table_header_dsiplay_claim_number": "Ouvrir en format PDF cette demande de réclamation présentée, ou encore l’ouvrir en un nouveau modèle en vue de créer une nouvelle demande.",
    "text_account_warranty_table_header_dsiplay_claim_number_content": "La nouvelle demande de réclamation aura la même information véhicule que l'originale : vérifier l’exactitude du NIV et des renseignements avant de la présenter",
    "text_account_warranty_table_header_dsiplay_claim_number_button_pdf": "Ouvrir la demande de réclamation en PDF",
    "text_account_warranty_table_header_dsiplay_claim_number_button_template": "Ouvrir la demande de réclamation comme nouveau modèle",
    "text_account_warranty_table_header_credit_memo": "No de note de crédit",
    "text_account_warranty_table_header_credit_amount": "Montant du crédit (USD)",
    "text_account_warranty_search_page_firstPage": "&laquo;",
    "text_consent_read": "J’ai lu la",
    "text_consent_accept": "Veuillez accepter la déclaration de protection des données et l’exclusion de responsabilité du téléchargement",
    "text_ADB_add_aditional_customer_tire_type": "Type de pneus",
    "text_return_request_po_number": "Numéro de bon de commande*",
    "text_return_request_return_type": "Type de retour*",
    "text_warranty_submit_kb_return_request_number": "Numéro de demande de retour",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name_oem": "Rapport de core / Soumissions de retours de core",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "Rapport de core / Soumissions de retours de core",
    "text_account_order_tracking": "Numéro de suivi",
    "text_account_order_tracking_ID": "Numéro d'identification de suivi",
    "text_checkout_page_delivered_qty": "Quantité livrée:",
    "text_return_request_heading": "Formulaire de demande de retour",
    "text_checkout_page_delivery_qty": "Quantité de livraison:",
    "text_ticket_search_from_date": "À partir de la date de début de la formation",
    "text_ticket_search_to_date": "À la date de fin de la formation",
    "text_account_supporttickets_createTicket_attachement_label": "pièces jointes",
    "text_account_supporttickets": "Tickets de support",
    "text_supporttickets_search_from_date": "Date ticket du",
    "text_supporttickets_search_to_date": "Date ticket au",
    "text_supporttickets_reset": "Réinitialiser",
    "text_supporttickets_search": "chercher",
    "text_account_supporttickets_customerID": "Cliente ID",
    "text_account_supporttickets_status": "Estado",
    "text_account_supporttickets_createTicket_no_attachement_label": "Aucune pièce jointe trouvée",
    "text_account_supporttickets_ticketIdAscending": "ID de ticket croissant",
    "text_account_supporttickets_ticketIdDescending": "ID de ticket décroissant",
    "text_account_supporttickets_categoryAscending": "Catégorie ascendante",
    "text_account_supporttickets_categoryDescending": "Catégorie décroissante",
    "text_account_supporttickets_headlineAscending": "Sujet croissant",
    "text_account_supporttickets_headlineDescending": "Sujet décroissant",
    "text_account_supporttickets_creationtimeAscending": "Date de création ascendante",
    "text_account_supporttickets_creationtimeDescending": "Date de création décroissante",
    "text_account_supporttickets_modifiedtimeAscending": "Date de mise à jour par ordre croissant",
    "text_account_supporttickets_modifiedtimeDescending": "Date de mise à jour décroissante",
    "text_account_supporttickets_stateAscending": "Statut croissant",
    "text_account_supporttickets_stateDescending": "Statut décroissant",
    "adb_approvalType_INREVIEW": "Avis d'ingénieur",
    "adb_approvalType_RECEIVED": "Approuvé par l'ingénieur",
    "adb_approvalType_AWAITING": "Entrée requise",
    "adb_approvalType_REJECTED": "rejeté",
    "header_customer_channel_oem": "OEM",
    "header_customer_channel_distributor": "Distributor",
    "header_customer_channel_dealer": "Dealer",
    "header_customer_channel_service_new": "Service New",
    "text_request_search_bendix_adb_number": "Bendix ADB Nombre",
    "text_company_manageUser_registration_zeroResults": "0 Nouvelle (s) demande (s) trouvée (s)",
    "text_generalInfo_submitdate": "Création Date",
    "text_core_search_appNumber": "Frein Utilisations numéro",
    "text_headline_status": "État",
    "text_generalInfo_comments": "Commentaires",
    "text_application_requestt": "Application des freins demande",
    "text_application_request": "Formulaire de demande de freins",
    "text_generalInfo_customerid": "Client ID",
    "text_ADB_Comments": "Commentaires",
    "account_adb_breadcrumbs": "Visitez ma page",
    "breadcrumb_bendixAdbCMSPage_text": "Application des freins",
    "text_ADB_brakeType": "Type de frein*",
    "addtional_comment_enginnering_admin": "Recommandations supplémentaires par l'équipe d'ingénierie",
    "text_adb_admin_edit_adminName": "Nom de l'administrateur technique",
    "text_adb_admin_edit_applicationNum": "Utilisations Numéro",
    "text_adb_admin_edit_applicationDate": "Utilisations Date",
    "text_adb_admin_edit_partNumber": "Numéro de pièce",
    "text_adb_admin_edit_additionComments": "Supplémentaires Commentaires",
    "text_adb_admin_editt_customerID": "Numéro de client",
    "text_ADB_register_company_phoneNumber": "Numéro de téléphone",
    "adb_register_lastName": "Nom",
    "text_adb_placeholder": "Entrer ici",
    "software_library_placeholder_text": "Entrez le nom du logiciel....",
    "text_booking_training_failed_noseats": "Aucune place disponible.",
    "text_ADB_approvalType": "Type d'approbation",
    "please_select_your_customer_id": "Sélectionnez votre Numéro de client",
    "text_account_supporttickets_createTicket_associatedTo_option_na": "N'est pas applicable",
    "text_account_supporttickets_invalid_format": "Remarque: Les fichiers word, xls, xlsx, csv, txt, tif, gif, jpg, pdf sont permis!",
    "text_request_search_claim_from_date": "Réclamation, date de début",
    "text_request_search_claim_to_date": "Réclamation, date de fin",
    "text_retrun_request_submit_part_nature_defect": "Raison du retour*",
    "text_return_request_please_upload_all": "Veuillez télécharger tous les documents nécessaires à l'examen de votre formulaire de demande de retour.",
    "text_return_request_document_attachement_all": "Les documents peuvent être joints s'ils sont au format jpg, word ou pdf et s'ils ne dépassent pas 9 Mo au total.",
    "general_phone_number": "Ingrese un número de teléfono válido",
    "text_cart_popup_tag": "Prix par qté/promo cliquer pour afficher",
    "text_cart_popup_tag_msg_title": "Prix par qté/promo",
    "text_cart_popup_tag_msg_content": "La référence suivante",
    "text_cart_popup_tag_msg_content2": "est actuellement en promotion de",
    "text_cart_popup_tag_msg_content3": "à",
    "text_cart_popup_tag_msg_content1": "La référence suivante",
    "text_cart_popup_tag_msg": "a un prix par qté",
    "text_cart_popup_tag_datemsg": "Cette promo est valide du {0} au {1}",
    "text_cart_popup_tag_new": "Cliquez ici pour obtenir des informations sur les prix",
    "basket_page_cartId_message_new": "Cliquez sur l'icône représentant une étiquette pour afficher des informations supplémentaires sur les prix de certains articles de votre panier.",
    "text_cart_popup_tag_msg_title_new": "Informations sur les prix",
    "text_scale_price": "Prix échelonnés pour",
    "text_scale_price_to": " à ",
    "text_scale_price_or": " ou",
    "text_scale_price_more": ">",
    "text_scale_price_per_piece": "{0} par pc",
    "text_ADB_proposed_Pusher": "Essieu pousseur proposé",
    "text_ADB_proposed_Tag": "Essieu suivre/auxiliaire proposé",
    "text_ADB_proposed_AuxilaryAxle": "Essieu auxiliaire proposé",
    "text_software_thank_for_request_lable_na": "Merci pour la demande de téléchargement du logiciel.",
    "text_software_search_type_code_content1_na": "Vous recevrez un e-mail. Pour télécharger ce logiciel, veuillez cliquer sur le lien contenu dans l'e-mail",
    "text_software_language_lable": "Language",
    "text_software_size_lable": "Taille du logiciel",
    "text_software_operating_system_lable": "Système d'exploitation",
    "text_software_software_producer_lable": "Fabricant du logiciel",
    "text_software_licence_lable": "Licence",
    "text_software_software_version_lable": "Version Software",
    "text_software_last_update_lable": "Dernière mise à jour ({0})",
    "text_software_general_information_lable": "Informations générales",
    "text_software_information_lable": "A propos du logiciel",
    "text_software_feature_list_lable": "Liste des caractéristiques du logiciel",
    "text_software_demo_lable": "Démo",
    "text_account_mypart_count_message": "Vous avez demandé le téléchargement de vos références articles dans le système  {0}.###Votre fichier original contenait  {1} références ; votre nouveau fichier contient {2} références.###Une fois que votre fichier sera complètement téléchargé dans le système  {3}, il remplacera toutes les informations existantes par votre nouveau fichier.###Souhaitez-vous continuer le téléchargement ?",
    "text_software_service_lable": "Workshop",
    "text_software_oem-eol_lable": "OEM-EOL (test fin de chaîne)",
    "text_software_request_form_lable": "Veuillez remplir le formulaire ci-dessous pour demander votre logiciel.",
    "text_software_request_form_choice_lable": "Avez-vous besoin seulement du logiciel ou avez-vous également besoin d'une licence ?",
    "text_software_request_form_choice_one_lable": "Logiciel et code Pin",
    "text_software_request_form_choice_two_lable": "Logiciel uniquement",
    "text_software_request_form_company_information_lable": "Informations société",
    "text_software_request_form_company_lable": "Société*",
    "text_software_request_form_roleinindustry_lable": "Rôle dans l'industrie*",
    "text_software_request_form_first_name_lable": "Prénom*",
    "text_software_request_form_last_name_lable": "Nom*",
    "text_software_request_form_department_lable": "Département",
    "text_software_request_form_street_lable": "Rue*",
    "text_software_request_form_postal_code_lable": "Code postal*",
    "text_software_request_form_city_lable": "Ville*",
    "text_software_request_form_country_lable": "Pays*",
    "text_software_request_form_phone_lable": "Téléphone*",
    "text_software_request_form_phone_eol_lable": "Téléphone",
    "text_software_request_form_email_lable": "E-mail*",
    "text_software_request_form_information_about_training_lable": "Informations concernant le stage",
    "text_software_request_form_check_person_lable": "Le stagiaire est-il toujours dans la société ?*",
    "text_software_request_form_check_yes_lable": "Oui",
    "text_software_request_form_check_no_lable": "Non",
    "text_software_request_form_check_certificate_lable": "Si possible, veuillez joindre votre attestation en PDF :",
    "text_software_request_form_ebs_person_firstname_lable": "Prénom du stagiaire formé sur l'EBS remorque*",
    "text_software_request_form_ebs_person_lastname_lable": "Nom du stagiaire formé sur l'EBS remorque*",
    "text_software_request_form_trainer_name_lable": "Formation dispensée par (Nom du formateur)*",
    "text_software_request_form_dot_lable": "Date de la formation",
    "text_software_request_form_place_of_training_lable": "Lieu du stage*",
    "text_software_thank_for_request_lable": "Merci pour votre demande de PIN / Logiciel",
    "text_software_return_homepage_lable": "Retour à la page d'accueil",
    "text_software_request_form_termandcondition_lable": "Conditions Générales",
    "text_software_request_form_licence_agreement_lable": "Contrat de licence",
    "text_software_request_form_privacy_agreement_lable": "l'Avis de Confidentialité",
    "text_software_request_form_conditions_lable": "Conditions d'utilisation de la boutique en ligne",
    "text_software_request_form_submit_lable": "Demande de logiciel",
    "text_software_search_software_download_lable": "Téléchargement de logiciel",
    "text_software_search_lable": "Recherche",
    "text_software_search_software_lable": "Logiciel",
    "text_software_search_language_lable": "Langue",
    "text_software_search_software_type_lable": "Type de logiciel",
    "text_software_search_button_reset_lable": "Réinitialiser",
    "text_software_search_button_search_lable": "Recherche",
    "text_software_search_title_lable": "Titre du logiciel (pack langue)",
    "text_software_search_type_lable": "Type de logiciel (pack langue)",
    "text_software_search_description_lable": "Description",
    "text_software_search_lang_lable": "Langue :",
    "text_software_search_version_lable": "Version :",
    "text_software_search_release_lable": "Date de la version :",
    "text_software_search_title_code_lable": "Titre du logiciel (TEBS G2)",
    "text_software_search_type_code_lable": "Type de logiciel (pack d'installation)",
    "text_software_search_type_code_i_accept_the": "J'accepte les",
    "text_software_search_type_code_i_have_read": "J’ai lu le",
    "text_software_search_type_code_content1": "Votre demande va être traitée",
    "text_software_search_type_code_content2": "Vous recevrez un e-mail avec votre demande ainsi qu’un autre dès que la demande aura été approuvée.",
    "storelocator_digits_validation": "Please enter 5 digits as zip code",
    "storelocator_valid_validation": "Please enter valid zip code",
    "storelocator_notFound_validation": "Aucune correspondance n'a été trouvée en utilisant le code postal, veuillez entrer une ville et un état",
    "text_request_core_search_claim_from_date": "Date de soumission du*",
    "text_request_core_search_claim_to_date": "Date de soumission au*",
    "text_core_submission_sucess_text1": "CANADA:<br/>Bendix CVS LLC / FastFrate<br/>9701 Hwy 50 <br/>Woodbridge, ON L4H 2G4 </br>***Les documents de retour de base doivent également être envoyés par courriel pour les envois canadiens <500 lb.",
    "text_core_submission_sucess_text2": "US:<br/>Bendix CVS LLC<br/> 1850 Riverfork Dr.</br>Huntington, IN 46750</br>***Les colis UPS doivent porter la mention CORE à l'extérieur",
    "pickup_address_provided": "Si la personne à contacter est différente de la personne ci-dessus, ajoutez ci-dessous:",
    "text_tooltip_actual_weight": "If you have the ability to weigh your return and it is different than our estimated weight above, please enter that here",
    "text_tooltip_package_type": "Pallets should be standard size, less than 48\" tall and under 2,000lbs.",
    "na_core_over500lbs_msg": "Plus de 500 lb ou 100 mâchoires de frein",
    "na_core_under500lbs_msg": "Moins de 500 lb (veuillez organiser vos envois)",
    "text_core_submission_product": "Type de produit*",
    "text_core_save_form_text": "You are saving this core return to be completed at a later date or when your shipment is ready for pickup.To open a saved form, go to Search Core Returns under My Account",
    "text_pickup_address": "Adresse de ramassage",
    "select_pickup_address": "Sélectionnez une adresse de prise en charge ci-dessous:",
    "text_core_submission_address_na": "Si l'adresse de ramassage n'est pas fournie dans la liste de sélection ci-dessus, veuillez ajouter une nouvelle adresse ci-dessous:",
    "text_actual_weight": "Vrai poids",
    "text_core_submit_address_stateCode": "État/Province*",
    "text_bendix_search_text4": "Core Formulaire de recherche de retour",
    "text_bendix_search_text5": "Les clients peuvent rechercher leurs déclarations de base en ligne. Toutes les déclarations de base soumises par tout utilisateur lié à l'ID client sélectionné seront visibles dans les résultats de la recherche.",
    "text_order_search_from_date_invalid_future": "La date du début de la commande ne peut pas être une date future",
    "text_order_search_to_date_invalid": "La date de fin de commande ne peut pas être inférieure à la date de début de commande",
    "text_order_search_to_date_invalid_future": "La date de commande à ne peut pas être dans une date future",
    "text_order_search_from_date_to_date_invalid": "La date de début de la commande ne peut pas être supérieure à la date de fin de la commande",
    "check_availability_btn_text": "Vérifier la disponibilité",
    "rhs_top_heading_text": "Outil de classification de l'appareil de direction Sheppard",
    "rhs_beginning_text": "STOP ! ! - LISEZ CECI AVANT DE COMMENCER.",
    "rhs_first_para_text": "<b><u>Les boîtiers de direction et les boîtiers esclaves</u></b><b><u>&nbsp;NE SONT PAS</u></b> concernés par ce rappel, à l’exception du modèle d’engrenage esclave HD94SAC2™. <p>Reportez-vous à la",
    "rhs_first_para_guide_label": "&nbsp;Guide d'identification",
    "rhs_first_para_identify_text": "&nbsp;pour l'identification des boîtiers de direction concernés ainsi que pour l'interprétation du numéro de série et de pièce.",
    "rhs_select_vehicle_gear_number_text": "Veuillez sélectionner la marque de votre véhicule et saisir le numéro de série complet à 8 caractères avant le tiret (-), comme indiqué ci-dessous, sans espace ni \"-C\" à la fin.",
    "rhs_select_vehicle_make_text": "Sélectionnez la marque du véhicule",
    "rhs_search_result_label": "Résultat",
    "rhs_search_details_label": "Détails",
    "rhs_vehicle_make_oem_mismatch_label": "Incohérence entre la marque du véhicule (OEM) et le numéro de série.",
    "rhs_vehicle_serial_number_label": "Numéro de série :",
    "rhs_search_details_heading": "Numéro de pièce/numéro de modèle de l'engrenage :",
    "rhsSearchText_placeHolder": "Veuillez entrer le numéro de série de l'engin",
    "rhs_search_details_vehicle_make": "Marque du véhicule (OEM) ou AM :",
    "rhs_search_form_error_not_found": "Numéro de série de l'appareil de direction : Introuvable <br><br>Vérifiez soigneusement le numéro de série et entrez de nouveau le numéro de série_ S'il n'est toujours pas trouvé, veuillez contacter Sheppard à <a href",
    "rhs_search_form_success_status_release": "Numéro de série de l'appareil de direction : Bon <br><br>Le véhicule peut être remis en service sans autre mesure corrective.",
    "rhs_search_form_rhsRecertified_status_release": "Numéro de série de l'appareil de direction : Bon - Recertifié <br><br>Le véhicule peut être remis en service sans autre mesure corrective.",
    "rhs_search_form_success_status_suspect": "Numéro de série de l'engrenage de direction : Suspect <br><br>Retirer et remplacer l'engrenage conformément aux instructions du constructeur du véhicule.",
    "rhs_search_form_serialNum_empty": "Veuillez saisir le numéro de série complet à 8 chiffres, sans espace",
    "rhs_search_form_make_empty": "Veuillez sélectionner la marque de votre véhicule",
    "rhs_search_form_serialNum_endsWithHyphenC": "Le numéro de série ne doit pas se terminer par -C. Veuillez le saisir à nouveau",
    "rhs_search_form_success_status_datarange": "Le numéro de série saisi est en dehors de la plage de dates et ne fait pas partie du rappel.",
    "rhs_search_form_success_status_remanufactured": "Le numéro de série saisi correspond à un engrenage remanufacturé et ne fait pas partie du rappel.",
    "rhs_search_form_success_status_reenter": "Vérifiez soigneusement le numéro de série et entrez à nouveau le numéro de série comme indiqué sur l'image ci-dessus",
    "rhs_search_form_mandate_check": "L'UTILISATEUR EST SEUL RESPONSABLE DE LA SAISIE DE DONNÉES EXACTES ET ASSUME TOUS LES RISQUES ASSOCIÉS À UN MANQUEMENT À CETTE OBLIGATION.",
    "text_anotherCR_sameBOL": "Voulez-vous créer un autre CR# à inclure sur la même BOL ?",
    "myReport_page_text_download_your_reports_NA": "Informations Bendix",
    "myReport_page_text_title_NA": "Télécharger les rapport",
    "myReport_page_text_paragraph1_NA": "Vous pouvez télécharger vos rapports ici. La liste suivante indique les rapports à votre disposition",
    "myReport_page_text_paragraph2_NA": "(sélectionnez ceux que vous souhaitez télécharger, puis cliquez sur le bouton de téléchargement).",
    "myReport_page_text_SelectAll_NA": "Sélectionner tout",
    "myReport_page_text_button_NA": "Télécharger les fichiers sélectionnés",
    "no_report_file_to_download_NA": "Aucun fichier de rapport à télécharger.",
    "register_checkbox_customerDocDownloadAccess_label": "Download Customer Documents",
    "myaccount_brakeform_customer_id": "Customer ID",
    "myaccount_brakeform_levelofexp_text": "Level of experience with installation/design/testing of ADB or S-Cam brakes*",
    "myaccount_brakeform_check_apply": "Check all that apply",
    "myaccount_brakeform_levelofexp_tooltext": "Foundation brake refers to air-actuated systems (air disc brake, s-cam drum brake)<br/>The purpose of this question is to determine the level of support you, the OEM customer, may require during the application request stage and the verification/validation and part release stages.",
    "myaccount_brakeform_projectreq_text": "Project Requirements",
    "myaccount_brakeform_projecttarget_text": "Project Target (Reason for Request)*",
    "myaccount_brakeform_projecttarget_tooltext": "\"Brake Model\" refers to the type (ADB or S-Cam) and sub-model (e.g. ADB22X, SN7, etc) <br/> \"Duty Cycle\" refers to the frequency, duration, magnitude, and other characteristics of the brake cycle that affect brake durability and performance.",
    "myaccount_brakeform_required_sample_text": "Will you require samples?",
    "myaccount_brakeform_required_sample_tooltext": "Select Yes if at least one type is needed",
    "myaccount_brakeform_required_sampleA_text": "Planned Unit Numbers",
    "myaccount_brakeform_required_sampleA_tooltext": "Indicate the quantity of A-Samples needed (first functional or prototype sample)",
    "myaccount_brakeform_targetdate_text": "Do you have target dates for samples?",
    "myaccount_brakeform_targetdate_text_tooltext": "Indicate whether you have target delivery dates.",
    "myaccount_brakeform_targetdate_sampleA_text": "Customer Schedule",
    "myaccount_brakeform_targetdate_sampleA_tooltext": "Indicate the target delivery date from Bendix to the customer for A-Samples",
    "myaccount_brakeform_sop_targetdate_text": "Customer Schedule (Start of Production Date)*",
    "myaccount_brakeform_sop_targetdate_tooltext": "Indicate the target date of start of production of the vehicle (or axle, in the case of axle manufacturers)",
    "myaccount_brakeform_ppv_firstyear_text": "Planned Production Volume - 1st Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_secondyear_text": "Planned Production Volume - 2nd Year (# of Vehicles)*",
    "myaccount_brakeform_ppv_thirdyear_text": "Planned Production Volume - 3rd Year (# of Vehicles)*",
    "myaccount_brakeform_ppap_level_text": "PPAP Level Required",
    "myaccount_brakeform_ppap_level_tooltext": "Bendix standard is Level 1 (Part Submission Warrant). Other requirements may incur additional cost and lead time.",
    "myaccount_brakeform_FMEA_text": "Are you able to provide FMEA (Design, System, or Process)?",
    "myaccount_brakeform_FMEA_tooltext": "Indicate whether you, the customer, are able to provide or show Bendix (under NDA) a Design, System, or Process FMEA at the level of the brake-to-axle interface",
    "myaccount_brakeform_conduct_fields_text": "Do you plan to conduct field tests for this application?*",
    "myaccount_brakeform_conduct_fields_tooltext": "A field test is a test using a fleet of vehicles in real world environments, serving the vehicle's primary vocation or purpose",
    "myaccount_brakeform_vehicles_used_text": "How many vehicles are or will be used in your field test(s)?",
    "myaccount_brakeform_field_test_text": "Have you performed field tests on similar applications? If yes, please provide detail*.",
    "myaccount_brakeform_field_test_tooltext": "Indicate whether you have performed field tests on similar applications. Provide detail on the vocation, axle weight ratings, brake models tested, number of vehicles tested, duration of the test, and the results",
    "myaccount_brakeform_legal_requirement_text": "Vehicle Operation Outside of USA/Canada?*",
    "myaccount_brakeform_legal_requirement_tooltext": "IF YES, List all countries where vehicle(s) will operate and the associated name/number of regulation(s) governing braking performance requirements in the COMMENTS section of this form",
    "myaccount_brakeform_cad_model_text": "Axle/chassis 3D CAD model availability for installation investigation*",
    "myaccount_brakeform_cad_model_tooltext": "\"3D CAD model\" refers to the customer model of the chassis or axle environment where the brake will be mounted.",
    "myaccount_brakeform_painting_condition_text": "Painting Conditions - Will Parts Be Painted after Delivery?",
    "myaccount_brakeform_painting_condition_tooltext": "Indicate whether parts will be painted after receipt, type and thickness of paint, and method of application",
    "myaccount_brakeform_vehicle_genral_tooltex": "Vehicle Information - General:",
    "myaccount_brakeform_Chassis_modification_text": "Post-Production Chassis Modification*",
    "myaccount_brakeform_Chassis_modification_tooltext": "Please describe whether you expect the chassis to be modified after delivery to your customer, and the details of the expected or known modification (e.g. body builder chassis modification)",
    "myaccount_brakeform_Vehicle_lifetime_text": "Lifetime of Vehicle*",
    "myaccount_brakeform_Vehicle_lifetime_tooltext": "Indicate the expected lifetime, in years, of the vehicle",
    "myaccount_brakeform_annual_use_text": "Annual Use (miles)*",
    "myaccount_brakeform_annual_use_tooltext": "Indicate expected or typical annual use, in miles per year",
    "myaccount_brakeform_highway_operation_text": "% On-Highway Operation*",
    "myaccount_brakeform_highway_operation_tooltext": "Indicate what percentage of total vehicle operation time is spent on-highway. Includes well-maintained major highways of excellent concrete or asphalt construction.Terrain may be level to rolling with occasional maximum adverse grades to 8%. Operations are subject to legal weight and dimensional limits.",
    "myaccount_brakeform_average_grade_text": "Average Grade (%)*",
    "myaccount_brakeform_avergae_grade_tooltext": "Indicate the average grade encountered during operation",
    "myaccount_brakeform_maximum_optimum_grade_text": "Maximum Operating Grade, Length, Speed (Descent)",
    "myaccount_brakeform_maximum_optimum_grade_tooltext": "Indicate the maximum grade encountered during typical operation (descent), length down grade, and speed down grade.",
    "myaccount_brakeform_endurance_brake_text": "What type of Endurance Brake System is onboard?*",
    "myaccount_brakeform_endurance_brake_tooltext": "Indicate the endurance brake systems equipped to the vehicle. An endurance brake system is an additional braking system having the capability to provide and to maintain a braking effect over a long period of time without a significant reduction in performance.",
    "myaccount_brakeform_service_brake_text": "Service Brake Duty Cycle (Excluding Parking)*",
    "myaccount_brakeform_service_brake_tooltext": "Describe the typical frequency (how often), duration (for how long), and magnitude (how hard) of the brake actuation. Describe typical speeds at which brakes are applied.",
    "myaccount_brakeform_parking_duty_text": "Parking Duty Cycle / Conditions*",
    "myaccount_brakeform_parking_duty_tooltext": "Describe the frequency and duration of the application of the parking brake, as well as the average and maximum grades on which the vehicle is expected to park",
    "myaccount_brakeform_parking_test_oem_text": "Parking Test Requirements - Customer (OEM)*",
    "myaccount_brakeform_parking_test_oem_tooltext": "*Note: Parking is a function of vehicle systems beyond the wheel end. The vehicle manufacturer is responsible for ensuring the vehicle meets parking requirements specified by FMVSS 121.",
    "myaccount_brakeform_parking_test_text": "Parking Test Requirements same as End User*",
    "myaccount_brakeform_parking_test_tooltext": "Indicate whether the end user's method to test parking performance is the same as your (the customer's) method",
    "myaccount_brakeform_Vehicle_Operating_text": "Vehicle's Operating Environment Conditions (as related to NVH)",
    "myaccount_brakeform_Vehicle_Operating_tooltext": "Select all usage/operational conditions that apply:",
    "myaccount_brakeform_required_NVH_text": "NVH Requirements, NVH Regional Concerns, NVH Application Concerns",
    "myaccount_brakeform_required_NVH_tooltext": "Please describe any NVH (Noise, Vibration, Harshness) expectations or requirements that Bendix is expected or required to meet. Consider NVH requirements specific to regions or countries the vehicle will be used in, or application-specific concerns. If none, type \"None\". If left blank, \"Bendix will contact you to obtain further clarification\".",
    "myaccount_brakeform_brake_type_text": "Brake Type",
    "myaccount_brakeform_brake_type_tooltext": "Indicate whether the vehicle uses or will use only ADB, only S-Cam, or a combination of ADB and S-Cam brakes on its axles",
    "myaccount_brakeform_axle_config_text": "Axle Configuration",
    "myaccount_brakeform_axle_config_tooltext": "Indicate the configuration of total wheel ends vs driven wheel ends (e.g. 6X4, 4X2, etc.)",
    "myaccount_brakeform_abs_sensor_text": "ABS Sensors for all wheel positions?",
    "myaccount_brakeform_abs_sensor_tooltext": "Indicate whether each wheel position has an ABS sensor",
    "myaccount_brakeform_abs_modular_count_text": "ABS Modulator Count*",
    "myaccount_brakeform_abs_modular_count_tooltext": "Indicate how many ABS modulators are equipped",
    "myaccount_brakeform_GVWR_lbs_text": "Gross Vehicle Weight Rating (GVWR) (lbs)*",
    "myaccount_brakeform_wheelbase_range_text": "Wheelbase Range (in)*",
    "myaccount_brakeform_cog_height_laden_text": "Center of Gravity Height (Laden) (in)*",
    "myaccount_brakeform_cog_height_unladen_text": "Center of Gravity Height (Unladen) (in)*",
    "myaccount_brakeform_abs_sensor_count_text": "ABS Sensor Count",
    "myaccount_brakeform_end_user_text": "End User (Fleet Customer)",
    "myaccount_brakeform_end_user_tooltext": "Indicate the end user(s) (your fleet customer(s), dealer(s), or other customer(s)) if known. If left blank, Bendix will assume the end user is unknown.",
    "myaccount_brakeform_vehicle_info_text": "Vehicle Information - Axle Information:",
    "myaacount_brakeform_steer_text": "Steer Axle",
    "myaacount_brakeform_drive_text": "Drive Axle",
    "myaccount_brakeform_axle_manu_text": "Axle Manufacturer*",
    "myaccount_brakeform_axle_manu_tooltext": "Indicate the manufacturer of the axle",
    "myaccount_brakeform_brake_assembly_text": "Party performing brake assembly install onto the axle(s)*",
    "myaccount_brakeform_brake_assembly_tooltext": "Indicate the manufacturer that installs the brake assembly onto the axle during production.",
    "myaccount_brakeform_axle_design_text": "Axle design release/production status*",
    "myaccount_brakeform_axle_design_tooltext": "Indicate the release status of the axle(s) on which the requested brakes will be mounted.",
    "myaccount_brakeform_axle_toc_text": "Type of Connection to Axle Flange*",
    "myaccount_brakeform_axle_toc_tooltext": "Indicate the type/manufacturer of the mounting interface to the axle",
    "myaccount_brakeform_brake_disc_text": "Rotor or Drum Intended Manufacturer and Part Number*",
    "myaccount_brakeform_brake_disc_tooltext": "Indicate the manufacturer and part number or model of the disc/drum of the requested brakes",
    "myaccount_brakeform_hub_intended_text": "Hub Intended Manufacturer and Part Number*",
    "myaccount_brakeform_hub_intended_tooltext": "Indicate the manufacturer and part number or model of the hub for the requested brakes",
    "myaccount_brakeform_actuator_intended_text": "Actuator/Chamber Intended Manufacturer and Part Number*",
    "myaccount_brakeform_act_intended_tooltext": "Indicate the manufacturer and part number or model of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_vcp_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_steer_axle_text": "Steer Axle Driven?",
    "myaccount_brakeform_steer_axletype_text": "Axle Type*",
    "myaccount_brakeform_steer_axletype_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_desired_parking_text": "Intended or Desired Parking Axle Configuration*",
    "myaccount_brakeform_desired_parking_tooltext": "Indicate which axle(s) are set up for or are allowed to be set up for parking.",
    "myaccount_brakeform_GAWR_lbs_text": "Gross Axle Weight Rating (GAWR) (lbs)*",
    "myaccount_brakeform_GAWR_lbs_tooltext": "Enter the gross axle weight rating",
    "myaccount_brakeform_axle_weight_text": "Customer Axle Weight Limit (lbs)",
    "myaccount_brakeform_axle_weight_tooltext": "Enter the axle weight limitation (below the GAWR), if any. This rating may be imposed by you, the customer, or the end user",
    "myaccount_brakeform_wheel_rimsize_text": "Wheel/Tire Size (example: 295/75R22.5)*",
    "myaccount_brakeform_tire_type_text": "Tire Type*",
    "myaccount_brakeform_tire_type_tooltext": "Indicate the tire type for the given axle",
    "myaccount_brakeform_tire_static_text": "Tire Static Loaded Radius (SLR) (in)*",
    "myaccount_brakeform_proposed_brake_text": "Customer-Proposed Brake",
    "myaccount_brakeform_proposed_brake_tooltext": "Indicate the proposed or desired brake model, friction material, chamber size, and slack adjuster (if applicable), for Bendix to consider for review",
    "myaccount_brakeform_disc_intended_tooltext": "Indicate the intended/requested manufacturer of the disc/drum of the requested brakes",
    "myaccount_brakeform_actuator_intended_tooltext": "Indicate the intended/requested manufacturer of the actuator/chamber/cylinder of the requested brakes",
    "myaccount_brakeform_value_crack_text": "Relay Valve Crack Pressure*",
    "myaccount_brakeform_axle_type_text": "Axle Type*",
    "myaccount_brakeform_axle_type_tooltext": "Indicate whether the axle is Single, Tandem, or Tridem (excluding pusher and tag axles)",
    "myaccount_brakeform_auxAxle_type_text": "Auxiliary Axle Type*",
    "myaccount_brakeform_auxAxle_type_tooltext": "Indicate whether the auxiliary axle is a \"pusher axle or tag axle\".",
    "myaccount_brakeform_auxAxle_attribute_text": "Auxiliary Axle Attributes",
    "myaccount_brakefor_addAux_button_text": "Add Auxiliary Axle",
    "myaccount_brakeform_auxAxle_attribute_tooltext": "Indicate whether the auxiliary axle is liftable and/or steerable, and whether it is set up for or intended for parking",
    "myaccount_brakeform_comments_attachments_tooltext": "Comments and Attachments",
    "myaccount_brakeform_pneumatic_system_text": "Bendix-Recommended Pneumatic System Design*",
    "myaccount_brakeform_pneumatic_system_tooltext": "Please indicate whether the vehicle's pneumatic system is a Bendix-recommended design",
    "myaccount_brakeform_brake_equipped_text": "Work Brake Equipped? If yes, enter pressure and application frequency*",
    "myaccount_brakeform_brake_equipped_tooltext": "Indicate whether the vehicle is equipped with a work brake and indicate the work brake pressure & application frequency. A work brake is a system or mechanism that allows the service brake to be applied at a defined pressure to act as a temporary parking brake. It may be activated (set) or deactivated by the driver but is not modulated by the driver through the treadle / pedal.",
    "myaccount_brakeform_brake_final_review": "Check Completeness",
    "text_adb_admin_edit_danaContactemail": "Bendix contact email",
    "sort_by_pdp": "Trier par :",
    "text_pdp_document_desc_asc": "Description de document - croissant",
    "text_pdp_document_desc_desc": "Description de document - décroissant",
    "text_pdp_document_type_asc": "Type de document - croissant",
    "text_pdp_document_type_desc": "Type de document - décroissant",
    "text_pdp_document_code_asc": "N° de document - croissant",
    "text_pdp_document_code_desc": "N° de document - décroissant",
    "text_pdp_document_relDate_asc": "Date de publication de document - croissant",
    "text_pdp_document_relDate_desc": "Date de publication de document - décroissant",
    "pdp_part_partNum_asc": "Référence par ordre croissant",
    "pdp_part_partNum_dsc": "Référence par ordre décroissant",
    "pdp_part_decs_asc": "Description par ordre croissant",
    "pdp_part_desc_dsc": "Description par ordre décroissant",
    "pdp_part_typeNum_asc": "Type par ordre croissant",
    "pdp_part_typeNum_dsc": "Type par ordre décroissant",
    "text_smartire_header": "SmarTire®",
    "text_smartire_return_investment": "Retour sur investissement",
    "text_smartire_return_bottom_line": "Contrôle de la pression des pneus... Votre résultat.",
    "text_smartire_return_bottom_line_para": "Le sous-gonflage augmente la quantité de carburant consommée par un véhicule et réduit la durée de vie de la bande de roulement et de la carcasse du pneu. Si l'on multiplie ce chiffre par le nombre de véhicules de votre flotte et les milliers de kilomètres qu'ils parcourent chaque année, il n'est pas surprenant que les pneus sous-gonflés représentent la dépense d'entretien la plus élevée pour une flotte commerciale. Souvent négligé en raison des coûts élevés et de la main-d'œuvre nécessaire, l'entretien régulier des pneus de flotte peut en fait vous faire économiser de l'argent s'il est effectué de manière cohérente et efficace.",
    "text_smartire_return_smartware": "Contrôle actif de la pression des pneus SmartWave",
    "text_smartire_return_smartware_para": "Le système de surveillance active de la pression et de la température des pneus SmartWave est conçu pour faciliter l'entretien régulier des pneus. Le système fournit aux conducteurs et au personnel d'entretien les outils dont ils ont besoin pour faire rouler les pneus de la manière la plus sûre et la plus rentable possible. Le système génère un retour sur investissement rapide en maximisant la durée de vie des pneus, l'économie de carburant et la sécurité routière, tout en réduisant les temps d'arrêt imprévus et les risques d'éclatement ou d'incendie des pneus.",
    "text_smartire_return_calculator": "Calculateur de ROI : USA Impérial",
    "text_smartire_return_calculator_para": "Entrez vos informations dans le calculateur ci-dessous et un retour sur investissement approximatif pour le système SmartWave sera généré. Chaque flotte étant différente, la valeur générée n'est qu'une estimation.",
    "text_smartire_company_info": "Informations sur l'entreprise",
    "text_smartire_units": "Unités",
    "text_smartire_numberof_vahicles": "Nombre de véhicules:",
    "text_smartire_vehicles": "véhicules",
    "text_smartire_average_mileage": "Kilométrage moyen par véhicule:",
    "text_smartire_numberof_tires": "Nombre de pneus par véhicule:",
    "text_smartire_per_year": "par an",
    "text_smartire_tire_inspection": "Intervalle d'inspection des pneus:",
    "text_smartire_tires": "pneus",
    "text_smartire_per_month": "par mois",
    "text_smartire_average_under_inflation": "Sous-inflation moyenne:",
    "text_smartire_average_anual_downtime": "Temps d'arrêt annuel moyen:",
    "text_smartire_instance": "pour chaque",
    "text_smartire_tire_life": "Durée de vie des pneus (en distance):",
    "text_smartire_miles": "Miles",
    "text_smartire_fuel_cunsumption": "Consommation de carburant:",
    "text_smartire_deafult_values": "Valeurs par défaut",
    "text_smartire_cost_fuel": "Coût du carburant (diesel):",
    "text_smartire_usd_per_gallon": "USD par gallon",
    "text_smartire_cost_per_tire": "Coût par pneu:",
    "text_smartire_cost_downtime": "Coût par instance de temps d'arrêt:",
    "text_smartire_service_cost": "Coût du service par véhicule:",
    "text_smartire_minutes_per_tire": "minutes/pneu",
    "text_smartire_usd_per_hour": "USD par heure",
    "text_smartire_usd": "USD",
    "text_smartire_btn_calculate": "Calculer",
    "text_smartire_error_numeric": "Use numeric values",
    "text_smartire_xyz_trucking_co": "XYZ Trucking Co.",
    "text_smartire_normal": "Normal",
    "text_smartire_with_smartwave": "Avec Smartwave",
    "text_smartire_saving": "Épargne",
    "text_smartire_annual_tire_cost": "Coût annuel des pneus:",
    "text_smartire_annual_fuel_cost": "Coût annuel du carburant:",
    "text_smartire_annual_tire_maintenance_cost": "Coûts annuels d'entretien des pneus:",
    "text_smartire_annual_downtime_cost": "Coûts annuels d'immobilisation:",
    "text_smartire_total": "TOTAL:",
    "text_smartire_annual_saving": "Économies annuelles par véhicule:",
    "text_smartire_calculate_following": "Les valeurs sont calculées comme suit:",
    "text_smartire_reduce_tire_thread": "Un sous-gonflage de 20% réduit la durée de vie des pneus de 25%.",
    "text_smartire_reduce_fuel_economy": "Un sous-gonflage de 20% réduit la consommation de carburant de 2%.",
    "text_smartire_tire_failure": "90% des défaillances de pneus sont dues à un sous-gonflage.",
    "text_smartire_tire_related": "Près de la moitié (49%) de tous les appels d'assistance routière sont liés aux pneus.",
    "text_smartire_smartwave_tpms": "SmartWave TPMS réduit le temps d'entretien des pneus:",
    "secure_update_application_title": "Création d'un mot de passe sécurisé",
    "secure_password_update_title": "Secure Update Password",
    "secure_update_application_msg": "Chers clients, afin de gérer vos transactions et vos données dans le portail client de manière encore plus sécurisée, veuillez changer votre mot de passe.",
    "secure_update_pwd_validation_title": "Votre nouveau mot de passe sécurisé doit être conforme à ces règles :",
    "secure_update_pwd_validation_msg1": "Au moins 12 caractères",
    "secure_update_pwd_validation_msg2": "Au moins 1 minuscule",
    "secure_update_pwd_validation_msg3": "Au moins 1 majuscule",
    "secure_update_pwd_validation_msg4": "Au moins 1 chiffre",
    "secure_update_pwd_validation_msg5": "Au moins un caractère spécial parmi ceux-ci : ( )~!@#$%^&*_-+=`|(){}[]:;\"'<>,?/",
    "secure_update_recentused_pwdMsg": "Les 5 derniers mots de passe ne peuvent pas être réutilisés",
    "secure_update_pwd_personalInfo_msg": "N'utilisez pas d'informations personnelles ou de noms d'entreprise dans votre mot de passe",
    "secure_update_pwd_mustChange_msg": "Le mot de passe doit être changé une fois par an",
    "secure_update_pwd_doesnot_meetReq_msg": "Le mot de passe choisi ne répond pas aux exigences.",
    "secure_update_pwd_alreadyUsed_msg": "Ce mot de passe a déjà été utilisé, veuillez créer un nouveau mot de passe.",
    "secure_update_pwd_expiration_msg": "Votre mot de passe a expiré après 365 jours. Veuillez créer un nouveau mot de passe.",
    "vizseek_Search_NOresults": "Recherche visuelle - Pas de résultats",
    "vizseek_Search_NOresults_found": "Désolé, nous n'avons pas trouvé de résultat pour ce produit en utilisant la recherche visuelle.",
    "vizseek_Search_category": "S'agit-il de la bonne page de catégorie de produits ?",
    "vizseek_Search_category_info": "Pour plus d'informations, consultez la page",
    "vizseek_tooltip": "Image de recherche visuelle",
    "Vizseek_Search_Guide": "Guide de recherche",
    "vizseek_search_Invalid_text1": "Désolé, nous ne sommes pas en mesure de localiser votre catégorie de produit.",
    "vizseek_search_Invalid_text2": "Veuillez vous référer à la",
    "vizseek_search_Invalid_text3": "ou ",
    "vizseek_Search_results": "echerche visuelle",
    "text_contactusform_submission_success": "Form Submitted Successfully.",
    "text_contactusform_submission_error": "Veuillez corriger les erreurs ci-dessous.",
    "text_contactusform_submission_failed": "Something went wrong. Please try again later.",
    "text_contactusform_page_title": "Contactez nous!",
    "contactUs_label_taxt": "Nous Contacter",
    "contactUS_form_select_empty": "Veuillez sélectionner",
    "contactUs_topics": "Sujet*",
    "contactUs_firstName": "Prénom*",
    "contactUs_lastName": "Nom de famille*",
    "contactUs_company_name": "Société",
    "contactUs_address_street_text": "Rue*",
    "contactUs_address_city_text": "Ville*",
    "contactUs_address_zip_text": "Code postal*",
    "contactUs_email_text": "Adresse électronique*",
    "contactUs_countryCode_text": "Pays d'origine*",
    "contactUs_phoneNumber_text": "Numéro de téléphone",
    "contactUs_company_comments_text": "Votre message*",
    "contactUs_comments_note_text": "Saisir la note ici",
    "contactUs_dataprotection_acceptNA": "J'accepte la",
    "contacUS_privacyPolicy_msgNA": "politique de confidentialité",
    "contactUs_privacyPolicy_accept_invalid": "Il est nécessaire d'accepter la politique de confidentialité",
    "typeMismatch_contactUSForm_termsOfUsageAcceptance": "Il est nécessaire d'accepter la politique de confidentialité",
    "register_captcha_invalid_msg": "Veuillez saisir un Captcha valide",
    "contactUs_captcha_text": "Captcha",
    "contactUs_form_submit_msg": "Votre message a été envoyé avec succès",
    "contactUS_send_button_msg": "Envoyer",
    "import_csv_savedCart_genericErrorNA": "Error in uploading the order template_ Please try again or contact <a href",
    "check_out_of_stock_table_text": "est en rupture de stock",
    "check_out_of_stock_text": "est en rupture de stock pour",
    "value_calculator_header": "EnduraSure®-Pro Savings Summary",
    "value_calculator_title": "Bendix Value Calculator",
    "available_product_text": "est disponible pour",
    "value_calculator_visitor_info_title": "Informations sur le visiteur",
    "value_calculator_firstName": "Prénom",
    "value_calculator_lastName": "Nom de famille",
    "value_calculator_email": "Adresse électronique de l'entreprise",
    "value_calculator_privacy_accept": "J'accepte la clause de non-responsabilité",
    "value_calculator_privacy_accept_link": "du (des) calculateur(s) de valeur",
    "value_calculator_next_button": "Suivant",
    "value_calculator_back_button": "Retour",
    "value_calculator_flit_info_title": "Informations sur le parc",
    "value_calculator_fleetSizeTractors": "Taille du parc - Tracteurs*",
    "value_calculator_tractors_text": "Tracteurs",
    "value_calculator_tractorTradeInCycle": "Cycle de reprise des tracteurs*",
    "value_calculator_fleetSizeTrailers": "Taille du parc - Remorques*",
    "value_calculator_trailers_text": "Remorques",
    "value_calculator_year_text": "Années",
    "value_calculator_trailerTradeInCycle": "Cycle de reprise des remorques*",
    "value_calculator_actuator_text": "Actionneur",
    "value_calculator_usdOcc_text": "USD / Occurrence",
    "value_calculator_calls_text": "Appels",
    "value_calculator_usdDay_text": "USD / Jour",
    "value_calculator_replacement_costNode_title": "Replacement Cost per Actuator",
    "value_calculator_replacement_cost_title": "Coste anual de sustitución por actuador:",
    "value_calculator_replacementFleetCostPerActuator": "Coût de remplacement du parc automobile par actionneur",
    "value_calculator_replacementFleetCostPerActuator_toolTip": "Le coût moyen de la flotte pour l'actionneur défectueux..",
    "value_calculator_laborToInstallActuator": "Main-d'œuvre pour l'installation de l'actionneur",
    "value_calculator_laborToInstallActuator_toolTip": "Coût de la main d'œuvre basé sur 30 minutes pour l'installation de l'actionneur de remplacement.",
    "value_calculator_totalCostPerFailedActuator": "Coût total par actionneur défectueux",
    "value_calculator_numberOfActuatorsReplacedPerYear": "Nombre d'actionneurs remplacés par an",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip1": "En moyenne, les flottes remplacent un actionneur par an sur 15 % de leurs tracteurs et 12 % de leurs remorques.\\",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip2": "Source : MacKay & Company 2023",
    "value_calculator_product_performance_title": "Performance du produit actuel",
    "value_calculator_brandOfActuator": "Marque de l'actionneur",
    "value_calculator_csa_title": "Coûts des temps d'arrêt du CSA",
    "value_calculator_roadsideCallRate": "Taux d'appels sur la route",
    "value_calculator_roadsideCallRate_toolTip": "Coût moyen d'un appel d'assistance routière, y compris le temps d'immobilisation.",
    "value_calculator_annualRoadsideCallsToActuators": "Nombre annuel d'appels de dépannage liés aux actionneurs*",
    "value_calculator_violations_text": "Violations",
    "value_calculator_roadsideCallRateCsaViolation": "Taux d'appels de dépannage pour infraction à la norme CSA",
    "value_calculator_roadsideCallRateCsaViolation_toolTip": "Estimation du coût de l'assistance routière lors d'un événement CSA hors service (OOS).",
    "value_calculator_annualOutOfServiceCsaViolations": "Nombre annuel d'infractions à la réglementation sur les freins hors service*",
    "value_calculator_fleetDowntimeRate": "Taux d'immobilisation de la flotte*",
    "value_calculator_upcharge_title": "Supplément pour le nouvel équipement",
    "value_calculator_estUpchargeForEndTractor": "Supplément estimé pour EnduraSure-Pro sur le tracteur par rapport à l'option actuelle",
    "value_calculator_estUpchargeForEndTractor_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on tractor over current option",
    "value_calculator_estUpchargeForEndTrailer": "Supplément estimé pour EnduraSure-Pro sur remorque par rapport à l'option actuelle",
    "value_calculator_estUpchargeForEndTrailer_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on trailer over current option",
    "value_calculator_enduraSure_summary": "EnduraSure®-Pro Résumé",
    "value_calculator_unit_cost": "Coût unitaire",
    "value_calculator_totalFleet_cost": "Coût total du parc",
    "value_calculator_initialpurchase_tractor_cost": "Coût d'achat initial - tracteur",
    "value_calculator_initialpurchase_trailer_cost": "Coût d'achat initial - remorque",
    "value_calculator_replacementTractor_cost": "Coût de remplacement à vie - tracteur",
    "value_calculator_replacementTrailer_cost": "Coût de remplacement sur la durée de vie - remorque",
    "value_calculator_csaTractor_cost": "Coûts liés à la CSA - tracteur",
    "value_calculator_csaTrailer_cost": "Coûts liés à la CSA - remorque",
    "value_calculator_total_text": "Total",
    "value_calculator_return_investment": "Retour sur investissement (ROI)",
    "value_calculator_TCO_perUnit_standard": "Coût total de possession par unité - Standard (USD)",
    "value_calculator_TCO_perUnit_Sealed": "Coût total de possession par unité - scellée (USD)",
    "value_calculator_fleet_saving": "Économies nettes pour le parc (USD)",
    "value_calculator_description_text": "Description",
    "value_calculator_email_results": "Résultats des courriels",
    "value_calculator_reset_text": "Remise à zéro",
    "value_calculator_email_text": "Email",
    "value_calculator_enduraSure_perTractor": "Supplément pour EnduraSure®-Pro par tracteur",
    "value_calculator_enduraSure_perTractor_desc": "Estimation du supplément pour EnduraSure®-Pro sur le tracteur par rapport à l'option actuelle. Le coût peut varier de 50 à 150 $ par nouveau tracteur.",
    "value_calculator_enduraSure_perTrailer": "Supplément pour EnduraSure®-Pro par remorque",
    "value_calculator_enduraSure_perTrailer_desc": "Estimation du supplément pour EnduraSure®-Pro sur la remorque par rapport à l'option actuelle. Le coût peut varier de 50 à 150 $ par nouvelle remorque.",
    "value_calculator_proEmail_summary": "EnduraSure®-Pro Email Summary",
    "value_calculator_contact_info": "Contact Information",
    "valueCalculator_brandOfActuator_bendixEnduraSure": "Bendix EnduraSure",
    "valueCalculator_brandOfActuator_bendixEnduraSurePro": "Bendix EnduraSure-Pro",
    "valueCalculator_brandOfActuator_haldexGoldSeal": "Haldex Gold Seal",
    "valueCalculator_brandOfActuator_haldexLifeSeal": "Haldex Life Seal",
    "valueCalculator_brandOfActuator_tseOmni": "TSE Omni",
    "valueCalculator_brandOfActuator_tseUltra": "TSE Ultra",
    "valueCalculator_brandOfActuator_wabcoTristop": "WABCO Tristop",
    "valueCalculator_brandOfActuator_other": "Other",
    "value_cal_fleetSizeTractors_valMsg": "Veuillez saisir la taille du parc - Tracteurs",
    "value_cal_tractorTradeInCycle_valMsg": "Veuillez saisir le cycle de reprise des tracteurs",
    "value_cal_fleetSizeTrailers_valMsg": "Veuillez saisir la taille du parc - Remorques",
    "value_cal_trailerTradeInCycle_valMsg": "Veuillez saisir le cycle de reprise des remorques",
    "value_cal_repFleetCostPerActuator_valMsg": "Veuillez entrer le coût de remplacement du parc par actionneur",
    "value_cal_laborToInstallActuator_valMsg": "Veuillez saisir le coût de la main-d'œuvre pour l'installation de l'actionneur",
    "value_cal_noOfActuatorsReplacedPerYear_valMsg": "Veuillez entrer le nombre d'actionneurs remplacés par an",
    "value_cal_roadsideCallRate_valMsg": "Veuillez entrer le taux d'appels de dépannage",
    "value_cal_annualRoadsideCallsToActuators_valMsg": "Veuillez entrer le nombre annuel d'appels de dépannage liés aux actionneurs",
    "value_cal_roadsideCallRateCsaViolation_valMsg": "Veuillez saisir le taux d'appels de dépannage pour infraction à la CSA",
    "value_cal_annualOutOfServiceCsaViolations_valMsg": "Veuillez saisir le nombre annuel d'infractions à la norme CSA concernant les freins hors service",
    "value_cal_fleetDowntimeRate_valMsg": "Veuillez saisir le taux d'immobilisation de la flotte",
    "value_cal_greaterThan_zeroMsg": "Saisir une valeur supérieure à 0",
    "value_cal_landingPage_textMsg": "Découvrez combien vous pouvez économiser en choisissant les freins à disque pneumatiques Bendix®, les freins à ressort EnduraSure®-Pro et le système de surveillance de la pression des pneus SmarTire® de Bendix CVS. Consultez nos calculateurs de valeur faciles à utiliser.",
    "value_cal_negativeVal_text": "Aucune économie nette n'est réalisée. La flotte devrait prendre en compte d'autres avantages tels que la réduction de la garantie, du stock de pièces et de l'utilisation du temps des techniciens.",
    "value_calculator_standardChamberLifetime": "Chambre standard (durée de vie)",
    "value_calculator_sealedChamberLifetime": "Chambre scellée (durée de vie)",
    "value_calculator_formSubmit_success": "Your EnduraSure-Pro savings projection summary has been emailed.",
    "value_calculator_formSubmit_failed": "Something went wrong while submitting the  EnduraSure-Pro savings. Please try again later.",
    "value_calculator_estUpchargeForEndTractor_pdf": "Upcharge for EnduraSure-Pro per tractor",
    "value_calculator_estUpchargeForEndTrailer_pdf": "Upcharge for EnduraSure-Pro per trailer",
    "value_calculator_formSubmit_error": "Veuillez corriger les erreurs ci-dessous.",
    "value_calculator_fName_emptyMsg": "Prénom Ne peut être vide.",
    "value_calculator_lName_emptyMsg": "Nom de famille Ne peut être vide.",
    "value_calculator_email_emptyMsg": "Email de l'entreprise Ne peut être vide.",
    "value_calculator_captcha_validMsg": "Veuillez saisir un Captcha valide.",
    "value_calculator_captcha_expiredMsg": "Captcha expiré.",
    "value_calculator_captcha_failedMsg": "Échec du chargement du captcha.",
    "value_calculator_captcha_invalidMsg": "Captcha invalide, veuillez réessayer.",
    "text_core_submit_internalTrackingNumber": "Il s'agit de votre numéro de suivi interne (facultatif)",
    "text_core_submit_internalUseOnly": "Réservé à l'usage interne de Bendix",
    "text_warranty_submit_datein_service_invalid": "Veuillez saisir une date de mise en service valide",
    "text_warranty_submit_date_removed_service_invalid": "Veuillez saisir une date valide de mise hors service",
    "text_account_table_header_order": "Numéro de commande Bendix",
    "text_warranty_submit_part_mileage": "Kilométrage en service*",
    "register_site_description": "Une fois rempli le formulaire d’inscription ci-dessous, votre demande de compte sera soumise à une révision. Vous recevrez une confirmation par courriel avec des instructions supplémentaires.",
    "text_warranty_vinNumber_invalid": "Please enter a valid Vehicle ID/VIN-Number/Numéro de châssis",
    "register_submit": "S’inscrire",
    "login_info": "Inscrivez-vous à Bendix pour obtenir la disponibilité des produits, la tarification, les informations de commande et bien plus encore!",
    "text_warranty_submit_date_removed_invalid": "La date de retrait du service ne peut être antérieure à la date de mise en service.",
    "text_warranty_search_claim_number": "No de réclamation sous garantie Bendix",
    "error_account_myPart_part_dublicate": "Numéro de pièce déjà utilisé.",
    "cart_page_req_delivery_date_for_all_items": "Toutes les lignes – Date de livraison demandée",
    "text_warranty_search_part_number": "Numéro de pièce Bendix",
    "error_account_myPart_solto_select": "Sélectionnez un client",
    "text_warranty_submit_returning_kbpart_number": "Numéro de pièce Bendix (remplissage auto)",
    "text_warranty_submit_kb_claim_generated": "Automatically generated by Bendix",
    "checkout_deliveryMethod_notSelected": "Sélectionnez la méthode de livraison de votre commande",
    "text_warranty_submit_part_datein_service": "Date en service*",
    "text_account_warranty_table_header_claim_number": "No de réclamation sous garantie Bendix",
    "warranty_information": "Centre d’informations de la garantie Bendix",
    "header_link_login": "Se connecter / S’inscrire",
    "text_core_search_coreGroup": "Saisir groupe de cores",
    "text_warranty_submit_alphanumeric_invalid": "Please enter alphanumeric Number",
    "register_description": "Validation d’achat rapide, accès facile aux commandes précédentes, et possibilité de créer un carnet d’adresses et de stocker les paramètres. Inscrivez-vous ci-dessous.",
    "text_warranty_search_customer_part_number": "Numéro de pièce client",
    "text_warranty_submit_email": "Adresse électronique*",
    "text_core_search_partNumber": "Saisir no de pièce Bendix",
    "error_account_myPart_part_notfound": "ligne {0} : {1} numéro de pièce {2} n’est pas reconnu, donc non téléversé. Corrigez votre entrée ou communiquez avec votre service client {3} local.",
    "text_warranty_claimRefNumber_invalid": "Please enter a valid Claim Number",
    "text_warranty_submit_datein_service_invalid_future": "Date In Service can't be in future date.",
    "text_warranty_submit_phone": "Numéro de téléphone",
    "text_warranty_submit_kb_claim_number": "No de réclamation Bendix",
    "import_csv_savedCart_customerPartNumber": "Numéro de pièce client(déterminera le numéro de pièce Bendix)",
    "quick_order_page_req_delivery_date_for_all_items": "Toutes les lignes – Date de livraison demandée",
    "error_account_myPart_template_select": "Sélectionnez un modèle",
    "text_warranty_submit_returning_part_number": "Numéro de la pièce en retour*",
    "text_account_warranty_table_header_part_number": "Bendix Part Number",
    "text_warranty_submit_date_removed_service_invalid_future": "Date Removed from Service can't be in future date.",
    "text_return_request_submit_returning_part_number": "Numéro de pièce Bendix*",
    "text_company_manageuser_disableuser_confirmation": "Doing this will prevent customer {0} from logging to storefront and placing order. Do you want to proceed?",
    "b2bcustomer_cancel": "Annuler",
    "text_company_administrators_page_linkPreviousPage": "Page précédente",
    "b2busergroup_name": "User group Name",
    "text_company_manage_units_addressForm_edit_title": "Edit Address",
    "text_company_user_dr_name": "Dr.",
    "text_company_manageUsergroups_unit_edit": "Edit User group",
    "text_company_manage_units_createNewUnit": "New Unit",
    "text_company_members_page_sort_byUnit": "Branche mère",
    "text_company_units_remove_confirmation_title_b2badmingroup": "Confirm removal of B2B Administrator",
    "text_company_permissions_page_linkPreviousPage": "Page précédente",
    "text_company_customers_page_linkNextPage": "Page suivante",
    "text_company_manage_units_childUnits": "Child Units",
    "form_b2bunit_notunique": "Business unit with the same id already exists",
    "text_company_manageUsergroups_details": "{0}t",
    "mycompany_accessAdditionalRights": "Droits d'utilisateur supplémentaires",
    "text_company_costCenter_page_totalResults": "{0} Cost Centers found",
    "text_company_manageUser_usergroups_title": "User Groups",
    "text_company_on": "ON",
    "text_company_usergroup_button_createnew": "Modifier",
    "text_company_manageUser_registration_showAllResults": "Afficher tout",
    "text_company_usergroup_name_title": "User Name",
    "text_company_editOrDisableUsergroups": "Edit or disable order user groups",
    "text_company_usergroups_page_linkPreviousPage": "Page précédente",
    "text_company_organizationManagement": "Organization Management",
    "text_company_usergroups_page_sortTitle": "Ordre de tri :",
    "b2buser_yes_button": "Oui",
    "text_company_administrators_page_sortTitle": "Ordre de tri :",
    "header_link_company": "Ma sociÃ©tÃ©",
    "b2buser_no_button": "Non",
    "text_company_costCenter_page_sortTitle": "Ordre de tri :",
    "form_b2busergroup_parentunit_updated": "Please be aware that modifying a user group's parent unit can have adverse affects.",
    "text_company_manageUsergroups_remove": "Confirm Remove",
    "text_company_costCenter_disable_button": "Disable Cost Center",
    "text_company_costCenter_costCenterBreadCrumb": "Cost Center: {0}",
    "text_company_usergroups_page_showPageResults": "Afficher paginé",
    "text_company_createNewUnits": "Create new units",
    "text_company_deselect_action_label": "Deselect",
    "text_company_budget_page_currentPage": "Page {0} sur {1}",
    "text_company_managePermissions": "Permissions",
    "text_company_usergroups_viewDetails_label": "View User group Details",
    "text_company_budget_page_totalResults": "{0} Budgets found",
    "text_company_customers_page_sortTitle": "Ordre de tri :",
    "text_company_costCenter_enabled_title": "Cost Center Enabled/disabled",
    "text_company_manage_budget_title": "Budgets",
    "text_Material_Core_Group": "Recherche article/groupe de cores",
    "text_company_managePermissions_assignName_per": "PER",
    "text_company_managePermissions_page_firstPage": "&laquo;",
    "text_manageuser_password": "Please enter and confirm the password for customer {0}",
    "text_company_budget_status_active": "Active",
    "b2bunit_parent": "Branche d’activité mère",
    "text_company_user_name": "First Name:",
    "text_company_managePermissions_page_lastPage": "&raquo;",
    "text_company_children_page_showPageResults": "Afficher paginé",
    "text_company_managers_viewPage": "View Managers",
    "text_company_usergroup_value_title": "Value",
    "usergroup_unit_invalid": "Please select a Parent Business unit",
    "usergroup_uid_invalid": "Please select a unique identifier for the user group",
    "text_company_permissions_page_showAllResults": "Afficher tout",
    "text_company_manage_units_unit_disable": "Confirm Disable",
    "text_company_manageUser_pageAll_firstPage": "&laquo;",
    "text_company_administrators_page_firstPage": "&laquo;",
    "form_select_empty_axle_position": "Veuillez sélectionner",
    "text_company_usergroup_unit_title": "Parent unit",
    "text_company_manage_units_newUnitButton": "Add New",
    "text_company_manageUsers_userDetails_title": "View User: {0}",
    "text_company_administrators_page_currentPage": "Page {0} sur {1}",
    "text_company_manageusers_restpassword_breadcrumb": "Mettre à jour le mot de passe",
    "text_company_manageB2BUserGroup_title": "User Groups",
    "text_company_permissions_title": "Manage Permissions",
    "text_company_manageUser_registration_lastPage": "&raquo;",
    "text_company_managePermissions_page_totalResults": "{0} Permissions found",
    "text_company_managePermissions_threshold_value_error": "Please enter a value greater than zero",
    "text_company_permission_disable_confirm_yes": "Disable",
    "text_Document": "Les Documents",
    "text_company_approvers_page_linkNextPage": "Page suivante",
    "text_company_manageUsergroup": "User groups",
    "text_company_managePermissions_threshold_value_invalid": "Please enter a valid amount",
    "form_b2bcustomer_adminrole_error": "A B2B Administrator can not downgrade their administrative role.",
    "b2bunit_approvalProcess": "Approval Process",
    "text_company_costCenter_page_showPageResults": "Afficher paginé",
    "text_company_manage_units_addressForm_create_header": "Create Address for Unit: {0}",
    "text_company_managePermissions_unit_label": "Branche mère",
    "text_company_managePermissions_create_type_label": "Typet",
    "text_company_manageB2BUserGroup_page_firstPage": "&laquo;",
    "text_company_manageB2BUserGroup_subtitle": "User Groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_customers_page_sort_byUnit": "Branche mère",
    "text_costcenter_parentunit_disabled_error": "This cost center may not be set to active state because the parent B2B Unit not active.",
    "text_company_manageusers_usergroups_subtitle": "User groups allow you to assign permissions to multiple customers without adhering to the hierarchical structure of the organization hierarchy.",
    "text_company_manageUsergroups_remove_breadcrumb": "Remove {0} User group",
    "text_company_manage_units_create": "Create Child Unit for Unit: {0}",
    "text_company_user_ms_name": "Mme",
    "text_company_users_remove_confirmation_title_usergroup": "Confirm removal of User Group",
    "text_mycompany_user_updateForm": "Please use this form to update customer {0} details",
    "text_How_to_guide": "Guide pratique",
    "text_company_usergroups_page_sort_byDate": "Date",
    "text_company_manageUsergroups_detailsUserGroup_title": "User Group Details",
    "text_company_budget_SelectBudgets": "Select Budgets.",
    "text_company_manage_units_disabled_label": "disabled",
    "text_company_managePermissions_disable_breadcrumb": "Disable {0}",
    "text_company_manageusers_subtitle": "A user is an individual who is able to login to the {0}. The {0} functionality available to the user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manage_units_managers_title": "Manage Managers for Unit: {0}",
    "text_company_editOrDisableBudgets": "Edit or disable budgets",
    "text_company_budget_createButton_displayName": "Add New",
    "text_company_managePermissions_view_page": "{0}t",
    "text_company_addExisting_button": "Add Existing",
    "text_company_manageUsergroups_disableUsergroup_confirmation": "Doing this will remove all the members from this User Group and it will become disabled. Do you want to proceed?",
    "text_company_usergroup_currency_title": "Currency",
    "text_company_manageUsergroups": "Manage User groups",
    "text_company_manage_units_addCostCenter_breadcrumb": "New Cost Center",
    "text_company_manageUsergroups_remove_success": "User group successfully removed",
    "b2busergroup_save": "Save Updates",
    "text_company_manageUser_pageAll_linkNextPage": "Page suivante",
    "text_company_select_name": "Sélectionner",
    "text_company_manageUsers_edit_title": "Edit User",
    "text_company_manage_unit_address_cancelButton": "Annuler",
    "text_company_manage_costcenters_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center&#145;s place within the organization structure defines who can place orders against it and its budget defines the limit of expenditure for that cost center at the {0}.",
    "text_company_costCenter_page_linkNextPage": "Page suivante",
    "updatePwd_pwd_invalid": "Le mot de passe ne répond pas aux conditions minimales.",
    "text_company_children_page_lastPage": "&raquo;",
    "text_company_manage_units_addressForm_header": "Add Business Address",
    "text_company_manage_units_view_approvers_subtitle": "The approval process will assign orders to approvers referenced here if the individual has sufficient permissions to approve the order and an approver with lower sufficient permissions was not already found further down this branch of the organization hierarchy before reaching the cost center against which the order was placed.",
    "text_company_costCenter_disable_confirm": "Confirm Disable",
    "text_company_costCenter_page_sort_byCode": "Id",
    "text_company_manageB2BUserGroup_viewPage": "View Groups",
    "text_company_budget_page_sortTitle": "Ordre de tri :",
    "text_account_profile_updatePasswordForm": "Mot de passe",
    "text_company_manage_units_customers_mainTitle": "Select Customer(s)",
    "text_company_manageusers_edit": "Modifier",
    "text_company_members_page_lastPage": "&raquo;",
    "text_company_manageUser_registration_sort_byEmail": "Email-Asc",
    "text_company_managePermissions_page_linkPreviousPage": "Page précédente",
    "text_company_user_rev_name": "Rev.",
    "text_company_costCenter_viewPage": "{0}t",
    "text_company_manage_costcenters_disable": "Disable",
    "text_company_managePermissions_create_permission_title": "New Permission",
    "text_company_manage_units_unit_edit_title": "Edit Unit: {0}",
    "text_company_managePermissions_title": "Permissions",
    "text_company_manageThresholds": "Manage Order Thresholds",
    "text_company_costCenter_addButton_displayName": "Create New Cost Center",
    "text_myCompany_manageUsers_approvers_title": "Select Approver(s)",
    "b2bunit_name": "Business Unit Name",
    "b2busergroup_b2bapprovergroup_name": "B2B Approver",
    "text_company_usergroup_enable_button": "Enable",
    "text_company_manage_units_users_new_title": "New User",
    "user_email": "Email",
    "text_company_manageUser": "Utilisateurs",
    "text_company_manageUser_viewUsers": "View Users",
    "text_company_managePermissions_currency_label": "Permission currency",
    "text_company_permissions_page_totalResults": "{0} Permissions found",
    "text_company_manage_units_create_costCenter_title": "Create Cost Center for Unit: {0}",
    "text_company_manageUser_pageAll_lastPage": "&raquo;",
    "text_company_cancel_button": "Annuler",
    "text_company_units_remove_b2bcustomergroup_confirmation": "Remove B2B Customer {0}",
    "text_company_manage_units_edit": "Modifier",
    "text_company_approvers_page_totalResults": "{0} Approvers found",
    "text_company_manage_units_edituser_title": "Edit User for Unit: {0}",
    "text_account_user_saveUpdates": "Save Updates",
    "text_company_permissions_actions_title": "Actionstt",
    "text_company_members_page_currentPage": "Page {0} sur {1}",
    "text_company_manage_units_view_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy where units inherit properties from their parent unit, although this can be overridden for each unit.",
    "text_company_manageUser_pageAll_sort_byDate": "Date",
    "text_company_manage_costcenters_title": "Cost Centers",
    "text_company_editOrDisableUnits": "Edit or disable units",
    "text_company_costCenter_editPage_breadcrumb": "Edit Cost Center: {0}",
    "text_company_manage_units_button_createnew": "Create New",
    "text_company_members_page_sortTitle": "Ordre de tri :",
    "text_company_manage_units_user_roles": "Roles",
    "text_confirmation_budget_created": "Budget created successfully",
    "text_confirmation_user_edited": "Customer successfully updated",
    "text_company_budget_page_sort_byValue": "Budget Amount",
    "text_company_addNewUsers": "Add new users",
    "text_company_addNew_button": "Add New",
    "text_company_manage_units_childrenUnits_id": "Jeu de pièces de rechange",
    "text_company_costCenter_state_active": "Active",
    "text_company_manageUsers_approvers_breadcrumb": "Approver(s)",
    "text_company_managePermissions_page_sort_byDate": "Date",
    "form_required": "Les champs marqués * sont obligatoires",
    "text_company_manageUser_registration_linkPreviousPage": "Page précédente",
    "text_company_manage_units_administrators_title": "Manage Administrators for Unit: {0}",
    "text_company_customers_page_sort_byName": "Nom",
    "text_company_budget_page_sort_byUnitName": "Branche mère",
    "text_company_costCenter_id_title": "Cost Center ID",
    "text_company_usergroup_edit_button": "Modifier",
    "text_company_addNewUsergroup": "Add new user group",
    "text_company_budget_budgetId": "Budget ID",
    "text_company_manage_units_approvers_mainTitle": "Select Approver(s)",
    "user_title": "Titre",
    "text_company_manage_units_administrators_subtitle": "Select or deselect users which should be administrators for this unit.",
    "text_company_budget_page_firstPage": "&laquo;",
    "text_company_managePermissions_viewDetails_page_title": "Permission Details",
    "text_company_diselect_name": "Diselect",
    "text_company_managePermissions_page_linkNextPage": "Page suivante",
    "text_company_manage_units_adduser": "Create User for Unit: {0}",
    "text_company_usergroups_page_totalResults": "{0} User groups found",
    "text_company_select_budget": "Edit Related Budgets for Cost Center: {0}",
    "text_company_units_remove_confirmation_b2bmanagergroup": "Doing this will remove B2B Manager {0} from Business unit {1}. Do you want to proceed?",
    "text_company_customers_page_totalResults": "{0} Customers found",
    "text_company_units_remove_b2bmanagergroup_confirmation": "Remove B2B Manager {0}",
    "text_company_disable_confirm_yes": "Oui",
    "error_bugetcode_notfound": "Budget code is not valid",
    "text_company_manage_units_viewcustomer_breadcrumb": "{0}t",
    "text_company_permissions_page_sort_byUnitName": "Branche mère",
    "text_company_managers_page_firstPage": "&laquo;",
    "text_company_budget_amount": "Budget Amount",
    "text_company_manageUser_pageAll_totalResults": "{0} utilisateur(s) trouvé(s)",
    "text_company_manageUsergroups_usergroup_disable": "Confirm Disable",
    "text_company_customers_page_lastPage": "&raquo;",
    "text_company_approvers_page_linkPreviousPage": "Page précédente",
    "text_company_budget_endDateLesser_error_title": "End Date should be greater than Start Date",
    "text_account_addressBook_addEditform": "Utilisez ce formulaire pour ajouter/modifier une adresse.",
    "text_company_members_page_linkNextPage": "Page suivante",
    "text_company_permissions_timespan_title": "Timespan",
    "text_company_manage_units_edituser": "Edit User for Unit: {0}",
    "text_company_manage_units_editCostCenter_breadcrumb": "Edit Cost Center for Unit: {0}",
    "text_company_permissions_type_label": "Permission type",
    "text_company_manageUser_registration_sort_byDateDesc": "Date-Desc",
    "text_company_manageUser_pageAll_showAllResults": "Afficher tout",
    "text_company_roles_all_label": "All Roles:",
    "text_company_children_page_sort_byDate": "Date",
    "text_company_administrators_page_sort_byUnit": "Branche mère",
    "text_company_managePermissions_status_enabled": "Enabled",
    "text_company_users_remove_confirmation_title_permission": "Confirm removal of Permission",
    "text_company_manage_units_remove": "Supprimert",
    "text_company_permission_disable_confirm_no": "Annuler",
    "text_company_users_remove_confirmation_usergroup": "Doing this will remove member {0} from user group {1}. Do you want to proceed?",
    "text_company_usergroups_page_showAllResults": "Afficher tout",
    "text_company_costCenter_unit_title": "Parent unit",
    "text_company_manage_units_view_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. The units below are descendant units of the current unit, for example, if this unit was \"Procurement\" then the child units might be \"Electricals Procurement\" and \"Office Supplies Procurement\". The child units, along with other business objects connected to them, form this branch of the organization hierarchy.",
    "text_company_manage_units_delete_address": "Supprimer l’adresse",
    "text_company_manageUser_registration_noRequestFound": "Aucune demande d’inscription en attente.",
    "text_company_administrators_page_linkNextPage": "Page suivante",
    "text_company_manage_units_unitDetails": "Unit Details",
    "text_company_user_resetPassword": "Réinitialiser le mot de passe",
    "text_company_costCenter_page_lastPage": "&raquo;",
    "text_company_managers_page_linkNextPage": "Page suivante",
    "text_confirmation_user_close": "The user account {0} has been closed",
    "text_company_unit_contactNumber": "Contact Number",
    "text_company_managePermissions_edit_cancelButton": "Annuler",
    "text_company_manageUsergroups_createUsergroup_breadcrumb": "Nouveau",
    "unit_name_invalid": "Please select a name for the business unit",
    "text_company_costCenter_code_exists_error_title": "This Cost Center ID already exists.",
    "text_company_manageB2BUserGroup_page_sort_byUnitName": "Branche mère",
    "text_company_manage_units_disableUnit_confirmation": "Warning! Disabling this unit will also disable its child units, users, budgets, and cost centers.",
    "text_company_costCenter_create_label": "Create Cost Center",
    "text_company_managePermissions_enable_button": "Enable",
    "b2bunit_save": "Save changes",
    "text_company_managePermissions_page_sort_byName": "Nom",
    "success_remove_user_from_unit": "{0} successfully removed from {1} Business Unit",
    "text_company_members_page_showAllResults": "Afficher tout",
    "text_company_units_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "text_company_manage_units_customers": "Customer(s)",
    "text_company_budget_addPage": "Nouveau",
    "text_mails_doubleopt_triggered": "Double Opt in Mail has been sent to : {0}",
    "text_company_manage_units_customers_subtitle": "Select or deselect users which should be customers for this unit.",
    "text_company_usergroups_page_linkNextPage": "Page suivante",
    "text_company_managePermissions_value_label": "Threshold Amount",
    "text_company_manageUsergroups_breadcrumb": "User groups",
    "text_company_manage_unit_user_view": "Affichert",
    "text_company_managers_page_sort_byUnit": "Branche mère",
    "text_company_customers_page_linkPreviousPage": "Page précédente",
    "text_company_costCenter_update_success": "Cost Center updated successfully",
    "text_company_budget_viewPage_costCenters": "Cost Centers",
    "text_company_managers_page_totalResults": "{0} Managers found",
    "text_company_members_page_linkPreviousPage": "Page précédente",
    "text_company_usergroups_viewPage": "View User groups",
    "text_company_managePermissions_edit_page": "Modifier",
    "text_company_children_page_currentPage": "Page {0} sur {1}",
    "text_company_user_mr_name": "M.",
    "text_company_customers_page_currentPage": "Page {0} sur {1}",
    "text_company_budget_edit_title_label": "Edit Budget",
    "text_company_permissions_value_title": "Value",
    "text_company_managePermissions_disable_confirm": "Confirm Disable",
    "text_company_manage_units_childrenUnits_actions": "Actionstt",
    "text_company_manageUser_userDetails": "Détails Utilisateur",
    "b2bunit_no_button": "Non",
    "text_company_budget_noBudgetMessage": "No Budgets found.",
    "text_company_permissions_view_page": "View Permission {0}",
    "text_company_costCenter_selectBox_unit": "Please select unit",
    "text_company_permissions_unit_label": "Branche d’activité mère",
    "text_company_manageUsers_users_new_title": "New User",
    "text_company_organizationManagement_manageUsergroup_breadcrumb": "Manage User group",
    "text_company_manageUsergroups_createUserGroup_title": "New User Group",
    "text_company_costCenter_state_title": "État",
    "text_company_manageUser_registration_request_breadcrumb": "Demandes",
    "text_company_units_remove_confirmation_title_b2bmanagergroup": "Confirm removal of B2B Manager",
    "text_company_manage_unit_editAddress": "Edit Address",
    "text_company_budget_page_linkNextPage": "Page suivante",
    "text_company_members_page_firstPage": "&laquo;",
    "text_company_managePermissions_actions_title": "Actionstt",
    "text_company_managePermissions_permissionType_title": "Permission Type",
    "text_user_disabled": "Disabled User",
    "text_company_manage_unit_costCenter_edit": "Modifier",
    "text_company_disable_name": "Disable",
    "text_company_permissions_viewDetails_page_title": "View Permissions",
    "text_company_manage_units_button_enableUnit": "Enable Unit",
    "text_company_permission_disable_confirm_message": "Warning! Disabling this Permission will not allow it to be used.",
    "text_company_manage_unit_saveAddress": "Enregistrer l’adresse",
    "text_company_manageB2BUserGroup_page_sortTitle": "Ordre de tri :",
    "text_company_usergroups_page_firstPage": "&laquo;",
    "text_company_manageUser_registration_sort_byCountry": "Country-Asc",
    "text_company_editOrDisableUsers": "Edit or disable users",
    "text_company_costCenter_page_firstPage": "&laquo;",
    "text_company_manageB2BUserGroup_page_showPageResults": "Afficher paginé",
    "text_company_costCenter_currency_title": "Currency",
    "text_company_unit_parent": "Branche mère",
    "text_company_column_status_name": "État",
    "text_company_managePermissions_page_showAllResults": "Afficher tout",
    "text_company_managePermissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_usergroups_page_sort_byName": "Nom",
    "text_company_managePermissions_name_label": "Permission ID",
    "text_company_manageUsers_usergroups_breadcrumb": "User Group(s)",
    "text_company_managePermissions_code_exists_error_title": "Permission with this name already exists.",
    "text_company_managePermissions_page_sortTitle": "Ordre de tri :",
    "text_company_manageUser_permission_title": "Permissions",
    "text_company_managePermissions_add_page_title": "Create Permission",
    "text_company_costCenter_add_new_label": "New Cost Center",
    "text_company_members_page_sort_byName": "Nom",
    "text_company_costCenter_saveButton_displayName": "Enregistrer",
    "text_company_managePermissions_selectBox_permissionType": "Sélectionner",
    "text_company_manage_units_parentUnit_disabled": "It is not possible to enable unit whose parent unit is disabled",
    "text_company_user_parentBusinessUnit": "Branche d’activité mère",
    "text_company_customers_viewPage": "View Customers",
    "text_company_administrators_page_sort_byName": "Nom",
    "text_company_budget_noCostCentersFound_message": "No Cost Centers found.",
    "text_company_manageUsers_back_button": "Back to Users",
    "text_company_budget_code_exists_error_title": "Budget Id already exists.",
    "text_company_usergroups_page_sort_byUnitName": "Branche mère",
    "text_company_myCompany": "Ma sociÃ©tÃ©",
    "text_company_roles_name": "Roles",
    "text_company_manage_unit_costCenter_id": "Jeu de pièces de rechange",
    "text_company_manageUser_registration_sort_byDate": "Date-Asc",
    "text_company_budget_edit": "Modifier",
    "text_company_addNewCostCenters": "Add new cost center",
    "text_company_units_remove_confirmation_b2bcustomergroup": "Doing this will remove B2B Customer {0} from Business unit {1}. Do you want to proceed?",
    "text_company_budget_saveButton_displayName": "Enregistrer",
    "text_company_manage_costcenters_edit_budgets_subtitle": "A cost center needs an active budget in so that a customer can place orders against it.",
    "text_company_manageusers_permission_edit": "Edit Permission {0}",
    "text_company_manage_units_childrenUnits_name": "Nom",
    "text_company_manage_units_usergroups_title": "Manage User groups for User: {0}",
    "text_company_manageUser_user_parentUnit": "Branche mère",
    "text_company_editOrDisableCostCenters": "Edit or disable cost centers",
    "usergroup_disabled": "User group is not active, in order to activate it add members to this user group",
    "text_company_budget_end": "End",
    "text_company_usergroups_users_subtitle": "Users within a User group will in-effect be assigned the Permissions of the User group.",
    "text_company_manageusers_button_enableuser": "Enable User",
    "text_company_budget_page_sort_byName": "Nom",
    "text_company_manage_units_approvers_subtitle": "Select or deselect users which should be approvers for this unit.",
    "text_company_manageUser_pageAll_currentPage": "Page {0} sur {1}",
    "text_company_costCenter_name_title": "Cost Center Name",
    "text_company_manageUsergroups_newUserGroupButton": "Create New User group",
    "text_company_managePermissions_create_step2_page": "Step2",
    "text_company_costCenter_disable_warning_message": "Warning!  Disabling this Cost Center will make it unavailable when placing orders.",
    "text_company_budget_status": "État",
    "text_company_permissions_page_sort_byDate": "Date",
    "text_company_manage_units_accountManager_name": "Nom",
    "text_company_manageUser_addedituser": "Edit User",
    "text_company_manage_units_managers_subtitle": "Select or deselect users which should be managers for this unit.",
    "text_parentunit_disabled_warning": "The parent business unit of this customer is not active. In order to manage this customer activate the parent unit first.",
    "text_company_managePermissions_timespan_label": "Time Period",
    "text_company_approvers_page_sort_byUnit": "Branche mère",
    "text_company_manageUser_back_button": "Back to User Details",
    "text_company_manage_units_label": "Units",
    "text_company_members_actions_title": "Actionstt",
    "text_company_manage_unit_childrenUnits_edit": "Modifier",
    "text_company_manage_units_addnewUnit": "Add New Unit",
    "text_company_manage_units_header_approvers": "Approvers",
    "text_company_manageUsers_details_breadcrumb": "{0}t",
    "text_company_manage_costcenters_view_budgets_subtitle": "A cost center needs budgets assigned to it so that customers can place orders against the cost center. This is possible until the limit of the active budget is reached.",
    "text_company_approvers_viewPage": "View Approvers",
    "text_company_approvers_name_title": "Nom",
    "text_company_manage_units_managers": "Manager(s)",
    "text_company_users_remove_confirmation_permission": "Doing this will remove Permission {0} from Customer {1}. Do you want to proceed?",
    "text_company_budget_id": "Jeu de pièces de rechange",
    "text_company_budget_disable_confirm_yes": "Oui",
    "text_company_manage_units_editUnit_breadcrumb": "Modifier",
    "text_company_manageUser_pageAll_sortTitle": "Sort By:",
    "text_mails_passwordSetup_triggered": "Password Setup Mail has been sent to : {0}",
    "text_company_addNewPermission": "Add new permission",
    "text_company_parentUnit_name": "Branche mère",
    "text_company_approvers_page_firstPage": "&laquo;",
    "text_company_user_title": "Title:",
    "text_company_manage_budget_view_subtitle": "Budgets limit the amount your organization can spend at the {0}. For a budget to be used by the system it must be assigned to a cost center so that it is assessed when an order is placed against the cost center.",
    "text_company_usergroup_permission_name": "Permission Name",
    "text_company_customers_page_showAllResults": "Afficher tout",
    "text_company_managePermissions_active_label": "Permission enabled/disabled",
    "text_company_costCenter_edit_title": "Modifier",
    "text_company_managers_page_showAllResults": "Afficher tout",
    "text_company_managePermissions_assignName_budget": "BUDGET",
    "text_company_children_page_firstPage": "&laquo;",
    "user_lastName": "Nom",
    "text_company_approvers_unit_title": "Branche mère",
    "b2bunit_disabled_infomsg": "This business unit is disabled",
    "text_company_manageUsers_usergroups_title": "Select User Group(s)",
    "text_company_budget_actions": "Actionstt",
    "text_company_budget_page_linkPreviousPage": "Page précédente",
    "text_company_manageUsergroups_editUserGroup_title": "Edit User Group",
    "text_company_column_roles_name": "Roles",
    "text_company_manageB2BUserGroup_page_linkPreviousPage": "Page précédente",
    "text_company_manageUser_registration_totalResults": "{0} demande(s) trouvée(s)",
    "text_confirmation_user_disable": "The user {0} has been disabled",
    "text_company_budget_viewPage_back": "Back to Budgets",
    "b2bunit_cancel": "Annuler",
    "text_company_manageUser_registration_sort_byName": "Name-Asc",
    "text_company_managePermissions_page_sort_byUnitName": "Branche mère",
    "text_company_budget_page_showPageResults": "Afficher paginé",
    "text_company_manageusers_button_disableuser": "Disable User",
    "text_company_usergroups_permissions_title": "Select Permission(s)",
    "text_company_manageusers_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_budget_disableButton_displayName": "Disable Budget",
    "text_company_manage_units_button_create": "Create",
    "text_company_budget_status_disabled": "Disabled",
    "text_company_administrators_page_showAllResults": "Afficher tout",
    "text_company_users_remove_permission_confirmation": "Remove Permission {0}",
    "text_company_manage_units_addressForm_create_title": "New Address",
    "text_company_members_roles_title": "Roles",
    "text_company_usergroup_disable_label": "Disable User Group",
    "text_company_user_mrs_name": "Mme",
    "b2busergroup_b2bcustomergroup_name": "B2B Customer",
    "text_company_manage_costcenters_view_subtitle": "All orders purchased on credit must be ordered against a cost center. The cost center's parent unit defines its place within the organization and hence the users who can place orders against it.",
    "text_company_manage_units_children": "Business Unit {0} Child Units",
    "text_company_permissions_page_sort_byName": "Nom",
    "text_company_manage_units_delete_address_message": "Are you sure you would like to delete this address?",
    "text_company_usergroup_delete_warning_message": "Warning! Are you sure you would like to delete this user group?",
    "text_company_column_parentUnit_name": "Branche mère",
    "text_confirmation_user_rejected": "The registration request for {0} been rejected.",
    "text_company_managePermissions_currency_title": "Currency",
    "text_company_managers_page_currentPage": "Page {0} sur {1}",
    "text_company_manage_units_button_disableUnit": "Disable Unit",
    "text_company_usergroup_disable_warning_message": "Warning! Disabling {0} will remove all users.",
    "text_company_permissions_value_label": "Permission value",
    "text_company_name_name_title": "Nom",
    "text_company_manage_units_address_country": "Pays/Région",
    "text_company_user_email": "Email",
    "text_company_manageUser_permission": "Autorisation",
    "text_company_unit_approvalProcess": "Approval Process",
    "text_company_manage_units_address_actions": "Actionstt",
    "text_company_manageB2BUserGroup_page_totalResults": "{0} User Groups found",
    "text_company_permissions_page_currentPage": "Page {0} sur {1}",
    "text_confirmation_budget_updated": "Budget updated successfully",
    "text_company_manageUser_pageAll_linkPreviousPage": "Page précédente",
    "text_company_costCenter_create_success": "Cost Center created successfully",
    "text_company_usergroups_page_currentPage": "Page {0} sur {1}",
    "text_company_manageUsergroups_editUsergroup_breadcrumb": "Modifier",
    "text_company_save_button": "Enregistrer",
    "text_company_save_later_button": "Enregistrer pour plus tard",
    "text_company_manageUser_registration_sort_byNameDesc": "Name-Desc",
    "text_company_manageBudgets_budget_invalid": "Please enter a valid budget",
    "text_company_managePermissions_type_label": "Permission type",
    "text_company_manage_unit_costCenter_actions": "Actionstt",
    "text_company_manageBudgets": "Budgets",
    "text_company_permissions_name_title": "Permission Name",
    "text_company_manageB2BUserGroup_page_currentPage": "Page {0} sur {1}",
    "text_company_manageUser_user_viewDetails": "View User Detail",
    "text_company_permissions_subtitle": "Permissions define the financial limits of a user. Permissions can be on a per-order or per-timespan basis.",
    "text_company_units_remove_b2bapprovergroup_confirmation": "Remove B2B Approver {0}",
    "text_company_editOrDisableUsergroups_confirm": "Confirm User group Changes",
    "text_company_budget_viewPage_label": "Budget Details",
    "text_company_delete_button": "Supprimer",
    "text_confirmation_password_updated": "Password of the customer updated successfully",
    "text_company_administrators_page_sort_byDate": "Date",
    "text_company_status_active_true": "Active",
    "text_company_manageUsers": "Utilisateurs",
    "text_company_not_applicable": "n/a",
    "text_company_manage_units_addressForm_edit_header": "Edit Address for Unit: {0}",
    "text_company_managePermissions_addButton_displayName": "Add New",
    "text_company_manage_units_button_editUnit": "Modifier",
    "text_company_column_name_name": "Nom",
    "text_company_manage_units_administrators": "Administrator(s)",
    "text_company_budget_currency": "Currency",
    "text_company_column_type": "Typet",
    "text_company_usergroups_permissions_breadcrumb": "Permission(s)",
    "text_company_managePermissions_status_disabled": "Disabled",
    "text_company_permissions_unit_title": "Branche d’activité mère",
    "text_company_name_name": "Nom",
    "text_company_budget_create_title_label": "New Budget",
    "text_company_select_action_label": "Sélectionner",
    "text_company_manage_unit_costCenter_currency": "Currency",
    "text_company_noentries": "No Entries",
    "text_company_budget_start": "Commencer",
    "text_company_costCenter_page_currentPage": "Page {0} sur {1}",
    "text_company_select_budgets": "Select Budget(s)",
    "text_company_costCenter_addNew": "Add New",
    "text_company_permissions_page_sortTitle": "Ordre de tri :",
    "b2busergroup_id": "User group ID",
    "text_confirmation_user_approved": "La demande d’inscription pour {0} est approuvée.",
    "text_company_usergroup_id_title": "User group ID",
    "text_company_manage_units_user_actions": "Actionstt",
    "text_company_manageB2BUserGroup_page_linkNextPage": "Page suivante",
    "text_company_deselect_action_label_confirm": "Confirm Deselect",
    "text_company_managers_page_linkPreviousPage": "Page précédente",
    "text_company_manageusers_label": "Utilisateurs",
    "text_company_manage_units_disabled": "Business Unit has been disabled",
    "text_company_budget_enabledDisabled": "État",
    "text_company_manage_units_approvers_manage_title": "Manage Approvers for Unit: {0}",
    "text_company_manage_units_view_addresses_subtitle": "The Addresses will be available to a customer ordering for a cost center related to this unit.",
    "text_company_manage_units_view_managers_subtitle": "Users with the manager role have the ability to see reports using the reports area of the storefront (awaiting implementation). Adding or removing a user here adds or removes the manager role from the user.",
    "text_company_permissions_timespan_label": "Permission timespan",
    "text_company_manageB2BUserGroup_page_sort_byName": "Nom",
    "text_company_manageB2BUserGroup_page_showAllResults": "Afficher tout",
    "text_company_manage_units_addAddress": "New Address",
    "text_company_user_password": "Password:",
    "text_company_costCenter_page_sort_byUnitName": "Branche mère",
    "text_company_manage_units_address_towncity": "Town/City",
    "unit_uid_invalid": "Please select a unique identifier for the business unit",
    "text_company_approvers_page_lastPage": "&raquo;",
    "text_company_budget_disable_confirm_no": "Non",
    "text_company_usergroup_delete_label": "Delete User Group",
    "text_company_usergroups_page_lastPage": "&raquo;",
    "text_company_manageUsergroup_editForm": "Please use this form to update user group details",
    "text_company_manage_units_customers_title": "Manage Customers for Unit: {0}",
    "text_company_budget_budgetBreadCrumb": "Budget {0}",
    "text_company_manage_units_createUnit_breadcrumb": "Nouveau",
    "text_company_manage_units_view_administrators_subtitle": "Users with the administrator role have the ability to administrate this branch of the organization using the My Company area of the storefront. Adding or removing a user here adds or removes the administrator role from the user.",
    "text_company_units_remove_confirmation_title_b2bcustomergroup": "Confirm removal of B2B Customer",
    "text_coreSearchTab_error": "Invalid input or no results found, please try again.",
    "text_company_manage_units_user_email": "Email",
    "text_company_costCenter_disable_confirm_yes": "Oui",
    "text_company_user_miss_name": "Miss",
    "text_company_editOrDisablePermissions": "Edit or disable permissions",
    "text_company_organizationManagement_createuser": "Nouveau",
    "text_company_costCenter_edit_required_label": "Fields marked with * are required",
    "text_company_manageUser_noUser": "Vous n'avez pas d'utilisateur",
    "text_company_usergroup_timespan_title": "TimeSpan",
    "text_company_budget_page_showAllResults": "Afficher tout",
    "validation_checkPwd_equals": "Le mot de passe ne correspond pas à la confirmation du mot de passe",
    "text_company_manage_units_address_zipcode": "Postal Code",
    "text_company_managePermissions_create_new_permission": "Nouveau",
    "text_company_units_remove_b2badmingroup_confirmation": "Remove B2B Administrator {0}",
    "text_company_approvers_page_sort_byName": "Nom",
    "text_company_permissions_page_showPageResults": "Afficher paginé",
    "text_company_children_page_linkNextPage": "Page suivante",
    "text_confirmation_approver_removed": "Approver removed successfully",
    "text_company_manageUsers_edituser_title": "Modifier les détails utilisateur",
    "text_company_members_page_totalResults": "{0} Members found",
    "text_company_manageusers_approvers_subtitle": "The approval process will assign orders to approvers if the customer placing the order has insufficient permissions to do so. By default approvers are picked from the organization hierarchy, but additional approvers can be assigned to a specific customer here.",
    "text_company_costCenter_id": "Jeu de pièces de rechange",
    "text_company_costCenter_budget_title": "Budget(s)",
    "text_company_manageUser_registration_sort_byCity": "City-Asc",
    "text_company_manageUser_registration_sortTitle": "Sort By:",
    "text_company_actions_name": "Actionstt",
    "text_company_costCenter_page_sort_byName": "Nom",
    "text_company_manageUser_button_edit": "Modifier",
    "text_company_manage_units_permissions_breadcrumb": "Permission(s)",
    "text_company_managers_page_lastPage": "&raquo;",
    "text_company_manage_unit_user_enable": "Enable",
    "text_company_managers_page_sort_byName": "Nom",
    "text_company_manageUser_registration": "Afficher tout",
    "text_company_manageUser_registration_currentPage": "Page {0} sur {1}",
    "text_company_manage_units_view_customers_subtitle": "Users with the customer role have the ability to place orders against cost centers to which they have access. Adding or removing a user here adds or removes the customer role.",
    "text_company_manageUser_registration_showPageResults": "Afficher paginé",
    "text_company_permissions_page_firstPage": "&laquo;",
    "text_company_usergroups_members_breadcrumb": "User(s)",
    "text_company_off": "OFF",
    "text_company_manageUser_registration_firstPage": "&laquo;",
    "user_firstName": "Prénom",
    "text_company_permission_disable_confirm": "Disable Permission",
    "text_confirmation_permission_created": "Permission created successfully",
    "myCompany_login_myCompanyHome": "Login to My Company",
    "text_company_manageUser_user_firstName": "Prénom",
    "text_company_manageusers_roles_subtitle": "A user is an individual who is able to login to the {0}. The functionality available to a user is dependent on the roles they have. B2B Administrators have access to the My Company area to modify the organization hierarchy. B2B Managers can view statistics on the sales of the organization (awaiting implementation). B2B Approvers can approve orders for which the B2B Customer did not have enough permissions. B2B Customers can place orders in the {0}front.",
    "text_company_budget_disable_confirm": "Confirm Disable",
    "text_company_editOrDisableUsergroups_confirm_action_label_confirm": "Confirm Changes",
    "text_company_administrators_viewPage": "View Administrators",
    "usergroup_no_button": "Non",
    "text_company_manage_unit_user_disable": "Disable",
    "text_company_costCenter_selectBox_currency": "Please select currency",
    "text_company_manage_budget_view_costcenter_subtitle": "The budget is assigned to these cost centers.<br /> To modify these assignments you need to navigate to the respective cost center using the links below.",
    "text_company_units_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Business unit {1}. Do you want to proceed?",
    "text_company_costCenter_back": "Back to Cost Centers",
    "text_company_members_name_title": "Nom",
    "form_b2busergroup_notunique": "User group with the same id already exists",
    "text_company_disable_confirm_no": "Non",
    "mycompany_delete_error_message": "Cannot delete as at least one sold to must be linked",
    "text_company_organizationManagement_manageUser_breadcrumb": "Manage User",
    "text_company_unit_name": "Unit Name",
    "text_company_manage_unit_user_edit": "Modifier",
    "text_manageuser_error_email_exists_title": "Email already exists",
    "text_company_approvers_page_sortTitle": "Ordre de tri :",
    "text_company_managePermissions_edit_page_title": "Edit Permission",
    "text_company_managePermissions_create_step1_page": "Create Permission - Step 1",
    "usergroup_name_invalid": "Please select a name for the user group",
    "text_company_children_page_sortTitle": "Ordre de tri :",
    "text_company_manageUser_registration_sort_byActiveDesc": "Active-Desc",
    "text_company_members_unit_title": "Parent unit",
    "text_company_back": "Retour",
    "text_company_usergroup_back_button": "Back to User Groups",
    "text_company_id_name": "Jeu de pièces de rechange",
    "text_company_managePermissions_name_title": "Permission Name",
    "text_company_members_page_sort_byDate": "Date",
    "text_company_managePermissions_selectBox_timespan": "Select a timespan",
    "text_company_users_remove_confirmation_title_b2bapprovergroup": "Confirm removal of B2B Approver",
    "text_company_costCenter_disable_confirm_message": "Doing this will prevent this cost center from being used when placing orders. Do you wish to continue?",
    "text_company_manageB2BUserGroup_page_lastPage": "&raquo;",
    "b2busergroup_parent": "Branche d’activité mère",
    "text_company_costCenter_viewDetails_label": "Cost Center Details",
    "text_company_manageUsergroups_unit_create": "Create User group",
    "text_company_user_roles": "Roles",
    "text_coreSearchTab_content": "Si vous n’êtes pas certain du numéro d’article ou du groupe de cores, entrez les renseignements connus ci-dessous dans le champ pertinent.",
    "text_company_budget_endDate": "End Date",
    "text_company_manage_units_details": "{0}t",
    "text_company_managePermissions_create_continueButton": "Continuer",
    "address_title_none": "Aucun",
    "text_company_manageUser_user_lastName": "Nom",
    "text_company_manage_units_unit_create": "Create Child Unit for Unit: {0}",
    "text_company_manage_unit_costCenter_view": "Affichert",
    "text_confirmation_permission_updated": "Permission updated successfully",
    "text_company_editOrDisableUsergroups_confirm_action_label_cancel": "Annuler",
    "text_company_done_button": "Terminé",
    "text_company_manage_units_view_accountManagers_subtitle": "The Account Managers are the {0} contacts for this unit.",
    "text_company_manage_unit_costCenter_name": "Nom",
    "text_company_manage_units_header_administrators": "Administrators",
    "text_company_manage_units_users_button_edit": "Modifier",
    "text_company_budget_viewPage": "{0}t",
    "text_company_budget_name": "Budget Name",
    "text_company_managers_page_showPageResults": "Afficher paginé",
    "text_company_budget_startDate": "Start Date",
    "text_company_manage_costcenter_budget_title": "Budgets",
    "text_company_managePermissions_value_title": "Threshold Value",
    "text_company_permissions_currency_title": "Currency",
    "text_Shipping_Packaging": "Expédition/Emballage",
    "text_company_budget_page_sort_byCode": "Id",
    "usergroup_notfound": "User group not found",
    "text_company_costCenter_addPage": "Nouveau",
    "text_company_manage_units_disable_breadcrumb": "Disable {0} Business Unit",
    "text_company_budget_deselect_confirm": "Confirm Budget Deselect",
    "text_company_manage_units_approvers": "Approver(s)",
    "text_company_manage_units_user_name": "Nom",
    "text_confirmation_user_accepted": "The Registration request has been accepted.",
    "usergroup_yes_button": "Oui",
    "text_company_add_button": "Ajouter",
    "text_company_manageUser_pageAll_sort_byName": "Nom",
    "text_company_editOrDisableUsergroups_confirm_message": "There are possible implications or limitations associated with modifying a user group's parent unit.  Please confirm these changes are intended.",
    "text_company_approvers_page_showAllResults": "Afficher tout",
    "text_company_budget_cancelButton_displayName": "Annuler",
    "text_confirmation_permission_removed": "Permission removed successfully",
    "text_company_managePermissions_disable_confirm_message": "Doing this will stop this permission level from being used. Do you wish to continue?",
    "text_company_manageusers_details_subtitle": "The functionality available to a user is dependent on the roles they have. In general, the visibility and jurisdiction of a user is restricted to the branch of the unit to which they are assigned.",
    "text_company_manageUser_pageAll": "Afficher tout",
    "text_company_manageUser_registration_sort_byCountryDesc": "Country-Desc",
    "text_company_managers_page_sortTitle": "Ordre de tri :",
    "form_b2bcustomer_parentunit_error": "A B2B Administrator can not modify his parent unit.",
    "text_company_costCenter_select_budget": "Edit Related Budgets",
    "text_mycompany_user_createForm": "Please use this form to create a new customer",
    "text_company_usergroup_members": "Utilisateurs",
    "text_company_managePermissions_disable_confirm_no": "Non",
    "form_b2bunit_success": "Business unit saved successfully",
    "text_company_costCenter_cancelButton_displayName": "Annuler",
    "text_company_manageUser_registration_sort_byEmailDesc": "Email-Desc",
    "text_company_permissions_page_linkNextPage": "Page suivante",
    "error_budget_parentunit_disabled": "This budget may not be set to not active state because the parent B2B Unit not active.",
    "text_company_usergroups_page_sort_byGroupID": "Id",
    "text_company_managePermissions_disable_button": "Disable Permission",
    "text_confirmation_user_saved": "The user details for {0} has been saved.",
    "text_company_managePermissions_unit_title": "Branche d’activité mère",
    "text_company_manageUser_user_costCenter": "Cost Centers",
    "text_company_manage_units_button_editChildren": "Modifier",
    "text_company_manage_units_costCenters": "Cost Centers",
    "b2busergroup_cancel": "Annuler",
    "text_company_manage_unit_user_remove": "Supprimert",
    "text_company_manage_units_adduser_title": "Create User for Unit: {0}",
    "text_company_unit_id": "Unit ID",
    "text_company_manage_units_view_costCenters_subtitle": "The cost centers will be available to members of this branch when placing an order.",
    "text_company_manageUser_user_roles": "Roles",
    "text_company_managePermissions_page_currentPage": "Page {0} sur {1}",
    "text_manageuser_restpasswordform": "Réinitialiser le mot de passe",
    "text_company_customers_page_sort_byDate": "Date",
    "text_company_costCenter_name": "Nom",
    "text_company_manageCostCenters": "Cost Centers",
    "text_company_administrators_page_showPageResults": "Afficher paginé",
    "text_company_children_page_sort_byName": "Nom",
    "text_company_status_title": "État",
    "text_company_approvers_page_currentPage": "Page {0} sur {1}",
    "text_company_breadcrumb": "Mon compte d'entreprise",
    "text_company_user_userEnabledStatus": "User Enabled Status",
    "text_company_manageUser_registration_totalResultsSinglePag": "{0} nouvelle(s) demande(s) trouvÃ©e(s)",
    "text_company_user_unit_title": "Branche mère",
    "text_company_manageUser_registration_request_details": "Request Details",
    "text_confirmation_user_enable": "The user {0} has been enabled",
    "form_b2busergroup_success": "User group updated successfully",
    "text_company_manageUser_registration_sort_byCityDesc": "City-Desc",
    "b2bunit_notfound": "Business Unit was not found",
    "text_company_customers_page_firstPage": "&laquo;",
    "text_company_manage_units_addresses": "Adresses",
    "text_company_managePermissions_status_title": "État",
    "text_company_manageUser_pageAll_showPageResults": "Afficher paginé",
    "text_company_manageUser_roles": "Roles",
    "text_company_manageUser_registration_linkNextPage": "Page suivante",
    "text_company_manage_units_users_button_createnew": "Nouveau",
    "text_company_manage_units_address_line2": "Adresse Ligne 2",
    "text_company_manage_units_address_line1": "Address Line 1",
    "text_company_manageusers_permissions_title": "Select Permission(s)",
    "text_company_costCenter_disable_confirm_no": "Non",
    "text_company_costCenter_state_inactive": "Disabled",
    "text_company_manageUser_button_create": "Créer un nouvel utilisateur",
    "text_company_approvers_page_showPageResults": "Afficher paginé",
    "text_company_costCenter_enable_button": "Enable",
    "text_company_administrators_page_lastPage": "&raquo;",
    "text_company_manage_units_administrators_mainTitle": "Select Administrator(s)",
    "text_company_managePermissions_create_step1": "Step 1 of 2",
    "text_company_managePermissions_create_step2": "Step 2 of 2",
    "text_company_manage_units": "Units",
    "text_company_managePermissions_disable_confirm_yes": "Oui",
    "text_company_managePermissions_page_showPageResults": "Afficher paginé",
    "text_company_manageuser_user_disable": "Confirm Disable",
    "text_company_budget_enableButton_displayName": "Enable",
    "text_company_budget_page_lastPage": "&raquo;",
    "text_confirmation_user_added": "Customer successfully created",
    "b2busergroup_b2badmingroup_name": "B2B Administrator",
    "text_company_permission_enable_confirm": "Enable Permission",
    "text_company_manage_units_createuser_breadcrumb": "New User",
    "text_company_manage_unit_childrenUnits_view": "Affichert",
    "text_company_costCenter_button_displayName": "Modifier",
    "form_b2bunit_approvalProcessCode_required": "Please select an approval process for the root unit",
    "text_company_manageUser_page_totalResults": "{0} utilisateur(s) trouvé(s)",
    "text_company_column_id_name": "Jeu de pièces de rechange",
    "text_company_members_page_showPageResults": "Afficher paginé",
    "text_company_approvers_actions_title": "Actionstt",
    "text_company_managePermissions_timespan_title": "Timespan",
    "text_company_costCenter_edit_label": "Edit Cost Center",
    "text_company_disable_confirm": "Confirm Disable",
    "text_company_manageUser_registration_totalResultsSingleOrder": "1 demande(s) trouvée(s)",
    "text_company_manage_budget_subtitle": "Budgets limit the amount your organization can spend at the {0}.",
    "text_company_managePermissions_assignName_order": "ORDER",
    "text_company_users_remove_confirmation_b2bapprovergroup": "Doing this will remove B2B Approver {0} from Customer {1}. Do you want to proceed?",
    "text_company_usergroup_disable_button": "Disable",
    "text_company_children_page_showAllResults": "Afficher tout",
    "b2bunit_id": "Business Unit ID",
    "text_company_disable_button": "Disable",
    "text_company_children_page_totalResults": "{0} Child Units found",
    "text_company_manage_units_header_managers": "Managers",
    "text_company_manageUser_registration_sort_byActive": "Active-Asc",
    "text_company_managePermissions_edit_saveButton": "Enregistrer",
    "text_company_usergroups_members_title": "Select User(s)",
    "text_company_manage_units_subtitle": "Units represent a logical grouping of individuals or function within an organization, such as a project team or a department. Units are placed into an organization hierarchy, which is navigable below. Units inherit from their parent unit (unless overridden locally) and as such the placement of a unit within the hierarchy is important. The organization hierarchy also affects such things as available cost centers, budgets, delivery addresses and the escalation of such things as order approval.",
    "text_company_manage_units_userDetails": "View User for Unit: {0}",
    "text_company_manageUser_pageAll_sort_byUnit": "Branche mère",
    "text_company_budget_unit": "Parent business unit",
    "text_company_manage_units_header_customers": "Customers",
    "b2busergroup_b2bmanagergroup_name": "B2B Manager",
    "text_company_permissions_page_lastPage": "&raquo;",
    "text_company_administrators_page_totalResults": "{0} Administrators found",
    "text_company_manageB2BUserGroup_page_sort_byGroupID": "Id",
    "text_confirmation_usergroup_removed": "User group removed successfully",
    "text_company_manageUsers_adduser_title": "Ajouter les détails utilisateur",
    "text_company_manageUser_edituser": "Modifier les détails utilisateur",
    "text_company_budget_editPage": "Modifier",
    "form_b2busergroup_noeditpermissions": "You don't have an appropriate permissions to edit this group.",
    "b2bunit_yes_button": "Oui",
    "text_company_units_remove_confirmation_b2badmingroup": "Doing this will remove B2B Administrator {0} from Business unit {1}. Do you want to proceed?",
    "text_company_manage_units_editForm": "Please use this form to update business unit details",
    "text_company_costCenter_page_linkPreviousPage": "Page précédente",
    "text_company_manage_units_accountManagers": "Account Managers",
    "text_company_manageUser_adduser": "Add User",
    "text_company_children_page_linkPreviousPage": "Page précédente",
    "text_company_status_active_false": "Disabled",
    "text_company_customers_page_showPageResults": "Afficher paginé",
    "text_company_manageUsergroups_remove_confirmation": "Doing this will remove User Group : {0} . Do you want to proceed?",
    "text_company_addNewBudgets": "Add New Budgets",
    "text_company_manageUser_registration_totalResultsCurrPage": "{0} sur {1} demande(s) trouvée(s)",
    "text_company_budget_disable_confirm_message": "Doing this will prevent this budget from being used. Do you wish to continue?",
    "text_company_manage_units_managers_mainTitle": "Select Manager(s)",
    "text_company_costCenter_page_showAllResults": "Afficher tout",
    "text_account_document_favorite_table_doc_subscribed": "Subscribed",
    "text_account_document_favorite_subscribed_boolean": "Oui",
    "text_account_document_favorite_not_subscribed_boolean": "Non",
    "text_software_search_button_download_lable": "Télécharger le logiciel",
    "text_software_search_button_viewdetails_lable": "Afficher les détails",
    "text_software_search_button_download_pin_lable": "Télécharger le logiciel et demander un code PIN",
    "na_crm_alreadyused_message": "The CR entered has already been used, please enter a different CR number.",
    "text_account_table_header_category": "Cat gorie  de commandes",
    "replenishmentScheduleForm_weekly_daysOfWeek": "Envoyer chaque",
    "text_account_orderApproval_rejectButton_displayName": "Refuser la commande",
    "text_account_order_status_title": "État",
    "text_account_order_orderDetails_validUntil": "Valide jusqu’au",
    "text_account_orderStatus": "État de la commande",
    "text_account_replenishment_page_linkNextPage": "Page suivante",
    "text_account_replenishment_orders": "Commandes de réapprovisionnement",
    "checkout_multi_costCenter_title_pleaseSelect": "Sélectionnez...",
    "search_advanced_search": "Recherche",
    "text_account_orderHistory_replenishment_link": "Afficher le calendrier de réapprovisionnement",
    "text_account_orderApprovalDetails_parentBusinessUnit": "Branche d’activité mère",
    "text_account_yes_button": "Oui",
    "text_account_manageReplenishment_confirm_cancel_breadcrumb": "Supprimer le calendrier de réapprovisionnement {0}",
    "text_account_table_header_sentBy": "Sent By",
    "text_account_replenishment_noOrdersFound": "Aucune commande de réapprovisionnement trouvée",
    "search_advanced_meta_description_title": "Formulaires de commande",
    "search_advanced_productids_add": "Ajouter",
    "replenishmentScheduleForm_startDate": "Lancer l’auto-réapprovisionnement le",
    "responsive_replenishmentScheduleForm_monthly_day": "Ce jour du mois :",
    "text_account_orderApprovalDetails_OrderNumber": "Numéro de commande",
    "text_account_order_status_display_approved": "Approuvée",
    "text_account_naPartNumber": "Numéro de pièce Bendix/Numéro de pièce client",
    "replenishmentScheduleForm_activateDaily": "Activation quotidienne",
    "text_account_replenishment_page_firstPage": "&laquo;",
    "text_account_order_status_display_merchant_rejected": "Refus marchand",
    "text_account_orderHistoryEntry_merchantTitle": "Détails, approbation marchand",
    "text_account_orderApprovalDetails_paidOntoAccount": "Compte acquitté",
    "text_account_replenishment_manageReplenishmentSchedule": "Gérer votre calendrier de réapprovisionnement",
    "text_account_replenishment_actions": "Annuler",
    "order_reorder_error": "Erreur de nouvelle commande.",
    "text_account_naOrderNumber": "Numéro de commande Bendix",
    "text_account_replenishment_replenishmentOrderDetailBreadcrumb": "Commande {0}",
    "checkout_multi_paymentType_continue": "Suivant",
    "checkout_multi_paymentType_notprovided": "Vous devez fournir un type de paiement avant de passer à l’étape suivante.",
    "checkout_error_paymenttype_formentry_invalid": "Le no de bon de commande client est obligatoire pour terminer le processus de validation d’achat.",
    "text_account_orderApprovalDetails_label": "Détails, approbation commande",
    "replenishmentScheduleForm_monthly_day": "Envoyer le",
    "text_user_table_save": "Enregistrer",
    "text_account_table_header_currency": "Currency",
    "search_advanced_keyword": "Recherche de mots-clés",
    "text_account_order_purchase": "Acheteur",
    "order_replenishment_confirmation": "Confirmation commande de réapprovisionnement",
    "text_account_table_header_customerNo": "No de pièce client",
    "text_account_openPosition_page_totalResultsCurrPage": "{0} of {1} Open Positions Found",
    "text_account_replenishment_replenishmentNumber": "Réapprovisionnement no",
    "text_user_table_header_Core": "Pièce uséet",
    "text_account_openPosition_page_totalResults": "{0} Positions en cours trouvés",
    "text_account_open_positions": "Search Open Positions",
    "text_account_replenishment_page_showAllResults": "Afficher tout",
    "search_advanced_catalog": "Catalogue",
    "text_account_replenishment_nextOrderDate": "Date suivante de commande",
    "text_account_orderApprovalDetails_orderPlacedBy": "Commande passée par",
    "text_user_table_header_order": "Commande",
    "checkout_multi_paymentType_stepHeader": "Type de paiement",
    "text_account_order_approver_title": "Approbateur",
    "replenishmentScheduleForm_weekly_weeks": "Chaque",
    "text_account_replenishment_page_currentPage": "Page {0} sur {1}",
    "responsive_replenishmentScheduleForm_daily_days": "Tous les # jours :",
    "text_account_table_header_partNo": "Général",
    "checkout_multi_costCenter_label": "Centre de coûts",
    "text_account_order_orderDetails_purchaseOrderNumber": "No de bon de commande",
    "checkout_multi_purchaseOrderNumber_label": "No de bon de commande",
    "checkout_summary_replenishmentScheduleForm_title": "Établir un calendrier de réapprovisionnement",
    "checkout_multi_replenishment": "Réapprovisionnement",
    "text_account_table_header_openQty": "Qté à définir",
    "text_account_orderApproval_addApproverComments": "Ajoutez des commentaires à votre décision",
    "checkout_summary_requestApproval_cancel": "Annuler",
    "search_nav_facetShowLess_fit": "moins d’ajustements...",
    "checkout_multi_costCenter_notprovided": "Vous devez fournir un centre de coûts avant de passer à l’étape suivante.",
    "text_account_quote_msg4": "Cliquer pour modifier les détails utilisateur",
    "text_account_order_approval_title": "Détails, approbation",
    "text_account_replenishment_page_sort_byReplenishmentNumber": "Numéro de réapprovisionnement",
    "text_account_quote_msg5": "Utilisateur bloqué – Cliquer pour activer l’utilisateur",
    "text_account_replenishment_confirmation_canceled": "Votre commande de réapprovisionnement a été annulée.",
    "text_account_orderApprovalDashBoard_orderCreated": "Commande créée",
    "text_account_orderApprovalDashBoard_viewOrdersPendingForApproval": "Commandes en attente de votre approbation",
    "text_notAvailable": "S.O.",
    "text_account_quote_active": "Effectiveness",
    "text_account_orderApprovalDashboard": "Tableau de bord des approbations de commandes",
    "text_account_replenishment_cancel_button": "Annuler réapprovisionnement",
    "text_account_orderApproval_reject_reason": "Ajouter le motif du refus ci-dessous",
    "text_account_order_permission_notes": "Commentaires de l’approbateur",
    "text_account_manageReplenishment": "Gérer le calendrier de réapprovisionnement",
    "text_account_replenishment_page_sort_byOrderNumber": "Numéro de commande",
    "text_account_replenishment_total": "Total est.",
    "text_user_table_approve": "Approve",
    "text_account_table_header_kbnumber": "Général",
    "text_account_orderHistoryEntry_customerTitle": "Détails, approbation client",
    "text_account_endNow": "Terminer maintenant",
    "text_store_dateformat": "MM/jj/aaaa",
    "text_account_replenishmentOrderDetails_title": "Détails, commande de réapprovisionnement",
    "text_account_replenishment_page_sort_byDate": "Date de création",
    "text_account_openPosition_page_totalResultsSingleOrder": "1 Open Position found",
    "text_account_replenishment_datePlaced": "Date comm. passée",
    "text_account_table_header_estDelDate": "Estimated Delivery Date",
    "text_account_table_header_reqDelDate": "Date de livraison demandée",
    "text_account_openPositions_export": "Export",
    "checkout_multi_summary_orderPlacedBy": "Commande passée par",
    "text_order_reorderbutton": "Nouvelle commande",
    "text_user_table_header_Warranty": "Garantie",
    "text_account_replenishment_noReplenishment": "Vous n’avez aucune commande de réapprovisionnement programmée",
    "replenishmentScheduleForm_activateMonthly": "Activation mensuelle",
    "responsive_replenishmentScheduleForm_activateWeekly": "Hebdomadaire",
    "text_account_table_header_typeNo": "Numéro du type",
    "text_account_replenishment_remove_confirmation_title": "Confirmer suppression",
    "text_account_replenishment_orderNumber": "Numéro de commande",
    "text_account_replenishment_replenishmentBreadcrumb": "Calendrier de réapprovisionnement {0}",
    "responsive_replenishmentScheduleForm_activateMonthly": "Mensuel",
    "checkout_summary_scheduleReplenishment": "Retour à la caisse",
    "text_account_table_header_pricePerUnit": "Prix net*",
    "text_account_reset": "Réinitialiser",
    "text_store_dateformat_datepicker_selection_hint": "mm/jj/aaaa",
    "text_account_order_orderDetails_CostCenter": "Centre de coûts",
    "responsive_replenishmentScheduleForm_activateDaily": "Quotidien",
    "replenishmentScheduleForm_daily_days": "Réapprovisionnement chaque",
    "text_account_orderHistory_replenishment_schedule": "Calendrier de réapprovisionnement : {0}",
    "search_nav_facetShowMore_color": "plus de couleurs...",
    "text_account_orderApprovalDashBoard_orderNumber": "Numéro de commande",
    "text_account_order_permission_title": "Autorisation",
    "text_account_replenishment_frequency": "Fréquence",
    "text_account_replenishment_page_totalResults": "{0} Réapprovisionnements trouvés",
    "text_account_replenishment_canceled": "Annulé",
    "text_account_order_status_display_rejected": "Refusée",
    "text_account_table_header_type": "Typet",
    "text_account_replenishment_page_sort_byNextOrderDate": "Date suivante de commande",
    "search_advanced": "Formulaires de commande",
    "search_advanced_onlyproductids": "ID produits seulement",
    "text_account_table_header_naNumber": "Numéro de commande Bendix",
    "search_nav_facetShowMore_fit": "plus d’ajustements...",
    "checkout_summary_placeReplenishmentOrder": "Passer une commande de réapprovisionnement",
    "text_account_replenishment_noOrders": "Vous n’avez aucune commande",
    "replenishmentScheduleForm_weeks": "semaine",
    "search_advanced_createorderform": "Créer un formulaire de commande",
    "search_advanced_orderform": "Formulaire de commande",
    "text_account_replenishment_page_linkPreviousPage": "Page précédente",
    "text_account_replenishment_confirm_cancel": "Cesser la commande régulière maintenant. Voulez-vous vraiment cesser le réapprovisionnement automatique de cette commande ({0})?",
    "order_replenishment_schedule_title": "Votre calendrier de réapprovisionnement",
    "text_account_replenishment_details": "Détails, réapprovisionnement",
    "text_account_table_header_confirmedQty": "Confirmed Quantity",
    "text_account_orderApproval_approve_reason": "Ajouter un commentaire d’approbation ci-dessous (facultatif) :",
    "text_account_table_header_status": "Téléchargements",
    "text_account_table_header_entry_status": "Order Item Status",
    "text_account_orderApprovalDashBoard_orderStatus": "État de la commande",
    "replenishmentScheduleForm_month": "jour/mois",
    "search_advanced_productids": "Entrer ID produit séparés par une virgule",
    "checkout_multi_paymentType_selectPaymentTypeMessage": "Sélectionnez votre type de paiement.",
    "text_user_table_linked_customer": "Lien ID client/Sélection vendu par défaut à",
    "text_user_table_unlock_user_account": "Déverrouiller le compte utilisateur",
    "text_account_order_status_display_merchant_approved": "Approbation marchand",
    "replenishmentScheduleForm_activateWeekly": "Activation hebdomadaire",
    "checkout_multi_paymentType_breadcrumb": "INFORMATION SUR LE CLIENT",
    "text_account_customerID": "Client ID",
    "text_account_replenishment_history": "Historique des réapprovisionnements",
    "order_replenishment_thankYou": "Merci de votre commande régulière de réapprovisionnement!",
    "responsive_checkout_summary_requestApproval_maxchars": "255 caractères maximum",
    "responsive_replenishmentScheduleForm_weekly_daysOfWeek": "Les jours suivants :",
    "checkout_multi_paymentType": "INFORMATION SUR LE CLIENT",
    "search_nav_facetShowLess_color": "moins de couleurs...",
    "checkout_multi_deliveryAddress_noPickup": "ADRESSE D’EXPÉDITION",
    "text_account_replenishment_shipToItems": "Articles pour l’expédition",
    "text_account_orderApproval_approveButton_displayName": "Accepter la commande",
    "text_account_orderApprovalDetails_comments_label": "Commentaires",
    "text_account_orderApproval_orderStatus": "État de la commande",
    "checkout_error_invalid_accountType": "Votre compte ne vous autorise pas à passer à la caisse ici.",
    "text_account_replenishment_page_showPageResults": "Afficher paginé",
    "text_account_replenishment_Schedule": "Calendrier",
    "checkout_multi_deliveryAddress_noPickup_breadcrumb": "ADRESSE D’EXPÉDITION",
    "responsive_replenishmentScheduleForm_weekly_weeks": "Toutes les # semaines :",
    "text_account_table_header_description": "Désignationt",
    "text_account_openPosition_page_totalResultsSinglePag": "{0} Positions en cours trouvés",
    "text_account_no_button": "Non",
    "text_account_table_header_lineItem": "Position No.",
    "text_account_myReplenishment": "Mes commandes de réapprovisionnement",
    "text_account_replenishment_creationDate": "Date de création",
    "text_account_orderHistory_replenishment_startFrom": "Commencer le réapprovisionnement de : {0}",
    "text_account_orderApprovalDashBoard_actions": "Actions",
    "text_account_orderApprovalDashBoard_purchaseOrderNumber": "No de bon de commande :",
    "text_account_replenishment_purchaseOrderNumber": "No de bon de commande",
    "order_replenishment_confirmation_number": "Numéro de confirmation :",
    "text_account_orderHistory_purchaseOrderNumber": "No de bon de commande",
    "text_account_order_status_display_pending_merchant_approval": "En attente d’approbation du marchand",
    "checkout_multi_paymentType_continue_NA": "Suivant",
    "text_account_order_status_display_pending_approval": "En attente d’approbation",
    "text_account_orderApprovalDetails_purchaseOrderNumber": "No de bon de commande",
    "text_account_replenishment_page_lastPage": "&raquo;",
    "text_account_order_status_display_assigned_admin": "Assigné à l’administrateur",
    "text_account_orderHistory_replenishment": "Cette commande est programmée",
    "text_account_replenishment_orderStatus": "État de la commande",
    "checkout_summary_replenishmentScheduleForm_cancel": "Annuler",
    "replenishmentScheduleForm_days": "jour",
    "text_account_order_orderDetails_ParentBusinessUnit": "Branche mère",
    "text_account_orderApprovalDetails_orderStatusDetails_label": "Détails, état de la commande",
    "text_account_replenishment_viewReplenishmentOrders": "Afficher vos commandes de réapprovisionnement",
    "text_account_table_header_orderedQty": "Ordered Quantity",
    "text_store_dateformat_datepicker_selection": "mm/jj/aaaa",
    "text_account_replenishment_page_sortTitle": "Ordre de tri :",
    "text_account_replenishment_startDate": "Commencer",
    "text_account_orderApprovalDetails_costCenter": "Centre de coûts",
    "checkout_error_paymenttype_formentry_repeat": "Le numéro de bon de commande saisi a déjà été utilisé, veuillez entrer un nouveau numéro de bon de commande client",
    "text_account_supporttickets_tryLater": "Désolé, un problème est survenu, veuillez réessayer plus tard",
    "text_account_supporttickets_updateTicket_message_desc": "Mettez à jour un message. Merci de bien vouloir indiquer autant d'informations que possible.",
    "text_account_supporttickets_updateTicket_c4cMessage1": "Ce ticket est déplacé vers le service client",
    "text_Show_adb_of_coworkers": "Show Brake Application requests from coworkers",
    "text_Show_core_of_coworkers": "Show core requests from coworkers",
    "text_Show_warranty_of_coworkers": "Show warranty requests from coworkers",
    "text_training_elearingrequired": "inclure les réservations eLearning",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Buscar garantía",
    "type_productWeight_unit_name": "Prix courant",
    "type_B2BCustomerCoreRightsEnum_CORE_SUBMISSION_name": "Présentation de pièces usées",
    "type_CoreCollectionAddress_zipCode_name": "Zip Code",
    "type_AbstractOrderEntry_updatedEntryNumber_name": "Outil de service",
    "type_ProductPlantStructure_plantNumber_name": "Distributeur",
    "type_SapOrderType_WEB_name": "WEB",
    "type_salesdata_product_name": "Date de livraison requise",
    "type_CoreGradeType_SC_name": "Scrap",
    "type_WarrantyClaim_businessType_name": "Type d’entreprise*",
    "type_KbEcomImportDataCronJob_name": "Produit de rechange",
    "type_product_customerLimitations_name": "Liste / Prix net KB",
    "type_saleableItemType_IC_name": "Demain avant midi",
    "type_WarrantyClaimProcess_warranty_name": "Warranty Claim",
    "type_B2BCustomerAccessRequestEnum_name": "jours",
    "type_SapOrderType_CONV_name": "CONV",
    "type_Product2KbEcomDocumentRel_name": "Code de l'appareil",
    "type_CoreCollectionAddress_emailAddress_name": "Adresse électronique       ",
    "type_CoreRequest_crmNumber_name": "CRM Number",
    "type_productReferenceTypeEnum_HasServiceTool_name": "Nom de la pièce",
    "password_policy_violation_regex_disallowed_not12345678": "Téléchargements",
    "type_CoreRequest_exportStatus_name": "Export Status",
    "type_EngineManufacturer_code_name": "Renvoi",
    "type_AbstractOrder_cutOffTimeMessage_name": "Région de ventes",
    "type_SAPCpiOutboundOrder_referenceNumber_name": "Centre de service réseau expert",
    "type_CoreGradeType_PD_name": "1- Part Damage",
    "type_KbEcomDocument_url_name": "Conteneur multimédia téléchargeable",
    "type_CoreRequest_packageInfo_name": "Package Info",
    "type_CoreRequest_name_name": "Nom",
    "type_CorePackaging_Weight_name": "Longueur",
    "type_WarrantyClaim_customer_name": "Produits",
    "type_saleableItemType_IY_name": "Obsolète",
    "password_policy_violation_blacklist_blacklistedpassword": "Téléchargements",
    "type_ProductPlantStructure_product_name": "Conditions d’utilisation de la boutique en ligne",
    "type_WarrantyClaim_exportStatus_name": "Export Status",
    "type_WarrantyClaim_vinNumber_name": "VIN-Numme",
    "type_BaseSite_registrationCustomerIndustryRoles_name": "Poids du produit",
    "type_RecallNumber_code_name": "Renvoi",
    "type_product_typenumber_name": "Numéro de Type",
    "type_B2BCustomerIndustryRoleEnum_EXPERT_NETWORK_SERVICE_CENTRE_name": "Inscription - Rôles de l'industrie",
    "type_CoreRequest_user_name": "User",
    "type_product_vmrsCodeRear_name": "Heure de la dernière exécution",
    "productSalesStatus_label_APAC_CODE10": "Numéro tarifaire",
    "type_Order_idocNumber_name": "Régions de ventes",
    "type_Product2SalesRegions_name": "Limitation des ventes spécifique au client",
    "type_Category_externalUrl_name": "External URL",
    "type_CMSNavigationNode_productCategoryTree_name": "Produit",
    "type_OrderTypeQuantityMapping_salesOrgId_name": "Enlèvement d’articles en consignation – Événement déclenché avec succès ",
    "type_ProductSalesStatus_CODE40_name": "Type de référence de produit",
    "type_OrderTypeQuantityMapping_name": "Livraison complète",
    "type_ProductImageMediaConversionCronJob_pictureMediaFormat_name": "Transitaire",
    "type_CorePackaging_typeOfpackaging_name": "Packaging Type",
    "type_WarrantyPart_serialNumber_name": "Serial Number",
    "type_WarrantyClaim_submitDate_name": "Submit Date",
    "type_WarrantyPart_quantity_name": "Quantitét",
    "type_PrimaryComplaint_name": "Réclamation principale*",
    "type_CoreCollectionAddress_totalWeight_name": "Total Weight",
    "type_AbstractOrderEntry_listPrice_name": "Samedi matin livraison le lendemain",
    "type_WarrantyPart_otherCost_name": "Autres frais",
    "type_WarrantyPart_hourlyLaborRate_name": "Taux horaire de main-d’œuvre",
    "type_KbOrderStatus_D_name": "Annulé",
    "type_KbEcomImportDataCronJob_catalogVersion_name": "AM seulement",
    "type_Chassis_name_name": "Nom",
    "type_CrossReferenceRelation_name": "Type de livraison",
    "type_B2BUnit_deliveryPriority_name": "Organisation de vente",
    "type_CoreCollectionAddress_tailLiftRequired_name": "Tail Lift",
    "productSalesStatus_label_APAC_CODE20": "Identifiant du titre",
    "type_CoreRequestItem_qty_name": "Quantitét",
    "type_B2BCustomerIndustryRoleEnum_DISTRIBUTER_name": "Distributeur Indépendant",
    "type_ProductWeight_name": "Livraison le lendemain avant 9h",
    "type_salesChannelLimitation_OEtruckonly_name": "Courriel d'échec de soumission de la commande envoyé",
    "type_ProductSalesStatus_CODE20_name": "Conteneur média produit",
    "type_WarrantyPart_invoiceNumber_name": "InvoiceNumber",
    "type_B2BCustomerIndustryRoleEnum_WORKSHOP_name": "Workshop/Public Service/Military/Private Citizen etc.",
    "type_AbstractOrderEntry_posType_name": "EXPÉDIER LE JOUR SUIVANT",
    "type_B2BCustomer_defaultB2BUnit_name": "Nom de fichier",
    "productSalesStatus_label_APAC_CODE30": "Numéro du type",
    "type_CustomerPartNumber_code_name": "Renvoi",
    "type_VehicleManufacturer_name_name": "Nom",
    "type_PrimaryComplaint_name_name": "Nom",
    "type_PackageType_CONTAINER_name": "Container",
    "type_product_dimension_name": "Taille",
    "type_WarrantyPart_dateInService_name": "Date en service",
    "type_ProductDimension_height_name": "Concurrent",
    "type_SAPCpiOutboundOrderItem_purchaseOrderNumber_name": "No de commande",
    "type_saleableItemType_IK_name": "Sans limite",
    "type_WarrantyPart_attachments_name": "Attachments",
    "type_CrossReference_alternativeXref_name": "Alternative X-ref",
    "type_saleableItemType_N_name": "Obsolète",
    "type_CoreRequest_packageCount_name": "Package Count",
    "type_ExternalLanguageMapping_languages_name": "Logiciel",
    "productSalesStatus_label_APAC_CODE40": "Unité",
    "type_productReferenceTypeEnum_IsReplacedBy_name": "Numéro d'article",
    "type_PartsDisposition_name": "Parts Disposition",
    "type_WarrantyPart_warrantyClaim_name": "Warranty Claim",
    "type_KBOrderTypeEnum_SAND_name": "Vue Web",
    "type_WarrantyPart_scale_name": "Échelle",
    "type_B2BUnit_orderBlocked_name": "Statut vendable",
    "type_CoreItemsEMEA_WeightAppx_name": "Weight Approx",
    "type_productReferenceTypeEnum_IsAccessoryPartFor_name": "Prix du mode d'appel",
    "type_SalesRegionCountryRelation_countries_name": "Client",
    "type_WarrantyClaim_phoneNumber_name": "Numéro de téléphone",
    "type_CoreGradeType_GC_name": "Good Core",
    "type_CoreGradeType_PSD_name": "2- Parts Damaged",
    "type_CoreItemsEMEA_description_name": "Description",
    "type_CoreCollectionAddress_firstName_name": "Prénom",
    "type_ExternalLanguageMapping_sourceSystem_name": "Composant unique",
    "type_KbEcomImportDataCronJob_fileName_name": "Tous les marchés (nouveau)",
    "type_VehicleManufacturer_customerSite_name": "Site",
    "type_CustomerPartNumber_customer_name": "Produits",
    "type_SapOrderType_EDI_name": "EDI",
    "type_B2BCustomerAccessRequestEnum_INFORMATION_ONLY_name": "À titre d’information",
    "type_WarrantyClaim_site_name": "Site",
    "type_Address_stateCode_name": "URL du document distant",
    "type_product_minimumDeliveryUnit_name": "Est un produit d'échange pour",
    "type_ProductWeight_netWeight_name": "Version du catalogue",
    "type_CoreCollectionAddress_lastName_name": "Nom",
    "type_product_salesDatas_name": "Date de livraison demandée",
    "type_WarrantyPart_laborAmount_name": "Labor Amount",
    "type_VehicleManufacturer_name": "Vehicle Manufacturer",
    "type_CoreItemsEMEA_qty_name": "Quantitét",
    "type_ProductImageMediaConversionCronJob_thumbnailMediaFormat_name": "À vendre - Jusqu'à épuisement des stocks",
    "type_productWeight_grossWeight_name": "Longueur",
    "type_marketType_NoExternalMarket_name": "Pas de marché extérieur",
    "type_OrderTypeQuantityMapping_overWritten_description": "Pays d’origine",
    "type_product_excludedCountries_name": "Est remplacé par",
    "type_ProductDimension_width_name": "État de l'entreprise",
    "type_saleableItemType_name": "Nom",
    "type_B2BCustomerApprovalStatus_name": "Produit",
    "type_DocumentType_name_name": "Date de livraison prévue",
    "type_CoreRequest_fax_name": "Téléchargements",
    "type_User_isPasswordExpired_name": "Password Expired",
    "export_openpositions_seebelow": "See Below",
    "type_salesChannelLimitation_NoLimitation_name": "Numéro de réference",
    "type_AbstractOrderEntry_customerReferenceNumber_name": "Numéro de référence client",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_SEARCH_name": "Recherche de garantie",
    "type_productReferenceTypeEnum_HasSparesKits_name": "Expédition du colis 48 heures",
    "type_CoreRequest_coreDate_name": "Core Date",
    "type_Product2SalesRegions_salesRegions_name": "Format de date",
    "type_PriceDocument_document_name": "Nom",
    "type_ExternalLanguageMapping_code_name": "URL initiale du site",
    "type_KBOrderTypeEnum_EMGY_name": "Commande critique",
    "type_WarrantyClaim_email_name": "Email",
    "type_B2BCustomerApprovalStatus_DENIED_name": "Cartographie des catégories de produits",
    "type_B2BCustomer_customerSite_name": "Parc de véhicules",
    "type_product_productHierarchy_name": "KB Importer des données CronJob",
    "type_ProductMediaContainer_name": "Statut approuvé",
    "type_CoreRequestItem_coreGroupUpgrade_name": "Core Group Upgrade",
    "type_AbstractOrderEntry_updateFlag_name": "Outil de service",
    "type_WarrantyPart_laborRequested_name": "Main-d’œuvre requise*",
    "type_ProductDimension_product_name": "Adresse de l'entreprise 2",
    "password_policy_violation_regex_disallowed_not12341234": "Téléchargements",
    "type_AbstractOrderEntry2AbstractOrderEntry_entries_name": "Entrées",
    "type_B2BCustomerAccessRequestEnum_CORE_REPORTS_name": "Rapport de core / Soumissions de retours de core",
    "type_AbstractOrderEntry_estimatedDeliveryDate_name": "Date de livraison estimée",
    "type_KBOrderTypeEnum_SHFD_name": "Commande pour le lendemain",
    "type_B2BCustomerCoreRightsEnum_CORE_REPORTS_name": "Rapports des Cores",
    "type_WarrantyPart_repairTime_name": "Durée de la réparation (en h)",
    "type_CoreRequest_warrantyMaterial_name": "Warranty Material Included",
    "type_Chassis_code_name": "Renvoi",
    "type_productDimension_width_name": "Type de matériau",
    "type_salesChannelLimitation_ContractPartneronly_name": "OEM uniquement",
    "type_CrossReference_target_name": "Supprimer des actifs de Blob",
    "type_SalesRegion_name_name": "Relation de référence croisée",
    "type_KbEcomDocument_code_name": "Conditions d’utilisation de la boutique en ligne",
    "type_AbstractOrderEntry_entries_name": "Entrées",
    "type_BaseSite_siteInitialUrl_name": "Renvoi",
    "type_SAPConfiguration_allSAPDistributionChannel_name": "Tous les canaux de distribution SAP",
    "type_DeliveryType_name": "Unité de poids",
    "type_EngineManufacturer_name_name": "Nom",
    "type_EngineManufacturer_name": "Hauteur du piston plongeur / bouton",
    "type_CoreRequestItem_coreGrade_name": "Core Grade",
    "type_salesChannelLimitation_OEMonly_name": "Type de commande",
    "type_PartsDisposition_name_name": "Nom",
    "type_B2BUnit_customerHierarchy_name": "Vendable à l'IAM",
    "type_marketType_AftermarketNew_name": "Marché secondaire (nouveau)",
    "type_WarrantyPart_axleNumber_name": "Axle Number",
    "type_B2BCustomer_showNetPrice_name": "Relation avec le document du produit",
    "type_productReferenceTypeEnum_name": "Type de commande",
    "type_Address_displayPobox_name": "PO Box",
    "type_WarrantyClaim_name_name": "Nom",
    "password_policy_violation_regex_required_mustcontaindigit": "poids",
    "type_productReferenceTypeEnum_HasExchangeProduct_name": "Écrasé",
    "type_ProductWeight_grossWeight_name": "Transporteurs",
    "type_PriceDocument_catalogVersion_name": "AM seulement",
    "type_product_webView_name": "Médias d'information",
    "type_B2BCustomer_industryRoles_name": "Dimension du produit",
    "type_productReferenceTypeEnum_REPAIRKIT_name": "Code de type de commande",
    "type_product_sapSalesStatus_name": "Types de livraison pris en charge",
    "type_product_titleId_name": "Limitation du canal de vente",
    "type_productDimension_unit_name": "Type de marché",
    "type_WarrantyClaim_vehicleId_name": "Numéro véhicule/unité",
    "type_B2BCustomer_approvalStatus_name": "Trousse de réparation",
    "type_CustomerSite_name": "Site",
    "type_salesChannelLimitation_OEtraileronly_name": "Schéma de commande",
    "type_KbEcomDocument_description_name": "Nom du type de document",
    "type_productWeight_unit_name": "Prix courant ",
    "type_saleableItemType_IF_name": "Pas de marché externe",
    "type_PartsDisposition_customerSite_name": "Site",
    "type_B2BUnit_erpID_name": "Vendable à l'IAM - jusqu'à épuisement des stocks",
    "type_WarrantyPart_product_name": "Général",
    "type_KbCoreDocument_CoreDocuments_name": "Core Document",
    "type_product_vmrsList_name": "Est un outil de service pour",
    "type_productReferenceTypeEnum_HasAccessoryPart_name": "Produit",
    "type_KbOrderStatus_A_name": "Acknowledged",
    "type_CrossReference_webName_name": "Priorité de livraison",
    "type_B2BCustomerIndustryRoleEnum_OEM_name": "Fabricant d'équipement d'origine (OEM)",
    "type_KBOrderTypeEnum_name": "Unité de longueur",
    "type_Address_displayPostalCode_name": "Postal Code",
    "type_productReferenceTypeEnum_IsSparesKitsFor_name": "Est un nécessaire de réparation pour",
    "type_CoreItemsEMEA_WeightComplete_name": "Complete Weight",
    "type_KBOrderTypeEnum_AFRT_name": "En attente d'approbation",
    "type_Product2KbEcomDocumentRel_products_name": "Code / type d'appareil",
    "type_productReferenceTypeEnum_HasAftermarketProduct_name": "Equipements originels",
    "type_DocumentTimeStamp_b2bUnit_name": "B2b Unit",
    "type_productReferenceTypeEnum_HasRationalisedProduct_name": "Limitation de page de catégorie statique",
    "type_productDimension_length_name": "Correspondance d'un code de langue externe à une liste de langues réelles",
    "type_CoreRequest_totalWeight_name": "Total Weight",
    "type_CoreRequest_phoneNumber_name": "Numéro de téléphone",
    "type_WarrantyClaim_parts_name": "Parts",
    "type_CoreCollectionAddress_additionInfo_name": "Additional Info",
    "type_B2BCustomerIndustryRoleEnum_FLEET_name": "Flotte de Camions",
    "type_CoreRequest_corePdfMedia_name": "PDF",
    "type_salesChannelLimitation_name": "Camion d'origine (OE) uniquement",
    "type_salesChannelLimitation_AMonly_name": "Schéma de commande",
    "type_productReferenceTypeEnum_COMPETITOR_name": "Produits",
    "type_saleableItemType_IT_name": "Pas à vendre",
    "type_SalesRegion_name": "Renvoi",
    "type_PackageType_BOX_name": "Box ",
    "type_CoreRequest_coreReturnItems_name": "Core Items(NA)",
    "type_WarrantyDecision_code_name": "Renvoi",
    "type_AbstractOrderEntry2AbstractOrderEntry_originalEntry_name": "Entrée d’origine",
    "type_AbstractOrder_shippingCondition_name": "Étiquette de statut des ventes",
    "type_B2BUnit_versionNumber_name": "ID de l'organisation commerciale",
    "type_CoreCollectionAddress_country_name": "Counrty",
    "type_CorePackaging_size_name": "Taille",
    "type_product_hazardousMaterial_name": "Est un produit rationalisé pour",
    "type_PricingProceduresSubtotal_KZWI3_name": "Afficher le prix de base",
    "type_B2BUnit_salesOffice_name": "Région de ventes",
    "type_SAPConfiguration_sappricingbol_surchargeSub_name": "Afficher le prix courant",
    "type_CoreRequestItem_itemWeight_name": "Item Weight",
    "type_PricingProceduresSubtotal_KZWI1_name": "Instructions d'expédition",
    "type_CMSStaticCategoryPageRestriction_description": "Produit",
    "type_AbstractOrder_lastPricingCallMode_name": "Type d'article vendable",
    "type_BaseStore_timeZone_name": "Type de marché SAP",
    "type_WarrantyPart_partInService_name": "Mileage / Part In Service",
    "type_Order_sapOrderId_name": "Régions de ventes",
    "type_KbEcomDocument_revision_name": "Type de document",
    "type_AbstractOrder_countryIsoCode_name": "Pays",
    "type_WarrantyDecision_decision_name": "Decision",
    "type_KBOrderTypeEnum_STOR_name": "Commande régulière",
    "type_saleableItemType_IA_name": "Nom",
    "type_DocumentType_name": "URGENCE",
    "type_BaseStore_maxRadiusForPoSSearch_name": "Max Radius for POS Search",
    "type_product_marketType_name": "Jeu de pièces de rechange",
    "type_ProductSalesStatus_name": "Conversion de média d'image principale du produit",
    "type_WarrantyClaim_claimType_name": "Type de réclamation",
    "type_B2BCustomerApprovalStatus_PENDING_name": "Produit",
    "type_product_salesStatusDescription_name": "Surtaxe",
    "type_CoreCollectionAddress_requestedTime_name": "Requested Time",
    "type_WarrantyClaim_email2_name": "Email2",
    "type_ProductPlantStructure_countryOfOrigin_name": "Description au document",
    "type_salesChannelLimitation_OESonly_name": "Commander en ligne",
    "type_CustomerPartNumber_sourceSystem_name": "Composant unique",
    "type_SalesRegionCountryRelation_salesRegions_name": "Client",
    "type_ProductCategoryMapping_name": "Catégorie",
    "type_saleableItemType_IM_name": "Non vendable à l'IAM",
    "type_KbCoreReports_b2bUnit_name": "Parent des Cores",
    "type_WarrantyPart_natureOfDefect_name": "Nature Of Defect",
    "type_CustomerHierarchyUnit_parent_name": "Limitation de page de catégorie statique",
    "type_WarrantyClaim_partsDisposition_name": "Sort des pièces en cas de refus* ",
    "type_Product_crossReferences_name": "Priorité de livraison",
    "type_B2BCustomerApprovalStatus_APPROVED_name": "Produit",
    "productSalesStatus_label_EMEA_CODE40_anonymous": "Unité",
    "type_WarrantyPart_name": "Warranty Part",
    "type_Product2KbEcomDocumentRel_kbEcomDocuments_name": "dimensions",
    "type_ProductMediaContainer_assetId_name": "ID du bien",
    "type_B2BCustomer_showListPrice_name": "Caractéristique du produit",
    "type_WarrantyClaim_tagSerialNumber_name": "T.A.G. (Garantie totale air) Numéro de série",
    "type_CorePackaging_stackable_name": "Stackable",
    "type_WarrantyClaim_date_name": "Date",
    "type_VehicleMfg2ChassisRelation_chassis_name": "Chassis(chass-eez)",
    "type_AbstractOrderEntry_estimatedQuantity_name": "Envoyer le courriel d'échec de la commande après avoir dépassé le nombre maximal de tentatives de soumission.",
    "type_CoreCollectionAddress_fax_name": "Téléchargements",
    "type_WarrantyClaim2PartInfo_parts_name": "Parts",
    "type_VehicleManufacturer_code_name": "Renvoi",
    "type_WarrantyTypeOperation_name": "Warranty Type Operation",
    "type_productReferenceTypeEnum_IsRationalisedProductFor_name": "Format d'image",
    "type_saleableItemType_IP_name": "Pas pour la vente externe",
    "type_AbstractOrder_minOrderCharge_name": "Relation entre les régions de vente et les pays",
    "type_AbstractOrder_currentDeliveryType_name": "État du cycle de vie SAP",
    "type_WarrantyClaim_claimRefNumber_name": "Claim Reference Number",
    "type_WarrantyPart_returningPartNumber_name": "Code-article, client régulier",
    "type_CustomerPartNumber_customerPartNumber_name": "Port(s) radial(aux) branché(s)",
    "type_WarrantyClaim_attachments_name": "Attachments",
    "type_WarrantyClaim_barCodeLabel_name": "BarCode Label",
    "type_OrderTypeQuantityMapping_lPriority_name": "Groupe pièce usée",
    "type_productReferenceTypeEnum_IsExchangeProductFor_name": "Modalités de paiement",
    "type_product_regionIndependentSaleableCountries_name": "Est un produit de rechange pour",
    "type_KBOrderTypeEnum_PEPR_name": "Nom Web",
    "type_CMSSiteRestriction_name": "Produit",
    "type_CoreRequest_totalQuantity_name": "Total Quantity",
    "password_policy_violation_regex_required_certainsize": "Téléchargements",
    "type_SalesData_minOrderQuantity_name": "Révision",
    "type_Category_productCategoryMapping_name": "Marché secondaire (nouveau)",
    "type_PartsDisposition_code_name": "Renvoi",
    "type_marketType_AftermarketRemanufactured_name": "Marché secondaire (Remanufacturé)",
    "productSalesStatus_label_EMEA_CODE10": "ID du titre",
    "type_SAPConfiguration_kbOrderTypes_name": "Types de commande",
    "type_CoreCollectionAddress_forkListRequired_name": "Fork Lift",
    "type_Address_displayCompany_name": "Company",
    "type_WarrantyClaim_chassis_name": "Châssis ",
    "type_B2BCustomerIndustryRoleEnum_name": "Produits",
    "type_ProductSalesStatus_CODE30_name": "Structure de l'usine du produit",
    "type_ProductDimension_name": "Collecte",
    "type_salesChannelLimitation_IAMonly_name": "Commande bloquée",
    "type_saleableItemType_IE_name": "Remorque d'origine (OE) uniquement",
    "type_WarrantyDecision_name": "Warranty Decision",
    "type_WarrantyClaim_name": "Warranty Claim",
    "type_WarrantyClaim_language_name": "Language",
    "type_productReferenceTypeEnum_IsServiceToolFor_name": "Données de l'usine",
    "type_CMSSiteRestriction_cmssite_name": "Produit",
    "type_KBOrderTypeEnum_SFRT_name": "Poids",
    "productSalesStatus_label_EMEA_CODE20": "Identifiant du titre",
    "type_CoreCollectionAddress_phone_name": "Téléphone",
    "type_sapMarketType_name": "Entrées de ligne max autorisées",
    "type_product_sapMarketType_name": "IAM seulement",
    "type_KBOrderTypeEnum_PS48_name": "Code VMRS",
    "type_B2BCustomer_accessRequests_name": "Cartographie des catégories de produits",
    "type_ProductDimension_length_name": "Rôle d’industrie de l’entreprise",
    "type_product_articleType_name": "Est un remplacement pour",
    "type_CoreRequest_email_name": "Email",
    "type_WarrantyTypeOperation_code_name": "Renvoi",
    "type_OrderProcess_sendOrderFailEmail_name": "Chemin de la hiérarchie des clients",
    "type_product_sapLifecycleStatus_name": "Intersociétés uniquement",
    "type_SAPCpiOutboundOrderItem_deliveryPriority_name": "Produit d'échange",
    "type_productReferenceTypeEnum_IsAftermarketProductFor_name": "Livraison partielle",
    "productSalesStatus_label_EMEA_CODE30": "Numéro du type",
    "type_KbEcomDocument_catalogVersion_name": "Conditions d’utilisation de la boutique en ligne",
    "type_KBOrderTypeEnum_PKSH_name": "Numéro d'entrée mis à jour",
    "type_ProductCategoryMapping_deviceCode_name": "Page CMS",
    "type_SalesRegion_products_name": "Références croisées",
    "type_SAPCpiOutboundOrder_purchaseOrderType_name": "Produit d'échange",
    "type_OrderTypeQuantityMapping_maxQuantityAllowed_name": "Classe pièce usée",
    "type_CrossReference_name": "Devise par défaut",
    "type_SalesRegion_countries_name": "Valeur de référence croisée (numéro du matériau X-ref)",
    "type_CoreGradeType_NA_name": "S.O.",
    "type_Employee_isPasswordExpired_name": "Password Expired",
    "type_B2BUnit_shippingInstructions_name": "Bureau de vente",
    "type_WarrantyClaim_idocNumber_name": "Régions de ventes",
    "type_WarrantyClaim_email1_name": "Email1",
    "type_B2BCustomerAccessRequestEnum_SUBMIT_WARRANTY_name": "Soumettre des réclamations de garantie",
    "type_WarrantyPart_partsDisposition_name": "Sort des pièces en cas de refus* ",
    "type_PrimaryComplaint_code_name": "Renvoi",
    "type_DownloadableMediaContainer_url_name": "Statut approuvé",
    "type_B2BUnit_defaultCurrency_name": "Nomenclature des ventes",
    "type_product_salesStatus_name": "Statut de Vente",
    "productSalesStatus_label_EMEA_CODE40": "Unité",
    "type_product_salesChannelLimitation_name": "Prix client KB",
    "type_RecallNumber_name": "Recall Number",
    "type_CoreCollectionAddress_requestedDate_name": "Requested Date",
    "type_WarrantyPart_dateCode_name": "Date Code",
    "type_ProductMediaContainer_product_name": "Approuvé",
    "type_SalesRegionCountryRelation_name": "Références croisées (numéros de matériau X-ref)",
    "type_WarrantyClaim_store_name": "Base Store",
    "type_WarrantyClaim2PartInfo_name": "Warranty Claim to Parts relation",
    "type_B2BUnit_incoTerms1_name": "Limitation du canal de vente",
    "type_B2BUnit_customerHierarchyUnit_name": "Type d'article vendable",
    "type_ProductCategoryMapping_category_name": "Renvoi",
    "productSalesStatus_label_NA_CODE20": "Pas à vendre",
    "type_CoreCollectionAddress_companyAddress2_name": "Adresse 2",
    "type_CoreCollectionAddress_companyAddress_name": "Adresse",
    "type_B2BCustomer_doubleOptCheck_name": "Indicateur d'activation ou de désactivation de l'écrasement de la date de livraison de la demande à partir de l'interface utilisateur.",
    "productSalesStatus_label_APAC_CODE40_anonymous": "Numéro du type",
    "type_WarrantyClaim_natureOfDefect_name": "Nature Of Defect",
    "type_CoreRequest_coreItemsEMEA_name": "Core Items(EMEA)",
    "type_PriceDocument_code_name": "Price Document",
    "type_marketType_AllMarketsNew_name": "Quantité minimale de livraison",
    "type_KBEcomProductCategoryMappingJob_name": "jours",
    "type_CoreRequest_coreCollectionAddress_name": "Téléchargements",
    "type_Product2SalesRegions_products_name": "Message HeureLimite",
    "type_WarrantyClaimProcess_sendWarrantyClaimRetryCount_name": "Number of attempts to send new warranty",
    "type_CrossReference_source_name": "Priorité de livraison",
    "type_KbOrderStatus_B_name": "En traitement",
    "type_productReferenceTypeEnum_IsSoftwareFor_name": "Numéro d'usine",
    "type_DocumentTimeStamp_lastDownloadtime_name": "Last Download Time",
    "type_CoreRequest_coreMonth_name": "Core Month",
    "productSalesStatus_label_NA_CODE30": "À vendre",
    "type_KBOrderTypeEnum_COLL_name": "Utilisé pour contrôler si la page de catégorie statique ou la page de grille de produits hybris standard est affichée",
    "type_WarrantyClaim_recallNumber_name": "Recall Number",
    "type_CoreRequest_site_name": "Site",
    "type_PackageType_PALLET_name": "Pallet",
    "type_B2BUnit_glnNumber_name": "Régions de ventes",
    "type_ProductWeight_unit_name": "Version du catalogue",
    "type_product_saleableItemType_name": "Charge maximale KB",
    "type_SAPCpiOutboundOrder_deliveryPriority_name": "Pays exclus",
    "type_RecallNumber_name_name": "Nom",
    "type_WarrantyClaim_user_name": "User",
    "type_WarrantyClaim_engineManufacturer_name": "Hauteur du piston plongeur / bouton",
    "type_VehicleMfg2ChassisRelation_name": "Vehicle Manufacturer to Chassis(chass-eez) Relation",
    "type_WarrantyDecision_name_name": "Nom",
    "type_Country_salesRegions_name": "Hiérarchie des clients",
    "type_KBOrderTypeEnum_B9ND_name": "Données Web",
    "type_product_xSuffixPart_name": "X Suffix Part",
    "type_Product_productPlantStructures_name": "Type de document",
    "type_DeliveryType_Partial_name": "Largeur",
    "type_Chassis_name": "Châssis",
    "type_KbOrderStatus_C_name": "Expédié",
    "type_salesdata_salesOrganizationID_name": "Profil d'arrondi",
    "type_WarrantyPart_requestedPartCost_name": "Montant demandé, pièce*",
    "type_CoreCollectionAddress_shipTo_name": "B2b Unit",
    "type_ProductSalesStatus_CODE10_name": "Conteneur média produit",
    "type_CoreRequest_language_name": "Language",
    "type_OrderTypeQuantityMapping_maxLineEntriesAllowed_name": "Partenaire contractuel uniquement",
    "type_ClaimType_name": "Type de réclamation",
    "type_CoreRequestItem_coreGroup_name": "Groupe pièce uséet",
    "type_KbCoreReports_pfdMedia_name": "PDF",
    "type_WarrantyClaim2PartInfo_warrantyClaim_name": "Warranty Claim",
    "type_CMSSiteRestriction_description": "Produit",
    "productSalesStatus_label_NA_CODE10": "Obsolète",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_name": "Réclamation  sous garantie",
    "type_B2BCustomer_showCorePrice_name": "Hiérarchie des produits",
    "type_OrderTypeQuantityMapping_days_name": "Supplément pièce usée",
    "type_Address_companyAddressTwo_name": "URL d'image distante",
    "type_SAPCpiOutboundOrder_completeDelivery_name": "Trousse d'action sur le terrain",
    "type_marketType_name": "Quantité maximale autorisée",
    "type_WarrantyClaimProcess_name": "Warranty Document Media",
    "type_CustomerHierarchyUnit_children_name": "COMMANDE DE STOCKAGE",
    "type_BaseStore_dateFormat_name": "Numéro de commande SAP",
    "type_ProductImageMediaConversionCronJob_name": "À vendre",
    "type_CoreRequest_uid_name": "Jeu de pièces de rechange",
    "type_product_vmrsCode_name": "Languestt",
    "type_ProductMediaContainer_mediasMap_name": "Type d'article",
    "type_OrderTypeQuantityMapping_supportedDeliveryTypes_name": "Type de doc. SAP",
    "type_DownloadableMediaContainer_name": "Approbation refusée",
    "type_MaintenanceScale_name": "Échelle",
    "type_VehicleManufacturer_chassis_name": "Chassis(chass-eez)",
    "type_Address_displayStreetNumber_name": "Street Number",
    "type_DocumentType_code_name": "ID ERP",
    "type_ProductCategoryMapping_titleId_name": "Enfants",
    "type_productReferenceTypeEnum_CUSTOMER_name": "Produits",
    "type_AbstractOrderEntry_surcharge_name": "Régions de ventes",
    "type_B2BCustomerIndustryRoleEnum_DEALER_name": "Concessionnaire de Véhicules (Dealer)",
    "type_productDimension_height_name": "Priorité",
    "type_B2BCustomerAccessRequestEnum_ORDER_ONLINE_name": "Passer une commande en ligne sur ce site",
    "type_ProductWeight_product_name": "Type de transporteur",
    "validation_B2BCustomer_DefaultB2BUnit_missing": "Système",
    "type_salesdata_distributionChannelID_name": "Date de livraison requise",
    "type_WarrantyTypeOperation_name_name": "Nom",
    "type_CoreCollectionAddress_city_name": "Ville",
    "type_productReferenceTypeEnum_IsReplacementFor_name": "Données de l'usine",
    "type_saleableItemType_IB_name": "Poids net",
    "type_WarrantyClaim_primaryComplaint_name": "Réclamation principale*",
    "type_KBEcomProductCategoryMappingJob_lastExecutedtime_name": "Marchand",
    "type_product_coreClass_name": "Numéro GLN",
    "type_CoreRequest_b2bUnit_name": "B2b Unit",
    "type_product_webData_name": "Données de vente",
    "type_KbCoreReports_csvMedia_name": "CSV",
    "type_productDimension_product_name": "Type de marché",
    "type_TypeOfOperation_name_name": "Nom",
    "type_product_code_name": "Général",
    "type_CoreItemsEMEA_coreGroup_name": "Groupe pièce uséet",
    "productSalesStatus_label_NA_CODE40": "À vendre - jusqu'à épuisement des stocks",
    "type_OrderTypeQuantityMapping_carriers_name": "Rapports de base",
    "type_WarrantyClaim_claimNumber_name": "Claim Number",
    "type_AbstractOrder_currentOrderType_name": "Données de ventes",
    "type_WarrantyDecision_customerSite_name": "Site",
    "type_CoreCollectionAddress_packagingItems_name": "Packaging Info",
    "type_WarrantyPart_totalCost_name": "Total Cost",
    "type_SapOrderType_code_name": "Sap Order Type",
    "type_product_materialType_name": "Hauteur",
    "type_ProductPlantStructure_name": "ID du canal de distribution",
    "type_Country_products_name": "Site client",
    "type_WarrantyPart_dateRemoved_name": "Date Removed",
    "type_ProductPlantStructure_tariffNumber_name": "Numéro de document",
    "type_KbEcomDocument_name": "Conditions d’utilisation de la boutique en ligne",
    "type_product_name_name": "Numéro IDoc",
    "type_WarrantyClaim_dealerCode_name": "Dealer Code",
    "type_CoreRequest_coreTransportRequired_name": "Core Transport Required",
    "type_AbstractOrderEntry_entryPricingError_name": "Erreur de tarification",
    "type_WarrantyDocumentMedia_name": "Warranty Claim Process",
    "type_TypeOfOperation_code_name": "Renvoi",
    "type_KbCoreReports_statementDate_name": "Statement Date",
    "type_KbEcomDocument_documentType_name": "Code de type de document",
    "type_AbstractOrder_docType_name": "Statut des ventes",
    "type_PackageType_OTHER_name": "Autres                                                                   ",
    "type_ProductDimension_unit_name": "Livraison complète",
    "type_DeliveryType_Complete_name": "Largeur",
    "type_product_coreGroup_name": "Poids brut",
    "type_Address_displayDistrict_name": "Secteur",
    "type_PricingProceduresSubtotal_KZWI2_name": "Condition d'expédition",
    "type_AbstractOrder_currentCarrierType_name": "Type de marché SAP",
    "type_KbCoreReports_reportType_name": "Report Type",
    "type_CustomerPartNumber_product_name": "Produitt",
    "type_B2BUnit_incoTerms2_name": "Données de vente",
    "type_KbEcomImportDataCronJob_deleteAssetsFromBlob_name": "Fret aérien",
    "type_SalesData_minDeliveringQuantity_name": "Date de livraison requise",
    "type_WarrantyClaim_typeOfOperation_name": "Type d’opération* ",
    "type_B2BCustomer_countryIsoCode_name": "Pays",
    "type_AbstractOrder_supportedDeliveryTypes_name": "Type de doc. SAP",
    "type_Chassis_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_WarrantyClaim_warrantyPdf_name": "Warranty PDF",
    "type_CustomerHierarchyUnit_b2bUnits_name": "Soumettre des demandes de compensation sous garantie",
    "type_product_salesRegions_name": "Est un accessoire pour",
    "type_CoreRequestItem_coreClass_name": "Classe pièce usée",
    "type_CorePackaging_packageQty_name": "Quantitét",
    "type_CustomerHierarchyUnit_name": "Système source",
    "type_CrossReferenceRelation_crossReferences_name": "Désignation",
    "type_AbstractOrderEntry_originalEntry_name": "EntrÃ©e dâorigine",
    "type_B2BUnit_accountGroup_name": "Vendable à l'IAM",
    "type_productReferenceTypeEnum_HasSoftware_name": "Type de point de vente",
    "type_ExternalLanguageMapping_name": "Afficher le prix net",
    "type_WarrantyClaim_countryIsoCode_name": "Pays",
    "type_CustomerHierarchyUnit_name_name": "Jeu de pièces de rechange / pièce",
    "type_product_deviceCode_name": "Produit dangereux",
    "type_OrderTypeQuantityMapping_orderTypeCode_name": "Contient l'arborescence des catégories",
    "type_CrossReference_customer_name": "Client",
    "type_CustomerHierarchyUnit_uid_name": "Jeu de pièces de rechange",
    "type_Address_dealerCode_name": "Dealer Code",
    "type_productWeight_product_name": "Longueur",
    "type_salesChannelLimitation_Intercompanyonly_name": "OES uniquement",
    "type_Category_useExternalUrl_name": "Use External URL",
    "type_CoreCollectionAddress_companyName_name": "Company Name",
    "type_VehicleMfg2ChassisRelation_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_TypeOfOperation_name": "Type d’opération* ",
    "type_product_weight_name": "Est un logiciel pour",
    "type_CMSStaticCategoryPageRestriction_name": "Produit",
    "type_ExternalLanguageMapping_description": "Restriction latérale",
    "type_SAPCpiOutboundOrderItem_requestedDeliveryDate_name": "Quantité estimée",
    "type_WarrantyPart_otherCostDescription_name": "Other Cost Description",
    "type_SAPCpiOutboundOrder_requestedDeliveryDate_name": "Correspondance des langues externes",
    "type_KBOrderTypeEnum_FWDR_name": "Mettre à jour l'indicateur",
    "type_CoreGradeType_DN_name": "Don't Know",
    "type_WarrantyPart_requestedHandlingCost_name": "Montant demandé, manutention",
    "type_WarrantyPart_replacementType_name": "Type de remplacement",
    "type_WarrantyClaim_vehicleManufacturer_name": "Vehicle Manufacturer",
    "type_SalesRegion_code_name": "Renvoi",
    "type_AbstractOrderEntry2AbstractOrderEntry_name": "AbstractOrderEntry2AbstractOrderEntry Relation",
    "type_B2BCustomer_doubleOptUrl_name": "Nom de fichier",
    "type_CoreRequest_store_name": "Magasin",
    "type_KbEcomDocument_fileName_name": "Nom de fichier",
    "type_OrderTypeQuantityMapping_overWritten_name": "Pays",
    "type_SalesData_roundingProfile_name": "Rôle",
    "type_CrossReferenceRelation_source_name": "Type de livraison",
    "type_KbEcomDocument_products_name": "Produits",
    "type_Address_displayTown_name": "Town",
    "type_KbCoreDocument_TabCode_name": "Tab Name",
    "type_AbstractOrderEntry_requestedDeliveryDate_name": "Statut des ventes SAP",
    "type_Address_displayStreetName_name": "Street Name",
    "type_OrderProcess_sendOrderFailEmail_description": "Unité de hiérarchie des clients",
    "type_Product_kbEcomDocuments_name": "Unités B2B attribuées directement",
    "type_B2BUnit_paymentTerms_name": "Limitation du canal de vente",
    "type_OrderTypeQuantityMapping_days_description": "Pays",
    "type_ReplacementType_name": "Type de remplacement",
    "type_marketType_OriginalEquipment_name": "Équipement d'origine",
    "type_B2BCustomerWarrantyRightsEnum_WARRANTY_CLAIM_VALUES_name": "Valeur du recours en garantie",
    "type_KbOrderStatus_code_name": "État de la commande",
    "type_CustomerPartNumber_catalogVersion_name": "Catalog Version",
    "type_KbEcomImportDataCronJob_lastRunTime_name": "Last Run Time",
    "type_KbEcomImportDataCronJob_exportedFiles_name": "Exported Files",
    "type_CorePackagingType_GITTERBOX_name": "Gitter Box",
    "type_CorePackagingType_EUR_PALLET_name": "EUR Pallet",
    "type_CorePackagingType_ONE_WAY_PALLET_name": "One Way Pallet",
    "text_excel_customerPartNumber": "Customer Part Number",
    "text_excel_partNumber": "Part Number",
    "type_KbEcomDocument_createdDocumentDate_name": "Document Creation Date ",
    "type_B2BUnit_warrantyPeriod_name": "Warranty Period",
    "type_B2BUnit_sdpGrp01_name": "SDP Group",
    "type_FavoriteList_code_name": "Favorite List",
    "type_FavoriteList_code_description": "Favorite List for adding list of documents to the user",
    "type_FavoriteListEntry_document_name": "document",
    "type_FavoriteListEntry_document_description": "document in each entry list",
    "type_FavoriteListEntry_addedDate_name": "Added Date",
    "type_FavoriteListEntry_addedDate_description": "Added Date of each entry list",
    "type_FavoriteListEntry_documentLanguage_name": "Document Language",
    "type_FavoriteListEntry_documentLanguage_description": "Added Document Language of each entry list",
    "type_DocUser_name": "Doc User",
    "type_DocUser_description": "Doc User for Favorite List ",
    "type_DocUser_email_name": "Doc User Email",
    "type_DocUser_email_description": "Doc User email",
    "type_GuestUser2FavoriteList_name": "GuestUser to FavoriteList",
    "type_GuestUser2FavoriteList_description": "GuestUser2FavoriteList",
    "type_GuestUser2FavoriteList_docUser_name": "Doc User",
    "type_GuestUser2FavoriteList_docUser_description": "Doc User in GuestUser2FavoriteList Relation",
    "type_GuestUser2FavoriteList_favoriteList_name": "Favorite List",
    "type_GuestUser2FavoriteList_favoriteList_description": "Favorite List in GuestUser2FavoriteList Relation",
    "type_AbstractOrder_ppdDelta_name": "PPD Delta Price",
    "type_AbstractOrder_ppdDelta_description": "PPD Delta Price coming from SAP response during price call ",
    "type_DocumentUpdatedNotificationEmailProcess_name": "Document Updated Notification  Email Process",
    "type_DocumentUpdatedNotificationEmailProcess_description": "Document Updated Notification  Email Process",
    "type_DocumentUpdatedNotificationEmailProcess_document_name": "document",
    "type_DocumentUpdatedNotificationEmailProcess_document_description": "document",
    "type_DocumentUpdatedNotificationEmailProcess_docUser_name": "Doc User",
    "type_DocumentUpdatedNotificationEmailProcess_docUser_description": "Doc User",
    "type_DocumentUpdatedNotificationEmailProcess_language_name": "language",
    "type_DocumentUpdatedNotificationEmailProcess_language_description": "language",
    "type_DocumentUpdatedNotificationEmailProcess_documentSubscriptionInfo_name": "Document Subscription Info",
    "type_DocumentUpdatedNotificationEmailProcess_documentSubscriptionInfo_description": "Document Subscription Info",
    "type_DocumentSubscribersList_name": "Document Subscribers Collection",
    "type_DocumentSubscribersList_description": "Document Subscribers Collection",
    "type_DocumentSubscriptionInfo_name": "Document Subscription Info",
    "type_DocumentSubscriptionInfo_description": "Document Subscription Info",
    "type_DocumentSubscriptionInfo_code_name": "code",
    "type_DocumentSubscriptionInfo_code_description": "code",
    "type_DocumentSubscriptionInfo_docUser_name": "docUser",
    "type_DocumentSubscriptionInfo_docUser_description": "docUser",
    "type_DocumentSubscriptionInfo_subscribed_name": "subscribed to document",
    "type_DocumentSubscriptionInfo_subscribed_description": "subscribed to document",
    "type_DocumentSubscriptionInfo_doubleOptIn_name": "double Opt-In",
    "type_DocumentSubscriptionInfo_doubleOptIn_descripton": "double Opt-In",
    "type_FavoriteListEntry_documentSubscribers_name": "Subscribed Users ",
    "type_FavoriteListEntry_documentSubscribers_description": "List of users subscribed to the document seen in favorite list entry",
    "type_B2BCustomer_technicalTrainingAccess_name": "Formation technique",
    "type_B2BCustomerAccessRequestEnum_TECHNICAL_TRAINING_name": "Formation technique",
    "type_B2BCustomer_additionalSoldToLocations_name": "Sites donneurs d'ordre additionnels",
    "type_ADBRequest_name": "ADB Demande",
    "type_AdbRequestProcess_adbRequest_name": "ADB Demande",
    "type_UserGroup_asmLocationIsoCodeAccess_name": "ASM Location Access ISOCODES",
    "type_UserGroup_asmLocationIsoCodeAccess_description": "All the ISOCode locations that ASM users that can access to (similar functionality to backoffice locations per backoffice user)",
    "productSalesStatus_label_NA_CODE50": "À vendre (restreint)",
    "productSalesStatus_label_NA_CODE60": "À vendre (restreint) - jusqu'à épuisement des stocks",
    "type_ExportStatus_saved_name": "Saved (Not Submitted)",
    "value_calculator_header": "EnduraSure®-Pro Savings Summary ",
    "value_calculator_title": "Bendix Value Calculator",
    "value_calculator_visitor_info_title": "Informations pour les visiteurs",
    "airDisc_value_calculator_visitor_info_title": "Informations pour les visiteurs",
    "value_calculator_firstName": "Prénom",
    "value_calculator_lastName": "Nom de famille",
    "value_calculator_email": "Adresse électronique de l'entreprise",
    "value_calculator_privacy_accept": "J'accepte la clause de non-responsabilité ",
    "value_calculator_privacy_accept_link": "du (des) calculateur(s) de valeur",
    "value_calculator_next_button": "Suivant",
    "value_calculator_back_button": "Retour",
    "value_calculator_flit_info_title": "Informations sur le parc",
    "airdisc_value_calculator_flit_info_title": "Informations sur la flotte",
    "value_calculator_fleetSizeTractors": "Taille du parc - Tracteurs*",
    "value_calculator_tractors_text": "Tracteurs",
    "value_calculator_tractorTradeInCycle": "Cycle de reprise des tracteurs*",
    "value_calculator_fleetSizeTrailers": "Taille du parc - Remorques*",
    "value_calculator_trailers_text": "Remorques",
    "value_calculator_year_text": "Années",
    "value_calculator_trailerTradeInCycle": "Cycle de reprise des remorques*",
    "airDisc_value_calculator_trailerTradeInCycle": "Cycle de reprise des remorques",
    "value_calculator_actuator_text": "Actionneur",
    "value_calculator_usdOcc_text": "USD / Occurrence",
    "airDisc_value_calculator_usdOcc_text": "USD / occurrence",
    "value_calculator_calls_text": "Appels",
    "value_calculator_usdDay_text": "USD / Jour",
    "value_calculator_replacement_costNode_title": "Replacement Cost per Actuator",
    "value_calculator_replacement_cost_title": "Coste anual de sustitución por actuador:",
    "value_calculator_replacementFleetCostPerActuator": "Coût de remplacement du parc automobile par actionneur",
    "value_calculator_replacementFleetCostPerActuator_toolTip": "Le coût moyen de la flotte pour l'actionneur défectueux..",
    "value_calculator_laborToInstallActuator": "Main-d'œuvre pour l'installation de l'actionneur",
    "value_calculator_laborToInstallActuator_toolTip": "Coût de la main d'œuvre basé sur 30 minutes pour l'installation de l'actionneur de remplacement.",
    "value_calculator_totalCostPerFailedActuator": "Coût total par actionneur défectueux",
    "value_calculator_numberOfActuatorsReplacedPerYear": "Nombre d'actionneurs remplacés par an",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip1": "En moyenne, les flottes remplacent un actionneur par an sur 15 % de leurs tracteurs et 12 % de leurs remorques.\\",
    "value_calculator_numberOfActuatorsReplacedPerYear_toolTip2": "Source : MacKay & Company 2023",
    "value_calculator_product_performance_title": "Performance du produit actuel",
    "value_calculator_brandOfActuator": "Marque de l'actionneur",
    "value_calculator_csa_title": "Coûts des temps d'arrêt du CSA ",
    "value_calculator_roadsideCallRate": "Taux d'appels sur la route",
    "value_calculator_roadsideCallRate_toolTip": "Coût moyen d'un appel d'assistance routière, y compris le temps d'immobilisation.",
    "value_calculator_annualRoadsideCallsToActuators": "Nombre annuel d'appels de dépannage liés aux actionneurs*",
    "value_calculator_violations_text": "Violations",
    "value_calculator_roadsideCallRateCsaViolation": "Taux d'appels de dépannage pour infraction à la norme CSA",
    "value_calculator_roadsideCallRateCsaViolation_toolTip": "Estimation du coût de l'assistance routière lors d'un événement CSA hors service (OOS).",
    "value_calculator_annualOutOfServiceCsaViolations": "Nombre annuel d'infractions à la réglementation sur les freins hors service*",
    "value_calculator_fleetDowntimeRate": "Taux d'immobilisation de la flotte*",
    "value_calculator_upcharge_title": "Supplément pour le nouvel équipement",
    "value_calculator_estUpchargeForEndTractor": "Supplément estimé pour EnduraSure-Pro sur le tracteur par rapport à l'option actuelle",
    "value_calculator_estUpchargeForEndTractor_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on tractor over current option",
    "value_calculator_estUpchargeForEndTrailer": "Supplément estimé pour EnduraSure-Pro sur remorque par rapport à l'option actuelle",
    "value_calculator_estUpchargeForEndTrailer_errorMsg": "Please enter Estimated upcharge for EnduraSure-Pro on trailer over current option",
    "value_calculator_enduraSure_summary": "EnduraSure®-Pro Résumé",
    "value_calculator_unit_cost": "Coût unitaire",
    "value_calculator_totalFleet_cost": "Coût total du parc",
    "value_calculator_initialpurchase_tractor_cost": "Coût d'achat initial - tracteur",
    "value_calculator_initialpurchase_trailer_cost": "Coût d'achat initial - remorque",
    "value_calculator_replacementTractor_cost": "Coût de remplacement à vie - tracteur",
    "value_calculator_replacementTrailer_cost": "Coût de remplacement sur la durée de vie - remorque",
    "value_calculator_csaTractor_cost": "Coûts liés à la CSA - tracteur",
    "value_calculator_csaTrailer_cost": "Coûts liés à la CSA - remorque",
    "value_calculator_total_text": "Total",
    "value_calculator_return_investment": "Retour sur investissement (ROI)",
    "value_calculator_TCO_perUnit_standard": "Coût total de possession par unité - Standard (USD)",
    "value_calculator_TCO_perUnit_Sealed": "Coût total de possession par unité - scellée (USD)",
    "value_calculator_fleet_saving": "Économies nettes pour le parc (USD)",
    "value_calculator_description_text": "Description",
    "value_calculator_email_results": "Résultats des courriels",
    "value_calculator_reset_text": "Remise à zéro",
    "value_calculator_email_text": "Email",
    "value_calculator_enduraSure_perTractor": "Supplément pour EnduraSure®-Pro par tracteur",
    "value_calculator_enduraSure_perTractor_desc": "Estimation du supplément pour EnduraSure®-Pro sur le tracteur par rapport à l'option actuelle. Le coût peut varier de 50 à 150 $ par nouveau tracteur.",
    "value_calculator_enduraSure_perTrailer": "Supplément pour EnduraSure®-Pro par remorque",
    "value_calculator_enduraSure_perTrailer_desc": "Estimation du supplément pour EnduraSure®-Pro sur la remorque par rapport à l'option actuelle. Le coût peut varier de 50 à 150 $ par nouvelle remorque.",
    "value_calculator_proEmail_summary": "EnduraSure®-Pro Email Summary",
    "value_calculator_contact_info": "Contact Information",
    "airDisc_value_calculator_contact_info": "Informations sur le contact",
    "valueCalculator_brandOfActuator_bendixEnduraSure": "Bendix EnduraSure",
    "valueCalculator_brandOfActuator_bendixEnduraSurePro": "Bendix EnduraSure-Pro",
    "valueCalculator_brandOfActuator_haldexGoldSeal": "Haldex Gold Seal",
    "valueCalculator_brandOfActuator_haldexLifeSeal": "Haldex Life Seal",
    "valueCalculator_brandOfActuator_tseOmni": "TSE Omni",
    "valueCalculator_brandOfActuator_tseUltra": "TSE Ultra",
    "valueCalculator_brandOfActuator_wabcoTristop": "WABCO Tristop",
    "valueCalculator_brandOfActuator_other": "Other",
    "value_cal_fleetSizeTractors_valMsg": "Veuillez saisir la taille du parc - Tracteurs",
    "value_cal_tractorTradeInCycle_valMsg": "Veuillez saisir le cycle de reprise des tracteurs",
    "value_cal_fleetSizeTrailers_valMsg": "Veuillez saisir la taille du parc - Remorques",
    "value_cal_trailerTradeInCycle_valMsg": "Veuillez saisir le cycle de reprise des remorques",
    "value_cal_repFleetCostPerActuator_valMsg": "Veuillez entrer le coût de remplacement du parc par actionneur",
    "value_cal_laborToInstallActuator_valMsg": "Veuillez saisir le coût de la main-d'œuvre pour l'installation de l'actionneur",
    "value_cal_noOfActuatorsReplacedPerYear_valMsg": "Veuillez entrer le nombre d'actionneurs remplacés par an",
    "value_cal_roadsideCallRate_valMsg": "Veuillez entrer le taux d'appels de dépannage",
    "value_cal_annualRoadsideCallsToActuators_valMsg": "Veuillez entrer le nombre annuel d'appels de dépannage liés aux actionneurs",
    "value_cal_roadsideCallRateCsaViolation_valMsg": "Veuillez saisir le taux d'appels de dépannage pour infraction à la CSA",
    "value_cal_annualOutOfServiceCsaViolations_valMsg": "Veuillez saisir le nombre annuel d'infractions à la norme CSA concernant les freins hors service",
    "value_cal_fleetDowntimeRate_valMsg": "Veuillez saisir le taux d'immobilisation de la flotte",
    "value_cal_greaterThan_zeroMsg": "Saisir une valeur supérieure à 0",
    "value_cal_landingPage_textMsg": "Découvrez combien vous pouvez économiser en choisissant les freins à disque pneumatiques Bendix®, les freins à ressort EnduraSure®-Pro et le système de surveillance de la pression des pneus SmarTire® de Bendix CVS. Consultez nos calculateurs de valeur faciles à utiliser.",
    "value_cal_negativeVal_text": "Aucune économie nette n'est réalisée. La flotte devrait prendre en compte d'autres avantages tels que la réduction de la garantie, du stock de pièces et de l'utilisation du temps des techniciens.",
    "value_calculator_standardChamberLifetime": "Chambre standard (durée de vie)",
    "value_calculator_sealedChamberLifetime": "Chambre scellée (durée de vie)",
    "value_calculator_formSubmit_success": "Your EnduraSure-Pro savings projection summary has been emailed.",
    "value_calculator_formSubmit_failed": "Something went wrong while submitting the  EnduraSure-Pro savings. Please try again later.",
    "value_calculator_estUpchargeForEndTractor_pdf": "Upcharge for EnduraSure-Pro per tractor",
    "value_calculator_estUpchargeForEndTrailer_pdf": "Upcharge for EnduraSure-Pro per trailer",
    "value_calculator_formSubmit_error": "Veuillez corriger les erreurs ci-dessous.",
    "value_calculator_fName_emptyMsg": "Prénom Ne peut être vide.",
    "value_calculator_lName_emptyMsg": "Nom de famille Ne peut être vide.",
    "value_calculator_email_emptyMsg": "Email de l'entreprise Ne peut être vide.",
    "value_calculator_captcha_validMsg": "Veuillez saisir un Captcha valide.",
    "value_calculator_captcha_expiredMsg": "Captcha expiré.",
    "value_calculator_captcha_failedMsg": "Échec du chargement du captcha.",
    "value_calculator_captcha_invalidMsg": "Captcha invalide, veuillez réessayer.",
    "text_core_submit_internalTrackingNumber": "Il s'agit de votre numéro de suivi interne (facultatif)",
    "text_core_submit_internalUseOnly": "Réservé à l'usage interne de Bendix",
    "text_warranty_submit_datein_service_invalid": "Veuillez saisir une date de mise en service valide",
    "text_warranty_submit_date_removed_service_invalid": "Veuillez saisir une date valide de mise hors service",
    "airdisc_value_calculator_tractors_text": "Tracteurs",
    "airdisc_value_calculator_privacy_accept": "J'accepte les clauses de non-responsabilité ",
    "airdisc_value_calculator_privacy_accept_link": "des calculateur(s) de valeur",
    "airDiscBrake_value_calculator_drumvsadb": "Résumé des freins à tambour et des freins à disque",
    "airDiscBrake_value_calculator_header": "Résumé des freins à tambour et des freins à disque",
    "airDiscBrake_value_calculator_firstName": "Prénom",
    "airDiscBrake_value_calculator_lastName": "Nom",
    "airDiscBrake_value_calculator_email": "Votre adresse e-mail d'entreprise",
    "airDiscBrake_value_calculator_adbValueCalculatorType": "Calculateur de valeur ADB type",
    "airDiscBrake_value_calculator_fleetSize": "Taille de la flotte*",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit": "Nombre total d'essieux par unité",
    "airDiscBrake_value_calculator_tractorTradeInCycle": "Cycle d'échange de tracteurs",
    "airDiscBrake_value_calculator_averageAnnualUnitMileage": "Kilométrage annuel moyen des unités de véhicules*",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency": "Fréquence de remplacement des freins à tambour et des mâchoires de frein",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyFrictionChange": "Tous les changements de friction",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_everyOtherFrictionChange": "Tous les deux changements de friction",
    "airDiscBrake_value_calculator_adbupcharge": "Surcoût du frein à disque pneumatique par rapport au frein à tambour",
    "airDiscBrake_value_calculator_adbResidualValueatTradeIn": "Valeur résiduelle des freins à disque au moment de la reprise (augmentation par rapport aux freins à tambour)",
    "airDiscBrake_value_calculator_fleetDowntimeRate": "Taux d'immobilisation de la flotte*",
    "airDiscBrake_value_calculator_fleetMaintenanceLaborRate": "Taux de main d'œuvre pour l'entretien du parc automobile",
    "airDiscBrake_value_calculator_annualFleetAccidentRate": "Taux annuel d'accidents de la flotte*",
    "airDiscBrake_value_calculator_noofRearEndCollisionsDuringLifeCycle": "Nombre de collisions par l'arrière pendant la durée de vie du véhicule",
    "airDiscBrake_value_calculator_rearEndCollisionUnitCost": "Collision par l'arrière coût unitaire",
    "airDiscBrake_value_calculator_lifeCycleRearEndCollisionsFleetCost": "Cycle de vie des collisions par l'arrière coût de la flotte",
    "airDiscBrake_value_calculator_noOfFrictionReplacementsInTradeIn": "Nombre de remplacements de frottement lors de la reprise",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn": "Exigences en matière de friction des freins au moment de la reprise",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_minimum": "Friction minimale de 50% à la reprise",
    "airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn_nominimum": "Pas de minimum requis lors de la reprise",
    "airDiscBrake_value_calculator_numberOfDrumReplacementsAtTradeIn": "Nombre de tambours remplacés lors de la reprise",
    "airDiscBrake_value_calculator_drumBrakeShoeReplacementUnitCost": "Remplacement des mâchoires de frein à tambour coût unitaire",
    "airDiscBrake_value_calculator_drumBrakeReplacementUnitCost": "Coût de l'unité de remplacement des freins à tambour",
    "airDiscBrake_value_calculator_drumReplacementUnitCost": "Coût de l'unité de remplacement du tambour",
    "airDiscBrake_value_calculator_drumbrakeReplacementFleetCost": "Remplacement des freins à tambour coût du parc",
    "airDiscBrake_value_calculator_drum_maintenance": "Coûts d'entretien des freins à tambour (inspection des freins, réglage, lubrification)",
    "airDiscBrake_value_calculator_drumBrakeServiceLaborCost": "Coût de la main-d'œuvre pour l'entretien des freins à tambour",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceUnitCost": "Coût unitaire total de l'entretien des freins à tambour",
    "airDiscBrake_value_calculator_drumBrakeServiceAnnualFrequency": "Entretien des freins à tambour Fréquence annuelle",
    "airDiscBrake_value_calculator_totalDrumBrakeServiceFleetCost": "Coût unitaire total de l'entretien des freins à tambour",
    "airDiscBrake_value_calculator_csaViolationsAnnualPercentage": "Infractions CSA pourcentage annuel",
    "airDiscBrake_value_calculator_numberofCSAViolations": "Nombre d'infractions CSA",
    "airDiscBrake_value_calculator_roadsideCallRateForCSAViolation": "Taux d'appels de dépannage pour infraction au code de la route*",
    "airDiscBrake_value_calculator_annualNoOfOutOfServiceBrakeCSAViolations": "Nombre annuel d'infractions au CSA sur les freins mis hors service*",
    "airDiscBrake_value_calculator_CSAUnitCost": "Coût unitaire du CSA (y compris le temps d'arrêt)",
    "airDiscBrake_value_calculator_lifecycleCSAFleetCost": "Coût du cycle de vie de la CSA coût du parc automobile",
    "airDiscBrake_value_calculator_drumbrakeReplacementDueToRustJacking": "Remplacement des freins à tambour en raison d'une accumulation de rouille",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementUnitCost": "Coût unitaire du remplacement des mâchoires de frein d'une accumulation de rouille",
    "airDiscBrake_value_calculator_rustJackingShoeReplacementFleetCost": "Remplacement de frein coût du parc automobile d'une accumulation de rouille",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance": "Impact de l'ADB avec l'amélioration de la distance d'arrêt",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ZERO": "0",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_ONE": "1",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TWO": "2",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_FIVE": "5",
    "airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance_TEN": "10",
    "airDiscBrake_value_calculator_initialAdbFleetCost": "Coût initial de la flotte de l'ADB",
    "airDiscBrake_value_calculator_impactToFleetAccidentCosts": "Impact sur les coûts des accidents de la flotte",
    "airDiscBrake_value_calculator_accidentcost": "Impact sur les coûts des accidents de la flotte ¹,²",
    "airDiscBrake_value_calculator_adbFrictionMileage": "ADB kilométrage de frottement",
    "airDiscBrake_value_calculator_adbFriction": "ADB kilométrage de frottement ³",
    "airDiscBrake_value_calculator_noOfPadReplacementsAtTradeIn": "Nombre de remplacements des plaquettes de frein lors de la reprise",
    "airDiscBrake_value_calculator_noOfRotarReplacementsAtTradeIn": "Nombre de rotors remplacés lors de la reprise",
    "airDiscBrake_value_calculator_padandRotarReplacementUnitCost": "Coût unitaire du remplacement des plaquettes et des rotors",
    "airDiscBrake_value_calculator_lifeCyclePadAndRotarReplacementFleetCosts": "Cycle de vie remplacement des plaquettes et des rotors coûts du parc automobile",
    "airDiscBrake_value_calculator_adbBrakeAdjustmentMaintanaceFleetCost": "ADB réglage des freins maintenance coût du parc automobile",
    "airDiscBrake_value_calculator_csaViolationFleetCost": "Infraction CSA coût de la flotte",
    "airDiscBrake_value_calculator_adbRustJackingPadReplacementFleetCost": "Remplacement des plaquettes de frein ADB Coût de la flotte en raison de la rouille",
    "airDiscBrake_value_calculator_totalAdbUnitCost": "Coût unitaire total du frein à disque",
    "airDiscBrake_value_calculator_totalAdbFleetCost": "Coût total du parc de freins à disque",
    "airDiscBrake_value_calculator_tractorDrumvsAirDiscBrakeSummaryCosts": "Tracteur frein à tambour vs. frein à disque résumé des coûts (USD)",
    "airDiscBrake_value_calculator_trailerDrumvsAirDiscBrakeSummaryCosts": "Coûts récapitulatifs des freins à tambour et des freins à disque de la remorque (USD)",
    "airDiscBrake_value_calculator_drum": "Frein à tambour",
    "airDiscBrake_value_calculator_adb": "Frein à disque",
    "airDiscBrake_value_calculator_description": "Description",
    "airDiscBrake_value_calculator_unit_cost": "Coût unitaire",
    "airDiscBrake_value_calculator_totalFleet_cost": "Coût total de la flotte",
    "airDiscBrake_value_calculator_initialpurchase_cost": "Coût d'achat initial",
    "airDiscBrake_value_calculator_residualValueAtTradeIn": "Valeur résiduelle à la reprise",
    "airDiscBrake_value_calculator_estimatedImpactOfSafety": "Estimation de l'impact sur la sécurité",
    "airDiscBrake_value_calculator_estimatedReplacementMaintenanceCost": "Estimation du coût de remplacement et d'entretien",
    "airDiscBrake_value_calculator_continuiousMaintananceCost": "Coût de la maintenance continue",
    "airDiscBrake_value_calculator_csaRelatedCosts": "Coûts liés à la CSA",
    "airDiscBrake_value_calculator_rustJackingCosts": "Coût de la rouille",
    "airDiscBrake_value_calculator_total_text": "Coût total",
    "airDiscBrake_value_calculator_returnOnInvestmentROI": "Return on Investment (ROI)",
    "airDiscBrake_value_calculator_roiOverLifeCycleUSD_UNIT": "Retour sur investissement au cours du cycle de vie (USD / unité)",
    "airDiscBrake_value_calculator_roiOVerLifeCycleUSD": "Retour sur investissement au cours du cycle de vie (USD)",
    "airDiscBrake_value_calculator_changeFriction": "Kilométrage moyen pour changer la friction",
    "airDiscBrake_value_calculator_replacementCycle": "Cycles de remplacement",
    "airDiscBrake_value_calculator_usd_hour": "USD / Heure",
    "airDiscBrake_value_calculator_usd_unit": "USD / unité",
    "airDiscBrake_value_calculator_hours_wheelend": "Heures par essieu",
    "airDiscBrake_value_calculator_times/year": "Nombre de fois par an",
    "airDiscBrake_value_calculator_drum_service": "Coût total de l'entretien des freins à tambour",
    "airDiscBrake_value_calculator_CSA_violation": "Coûts de l'infraction CSA (déréglage / friction fissurée)",
    "airDiscBrake_value_calculator_drum_rust": "Entretien des freins à tambour en raison de l'accumulation de rouille",
    "airDiscBrake_value_calculator_brake_summary": "Résumé des coûts des freins à disque",
    "airDiscBrake_value_calculator_adb_percentage": "% with ADB",
    "airdisc_value_calculator_proEmail_summary": "Résumé des économies réalisées sur les freins à disque pneumatiques Bendix",
    "airDiscBrake_value_calculator_totalNumberOfAxlesPerUnit_tooltip": "Nombre total d'essieux par configuration de l'unité (par exemple, 3 essieux pour un tracteur 6x4 ou une remorque à essieu tridem : 3 essieux pour un tracteur 6x4 ou une remorque à essieu tridem, 2 essieux pour un véhicule 4x2 ou une remorque à essieu tandem, etc.).",
    "airDiscBrake_value_calculator_drumtoshorereplacementFrequency_tooltip": "Sélectionner la fréquence de remplacement du tambour par rapport à la fréquence de remplacement des patins du tambour.",
    "airDiscBrake_value_calculator_adbupcharge_tootlip": "Supplément pour l'ADB sur toutes les roues (essieux directeur et moteur avant).  Il varie en fonction de l'équipementier (prendre en compte les crédits de suppression des tambours).",
    "airDiscBrake_value_calculator_popup_tradeIn": "Indiquer le montant résiduel que le véhicule ADB obtiendrait à la reprise sur le tambour.",
    "airDiscBrake_value_calculator_popup_fleet": "Taux d'immobilisation (USD / jour) lorsque le camion ne fonctionne pas_  (Moyenne de l'enquête sur la flotte ",
    "airDiscBrake_value_calculator_popup_annualfeet": "Indiquez le taux d'accident annuel estimé pour la flotte.  Taux d'accident typique de 7% basé sur les données RigDig™ pour les 200 principales flottes (par exemple : une flotte de 100 unités avec 5 accidents par an donnerait un taux d'accident de 5%).",
    "airDiscBrake_value_calculator_popup_annualfeet_title": "Taux annuel d'accidents de la flotte",
    "airDiscBrake_value_calculator_popup_rearendCycle": "On estime que 22.8% des accidents de véhicules commerciaux sont des collisions par l'arrière, selon la FMCSA Large Truck and Bus Crash Facts (2022).",
    "airDiscBrake_value_calculator_popup_rearendCost": "Les collisions par l'arrière coûtent en moyenne 75,301 USD par incident (dommages matériels uniquement) pour les calculs estimés selon le 2020 FMCSA Pocket Guide to Large Truck and Bus Statistics (Guide de poche des statistiques sur les gros camions et les bus).",
    "airDiscBrake_value_calculator_popup_changeFriction": "Kilométrage moyen du véhicule pour remplacer les frottements normalement usés.",
    "airDiscBrake_value_calculator_popup_brakeFrictionRequirementAtTradeIn": "Choisissez entre les exigences de friction des freins définies lors de la reprise du véhicule.",
    "airDiscBrake_value_calculator_popup_drumBrakeShoeReplacementUnitCost": "Coût par véhicule du remplacement des mâchoires de frein à tambour à toutes les positions des roues (par exemple : 60 USD / kit de mâchoires x 6 kits de mâchoires / véhicule = 360 USD / unité).",
    "airDiscBrake_value_calculator_popup_drumReplacementUnitCost": "Coût par véhicule pour remplacer les tambours à toutes les positions des roues (par exemple : 100 USD / tambour x 6 tambours / véhicule = 600 USD / unité).",
    "airDiscBrake_value_calculator_popup_drumBrakeReplacementUnitCost": "Coûts moyens de remplacement du frottement et du tambour (par véhicule) accumulés au cours du cycle de vie. (Pièces de rechange et coûts de main-d'œuvre uniquement)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceLaborCost": "Temps de travail (heures/extrémité de roue) nécessaire pour inspecter visuellement les freins, mesurer le réglage et graisser les régleurs de jeu et les tubes de came_ (par exemple : 10 minutes = 0.17 heure)",
    "airDiscBrake_value_calculator_popup_drumBrakeServiceAnnualFrequency": "Nombre moyen de fois où les freins à tambour sont inspectés/réglés chaque année.",
    "airDiscBrake_value_calculator_popup_csaViolationsAnnualPercentage": "Estimation des infractions au CSA en pourcentage annuel des véhicules d'une flotte.",
    "airDiscBrake_value_calculator_popup_roadsideCallRateForCSAViolation": "Estimation du coût de l'assistance routière lors d'un événement CSA hors service (OOS).",
    "airDiscBrake_value_calculator_popup_annualNoOfOutOfServiceBrakeCSAViolations": "Calcul du nombre d'infractions au code de la route entraînant la mise hors service des freins, sur la base de 13% des infractions au code de la route liées à la mise hors service des freins.",
    "airDiscBrake_value_calculator_popup_CSAUnitCost": "Coûts totaux du cycle de vie estimés pour les infractions à la CSA par véhicule, y compris les temps d'arrêt.",
    "airDiscBrake_value_calculator_popup_drumbrakeReplacementDueToRustJacking": "Nombre annuel de véhicules nécessitant un remplacement des semelles de tambour en raison de la rouille.",
    "airDiscBrake_value_calculator_popup_rustJackingShoeReplacementUnitCost": "Coût unitaire total du cycle de vie du remplacement des mâchoires de frein associé à la rouille (par véhicule), incluant la main d'œuvre et le temps d'immobilisation.",
    "airDiscBrake_value_calculator_popup_adbImpactWithImprovedStoppingDistance": "Contribution de la flotte à l'estimation du niveau d'impact associé aux collisions par l'arrière en améliorant la distance de freinage des véhicules par rapport aux freins à tambour.  (par exemple : un impact de 2% sur 125 collisions par l'arrière estimées correspondrait à environ 3 incidents).",
    "airDiscBrake_value_calculator_popup_impactToFleetAccidentCosts": "Estimation des coûts évités sur la base des données de la flotte concernant le niveau d'impact associé aux collisions par l'arrière (par exemple : 2 incidents x 75,301 USD / incident = 150,602 USD d'évitement).",
    "airDiscBrake_value_calculator_popup_adbFrictionMileage": "Le calcul du taux d'usure suppose une amélioration de 1.5 fois de la durée de vie des plaquettes Bendix ADB par rapport à la durée de vie de la friction des freins à tambour.",
    "airDiscBrake_value_calculator_popup_noOfRotarReplacementsAtTradeIn": "Calcul du nombre de remplacements de rotor sur la base du nombre estimé de remplacements de plaquettes (en supposant que le remplacement du rotor s'accompagne d'un deuxième remplacement de plaquette).",
    "airDiscBrake_value_calculator_popup_adbBrakeAdjustmentMaintanaceFleetCost": "Les freins à disque pneumatiques sont dotés d'un mécanisme de réglage interne qui ne nécessite pas de travail de maintenance pour inspecter ou maintenir le réglage.",
    "airDiscBrake_value_calculator_popup_csaViolationFleetCost": "Les freins à disque pneumatiques sont dotés d'un mécanisme de réglage interne qui réduit le risque d'infractions à la CSA liées à des freins déréglés et/ou à une friction fissurée en raison d'un soulèvement par la rouille.",
    "airDiscBrake_value_calculator_popup_adbRustJackingPadReplacementFleetCost": "La conception des tampons ADB ne permet pas aux contaminants de pénétrer sous la friction, ce qui élimine les coûts associés au remplacement de la friction en raison de la rouille.",
    "value_calculator_adb_calculatorTypes": "Calculateur de valeur ADB type",
    "value_calculator_adb_tractors": "Tracteur",
    "value_calculator_adb_trailer": "Remorque",
    "value_calculator_fleetSize": "Taille de la flotte",
    "value_calculator_fleet_error": "Enter greater than 1",
    "value_calculator_fleet_mileage": "Kilométrage annuel moyen des unités de véhicules",
    "value_calculator_fleet_axles_unit": "Essieux / unité",
    "value_calculator_fleet_miles": "Miles",
    "value_calculator_fleet_residualValue": "Valeur résiduelle des freins à disque au moment de la reprise (augmentation par rapport aux freins à tambour)",
    "value_calculator_fleet_safety_title": "Coûts de la sécurité des flottes",
    "value_calculator_fleet_drumBrake_title": "Entretien des freins à tambour associé à l'inspection, au réglage et à la lubrification des freins",
    "airdiscBrake_calculator_drum_costs": "Coût de l'entretien des freins à tambour",
    "airdiscBrake_calculator_csa_costs": "Frais d'infraction à la loi CSA",
    "airdiscBrake_calculator_rust": "Entretien de la rouille",
    "airdiscBrake_calculator_adbCost": "Résumé des coûts de l'ADB",
    "airdiscBrake_value_calculator_violations_text": "Violations",
    "airdiscBrake_value_calculator_negative_roi": "Aucune économie nette n'est réalisée.  La flotte peut envisager d'autres avantages tels que la réduction de la garantie, du stock de pièces et de l'utilisation du temps des techniciens.",
    "airdiscBrake_value_calculator_annualOutOfServiceCsaViolations": "Nombre annuel d'infractions à la réglementation sur les freins hors service",
    "airdiscBrake_value_calculator_emailResulht": "Bendix ADB Savings Summary",
    "airdiscBrake_value_calculator_cost_summary": "Les collisions par l'arrière coûtent en moyenne 75,301 USD par incident (dommages matériels uniquement) pour les calculs estimatifs.",
    "airdiscBrake_value_calculator_cost_line": "(2020 FMCSA Pocket Guide to Large Truck and Bus Statistics).",
    "airdiscBrake_value_calculator_cost_secondsummary": "Il s'agit d'une estimation des coûts basée sur les données de la flotte et ne représente pas un coût validé par Bendix.",
    "airdiscBrake_value_calculator_cost_thirdsummary": "Les kilométrages estimés sont basés sur les résultats des tests d'usure. Les résultats réels peuvent varier en fonction (mais sans s'y limiter) de la variation de la flotte, des pratiques d'entretien, des spécifications de l'équipement, du comportement du conducteur, de l'application, du cycle de travail, etc. Un entretien adéquat est une condition importante de l'entretien de tout système de freinage afin d'en optimiser les performances.",
    "airdisc_value_calculator_fleet_drumBrake_title": "Friction / Entretien des tambours",
    "airdiscBrake_value_calculator_negative_estimated_roi": "Sur la base des données de votre parc, le choix des freins à disque à air comprimé permet d'estimer le retour sur investissement net pour votre parc.",
    "airdiscBrake_value_calculator_formSubmit_success": "Votre résumé sur les freins à disque pneumatiques a été envoyé par courriel.",
    "airdiscBrake_value_calculator_formSubmit_failed": "Un problème s'est produit lors de la soumission des économies sur les freins à disque pneumatiques.  Veuillez réessayer plus tard.",
    "airdiscbreak_calculator_title": "Freins à disque pneumatiques",
    "airdiscBrake_value_calculator_title": "Calculateurs de Valeur Bendix",
    "airDisc_value_calculator_title": "Calculateur de valeur",
    "text_select_master_country_europe": "Europe",
    "text_select_master_country_na": "Amérique du Nord",
    "text_select_master_country_asia": "Asie Pacifique",
    "text_select_master_country_africa": "Moyen Orient & Afrique",
    "text_select_master_country_frenchoverseas": "DOM-TOM",
    "text_account_supporttickets": "Tickets de support",
    "text_account_supporttickets_heading": "Tickets de support",
    "text_account_supporttickets_history": "Tickets de support",
    "text_account_supporttickets_noSupporttickets": "Vous n'avez aucun ticket de support",
    "text_account_supporttickets_subHeading": "Gérer vos tickets de support",
    "text_account_supporttickets_requestSupport": "Créer un nouveau ticket",
    "text_account_supporttickets_ticketId": "ID de ticket",
    "text_account_supporttickets_subject": "Objet",
    "text_account_supporttickets_dateCreated": "Date de création",
    "text_account_supporttickets_dateUpdated": "Date de mise à jour",
    "text_account_supporttickets_status": "Statut",
    "text_software_download_header": "Télécharger un logiciel",
    "text_account_supporttickets_viewDetails": "Afficher les détails",
    "text_account_supporttickets_addSupportTicket": "Ajouter un ticket de support",
    "text_account_supportTickets_page_currentPage": "Page {0} sur {1}",
    "text_account_supportTickets_page_firstPage": "&laquo;",
    "text_account_supportTickets_page_lastPage": "&raquo;",
    "text_account_supportTickets_page_linkNextPage": "Page suivante",
    "text_account_supportTickets_page_linkPreviousPage": "Page précédente",
    "text_account_supportTickets_page_showAllResults": "Afficher tout",
    "text_account_supportTickets_page_showPageResults": "Afficher avec pagination",
    "text_account_supportTickets_page_sort_byDate": "Date de mise à jour",
    "text_account_supportTickets_page_sort_byTicketId": "ID de ticket",
    "text_account_supportTickets_page_sort_LastChangeDateTime": "Date de mise à jour",
    "text_account_supportTickets_page_sort_ObjectID": "ID de ticket",
    "text_account_supportTickets_page_sortTitle": "Trier par",
    "text_account_supportTickets_page_totalResults": "sur {0} tickets",
    "text_account_supportTickets_page_totalResultsCurrPage": "{0} Tickets sur {1}",
    "text_account_supportTickets_page_totalResultsSinglePag": "{0} tickets",
    "text_account_supportTickets_page_totalResultsSingleOrder": "1 ticket",
    "supportticket_subject_invalid": "Veuillez entrer un objet.",
    "supportticket_subject_invalid_length": "Le sujet ne doit pas dépasser 255 caractères.",
    "supportticket_message_invalid": "Veuillez entrer un message valide.",
    "supportticket_message_invalid_length": "Le message ne doit pas dépasser 5 000 caractères.",
    "text_account_supporttickets_messages": "Messages",
    "text_account_supporttickets_createTicket_heading": "Demander un support client",
    "text_account_supporttickets_createTicket_subject": "Objet",
    "text_account_supporttickets_createTicket_subject_desc": "Entrez l'objet de votre demande.",
    "text_account_supporttickets_createTicket_message": "Message",
    "text_account_supporttickets_createTicket_message_history": "Historique des messages",
    "text_account_supporttickets_createTicket_message_desc": "Entrez un message. Veuillez indiquer le plus d'informations possible.",
    "text_account_supporttickets_attachment_block_listed": "L’extension de la pièce jointe n’est pas prise en charge. Seule l’extension {0} est autorisée.",
    "text_account_supporttickets_createTicket_associatedTo": "Associé à",
    "text_account_supporttickets_createTicket_associatedTo_option1": "Sélection facultative...",
    "text_account_supporttickets_createTicket_ticketCategory": "Catégorie",
    "text_account_supporttickets_createTicket_ticketCategory_ENQUIRY": "Demande",
    "text_account_supporttickets_createTicket_ticketCategory_COMPLAINT": "Réclamation",
    "text_account_supporttickets_createTicket_ticketCategory_PROBLEM": "Problème",
    "text_account_supporttickets_createTicket_updated": "Mis à jour",
    "text_account_supporttickets_createTicket_selectFile": "Sélectionner un fichier",
    "text_account_supporttickets_createTicket_chooseFile": "Choisir un fichier",
    "text_account_supporttickets_fileMaxSizeExceeded": "Le fichier est trop grand.",
    "text_account_supporttickets_file_is_large_than": "Fichier trop grand (> {0})",
    "text_account_supporttickets_createTicket_noFileChosen": "Aucun fichier sélectionné",
    "text_account_supporttickets_createTicket_Cart": "Panier",
    "text_account_supporttickets_createTicket_SavedCart": "Panier enregistré",
    "text_account_supporttickets_createTicket_Order": "Commande",
    "text_account_supporttickets_createTicket_submit": "Envoyer",
    "text_account_supporttickets_createTicket_back": "Précédent",
    "text_account_supportTicket_confirmation_ticket_added": "Nous vous remercions d'avoir soumis un ticket de demande d'assistance. Votre message a été envoyé à l'équipe Assistance Client, qui vous répondra.",
    "text_account_supporttickets_history_addedBy_customerService": "Service clients",
    "text_account_supporttickets_updateSupportTicket": "Mettre à jour un ticket de support",
    "text_account_supportTicket_updateTicket_heading": "Mettre à jour un ticket de support",
    "text_account_supportTicket_updateTicket_status": "Statut",
    "text_account_supporttickets_currentStatus": "statut actuel",
    "text_account_supporttickets_updateTicket_addMessage": "Ajouter un message",
    "text_account_supporttickets_updateTicket_on": "le",
    "text_account_supporttickets_cancel": "Annuler",
    "ticketstatus_OPEN": "Ouvert",
    "ticketstatus_INPROCESS": "En cours de traitement",
    "ticketstatus_COMPLETED": "Terminé",
    "ticketstatus_CLOSED": "Fermé",
    "ticketstatus_REOPEN": "Rouvert",
    "ticketstatus_box_COMPLETED": "Fermer le ticket",
    "ticketstatus_box_INPROCESS": "Rouvrir",
    "ticketstatus_box_CLOSED": "Fermé",
    "text_supporttickets_reset": "Réinitialiser",
    "text_supporttickets_search": "chercher",
    "text_supporttickets_search_from_date": "Date ticket du",
    "text_supporttickets_search_to_date": "Date ticket au",
    "text_account_supporttickets_createTicket_message_mandatory": "Message*",
    "text_account_supporttickets_content1": "aucun fichier sélectionné",
    "text_account_supporttickets_content2": "(Max: 9 MB)",
    "text_account_supporttickets_content3": "Afficher / Ajouter",
    "text_account_supporttickets_createTicket_subject_mandatory": "Objet*",
    "supportticket_tickettype_invalid": "Veuillez saisir un valideTicket Taper.",
    "supportticket_category_invalid": "Veuillez saisir un valide Catégorie.",
    "supportticket_associatedTo_invalid": "Veuillez saisir un valide Associé À.",
    "text_account_supporttickets_createTicket_category_option1": "Veuillez sélectionner Catégorie",
    "text_account_supporttickets_createTicket_associatedTo_option2": "Veuillez sélectionner Associé À",
    "text_account_supporttickets_statusList": "Veuillez sélectionner le statut",
    "text_account_supporttickets_tickettypeList": "Veuillez sélectionner le type de ticket",
    "text_account_supporttickets_createTicket_status_NEW": "Nouveau",
    "text_account_supporttickets_createTicket_status_OPEN": "Ouvert",
    "text_account_supporttickets_createTicket_status_INPROGRESS": "En cours",
    "text_account_supporttickets_createTicket_status_COMPLETED": "Complété",
    "text_account_supporttickets_createTicket_status_CLOSED": "Fermé",
    "text_account_supporttickets_createTicket_tickettype_WEB": "Créé par l'utilisateur",
    "text_account_supporttickets_createTicket_tickettype_MANUAL": "Créé par le service client",
    "text_account_supporttickets_createTicket_ticketID": "N° de ticket",
    "text_account_supporttickets_customerID": "Client ID",
    "text_account_supporttickets_tryLater": "Désolé, un problème est survenu, veuillez réessayer plus tard",
    "text_account_supporttickets_updateTicket_message_desc": "Mettez à jour un message. Merci de bien vouloir indiquer autant d'informations que possible.",
    "text_account_supporttickets_updateTicket_c4cMessage1": "Ce ticket est déplacé vers le service client",
    "text_account_openPosition_emptyPositions": "Aucune position ouverte trouvée",
    "search_reference_and_customer_info": "Rechercher une référence et des informations client",
    "text_account_supporttickets_updateTicket_c4cMessage2": "Cliquez ici ",
    "text_account_supporttickets_updateTicket_c4cMessage3": "pour mettre à jour le ticket",
    "core_page_placeholder": "rechercher Compte client contreparties",
    "text_account_training_registration_totalResultsCurrPage": "{0} inscription à la formation sur {1} trouvée",
    "document_subscription_email": "Adresse e-mail",
    "document_subscription_first_name": "Prénom",
    "document_subscription_last_name": "Nom",
    "download_agree_disclaimer_text": "J'accepte la clause de non-responsabilité",
    "account_adb_breadcrumbs": "Visitez ma page",
    "breadcrumb_my_training_text": "Mes Formations",
    "breadcrumb_training_text": "Mes Formations",
    "document_library_text_document_type": "Type de document",
    "document_library_text_language": "Langue",
    "subscription_text_document_download": "Commencer Le Téléchargement",
    "order_track_my_status_popup": "Suivre Mon commandes",
    "order_track_my_status": "Suivre Mon commande",
    "order_track_my_status_po": "PO#:",
    "order_track_my_status_pos": "Pos:",
    "order_track_my_status_part": "Part#:",
    "order_track_my_status_qty": "Qty:",
    "order_track_my_status_date-shipped": "Date shipped:",
    "order_track_my_status_carrier": "Carrier:",
    "order_track_my_status_tracking": "Tracking#:",
    "order_back_to_status": "Back to Order Status",
    "text_breakapplication_button_uploadfile": "Téléverser un fichier",
    "text_breakapplication_name": "Nom",
    "text_breakapplication_size": "Taille",
    "text_breakapplication_remove": "Supprimer",
    "text_account_supporttickets_content": "Veuillez joindre au maximum 9,00 mb",
    "text_software_request_form_tebs_info": "<div style",
    "airdiscBrake_text_numberof_vahicles": "Nombre de véhicules",
    "airdiscBrake_drum_summary_paragraph1": "Pour en savoir plus sur Bendix® air disc brakes pour tracteurs et remorques. Contactez votre responsable de compte Bendix, appelez le 1-800-AIR-BRAKE (1-800-247-2725) ou visitez le site Bendix.com dès aujourd'hui.",
    "airdiscBrake_drum_summary_paragraph2": "Le(s) calculateur(s) de valeur Bendix est(sont) destiné(s) à être utilisé(s) à titre de référence uniquement ; le calculateur aide à fournir des conseils aux utilisateurs souhaitant",
    "airdiscBrake_drum_summary_paragraph3": "comprendre leur retour sur investissement (ROI) potentiel pour divers produits tout en les comparant à d'autres systèmes/produits. Les résultats du calculateur ne sont que des estimations. Les données d'usure réelles, la durée de vie des composants, les calendriers/cycles de remplacement, les coûts du cycle de vie, les données d'économie/d'évitement, les performances des produits et les spécifications peuvent varier en fonction (mais pas exclusivement) des configurations de véhicules, des applications de véhicules, du comportement des conducteurs, des pratiques d'entretien, des cycles de travail, de l'utilisation des véhicules et d'autres facteurs.",
    "airdiscBrake_drum_summary_paragraph4": "Dans les cas où l'utilisateur ne dispose pas d'informations spécifiques, Bendix a fourni des chiffres par défaut qui sont basés sur des informations générales d'enquête, des données/informations de flotte nationale, etc. afin de faciliter l'analyse.",
    "airdiscBrake_drum_summary_paragraph5": "LA CONFORMITÉ ET LA CERTIFICATION DES VÉHICULES À TOUTES LES RÉGLEMENTATIONS RELÈVENT DE LA SEULE RESPONSABILITÉ DU FABRICANT DU VÉHICULE.",
    "airdiscBrake_drum_summary_paragraph6": "Bendix Commercial Vehicle Systems LLC, membre du groupe Knorr-Bremse. Tous droits réservés.",
    "endurasure_summary_paragraph1": "Pour en savoir plus sur Bendix® EnduraSure® -Pro pour tracteurs et remorques. Contactez votre responsable de compte Bendix, appelez le 1-800-AIR-BRAKE (1-800-247-2725) ou visitez le site Bendix.com dès aujourd'hui.",
    "endurasure_summary_paragraph2": "Le(s) calculateur(s) de valeur Bendix est(sont) destiné(s) à être utilisé(s) à titre de référence uniquement ; le calculateur aide à fournir des conseils aux utilisateurs souhaitant",
    "endurasure_summary_paragraph3": "comprendre leur retour sur investissement (ROI) potentiel pour divers produits tout en les comparant à d'autres systèmes/produits. Les résultats du calculateur ne sont que des estimations. Les données d'usure réelles, la durée de vie des composants, les calendriers/cycles de remplacement, les coûts du cycle de vie, les données d'économie/d'évitement, les performances des produits et les spécifications peuvent varier en fonction (mais pas exclusivement) des configurations de véhicules, des applications de véhicules, du comportement des conducteurs, des pratiques d'entretien, des cycles de travail, de l'utilisation des véhicules et d'autres facteurs.",
    "endurasure_summary_paragraph4": "Dans les cas où l'utilisateur ne dispose pas d'informations spécifiques, Bendix a fourni des chiffres par défaut qui sont basés sur des informations générales d'enquête, des données/informations de flotte nationale, etc. afin de faciliter l'analyse.",
    "endurasure_summary_paragraph5": "LA CONFORMITÉ ET LA CERTIFICATION DES VÉHICULES À TOUTES LES RÉGLEMENTATIONS RELÈVENT DE LA SEULE RESPONSABILITÉ DU FABRICANT DU VÉHICULE.",
    "endurasure_summary_paragraph6": "Bendix Commercial Vehicle Systems LLC, membre du groupe Knorr-Bremse. Tous droits réservés.\n\n",
    "warranty_eligibility_check": "Contrôle d’admissibilité à la garantie",
    "warranty_terms": "Warranty Terms",
    "warranty_quick_coverage_guide": "Couverture – Guide de consultation rapide",
    "warranty_documents": "Documents de garantie",
    "warranty_shipping_packaging": "Shipping/Packaging",
    "basket_page_totalWeight": "Poids TOTAL",
    "basket_page_weightPerKg": "Poids (KG)",
    "notifications_available": " Nouvelle(s) notification(s)",
    "notifications_not_available": "Aucune nouvelle notification",
    "text_compare_show_difference_only": "Afficher uniquement les différences",
    "text_demo_bendix_center": "Bendix Demo Center",
    "text_demo_bendix_form": "Demo Registration",
    "register_success": "Vous vous êtes inscrit avec succès à la démonstration. Vous recevrez un e-mail de confirmation avec votre renonciation acceptée."
  },
  "registrationDemoLandingPage": {
    "bendix_demo_center": "Centre de démonstration Bendix",
    "title1": "Investir intelligemment dans la sécurité",
    "p1": "Disposer de la bonne technologie sur vos camions et remorques peut contribuer à améliorer la sécurité et la fidélisation des conducteurs... sans parler de la réduction du coût total de possession (TCO). ",
    "p2": "C'est là que nous pouvons vous aider. Découvrez ce que la suite de technologies de sécurité Bendix peut signifier pour votre flotte.",
    "resgister": "inscrivez-vous dès",
    "today": " aujourd'hui !",
    "image-text": "Plus d'apprentissage à votre disposition",
    "title2": "Technologies en vedette",
    "p3": "Une expérience de première main depuis le siège passager",
    "p4": "Ressentez la puissance de ces solutions de sécurité intégrées de Bendix",
    "list_title1": "Bendix® Fusion™",
    "list_desc1": "- comprend des fonctionnalités améliorées telles que l'alerte et le freinage de sortie d'autoroute, l'AEB multi-voies, et plus encore.",
    "list_title2": "Bendix® ADB22X®",
    "list_desc2": "- pratiquement pas d'évanouissement des freins et une durée de vie plus longue grâce à une conception optimisée du couple de frottement.",
    "list_title3": "ESP® Full Stability",
    "list_desc3": "- réduit les risques de retournement et de perte de contrôle.",
    "list_title4": "TABS avec TRSP®",
    "list_desc4": "- aide à garder le contrôle et à réduire le risque de renversement de la remorque.",
    "launch_video": "vidéo de lancement",
    "register_here": "Registrarse aquí",
    "Currently_no_demos": "Actuellement, aucune démo n'est disponible.",
    "Bendix_in_action": "Cliquez ici pour découvrir la démo Bendix en action"
  },
  "registrationDemoForm": {
    "l1": "Si vous souhaitez participer à notre démonstration, veuillez remplir le formulaire d'inscription à la démonstration.",
    "l2": "Pour toute question, veuillez envoyer un e-mail à l'équipe ",
    "demo_team": "de démonstration.",
    "l3": "Pour toute autre question, veuillez contacter votre responsable de compte Bendix.  Nous vous remercions de votre attention.",
    "confirmEmailAddresslabel": "Confirmez votre adresse e-mail*",
    "confirmEmailAddressError": "Incorrect. Veuillez réessayer",
    "popupMsgDemoCode": "Ne s'applique que si vous avez reçu un code d'accès de la part de Bendix",
    "date_and_times": "DATE / HEURE",
    "Locations": "EMPLACEMENT",
    "Wavier": "DÉCHARGE DE RESPONSABILITÉ / INSCRIPTION"
  },
  "WarrentyParagraph": {
    "p1": "Pour soumettre une réclamation au titre de la garantie Bendix, veuillez remplir le formulaire en ligne suivant. Les informations obligatoires sont indiquées par un astérisque (*).",
    "p2": "Si vous avez des questions supplémentaires, veuillez télécharger",
    "hyperlinkText": "Comment soumettre une réclamation au titre de la garantie",
    "p3": "Merci à votre équipe d'assistance à la garantie Bendix"
  },
  "coreReport": {
    "page_Title": " Centre de base Bendix",
    "p1": "Bienvenue au Bendix Core Center",
    "p2": "En tant que client, vous pourrez obtenir les rapports de cores, présenter un retour de cores, programmer les envois... et plus encore.",
    "p3": "Vous devez être connecté à votre compte pour accéder aux liens suivants :",
    "link1": "Présenter un retour de cores ",
    "link2": "Recherche des retours de base",
    "link3": "Rapports des cores"
  },
  "SelectAllVehicalPopup": {
    "p1": "Types de véhicules:",
    "p2": "Chaque secteur d'activité ne pourra utiliser qu'un seul type de véhicule, à l'exception des clients de la flotte.  Ces derniers pourront sélectionner plusieurs types de véhicules.",
    "p3": "Le type de véhicule sélectionné détermine le programme de démonstration disponible."
  },
  "waiver_popup_content": {
    "title": "ACCORD DE RENONCIATION ET DE PRISE EN CHARGE DES RISQUES",
    "p1": "En considération de l'opportunité qui m'est offerte par Bendix Commercial Vehicle Systems LLC ( » BENDIX ») de participer en tant que passager, conducteur ou spectateur à une démonstration de véhicule motorisé conduite par BENDIX démontrant les caractéristiques d'un produit BENDIX et/ou le fonctionnement d'un véhicule équipé des technologies de sécurité active et de soutien de Bendix, Par la présente, en mon nom et au nom de mes héritiers, exécuteurs, administrateurs, successeurs et ayants droit, je libère et décharge complètement et inconditionnellement BENDIX et chacun de ses dirigeants, administrateurs, actionnaires, membres, avocats, concessionnaires, distributeurs, fournisseurs, assureurs, indemnisateurs, agents, préposés, représentants, employés, sociétés mères et filiales, sociétés affiliées, et ce dans le passé, le présent et le futur, employés, sociétés mères et filiales, affiliés, partenaires, prédécesseurs, successeurs et ayants droit (collectivement « les renonciataires »), de toute réclamation, demande, obligation, action, cause d'action, réclamation pour mort injustifiée, droit, dommage, coût, perte de services, perte de confort et de société, dépense et compensation de quelque nature que ce soit, passés, présents et futurs, y compris toutes les demandes de dommages-intérêts compensatoires, exemplaires ou punitifs, de contribution ou d'indemnisation, qu'elles soient fondées sur la négligence, le contrat, la rupture de garantie, la responsabilité stricte ou toute autre théorie juridique ou équitable, que j'ai jamais eues, que j'ai maintenant ou que je pourrais accumuler ou acquérir par la suite, et qui découlent de ou sont liées à : (a) la démonstration de produits, son environnement et son emplacement, (b) tout défaut ou état associé aux produits en démonstration ou aux véhicules utilisés pendant cette démonstration, (c) toute condition physique associée au site, (d) ma participation à la démonstration de produits ou mon observation de celle-ci, et/ou (e) le fait de monter dans un véhicule à moteur, de le conduire ou d'être présent à proximité d'un véhicule à moteur sur le site pendant cette démonstration de produits (collectivement, « les risques volontairement assumés et libérés »).",
    "p2": "Cet Accord de renonciation et d'acceptation des risques inclut spécifiquement toutes les réclamations ou causes d'action connues ou inconnues contre BENDIX et les renonciataires pour les pertes économiques, les blessures personnelles, les maladies, les décès ou les dommages matériels causés à ou par moi ou subis par moi, qu'ils surviennent ou s'accumulent avant, à partir de ou après la date de cet Accord, ou après la date de cet Accord, et comprend également toutes les conséquences d'une telle perte économique, d'une blessure personnelle, d'une maladie, d'un décès ou d'un dommage matériel (qu'elles soient attendues, anticipées, inattendues ou non anticipées), résultant ou pouvant résulter à l'avenir d'un ou de plusieurs des Risques Volontairement Assumés et Déchargés.",
    "p3": "Je reconnais sciemment et volontairement et j'assume personnellement tous les risques liés (a) à la démonstration du produit, à son environnement et à son emplacement, (b) à tout défaut ou état associé aux produits démontrés ou aux véhicules utilisés pendant une telle démonstration, (c) à toute condition physique associée au Site, (d) à ma participation ou à mon observation de la démonstration du produit, et/ou (e) au fait de monter dans, de conduire ou d'être présent à proximité de tout véhicule motorisé sur le Site pendant une telle démonstration du produit. En outre, je garantis et déclare à BENDIX que je n'ai connaissance d'aucun défaut physique ou mental, d'aucune condition médicale, d'aucune maladie physique, d'aucune limitation ou restriction physique qui m'empêcherait, me gênerait ou me rendrait susceptible de me blesser en participant ou en observant la démonstration de produits ou en montant dans, en conduisant ou en étant présent à proximité d'un véhicule à moteur sur le Site pendant la démonstration de produits.",
    "p4": "Je reconnais et autorise volontairement BENDIX et ses agents ou ayants droit dûment autorisés à utiliser, de manière non exclusive, mon nom, mon image, mes sons et/ou ma performance tels qu'enregistrés, photographiés, filmés ou autrement conservés, numériquement ou autrement, lors de ma participation ou de mon observation d'une telle démonstration de produit, et je renonce par la présente à BENDIX à perpétuité à tous les droits y afférents à de telles fins..",
    "p5": "EN FOI DE QUOI, j'ai signé le présent accord de décharge et de prise en charge des risques en tant qu'acte volontaire, ce jour :",
    "p6": "Démonstration d'exonération de responsabilité - 06-29-26 BCVS ",
    "accept": "Accorder"
  },
  "dataExtractionRquest": {
    "dataExtractionRquestTitle": "Demande d'extraction de données",
    "dataExtractionOverview": "Présentation de l'extraction de données",
    "customerVehicleOwner": "Client / Propriétaire du véhicule",
    "requestor": "Demandeur",
    "reportECURecipient": "Rapport / Destinataire de l'ECU",
    "vehicleInformation": "Informations sur le véhicule",
    "eCUInformation": "Informations sur l'ECU",
    "incidentInformation": "Informations sur l'incident",
    "returnShippingInformation": "Informations sur le retour",
    "Next": "Suivant",
    "back": "Retour",
    "error_message": "Veuillez saisir une valeur valide."
  },
  "dataExtractionOverviewPage": {
    "p1": "Veuillez utiliser ce formulaire pour demander et obtenir l'extraction des données de l'unité de contrôle électronique (ECU) Bendix® et pour suivre la garde de tout composant retiré de votre véhicule et envoyé à Bendix Commercial Vehicle Systems (Bendix).",
    "Note": "REMARQUE : DES FRAIS D'EXTRACTION DE DONNÉES DE 1 000,00 $ US SONT APPLICABLES. ",
    "p2": "Après avoir retiré le ou les composants du véhicule, envoyez-les, accompagnés du formulaire dûment rempli et d'un chèque de 1 000,00 USD à l'ordre de Bendix Commercial Vehicle Systems, à l'adresse suivante :",
    "address1": "Bendix Commercial Vehicle Systems",
    "address2": "Event Log Reporting",
    "address3": "35500 Chester Road",
    "address4": "Avon, Ohio 44011",
    "p3_1": "Le ou les composants, le formulaire dûment rempli et le chèque de 1 000,00 $ US doivent être reçus avant le début de toute extraction par Bendix.  Pour toute question, veuillez envoyer un e-mail à",
    "p3_2": "ou contacter directement votre responsable de compte Bendix.  Merci.",
    "p4_1": "J'accepte la clause de",
    "p4_2": "non-responsabilité relative à l'extraction des données Bendix."
  },
  "bendix_data_extraction_disclaimer_popup": {
    "title": "Avertissement relatif à l'extraction de données Bendix",
    "p1": "Exclusion des dommages accessoires, indirects et certains autres dommages :",
    "p2": "Dans la mesure maximale permise par la loi applicable, Bendix, ses filiales, ses sociétés affiliées, ses fournisseurs ou ses prestataires de services agréés ne peuvent en aucun cas être tenus responsables des dommages spéciaux, accessoires, indirects ou consécutifs résultant de ou liés de quelque manière que ce soit à la perte de l'ECU, à l'utilisation ou à l'impossibilité d'utiliser l'extraction de données, à la fourniture ou à la non-fourniture de rapports d'événements, ou autrement en vertu ou en relation avec toute disposition du présent accord.",
    "attention": "ATTENTION:",
    "p3": "Selon le type et la version du produit, les unités de contrôle électronique (ECU) Bendix® peuvent stocker des données relatives au dépannage, aux diagnostics, aux besoins d'entretien, à l'état de fonctionnement du système du véhicule et aux entrées du conducteur du véhicule. Aucune donnée permettant d'identifier personnellement l'utilisateur (par exemple, nom, sexe ou âge) n'est enregistrée. Bendix n'accédera pas aux données stockées dans l'ECU et ne les partagera pas avec des tiers, sauf avec le consentement du propriétaire du véhicule, en réponse à une demande officielle des forces de l'ordre ou d'une autre agence gouvernementale, dans le cadre de la défense de Bendix dans le cadre d'un litige, ou si la loi l'exige. Les données reçues par Bendix peuvent également être utilisées à des fins de recherche ou mises à la disposition d'autres personnes à des fins de recherche, lorsque cela s'avère nécessaire et que les données ne sont pas liées à un véhicule ou à un propriétaire spécifique.",
    "p4": "Les unités de contrôle électronique (ECU) de marque Bendix® ne sont pas conçues pour stocker des données à des fins de reconstitution d'accidents, et le logiciel de diagnostic Bendix® ACom® n'est pas destiné à récupérer des données à des fins de reconstitution d'accidents. Bendix ne fait aucune déclaration quant à l'exactitude des données récupérées et interprétées à partir des ECU à des fins de reconstitution d'accidents. Bendix n'offre pas de services de reconstitution d'accidents ni d'interprétation des données stockées. Les ECU Bendix ne sont pas protégés contre les incendies, les coupures de courant, les dommages dus à des chocs ou d'autres conditions pouvant survenir lors d'un accident et rendre les données indisponibles ou irrécupérables.",
    "p5_1": "Lorsque vous demandez l'extraction des données d'un calculateur électronique à partir de composants Bendix, un seul formulaire peut être utilisé pour l'envoi de plusieurs composants à extraire.",
    "p5_2": " Il est essentiel que ce formulaire soit rempli dans son intégralité.",
    "p5_3": "VEUILLEZ INDIQUER LE NUMÉRO DE SÉRIE",
    "p5_4": "de chaque composant que vous envoyez. Il est également fortement recommandé d'envoyer une photo claire de l'étiquette de chaque composant.",
    "p6": "Veuillez noter les exceptions suivantes :",
    "p7": "électronique du système de freinage antiblocage (ABS) Bendix® :",
    "p7_1": "Il n'est pas nécessaire d'envoyer le calculateur électronique des freins si vous demandez un rapport de l'enregistreur de données Bendix (BDR). Le rapport sur les codes de diagnostic (DTC) ABS au format HTML (pour Bendix® ACom® Legacy) ou dans un fichier ZIP (pour le logiciel de diagnostic Bendix® ACom® PRO™/AE™) est nécessaire pour que Bendix puisse générer le rapport BDR. Bendix vous recommande d'envoyer le rapport DTC sur une clé USB accompagné des éléments requis indiqués dans la SECTION 1 : APERÇU du présent document. Tout document incomplet ou manquant entraînera un retard dans le traitement.",
    "p8": "Bendix™ FLR-21™, FLR-25™ (radar avant) :",
    "p8_1": "Les seules données disponibles sont celles du rapport DTC du radar.",
    "p8_2": "Veuillez ne pas envoyer ces radars,",
    "p8_3": "car aucune donnée ne pourra en être extraite.",
    "note": "REMARQUE : les calculateurs AutoVue® / SafetyDirect® doivent être envoyés à Rand McNally®.",
    "p9": "©Bendix Commercial Vehicle Systems LLC, membre du groupe Knorr-Bremse. Tous droits réservés.",
    "accept": "Accorder",
    "description_text": "Description"
  },
  "customerVehicleOwnerForm": {
    "companyName": "Nom de l'entreprise*",
    "contactName": "Nom du contact*",
    "contactEmail": "E-mail du contact*",
    "contactPhoneNumber": "Numéro de téléphone du contact*",
    "companyAddresswithStreetNumber": "Adresse de l'entreprise avec numéro de rue*",
    "address2": "Adresse 2 (par exemple, unité, étage, nom de la maison)",
    "city": "Ville*",
    "state": "État*",
    "zipPostalCode": "Code postal*",
    "country": "Pays*",
    "company_name_popup_title": "Nom de l'entreprise",
    "company_name_popup_content": "L'entreprise propriétaire du véhicule.",
    "contact_name_popup_title": "Nom du contact",
    "contact_name_popup_content": "La personne propriétaire du véhicule."
  },
  "requestorForm": {
    "checkbox_label": "Identique aux informations sur le client / propriétaire du véhicule",
    "companyName": "Nom de l'entreprise du demandeur*",
    "contactName": "Nom du contact du demandeur*",
    "contactEmail": "Adresse e-mail du contact du demandeur*",
    "contactPhoneNumber": "Numéro de téléphone du contact du demandeur*",
    "companyAddresswithStreetNumber": "Adresse de l'entreprise avec numéro de rue*",
    "address2": "Adresse 2 (par exemple, unité, étage, nom de la maison)",
    "city": "Ville*",
    "state": "État*",
    "zipPostalCode": "Code postal*",
    "country": "Pays*",
    "company_name_popup_title": "Nom de la société requérante",
    "company_name_popup_content": "La société qui demande l'extraction des données (si elle n'est pas le propriétaire du véhicule).",
    "contact_name_popup_title": "Nom du demandeur",
    "contact_name_popup_content": "La personne qui demande l'extraction des données (si elle n'est pas le propriétaire du véhicule)."
  },
  "reportECURecipientForm": {
    "checkbox_label": "Identique aux informations du demandeurs",
    "companyName": "Nom de l'entreprise destinataire*",
    "contactName": "Nom du contact destinataire*",
    "contactEmail": "E-mail du contact destinataire*",
    "contactPhoneNumber": "Numéro de téléphone du contact destinataire*",
    "companyAddresswithStreetNumber": "Adresse de l'entreprise avec numéro de rue*",
    "address2": "Adresse 2 (par exemple, unité, étage, nom de la maison)",
    "city": "Ville*",
    "state": "État*",
    "zipPostalCode": "Code postal*",
    "country": "Pays*",
    "customer_reference_number": "Numéro de téléphone du contact destinataire*",
    "company_name_popup_title": "Nom de la société destinataire du rapport",
    "company_name_popup_content": "Société à laquelle Bendix renverra le(s) rapport(s) et le(s) ECU.",
    "contact_name_popup_title": "Nom du destinataire du rapport",
    "contact_name_popup_content": "Personne à laquelle Bendix renverra le(s) rapport(s) et le(s) ECU."
  },
  "vehicleInformation": {
    "vehicleIdentificationNumber": "Numéro d'identification du véhicule (VIN)*",
    "vehicleYear": "Année du véhicule*",
    "vehicleMake": "Marque du véhicule*",
    "vehicleModel": "Vehicle Model*",
    "vehicleTruckNumber": "Numéro du camion*",
    "vehicleMileage": "Kilométrage du véhicule",
    "mileageUnit": "Kilomètres"
  },
  "IncidentForm": {
    "label_Is_this_Request_the_Result_of_an_Accident": "Cette demande résulte-t-elle d'un accident ?*",
    "Yes": "Oui",
    "No": "Non",
    "Date_of_Incident": "Date de l'incident*",
    "Select_Date": "Sélectionnez la date",
    "Time_of_Incident": "Heure de l'incident*",
    "City_of_Incident": "Ville où l'incident s'est produit*",
    "State_of_Incident": "État où l'incident s'est produit*",
    "Select_Your_State": "Sélectionnez votre État",
    "Country_of_Incident": "Pays où l'incident s'est produit* ",
    "Select_Your_Country": "Sélectionnez votre pays"
  },
  "returnShippingInformation": {
    "return_shipping_type": "Type d'expédition pour le retour:",
    "domestic": "National",
    "international": "International",
    "carrier": "Transporteur*",
    "account_number": "Numéro de compte*",
    "account_postal_code": "Code postal du compte*",
    "account_country_code": "Code pays du compte*",
    "e-signature": "Signature électronique",
    "i_am_not_robot": "Je ne suis pas un robot",
    "domestic_shipping_label": "Pour les envois internationaux uniquement:",
    "domestic_not_required": "Non requis si",
    "domestic_shipping_desc": "le retour est effectué aux États-Unis.",
    "international_shipping_label": "Toutes les informations relatives à l'expédition internationale sont",
    "international_required": "requises pour le",
    "international_shipping_desc": "retour de l'ECU au client. Tous les droits et frais associés à cet envoi seront facturés sur votre compte Bendix."
  },
  "ECUForm": {
    "dtc_report_text": "Rapport sur les codes de diagnostic (DTC)*",
    "ecu_removed": "ECU retirés - Cochez toutes les cases qui s'appliquent*",
    "ecu_serial_no": "ECU Serial Number*",
    "ecu_photo": "ECU Photo*",
    "ecu_serial_popup": "ECU Serial Number",
    "ecu_serial_popup_title": "Display Instructions on how to find each ECU serial number – work with Keving Kinley (this will vary by product)",
    "ecu_photo_popup": "ECU Photo",
    "ecu_photo_popup_title": "Photo of the ECU being sent to Bendix for data extraction (for traceability).",
    "dtc_report_text_popup": "Rapport sur les codes de diagnostic (DTC)",
    "dtc_report_text_popup_title": "Joindre le rapport sur les codes de diagnostic (DTC) du système de freinage antiblocage (ABS) Bendix® au format HTML pour Bendix® ACom® Legacy et au format ZIP ou XML pour le logiciel de diagnostic Bendix® ACom® PRO™/ AE™.",
    "text_ecu_select_file_wish": "Sélectionnez le fichier que vous souhaitez télécharger et cliquez sur le bouton \"Télécharger\". Chaque fichier téléchargé sera ajouté à la demande.",
    "text_ecu_select_file_type_upload": "Note: only html, xml, or zip files are permitted.",
    "text_ecu_select_file_type_upload_1": "Note: Only image file formats are permitted.",
    "bendix_ABS_text": "Bendix® ABS ECU",
    "bendix_EBS_Text": "Bendix® EBS-90™ ECU",
    "bendix_FLC_text": "Bendix® Caméra FLC-20™ (noire)",
    "bendix_intellipark_text":"Bendix® Intellipark® Dash ECU (DECU)",
    "sdp_text": "Processeur SafetyDirect® (SDP)",
    "ecu_text": "Unité de contrôle électronique (ECU) AutoVue®",
    "camera_text": "Caméra AutoVue® 3G (grise)",
    "flr_text": "Bendix® FLR-21™, FLR-25™ (radar avant)",
    "not_send_bendix_text": "<u>Ne</u> pas envoyer à Bendix. Envoyer à Rand McNally pour traitement.",
    "not_send_ecu_text": "<u>Ne</u> pas envoyer à Bendix. Cet ECU <u>ne</u> sera pas traité.",
    "record_text": "d'enregistrements"
  },
  "DTC_PAGE": {
    "dtc_Form_title": "Recherche de codes de diagnostic",
    "product_type": "Type de produit",
    "dtc_type": "Type de code*",
    "search": "Recherche",
    "search_string": "Chaîne de recherche*",
    "internalCodesOptional": "Codes internes (facultatif)",
    "internalCode1": "Code interne 1:",
    "internalCode2": "Code interne 2:",
    "downloadDocument": "Documents à télécharger",
    "troubleshootingSteps": "Étapes de dépannage",
    "reset": "Remise à zéro",
    "dtc_popup_title": "Type de code:",
    "spn_text": "<b>SPN</b> est le <b>numéro de paramètre suspect</b>,qui identifie le produit ou le système spécifique où un problème a été détecté.",
    "fmi_text": "<b>FMI</b> est <b>l'identifiant du mode de défaillance</b>,qui indique le type de problème ou de défaillance.",
    "hex_code_text": "Les <b>codes hexadécimaux</b> sont l'ensemble des informations relatives aux défauts, y compris toutes les métadonnées de diagnostic stockées au format hexadécimal.",
    "blink_codes_text": "Les <b>codes clignotants</b> sont une méthode d'affichage des codes d'erreur qui consiste à utiliser un voyant (comme le voyant ABS) pour faire clignoter une série d'éclairs représentant un code numérique.",
    "faultCodeSpnSidDecPreferred": "Code d'erreur SPN/SID (DEC) Préféré",
    "fmi": "FMI",
    "hexCode": "Code hexadécimal",
    "internalCode1Path": "Code interne 1 (Chemin)",
    "internalCode2Type": "Code interne 2 (Type)",
    "blinkCode1": "Code clignotant 1",
    "blinkCode2": "Code clignotant 2",
    "publiclySharableFaultDescription": "Description du défaut pouvant être partagée publiquement",
    "public": "Public",
    "repairTabInfoSection": "Informations de l'onglet Réparation / Section",
    "serviceActionCodeList": "Service (tableau des défauts de la feuille SD) Liste des codes.",
    "ecuPinLocations": "Emplacement des goupilles de l'ECU",
    "overview": "Aperçu",
    "possibleCauses": "Causes possibles",
    "sdSheetFaultCodeTableSection": "Fiche technique Section « Tableau des codes d'erreur »",
    "schematics": "Schémas",
    "disclaimer": "Avertissement",
    "beforeYouBegin": "Avant de commencer",
    "afterRepairsHaveBeenMade": "Une fois les réparations effectuées",
    "sortBy": "Trier par",
    "dtcTypeAscending": "Type de DTC : par ordre croissant",
    "dtcTypeDescending": "Type de DTC : décroissant",
    "productTypeAscending": "Type de produit : par ordre croissant",
    "productTypeDescending": "Type de produit : décroissant",
    "defaultSort": "Type de DTC : par ordre croissant",
    "back_button": "Retour"
  }
}